webpackJsonp([222],{

/***/ "+LB2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+LE5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/4VV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/iSo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/kga":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/prevent-body-scroll.js
var prevent_body_scroll = __webpack_require__("JkZY");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31c83ce0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-dialog/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-dialog",class:{'vux-x-dialog-absolute': _vm.layout === 'VIEW_BOX'}},[_c('transition',{attrs:{"name":_vm.maskTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-mask",style:(_vm.maskStyle),on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.hide.apply(null, arguments)}}},[_c('transition',{attrs:{"name":_vm.dialogTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],class:_vm.dialogClass,style:(_vm.dialogStyle)},[_vm._t("default")],2)])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_x_dialog = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-dialog/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("7DAO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_x_dialog,
  src_components_x_dialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_dialog = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "03dp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1uDx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2tP1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3Lt7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox-item.vue
//
//
//
//
//
//

var prefixList = ['-moz-box-', '-webkit-box-', ''];

/* harmony default export */ var flexbox_item = ({
  name: 'flexbox-item',
  props: {
    span: [Number, String],
    order: [Number, String]
  },
  beforeMount: function beforeMount() {
    this.bodyWidth = document.documentElement.offsetWidth;
  },

  methods: {
    buildWidth: function buildWidth(width) {
      if (typeof width === 'number') {
        if (width < 1) {
          return width;
        } else {
          return width / 12;
        }
      } else if (typeof width === 'string') {
        return width.replace('px', '') / this.bodyWidth;
      }
    }
  },
  computed: {
    style: function style() {
      var styles = {};
      var marginName = this.$parent.orient === 'horizontal' ? 'marginLeft' : 'marginTop';

      if (this.$parent.gutter * 1 !== 0) {
        styles[marginName] = this.$parent.gutter + 'px';
      }

      if (this.span) {
        for (var i = 0; i < prefixList.length; i++) {
          styles[prefixList[i] + 'flex'] = '0 0 ' + this.buildWidth(this.span) * 100 + '%';
        }
      }
      if (typeof this.order !== 'undefined') {
        styles.order = this.order;
      }
      return styles;
    }
  },
  data: function data() {
    return {
      bodyWidth: 0
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox-item.vue
//
//
//
//
//
//

var flexbox_item_prefixList = ['-moz-box-', '-webkit-box-', ''];

/* harmony default export */ var flexbox_flexbox_item = ({
  name: 'flexbox-item',
  props: {
    span: [Number, String],
    order: [Number, String]
  },
  beforeMount: function beforeMount() {
    this.bodyWidth = document.documentElement.offsetWidth;
  },

  methods: {
    buildWidth: function buildWidth(width) {
      if (typeof width === 'number') {
        if (width < 1) {
          return width;
        } else {
          return width / 12;
        }
      } else if (typeof width === 'string') {
        return width.replace('px', '') / this.bodyWidth;
      }
    }
  },
  computed: {
    style: function style() {
      var styles = {};
      var marginName = this.$parent.orient === 'horizontal' ? 'marginLeft' : 'marginTop';

      if (this.$parent.gutter * 1 !== 0) {
        styles[marginName] = this.$parent.gutter + 'px';
      }

      if (this.span) {
        for (var i = 0; i < flexbox_item_prefixList.length; i++) {
          styles[flexbox_item_prefixList[i] + 'flex'] = '0 0 ' + this.buildWidth(this.span) * 100 + '%';
        }
      }
      if (typeof this.order !== 'undefined') {
        styles.order = this.order;
      }
      return styles;
    }
  },
  data: function data() {
    return {
      bodyWidth: 0
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30e3872a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/flexbox/flexbox-item.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-flexbox-item",style:(_vm.style)},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_flexbox_flexbox_item = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/flexbox/flexbox-item.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  flexbox_flexbox_item,
  components_flexbox_flexbox_item,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_flexbox_flexbox_item = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3VVt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchMyInfo;
/* harmony export (immutable) */ __webpack_exports__["d"] = fetchMyLimit;
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchMyFavTopicList;
/* harmony export (immutable) */ __webpack_exports__["p"] = updateMyInfo;
/* harmony export (immutable) */ __webpack_exports__["v"] = uploadImage;
/* harmony export (immutable) */ __webpack_exports__["u"] = uploadExpoImage;
/* harmony export (immutable) */ __webpack_exports__["t"] = uploadAvatar;
/* harmony export (immutable) */ __webpack_exports__["o"] = updateMyAvatar;
/* harmony export (immutable) */ __webpack_exports__["q"] = updateMyMobile;
/* harmony export (immutable) */ __webpack_exports__["r"] = updateMyMobile2;
/* harmony export (immutable) */ __webpack_exports__["m"] = saveSign;
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchMyCoinLog;
/* harmony export (immutable) */ __webpack_exports__["e"] = fetchMyMsg;
/* harmony export (immutable) */ __webpack_exports__["k"] = fetchMySetting;
/* harmony export (immutable) */ __webpack_exports__["s"] = updateMySetting;
/* harmony export (immutable) */ __webpack_exports__["i"] = fetchMyOrderMeetingList;
/* harmony export (immutable) */ __webpack_exports__["j"] = fetchMyOrderVipList;
/* harmony export (immutable) */ __webpack_exports__["g"] = fetchMyOrderContactsList;
/* harmony export (immutable) */ __webpack_exports__["f"] = fetchMyOrderCardList;
/* unused harmony export fetchMyOrderVideoList */
/* harmony export (immutable) */ __webpack_exports__["h"] = fetchMyOrderLiveList;
/* harmony export (immutable) */ __webpack_exports__["n"] = unbindMyWechat;
/* harmony export (immutable) */ __webpack_exports__["l"] = noticeMySubscribe;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_request__ = __webpack_require__("vLgD");


function fetchMyInfo(query) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/my/info',
    params: query
  });
}

function fetchMyLimit() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/my/limit'
  });
}

function fetchMyFavTopicList() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/my/topic/list/fav'
  });
}

function updateMyInfo(item) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/my/info',
    method: 'put',
    data: item
  });
}

function uploadImage(file) {
  var fileData = new FormData();
  fileData.append('img', file);
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/upload/',
    method: 'post',
    data: fileData
  });
}

function uploadExpoImage(file) {
  var fileData = new FormData();
  fileData.append('img', file);
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/upload/expo',
    method: 'post',
    data: fileData
  });
}

function uploadAvatar(file) {
  var fileData = new FormData();
  fileData.append('img', file);
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/upload/avatar',
    method: 'post',
    data: fileData
  });
}

function updateMyAvatar(url) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/my/info/avatar',
    method: 'put',
    data: { avatar: url }
  });
}

function updateMyMobile(item) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/my/info/mobile',
    method: 'put',
    data: item
  });
}

function updateMyMobile2(item) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/my/info/mobile2',
    method: 'put',
    data: item
  });
}

function saveSign() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/my/sign',
    method: 'post'
  });
}

function fetchMyCoinLog(query) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/my/coin/log',
    method: 'get',
    params: query
  });
}

function fetchMyMsg(query) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/my/msg',
    method: 'get',
    params: query
  });
}

function fetchMySetting() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/my/setting',
    method: 'get'
  });
}

function updateMySetting(item) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/my/setting',
    method: 'put',
    data: item
  });
}

function fetchMyOrderMeetingList(query) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/order/m/list',
    method: 'get',
    params: query
  });
}

function fetchMyOrderVipList(query) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/order/vip/list',
    method: 'get',
    params: query
  });
}

function fetchMyOrderContactsList(query) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/order/contacts/list',
    method: 'get',
    params: query
  });
}

function fetchMyOrderCardList(query) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/order/card/list',
    method: 'get',
    params: query
  });
}

function fetchMyOrderVideoList(query) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/order/video/list',
    method: 'get',
    params: query
  });
}

function fetchMyOrderLiveList(query) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/order/live/list',
    method: 'get',
    params: query
  });
}

function unbindMyWechat() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/my/wx/unbind',
    method: 'put'
  });
}

function noticeMySubscribe() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/my/subscribe/notice',
    method: 'post'
  });
}

/***/ }),

/***/ "3Ziz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4WEX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5VbK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5jbP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "62KO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/components/x-dialog/index.vue + 3 modules
var x_dialog = __webpack_require__("/kga");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/confirm/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var components_confirm = ({
  name: 'confirm',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object,
    showContent: {
      type: Boolean,
      default: true
    },
    confirmType: {
      type: String,
      default: 'primary'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.setInputFocus();
            }
          }, 300);
        }
        this.$emit('on-show'); // emit just after msg is cleared
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    getInputAttrs: function getInputAttrs() {
      return this.inputAttrs || {
        type: 'text'
      };
    },
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    setInputFocus: function setInputFocus(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.$refs.input.focus();
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/confirm/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var src_components_confirm = ({
  name: 'confirm',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object,
    showContent: {
      type: Boolean,
      default: true
    },
    confirmType: {
      type: String,
      default: 'primary'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.setInputFocus();
            }
          }, 300);
        }
        this.$emit('on-show'); // emit just after msg is cleared
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    getInputAttrs: function getInputAttrs() {
      return this.inputAttrs || {
        type: 'text'
      };
    },
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    setInputFocus: function setInputFocus(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.$refs.input.focus();
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a6d97f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/confirm/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-confirm"},[_c('x-dialog',{attrs:{"dialog-class":_vm.theme === 'android' ? 'weui-dialog weui-skin_android' : 'weui-dialog',"mask-transition":_vm.maskTransition,"dialog-transition":_vm.theme === 'android' ? 'vux-fade' : _vm.dialogTransition,"hide-on-blur":_vm.hideOnBlur,"mask-z-index":_vm.maskZIndex},on:{"on-hide":function($event){return _vm.$emit('on-hide')}},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[(!!_vm.title)?_c('div',{staticClass:"weui-dialog__hd",class:{'with-no-content': !_vm.showContent}},[_c('strong',{staticClass:"weui-dialog__title"},[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_vm._v(" "),(_vm.showContent)?[(!_vm.showInput)?_c('div',{staticClass:"weui-dialog__bd"},[_vm._t("default",function(){return [_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})]})],2):_c('div',{staticClass:"vux-prompt"},[(((_vm.getInputAttrs()).type)==='checkbox')?_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.msg)?_vm._i(_vm.msg,null)>-1:(_vm.msg)},on:{"touchend":_vm.setInputFocus,"change":function($event){var $$a=_vm.msg,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.msg=$$a.concat([$$v]))}else{$$i>-1&&(_vm.msg=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.msg=$$c}}}},'input',_vm.getInputAttrs(),false)):(((_vm.getInputAttrs()).type)==='radio')?_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":"radio"},domProps:{"checked":_vm._q(_vm.msg,null)},on:{"touchend":_vm.setInputFocus,"change":function($event){_vm.msg=null}}},'input',_vm.getInputAttrs(),false)):_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":(_vm.getInputAttrs()).type},domProps:{"value":(_vm.msg)},on:{"touchend":_vm.setInputFocus,"input":function($event){if($event.target.composing){ return; }_vm.msg=$event.target.value}}},'input',_vm.getInputAttrs(),false))])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"weui-dialog__ft"},[(_vm.showCancelButton)?_c('a',{staticClass:"weui-dialog__btn weui-dialog__btn_default",attrs:{"href":"javascript:;"},on:{"click":_vm._onCancel}},[_vm._v(_vm._s(_vm.cancelText || '取消'))]):_vm._e(),_vm._v(" "),(_vm.showConfirmButton)?_c('a',{staticClass:"weui-dialog__btn",class:("weui-dialog__btn_" + _vm.confirmType),attrs:{"href":"javascript:;"},on:{"click":_vm._onConfirm}},[_vm._v(_vm._s(_vm.confirmText || '确定'))]):_vm._e()])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var vux_src_components_confirm = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/confirm/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("6f65")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_components_confirm,
  vux_src_components_confirm,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var node_modules_vux_src_components_confirm = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6ReU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6f65":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6ylN":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/subscribe.553e158.jpeg";

/***/ }),

/***/ "7DAO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7Otq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.a3cc90b.png";

/***/ }),

/***/ "9lt8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9mUp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AoBP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/components/icon/index.vue + 3 modules
var icon = __webpack_require__("oWtu");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/timeline/timeline-item.vue
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var timeline_item = ({
  name: 'timeline-item',
  data: function data() {
    return {
      isLast: true,
      isFirst: true,
      headStyle: { backgroundColor: this.$parent.color }
    };
  },
  mounted: function mounted() {
    this.$parent.setChildProps();
  },
  beforeDestroy: function beforeDestroy() {
    // this will be null
    var $parent = this.$parent;
    this.$nextTick(function () {
      $parent.setChildProps();
    });
  },

  components: {
    Icon: icon["a" /* default */]
  },
  computed: {
    tailStyle: function tailStyle() {
      return this.isLast ? { display: 'none', backgroundColor: this.$parent.color } : { display: 'block', backgroundColor: this.$parent.color };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/timeline/timeline-item.vue
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var timeline_timeline_item = ({
  name: 'timeline-item',
  data: function data() {
    return {
      isLast: true,
      isFirst: true,
      headStyle: { backgroundColor: this.$parent.color }
    };
  },
  mounted: function mounted() {
    this.$parent.setChildProps();
  },
  beforeDestroy: function beforeDestroy() {
    // this will be null
    var $parent = this.$parent;
    this.$nextTick(function () {
      $parent.setChildProps();
    });
  },

  components: {
    Icon: icon["a" /* default */]
  },
  computed: {
    tailStyle: function tailStyle() {
      return this.isLast ? { display: 'none', backgroundColor: this.$parent.color } : { display: 'block', backgroundColor: this.$parent.color };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09234c99","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/timeline/timeline-item.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"vux-timeline-item"},[_c('div',{class:['vux-timeline-item-color', {'vux-timeline-item-head': !_vm.isFirst,'vux-timeline-item-head-first': _vm.isFirst }],style:(_vm.headStyle)},[_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.isFirst && _vm.$parent.isShowIcon),expression:"isFirst && $parent.isShowIcon"}],staticClass:"vux-timeline-item-checked",attrs:{"type":"success_no_circle"}})],1),_vm._v(" "),_c('div',{staticClass:"vux-timeline-item-tail",style:(_vm.tailStyle)}),_vm._v(" "),_c('div',{staticClass:"vux-timeline-item-content"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_timeline_timeline_item = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/timeline/timeline-item.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  timeline_timeline_item,
  components_timeline_timeline_item,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_timeline_timeline_item = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Bdcp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BfUi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__storage__ = __webpack_require__("VKKs");




var domain = 'https://www.aibang360.com';

var appid = 'wx794bdb61946633eb';
var openid = 'wxcedf5e0067272523';
var redirectCode = [401, 403];

var apiUrl = Object(__WEBPACK_IMPORTED_MODULE_2__storage__["a" /* getApiUrl */])() ? Object(__WEBPACK_IMPORTED_MODULE_2__storage__["a" /* getApiUrl */])() : 'https://api.aibang360.com';
var downloadUrl = apiUrl + '/aa/v1/admin/download/csv';
// const apiUrl = 'https://api-frp.aibang360.com'
// const apiUrl = 'https://api.v2.aibang360.com/'
// const apiUrl = 'https://api-test.aibang360.com'
// const apiUrl = 'https://api-50-3.aibang360.com'

var apiVideoUrl = 'https://api-video.aibang360.com';

// const apiVideoUrl = 'https://api-test.aibang360.com'

function getLanguage() {
  var chooseLanguage = __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.get('language');
  var lang = 'zh';
  if (chooseLanguage) {
    lang = chooseLanguage;
  } else {
    var _language = (navigator.language || navigator.browserLanguage).toLowerCase();
    var locales = ['zh', 'en'];
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(locales), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var locale = _step.value;

        if (_language.indexOf(locale) > -1) {
          lang = locale;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }
  return lang;
}

var language = getLanguage() === 'zh';

var countryOptions = [{
  key: '86',
  value: (language ? '中国大陆' : 'China Mainland') + ' +86'
}, { key: '1', value: (language ? '美国' : 'United States') + ' +1' }, { key: '852', value: (language ? '中国香港' : 'Hong Kong') + ' +852' }, { key: '853', value: (language ? '中国澳门' : 'Macro') + ' +853' }, { key: '886', value: (language ? '中国台湾' : 'Taiwan') + ' +886' }, { key: '81', value: (language ? '日本' : 'Japan') + ' +81' }, { key: '82', value: (language ? '韩国' : 'Korea') + ' +82' }, { key: '65', value: (language ? '新加坡' : 'Singapore') + ' +65' }, { key: '60', value: (language ? '马来西亚' : 'Malaysia') + ' +60' }, { key: '84', value: (language ? '越南' : 'Vietnam') + ' +84' }, { key: '66', value: (language ? '泰国' : 'Thailand') + ' +66' }, { key: '61', value: (language ? '澳大利亚' : 'Australia') + ' +61' }, { key: '64', value: (language ? '新西兰' : 'New Zealand') + ' +64' }, { key: '7', value: (language ? '俄罗斯' : 'Russia') + ' +7' }, { key: '44', value: (language ? '英国' : 'England') + ' +44' }, { key: '33', value: (language ? '法国' : 'Franch') + ' +33' }, { key: '49', value: (language ? '德国' : 'Germany') + ' +49' }, { key: '39', value: (language ? '意大利' : 'Italy') + ' +39' }, { key: '34', value: (language ? '西班牙' : 'Spain') + ' +34' }, { key: '90', value: (language ? '土耳其' : 'Turkey') + ' +90' }];

var focus = 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzUzNzMyMzkzMg==&scene=126#wechat_redirect';
/* harmony default export */ __webpack_exports__["a"] = ({
  domain: domain,
  downloadUrl: downloadUrl,
  appid: appid,
  openid: openid,
  focus: focus,
  redirectCode: redirectCode,
  countryOptions: countryOptions,
  apiUrl: apiUrl,
  apiVideoUrl: apiVideoUrl
});

/***/ }),

/***/ "Bfwr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73f1dc7e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/loading/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-loading_toast vux-loading",class:!_vm.text ? 'vux-loading-no-text' : ''},[_c('div',{staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('div',{staticClass:"weui-toast",style:({
        position: _vm.position
      })},[_c('i',{staticClass:"weui-loading weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content"},[_vm._v(_vm._s(_vm.text || '加载中')),_vm._t("default")],2):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_loading = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/loading/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("lvdZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_loading,
  src_components_loading,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var vux_src_components_loading = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BsF3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "C19j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CMiz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ckmr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CloN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "F+qD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "G6U3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HH82":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/get-iterator.js
var get_iterator = __webpack_require__("BO1k");
var get_iterator_default = /*#__PURE__*/__webpack_require__.n(get_iterator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./src/utils/auth.js
var auth = __webpack_require__("TIfe");

// EXTERNAL MODULE: ./src/utils/cookie.js
var cookie = __webpack_require__("iPXC");

// EXTERNAL MODULE: ./src/api/auth.js
var api_auth = __webpack_require__("Pfph");

// EXTERNAL MODULE: ./src/api/my.js
var my = __webpack_require__("3VVt");

// EXTERNAL MODULE: ./src/api/wx.js
var wx = __webpack_require__("SDXL");

// EXTERNAL MODULE: ./src/utils/request_no_error.js
var request_no_error = __webpack_require__("lRz9");

// CONCATENATED MODULE: ./src/api/setting.js


function fetchSetting() {
  return Object(request_no_error["a" /* default */])({
    url: '/setting'
  });
}
// EXTERNAL MODULE: ./src/utils/storage.js
var storage = __webpack_require__("VKKs");

// CONCATENATED MODULE: ./src/store/modules/user.js












var user = {
  state: {
    token: Object(auth["a" /* getToken */])(),
    user: null,
    surveyCode: null,
    popupSetting: -1,
    popupViewList: Object(storage["e" /* getPopupList */])(),
    showPopup: false
  },

  mutations: {
    SET_TOKEN: function SET_TOKEN(state, token) {
      state.token = token;
      Object(auth["c" /* setToken */])(token);
    },
    DEL_TOKEN: function DEL_TOKEN(state) {
      state.token = '';
      state.user = null;
      Object(auth["b" /* removeToken */])();
    },
    SET_USER: function SET_USER(state, user) {
      state.user = user;
    },
    SET_SIGN: function SET_SIGN(state) {
      state.user.sign = 1;
    },
    SET_SURVEY_CODE: function SET_SURVEY_CODE(state, code) {
      state.surveyCode = code.code;
    },
    SET_POPUP_SETTING: function SET_POPUP_SETTING(state, setting) {
      state.popupSetting = setting;
    },
    SET_SHOW_POPUP: function SET_SHOW_POPUP(state, showPopup) {
      state.showPopup = showPopup;
    },
    ADD_POPUP_VIEW_LIST: function ADD_POPUP_VIEW_LIST(state, image) {
      state.popupViewList.push({ image: image, timestamp: new Date().getTime() });
      Object(storage["m" /* setPopupList */])(state.popupViewList);
    },
    SET_SMS_VERIFY_FLAG: function SET_SMS_VERIFY_FLAG(state) {
      state.user.sms_verify_flag = 1;
    }
  },

  actions: {
    GetWxUserInfo: function GetWxUserInfo(_ref, query) {
      var _this = this;

      var commit = _ref.commit;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _ref2, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return Object(wx["a" /* fetchWxAuth */])(query);

              case 3:
                _ref2 = _context.sent;
                data = _ref2.data;

                if (data.message === 'ok') {
                  if (data.rst.token) {
                    commit('SET_TOKEN', data.rst.token);
                  } else if (data.rst.wx_code) {
                    Object(cookie["u" /* setWxCode */])(data.rst.wx_code);
                  }
                }
                return _context.abrupt('return', data);

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](0);
                return _context.abrupt('return', promise_default.a.reject(_context.t0));

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 9]]);
      }))();
    },
    LoginByMobile: function LoginByMobile(_ref3, loginForm) {
      var _this2 = this;

      var commit = _ref3.commit;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _ref4, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return Object(api_auth["a" /* loginByMobile */])(loginForm);

              case 3:
                _ref4 = _context2.sent;
                data = _ref4.data;

                if (data.message === 'ok') {
                  if (data.rst.token) {
                    // 返回token,表示该手机号码对应的用户已注册
                    commit('SET_TOKEN', data.rst.token);
                  } else {
                    // 保存注册用的code，用于注册时带上
                    Object(cookie["p" /* setRegCode */])(data.rst.reg_code);
                  }
                }
                return _context2.abrupt('return', data);

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](0);
                return _context2.abrupt('return', promise_default.a.reject(_context2.t0));

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 9]]);
      }))();
    },
    Register: function Register(_ref5, regForm) {
      var _this3 = this;

      var commit = _ref5.commit;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var _ref6, data;

        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return Object(api_auth["d" /* register */])(regForm);

              case 3:
                _ref6 = _context3.sent;
                data = _ref6.data;

                if (data.message === 'ok' && data.rst.token) {
                  commit('SET_TOKEN', data.rst.token);
                }
                return _context3.abrupt('return', data);

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3['catch'](0);
                return _context3.abrupt('return', promise_default.a.reject(_context3.t0));

              case 12:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 9]]);
      }))();
    },
    GetUserInfo: function GetUserInfo(_ref7) {
      var _this4 = this;

      var commit = _ref7.commit;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var rsp;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return Object(my["c" /* fetchMyInfo */])();

              case 3:
                rsp = _context4.sent;

                if (rsp.data.message === 'ok') {
                  rsp.data.rst.avatar = rsp.data.rst.avatar + '?version=' + new Date().valueOf();
                  commit('SET_USER', rsp.data.rst);
                }
                return _context4.abrupt('return', promise_default.a.resolve(rsp));

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4['catch'](0);
                return _context4.abrupt('return', promise_default.a.reject(_context4.t0));

              case 11:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[0, 8]]);
      }))();
    },
    SaveSign: function SaveSign(_ref8) {
      var _this5 = this;

      var commit = _ref8.commit;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        var _ref9, data;

        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return Object(my["m" /* saveSign */])();

              case 3:
                _ref9 = _context5.sent;
                data = _ref9.data;

                if (data.message === 'ok') {
                  commit('SET_SIGN');
                }
                return _context5.abrupt('return', data);

              case 9:
                _context5.prev = 9;
                _context5.t0 = _context5['catch'](0);
                return _context5.abrupt('return', promise_default.a.reject(_context5.t0));

              case 12:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[0, 9]]);
      }))();
    },
    GetSetting: function GetSetting(_ref10) {
      var _this6 = this;

      var commit = _ref10.commit;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        var _ref11, data, popupViewList, historyPopup, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, popup, currTime;

        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return fetchSetting();

              case 3:
                _ref11 = _context6.sent;
                data = _ref11.data;

                if (!(data.message === 'ok')) {
                  _context6.next = 33;
                  break;
                }

                popupViewList = Object(storage["e" /* getPopupList */])();

                if (!(data.rst.popup.image && data.rst.popup.time.start <= new Date().getTime() / 1000 && data.rst.popup.time.end > new Date().getTime() / 1000)) {
                  _context6.next = 31;
                  break;
                }

                historyPopup = null;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context6.prev = 12;

                for (_iterator = get_iterator_default()(popupViewList); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  popup = _step.value;

                  if (popup.image === data.rst.popup.image) {
                    historyPopup = popup;
                  }
                }
                _context6.next = 20;
                break;

              case 16:
                _context6.prev = 16;
                _context6.t0 = _context6['catch'](12);
                _didIteratorError = true;
                _iteratorError = _context6.t0;

              case 20:
                _context6.prev = 20;
                _context6.prev = 21;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 23:
                _context6.prev = 23;

                if (!_didIteratorError) {
                  _context6.next = 26;
                  break;
                }

                throw _iteratorError;

              case 26:
                return _context6.finish(23);

              case 27:
                return _context6.finish(20);

              case 28:
                if (historyPopup) {
                  currTime = new Date().getTime();

                  if (currTime - historyPopup.timestamp > 60 * 60 * 24 * 1000) {
                    commit('SET_POPUP_SETTING', data.rst.popup);
                    commit('SET_SHOW_POPUP', true);
                  }
                } else {
                  commit('SET_POPUP_SETTING', data.rst.popup);
                  commit('SET_SHOW_POPUP', true);
                }
                _context6.next = 33;
                break;

              case 31:
                commit('SET_POPUP_SETTING', null);
                commit('SET_SHOW_POPUP', false);

              case 33:
                _context6.next = 38;
                break;

              case 35:
                _context6.prev = 35;
                _context6.t1 = _context6['catch'](0);

                console.log(_context6.t1);

              case 38:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6, [[0, 35], [12, 16, 20, 28], [21,, 23, 27]]);
      }))();
    },
    AddPopupViewList: function AddPopupViewList(_ref12, image) {
      var commit = _ref12.commit;

      commit('ADD_POPUP_VIEW_LIST', image);
    },
    Logout: function Logout(_ref13) {
      var commit = _ref13.commit,
          state = _ref13.state;

      return new promise_default.a(function (resolve, reject) {
        Object(api_auth["b" /* logout */])(state.token).then(function () {
          commit('DEL_TOKEN');
          resolve();
        }).catch(function (error) {
          Object(auth["b" /* removeToken */])();
          reject(error);
        });
      });
    },
    FedLogOut: function FedLogOut(_ref14) {
      var commit = _ref14.commit;

      commit('DEL_TOKEN');
      setTimeout(function () {
        return new promise_default.a(function (resolve) {
          resolve();
        });
      }, 1500);
    }
  }
};

/* harmony default export */ var modules_user = (user);
// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__("lbHh");
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// CONCATENATED MODULE: ./src/store/modules/env.js



var u = navigator.userAgent;

var env = {
  state: {
    isMacOS: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
    isAndroid: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1,
    isWX: u.indexOf('MicroMessenger') > -1,
    isMobile: /Mobile|Android|iPhone|iPad|Phone/i.test(u),
    isMiniProgram: u.indexOf('miniProgram') > -1,
    isLoading: false,
    isDebug: false,
    wxSignUrl: '',
    language: '',
    smsCount: Object(storage["h" /* getSmsCount */])(),
    offsetWidth: document.body.offsetWidth,
    offsetHeight: document.body.offsetHeight,
    expoConfig: Object(storage["b" /* getExpoConfig */])()
  },
  mutations: {
    SET_WXSIGN_URL: function SET_WXSIGN_URL(state, url) {
      state.wxSignUrl = url;
    },
    UPDATE_LOADING_STATUS: function UPDATE_LOADING_STATUS(state, payload) {
      state.isLoading = payload.isLoading;
    },
    SET_DEBUG: function SET_DEBUG(state, debug) {
      state.isDebug = debug;
    },
    SET_LANGUAGE: function SET_LANGUAGE(state, language) {
      state.language = language;
      js_cookie_default.a.set('language', language);
    },
    INCR_SMS_COUNT: function INCR_SMS_COUNT(state) {
      state.smsCount += 1;
      Object(storage["q" /* setSmsCount */])(state.smsCount);
    },
    SET_OFFSET_HEIGHT: function SET_OFFSET_HEIGHT(state) {
      state.offsetHeight = document.body.offsetHeight;
    }
  },
  actions: {
    SetWxSignUrl: function SetWxSignUrl(_ref, url) {
      var commit = _ref.commit;

      commit('SET_WXSIGN_URL', url);
    },
    SetDebug: function SetDebug(_ref2, debug) {
      var commit = _ref2.commit;

      commit('SET_DEBUG', debug);
    }
  }
};

/* harmony default export */ var modules_env = (env);
// CONCATENATED MODULE: ./src/store/modules/scroll.js
var scroll_scroll = {
  state: {
    scroll: {}
  },
  mutations: {
    SET_ROUTE_SCROLL: function SET_ROUTE_SCROLL(state, scroll) {
      state.scroll[scroll.routeName] = scroll.scrollTop;
    }
  },
  actions: {
    SetRouteScroll: function SetRouteScroll(_ref, scroll) {
      var commit = _ref.commit;

      commit('SET_ROUTE_SCROLL', scroll);
    }
  }
};
/* harmony default export */ var modules_scroll = (scroll_scroll);
// CONCATENATED MODULE: ./src/store/getters.js
var getters = {
  token: function token(state) {
    return state.user.token;
  },
  user: function user(state) {
    return state.user.user;
  },
  isMacOS: function isMacOS(state) {
    return state.env.isMacOS;
  },
  isAndroid: function isAndroid(state) {
    return state.env.isAndroid;
  },
  isWX: function isWX(state) {
    return state.env.isWX;
  },
  isMobile: function isMobile(state) {
    return state.env.isMobile;
  },
  isMiniProgram: function isMiniProgram(state) {
    return state.env.isMiniProgram;
  },
  wxSignUrl: function wxSignUrl(state) {
    return state.env.wxSignUrl;
  },
  isLoading: function isLoading(state) {
    return state.env.isLoading;
  },
  isDebug: function isDebug(state) {
    return state.env.isDebug;
  },
  surveyCode: function surveyCode(state) {
    return state.user.surveyCode;
  },
  popupSetting: function popupSetting(state) {
    return state.user.popupSetting;
  },
  showPopup: function showPopup(state) {
    return state.user.showPopup;
  },
  tokenExpired: function tokenExpired(state) {
    return state.env.isWX ? 7 : 0.33;
  },
  language: function language(state) {
    return state.env.language;
  },
  smsCount: function smsCount(state) {
    return state.env.smsCount;
  },
  scroll: function scroll(state) {
    return state.scroll.scroll;
  },
  offsetWidth: function offsetWidth(state) {
    return state.env.offsetWidth;
  },
  offsetHeight: function offsetHeight(state) {
    return state.env.offsetHeight;
  }
};
/* harmony default export */ var store_getters = (getters);
// CONCATENATED MODULE: ./src/store/index.js








vue_esm["default"].use(vuex_esm["a" /* default */]);

var store = new vuex_esm["a" /* default */].Store({
  modules: {
    user: modules_user,
    env: modules_env,
    scroll: modules_scroll
  },
  getters: store_getters
});

/* harmony default export */ var src_store = __webpack_exports__["a"] = (store);

/***/ }),

/***/ "JvV8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LWON":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Liau":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M5Ib":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/babel-polyfill/lib/index.js
var lib = __webpack_require__("j1ja");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/fastclick/lib/fastclick.js
var fastclick = __webpack_require__("v5o6");
var fastclick_default = /*#__PURE__*/__webpack_require__.n(fastclick);

// EXTERNAL MODULE: ./src/router/index.js + 38 modules
var router = __webpack_require__("YaEn");

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/vconsole/dist/vconsole.min.js
var vconsole_min = __webpack_require__("Lw6n");
var vconsole_min_default = /*#__PURE__*/__webpack_require__.n(vconsole_min);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AppContainer.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var AppContainer = ({
  name: 'AppContainer',
  props: {
    'bodyPaddingTop': {
      type: String
    },
    'bodyPaddingBottom': {
      type: String
    }
  },
  data: function data() {
    return {};
  },

  methods: {
    refresh: function refresh() {
      location.reload();
    },
    scrollTo: function scrollTo(top) {
      this.$refs.viewBoxBody.scrollTop = top;
    },
    getScrollTop: function getScrollTop() {
      return this.$refs.viewBoxBody.scrollTop;
    },
    getScrollBody: function getScrollBody() {
      return this.$refs.viewBoxBody;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AppContainer.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_AppContainer = ({
  name: 'AppContainer',
  props: {
    'bodyPaddingTop': {
      type: String
    },
    'bodyPaddingBottom': {
      type: String
    }
  },
  data: function data() {
    return {};
  },

  methods: {
    refresh: function refresh() {
      location.reload();
    },
    scrollTo: function scrollTo(top) {
      this.$refs.viewBoxBody.scrollTop = top;
    },
    getScrollTop: function getScrollTop() {
      return this.$refs.viewBoxBody.scrollTop;
    },
    getScrollBody: function getScrollBody() {
      return this.$refs.viewBoxBody;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78012dea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppContainer.vue
var AppContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container"},[_vm._t("header"),_vm._v(" "),_c('div',{ref:"viewBoxBody",staticClass:"app-container__panel vux-fix-safari-overflow-scrolling",style:({paddingTop: _vm.bodyPaddingTop, paddingBottom: _vm.bodyPaddingBottom}),attrs:{"id":"vux_view_box_body"}},[_vm._t("default")],2),_vm._v(" "),_vm._t("bottom")],2)}
var staticRenderFns = []
var esExports = { render: AppContainer_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_AppContainer = (esExports);
// CONCATENATED MODULE: ./src/components/AppContainer.vue
function injectStyle (ssrContext) {
  __webpack_require__("hdOo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_AppContainer,
  selectortype_template_index_0_src_components_AppContainer,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_AppContainer = (Component.exports);

// EXTERNAL MODULE: ./src/api/my.js
var my = __webpack_require__("3VVt");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var App = ({
  name: 'app',
  components: { AppContainer: src_components_AppContainer },
  data: function data() {
    return {
      console: null,
      popupViewList: [],
      popupObj: null,
      intervalSecond: 0,
      showSubscribeNotice: false
    };
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['isLoading', 'isDebug', 'user', 'showPopup', 'popupSetting', 'scroll']), {
    currentRouter: function currentRouter() {
      return this.$route.name;
    },
    key: function key() {
      return this.$route.fullPath;
    }
  }),
  watch: {
    isDebug: function isDebug() {
      if (this.isDebug) {
        this.console = new vconsole_min_default.a();
      } else {
        this.console.destroy();
      }
    },
    $route: function $route(to, from) {
      if (to.query && to.query.mode && to.query.mode === 'debugab') {
        this.$store.dispatch('SetDebug', true);
      } else if (to.query && to.query.mode && to.query.mode === 'normal') {
        this.$store.dispatch('SetDebug', false);
      }
      if (from.meta.keepAlive) {
        this.$store.dispatch('SetRouteScroll', { routeName: from.name, scrollTop: this.$refs.viewBox.getScrollTop() });
      }
      var _this = this;
      if (to.meta.keepAlive && to.meta.isBack) {
        setTimeout(function () {
          if (_this.scroll[to.name]) {
            _this.$refs.viewBox.scrollTo(_this.scroll[to.name]);
          }
        });
      }
    },

    popupSetting: {
      handler: function handler(val) {
        this.popupObj = this.popupSetting;
      },

      deep: true,
      immediate: true
    },
    showPopup: function showPopup() {
      if (this.showPopup) {
        this.intervalSecond = this.popupObj.interval;
        var _this = this;
        if (this.intervalSecond > 0) {
          var interval = window.setInterval(function () {
            _this.intervalSecond -= 1;
            if (_this.intervalSecond === 0) {
              clearInterval(interval);
            }
          }, 1000);
        }
      }
    },

    user: {
      handler: function handler() {
        this.checkUserSubscribeNotice();
      },

      immediate: true,
      deep: true
    }
  },
  mounted: function mounted() {
    // this.console = new VConsole()
    this.popupObj = this.popupSetting;
    this.$store.commit('SET_OFFSET_HEIGHT');
  },

  methods: {
    checkUserSubscribeNotice: function checkUserSubscribeNotice() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.showSubscribeNotice = _this2.user ? !!_this2.user.subscribe_notice : false;

                if (!_this2.showSubscribeNotice) {
                  _context.next = 4;
                  break;
                }

                _context.next = 4;
                return Object(my["l" /* noticeMySubscribe */])();

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    onClosePopup: function onClosePopup() {
      this.$store.dispatch('AddPopupViewList', this.popupSetting.image);
      this.$store.commit('SET_SHOW_POPUP', false);
    },
    onClickImage: function onClickImage() {
      this.onClosePopup();
      location.href = this.popupObj.url;
    },
    handleCloseNotice: function handleCloseNotice() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.showSubscribeNotice = false;
                _context2.next = 3;
                return _this3.$store.dispatch('GetUserInfo');

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var selectortype_script_index_0_src_App = ({
  name: 'app',
  components: { AppContainer: src_components_AppContainer },
  data: function data() {
    return {
      console: null,
      popupViewList: [],
      popupObj: null,
      intervalSecond: 0,
      showSubscribeNotice: false
    };
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['isLoading', 'isDebug', 'user', 'showPopup', 'popupSetting', 'scroll']), {
    currentRouter: function currentRouter() {
      return this.$route.name;
    },
    key: function key() {
      return this.$route.fullPath;
    }
  }),
  watch: {
    isDebug: function isDebug() {
      if (this.isDebug) {
        this.console = new vconsole_min_default.a();
      } else {
        this.console.destroy();
      }
    },
    $route: function $route(to, from) {
      if (to.query && to.query.mode && to.query.mode === 'debugab') {
        this.$store.dispatch('SetDebug', true);
      } else if (to.query && to.query.mode && to.query.mode === 'normal') {
        this.$store.dispatch('SetDebug', false);
      }
      if (from.meta.keepAlive) {
        this.$store.dispatch('SetRouteScroll', { routeName: from.name, scrollTop: this.$refs.viewBox.getScrollTop() });
      }
      var _this = this;
      if (to.meta.keepAlive && to.meta.isBack) {
        setTimeout(function () {
          if (_this.scroll[to.name]) {
            _this.$refs.viewBox.scrollTo(_this.scroll[to.name]);
          }
        });
      }
    },

    popupSetting: {
      handler: function handler(val) {
        this.popupObj = this.popupSetting;
      },

      deep: true,
      immediate: true
    },
    showPopup: function showPopup() {
      if (this.showPopup) {
        this.intervalSecond = this.popupObj.interval;
        var _this = this;
        if (this.intervalSecond > 0) {
          var interval = window.setInterval(function () {
            _this.intervalSecond -= 1;
            if (_this.intervalSecond === 0) {
              clearInterval(interval);
            }
          }, 1000);
        }
      }
    },

    user: {
      handler: function handler() {
        this.checkUserSubscribeNotice();
      },

      immediate: true,
      deep: true
    }
  },
  mounted: function mounted() {
    // this.console = new VConsole()
    this.popupObj = this.popupSetting;
    this.$store.commit('SET_OFFSET_HEIGHT');
  },

  methods: {
    checkUserSubscribeNotice: function checkUserSubscribeNotice() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.showSubscribeNotice = _this2.user ? !!_this2.user.subscribe_notice : false;

                if (!_this2.showSubscribeNotice) {
                  _context.next = 4;
                  break;
                }

                _context.next = 4;
                return Object(my["l" /* noticeMySubscribe */])();

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    onClosePopup: function onClosePopup() {
      this.$store.dispatch('AddPopupViewList', this.popupSetting.image);
      this.$store.commit('SET_SHOW_POPUP', false);
    },
    onClickImage: function onClickImage() {
      this.onClosePopup();
      location.href = this.popupObj.url;
    },
    handleCloseNotice: function handleCloseNotice() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.showSubscribeNotice = false;
                _context2.next = 3;
                return _this3.$store.dispatch('GetUserInfo');

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d60f050","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.currentRouter === 'ActivityDetail' ? 'theme-black' : 'theme-grey',attrs:{"id":"app"}},[_c('app-container',{ref:"viewBox",staticClass:"viewbox",attrs:{"body-padding-top":['SignDetail', 'MeetingSign', 'ActivityDetail', 'SurveyBefore', 'SurveyDetail', 'LuckyDetail', 'LibraryDetail', 'LiveDetail', 'LivePreview', 'LiveApply', 'SignView', 'MeetingSignRecord'].includes(_vm.currentRouter) ? '' : '45px'}},[_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view',{key:_vm.key}):_vm._e()],1),_vm._v(" "),(!_vm.$route.meta.keepAlive)?_c('router-view',{key:_vm.key}):_vm._e()],1),_vm._v(" "),_c('loading',{model:{value:(_vm.isLoading),callback:function ($$v) {_vm.isLoading=$$v},expression:"isLoading"}}),_vm._v(" "),(_vm.user && _vm.user.subscribe_notice)?_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('x-dialog',{attrs:{"hide-on-blur":"","dialog-style":{'max-width': '90%', width: '90%'}},model:{value:(_vm.showSubscribeNotice),callback:function ($$v) {_vm.showSubscribeNotice=$$v},expression:"showSubscribeNotice"}},[_c('div',{staticClass:"padding-10"},[_c('div',{staticClass:"lin-flex lin-flex-right"},[_c('svg',{staticClass:"vux-x-icon vux-x-icon-ios-close-empty",staticStyle:{"fill":"#000000"},attrs:{"type":"ios-close-empty","size":"24","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 512 512"},on:{"click":_vm.handleCloseNotice}},[_c('path',{staticClass:"st0",attrs:{"d":"M340.2 160l-84.4 84.3-84-83.9-11.8 11.8 84 83.8-84 83.9 11.8 11.7 84-83.8 84.4 84.2 11.8-11.7-84.4-84.3 84.4-84.2z"}})])]),_vm._v(" "),_c('h3',[_vm._v("温馨提示")]),_vm._v(" "),_c('div',{staticClass:"lin-flex padding-top-5",staticStyle:{"text-align":"left","font-size":"16px"}},[_vm._v("\n                  关注艾邦360微信公众号，底部菜单有您加入通讯录的入口，方便下次查找。同时有人跟您交换名片会收到微信推送。\n        ")]),_vm._v(" "),_c('img',{staticStyle:{"width":"200px","height":"auto"},attrs:{"src":__webpack_require__("6ylN"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"padding-10"},[_c('h3',{staticClass:"bold primary margin-bottom-10"},[_vm._v("请长按二维码关注公众号")]),_vm._v(" "),_c('x-button',{attrs:{"type":"primary","plain":""},nativeOn:{"click":function($event){return _vm.handleCloseNotice.apply(null, arguments)}}},[_vm._v("点击关闭")])],1)])])],1):_vm._e(),_vm._v(" "),(_vm.popupObj)?_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('x-dialog',{attrs:{"hide-on-blur":"","dialog-style":{'max-width': '100%', width: '100%', height: '100%', 'background-color': 'transparent', 'display': 'flex', 'justify-content': 'center', 'align-items': 'center'}},model:{value:(_vm.showPopup),callback:function ($$v) {_vm.showPopup=$$v},expression:"showPopup"}},[_c('div',{staticClass:"lin-flex-v lin-flex-center lin-flex-v-center"},[_c('div',{staticStyle:{"margin":"0 0 10px 0","text-align":"right","height":"24px","width":"100%"}},[(_vm.intervalSecond)?[_c('span',{staticStyle:{"border":"1px solid #FFFFFF","border-radius":"10px","color":"#FFFFFF","padding":"2px 10px","margin-bottom":"5px"}},[_vm._v("\n                倒计时"+_vm._s(_vm.intervalSecond)+"秒\n            ")])]:[_c('svg',{staticClass:"vux-x-icon vux-x-icon-ios-close-outline",staticStyle:{"cursor":"pointer","fill":"#fff"},attrs:{"type":"ios-close-outline","size":"24","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 512 512"},on:{"click":_vm.onClosePopup}},[_c('path',{staticClass:"st0",attrs:{"d":"M403.1 108.9c-81.2-81.2-212.9-81.2-294.2 0s-81.2 212.9 0 294.2c81.2 81.2 212.9 81.2 294.2 0s81.2-213 0-294.2zm-12.3 281.9c-74.3 74.3-195.3 74.3-269.6 0-74.3-74.3-74.3-195.3 0-269.6s195.3-74.3 269.6 0c74.4 74.3 74.4 195.3 0 269.6z"}}),_c('path',{staticClass:"st0",attrs:{"d":"M340.2 160l-84.4 84.2-84-83.8-11.8 11.8 84 83.8-84 83.8 11.8 11.8 84-83.8 84.4 84.2 11.8-11.8-84.4-84.2 84.4-84.2z"}})])]],2),_vm._v(" "),_c('div',{staticStyle:{"width":"90%","margin-bottom":"10%","position":"relative"}},[_c('img',{staticStyle:{"width":"100%","text-align":"center","height":"auto","max-height":"550px","object-fit":"contain","border-radius":"10px 10px 10px 10px"},attrs:{"src":_vm.popupObj.image},on:{"click":_vm.onClickImage}})])])])],1):_vm._e()],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("t7qc")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  selectortype_script_index_0_src_App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-touch/dist/vue-touch.js
var vue_touch = __webpack_require__("I0MY");
var vue_touch_default = /*#__PURE__*/__webpack_require__.n(vue_touch);

// EXTERNAL MODULE: ./node_modules/vue-infinite-loading/dist/vue-infinite-loading.js
var vue_infinite_loading = __webpack_require__("qK+J");
var vue_infinite_loading_default = /*#__PURE__*/__webpack_require__.n(vue_infinite_loading);

// EXTERNAL MODULE: ./src/store/index.js + 5 modules
var store = __webpack_require__("IcnI");

// EXTERNAL MODULE: ./src/utils/global.js
var global = __webpack_require__("BfUi");

// EXTERNAL MODULE: ./src/utils/auth.js
var auth = __webpack_require__("TIfe");

// EXTERNAL MODULE: ./src/utils/cookie.js
var cookie = __webpack_require__("iPXC");

// EXTERNAL MODULE: ./src/utils/base.js
var base = __webpack_require__("aFVK");

// CONCATENATED MODULE: ./src/permission.js



var permission__this = this;

var handleToLogin1 = function () {
  var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(to, from, next) {
    var wxFlag, rsp, redirectUri;
    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!to.query.code) {
              _context.next = 16;
              break;
            }

            wxFlag = store["a" /* default */].getters.isWX ? '1' : '0';
            _context.prev = 2;
            _context.next = 5;
            return store["a" /* default */].dispatch('GetWxUserInfo', { 'code': to.query.code, 'wx': wxFlag });

          case 5:
            rsp = _context.sent;

            if (rsp.message === 'ok') {
              next('/login1?back=' + to.query.back);
            } else {
              Object(cookie["c" /* delWxCode */])();
              next('/login1?type=sms&back=' + to.query.back);
            }
            _context.next = 14;
            break;

          case 9:
            _context.prev = 9;
            _context.t0 = _context['catch'](2);

            this.$vux.toast.text('通过微信code获取token出错', 'top');
            Object(cookie["c" /* delWxCode */])();
            next('/login1?type=sms&back=' + to.query.back);

          case 14:
            _context.next = 17;
            break;

          case 16:
            if (Object(cookie["k" /* getWxCode */])()) {
              next();
            } else {
              if (!store["a" /* default */].getters.isWX || to.query.type && to.query.type === 'sms') {
                next();
              } else {
                redirectUri = global["a" /* default */].domain + to.fullPath;

                if (store["a" /* default */].getters.isWX) {
                  window.location.href = clientAuthUri + ('?appid=' + global["a" /* default */].appid + '&redirect_uri=' + redirectUri + '&response_type=' + responseType + '&scope=' + scope + '#wechat_redirect');
                } else {
                  window.location.href = webAuthPageUri + ('?appid=' + global["a" /* default */].openid + '&redirect_uri=' + redirectUri + '&response_type=' + responseType + '&scope=snsapi_login#wechat_redirect');
                }
              }
            }

          case 17:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[2, 9]]);
  }));

  return function handleToLogin1(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var handleToLogin = function () {
  var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2(to, from, next) {
    var wxFlag, rsp, redirectUri;
    return regenerator_default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            console.log('handleToLogin');

            if (!to.query.code) {
              _context2.next = 17;
              break;
            }

            wxFlag = store["a" /* default */].getters.isWX ? '1' : '0';
            _context2.prev = 3;
            _context2.next = 6;
            return store["a" /* default */].dispatch('GetWxUserInfo', { 'code': to.query.code, 'wx': wxFlag });

          case 6:
            rsp = _context2.sent;

            if (rsp.message === 'ok') {
              next('/login?back=' + encodeURIComponent(to.query.back));
            } else {
              Object(cookie["c" /* delWxCode */])();
              next('/login?type=sms&back=' + encodeURIComponent(to.query.back));
            }
            _context2.next = 15;
            break;

          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2['catch'](3);

            this.$vux.toast.text('通过微信code获取token出错', 'top');
            Object(cookie["c" /* delWxCode */])();
            next('/login?type=sms&back=' + encodeURIComponent(to.query.back));

          case 15:
            _context2.next = 18;
            break;

          case 17:
            if (Object(cookie["k" /* getWxCode */])()) {
              next();
            } else {
              if (!store["a" /* default */].getters.isWX) {
                next();
              } else {
                redirectUri = global["a" /* default */].domain + to.fullPath;

                if (store["a" /* default */].getters.isWX && (!to.query.type || to.query.type !== 'sms')) {
                  window.location.href = clientAuthUri + ('?appid=' + global["a" /* default */].appid + '&redirect_uri=' + redirectUri + '&response_type=' + responseType + '&scope=' + scope + '#wechat_redirect');
                } else {
                  // next()
                  window.location.href = webAuthPageUri + ('?appid=' + global["a" /* default */].openid + '&redirect_uri=' + redirectUri + '&response_type=' + responseType + '&scope=snsapi_login#wechat_redirect');
                }
              }
            }

          case 18:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this, [[3, 10]]);
  }));

  return function handleToLogin(_x4, _x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}();





// import { setFirstPage, getFirstPage, delFirstPage } from '@/utils/cookie'




var webAuthPageUri = 'https://open.weixin.qq.com/connect/qrconnect';
var clientAuthUri = 'https://open.weixin.qq.com/connect/oauth2/authorize';

var scope = 'snsapi_userinfo';
var responseType = 'code';

var whiteList = ['Redirect', 'NewsIndex', 'NewsDetail', 'MeetingIndex', 'MeetingDetail', 'FormDetail', 'TopicIndex', 'TopicDetail', 'ExpoIndex', 'ExpoDetail', 'EpDetail', 'ExpoVote', 'ExpoVoteSuccess', 'SearchIndex', 'MyIndex', 'TopicTag', 'MyAbout', '404', '403', 'Register', 'Register1', 'WxNotice', 'SurveyBefore', 'SurveyDetail', 'SurveySuccess', 'AdminDownloadDetail', 'ContactsDetail', 'ActivityDetail', 'UserDetail', 'VideoIndex', 'VideoDetail', 'LuckyDetail', 'LibraryDownload', 'CardDetail', 'CardDetailKey', 'Term', 'LibraryDetail', 'LivePreview', 'LiveDetail', 'Logout', 'MeetingSignRecord', 'LinkDetail'];

function redirectToLogin(to, from, next) {
  // console.log(addOauthPath(to.path, to.query))
  // console.log(encodeURIComponent(addOauthPath(to.path, to.query)))
  var loginPath = '/login?back=' + encodeURIComponent(Object(base["a" /* addOauthPath */])(to.path, to.query));
  if (to.name === 'SignDetail') {
    loginPath = '/login1?back=' + encodeURIComponent(Object(base["a" /* addOauthPath */])(to.path, to.query));
  }
  // console.log('loginPath:', loginPath)
  vue_esm["default"].$vux.toast.show({
    text: '请先登录<br/>(系统自动跳转中)',
    type: 'warn',
    width: '9em',
    time: 500,
    onHide: function onHide() {
      next(loginPath);
    }
  });
}

function handleConfirmMobile(to, from, next) {
  if (to.name === 'ConfirmMobile' || to.name === 'MyMobileEdit') {
    next();
  } else {
    next('/confirm_mobile?back=' + to.fullPath);
  }
}

router["a" /* default */].beforeEach(function () {
  var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(to, from, next) {
    return regenerator_default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            store["a" /* default */].commit('UPDATE_LOADING_STATUS', { isLoading: true });

            if (!(store["a" /* default */].getters.popupSetting === -1)) {
              _context3.next = 4;
              break;
            }

            _context3.next = 4;
            return store["a" /* default */].dispatch('GetSetting');

          case 4:

            // if (!store.getters.wxSignUrl) {
            //   store.dispatch('SetWxSignUrl', to.fullPath)
            // }

            // 百度统计使用
            if (to.path) window._hmt.push(['_trackPageview', to.fullPath]);

            if (to.name === 'Login' && whiteList.includes(from.name)) {
              Object(cookie["q" /* setRegSource */])(from.fullPath);
            }

            if (to.name === 'SurveyDetail') {
              if (Object(auth["a" /* getToken */])() || Object(cookie["i" /* getSurveyCode */])()) {
                next();
              } else {
                next();
              }
            } else {
              // 没有token，无登录状态
              if (!Object(auth["a" /* getToken */])() || Object(auth["a" /* getToken */])() === undefined) {
                if (to.name === 'Login') {
                  handleToLogin(to, from, next);
                } else if (to.name === 'Login1') {
                  handleToLogin1(to, from, next);
                } else if (whiteList.indexOf(to.name) !== -1) {
                  next();
                } else {
                  redirectToLogin(to, from, next);
                }
              } else {
                // 有token的情况
                if (store["a" /* default */].getters.user) {
                  // 有user info的情况
                  if (to.name === 'Login') {
                    next(to.query.back || '/');
                  } else if (to.name === 'Login1') {
                    next(to.query.back || '/');
                  } else if (!['Logout', '404', '403'].includes(to.name) && store["a" /* default */].getters.user.sms_verify_flag === 1) {
                    handleConfirmMobile(to, from, next);
                  } else {
                    next();
                  }
                } else {
                  // 有token，无user info的情况
                  store["a" /* default */].dispatch('GetUserInfo').then(function (res) {
                    if (res.data.message === 'ok') {
                      if (!['Logout', '404', '403'].includes(to.name) && store["a" /* default */].getters.user.sms_verify_flag === 1) {
                        handleConfirmMobile(to, from, next);
                      } else {
                        if (to.name === 'Login') {
                          var backUrl = decodeURIComponent(to.query.back);
                          if (backUrl.startsWith('https://www.aibang.com')) {
                            backUrl += (backUrl.split('?')[1] ? '&' : '?') + 'ab360=' + store["a" /* default */].getters.token;
                            location.href = backUrl;
                          } else {
                            next(decodeURIComponent(to.query.back) || '/');
                          }
                        } else if (to.name === 'Login1') {
                          next(decodeURIComponent(to.query.back) || '/');
                        } else {
                          next();
                        }
                      }
                    } else {
                      if (whiteList.indexOf(to.name) !== -1) {
                        Object(auth["b" /* removeToken */])();
                        next();
                      } else {
                        store["a" /* default */].dispatch('FedLogOut').then(function () {
                          redirectToLogin(to, from, next);
                        }).catch(function (e) {
                          console.log(e);
                          Object(auth["b" /* removeToken */])();
                          redirectToLogin(to, from, next);
                        });
                      }
                    }
                  }).catch(function (e) {
                    console.log(e);
                    if (whiteList.indexOf(to.name) !== -1) {
                      if (e.response.status === 401) {
                        Object(auth["b" /* removeToken */])();
                      }
                      next();
                    } else {
                      if (e.response.status === 401) {
                        store["a" /* default */].dispatch('FedLogOut').then(function () {
                          redirectToLogin(to, from, next);
                        }).catch(function (e) {
                          console.log(e);
                          Object(auth["b" /* removeToken */])();
                          redirectToLogin(to, from, next);
                        });
                      } else {
                        Object(auth["b" /* removeToken */])();
                        redirectToLogin(to, from, next);
                      }
                    }
                  });
                }
              }
            }

          case 7:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, permission__this);
  }));

  return function (_x7, _x8, _x9) {
    return _ref3.apply(this, arguments);
  };
}());

router["a" /* default */].afterEach(function (to, from) {
  store["a" /* default */].commit('UPDATE_LOADING_STATUS', { isLoading: false });
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/actionsheet/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var actionsheet = ({
  name: 'actionsheet',
  mounted: function mounted() {
    var _this = this;

    this.hasHeaderSlot = !!this.$slots.header;
    this.$nextTick(function () {
      _this.$tabbar = document.querySelector('.weui-tabbar');
      _this.$refs.iOSMenu && _this.$refs.iOSMenu.addEventListener('transitionend', _this.onTransitionEnd);
    });
  },

  props: {
    value: Boolean,
    showCancel: Boolean,
    cancelText: String,
    theme: {
      type: String,
      default: 'ios'
    },
    menus: {
      type: [Object, Array],
      default: function _default() {
        return {};
      }
    },
    closeOnClickingMask: {
      type: Boolean,
      default: true
    },
    closeOnClickingMenu: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      hasHeaderSlot: false,
      show: false
    };
  },

  methods: {
    onTransitionEnd: function onTransitionEnd() {
      this.$emit(this.show ? 'on-after-show' : 'on-after-hide');
    },
    onMenuClick: function onMenuClick(text, key) {
      if (typeof text === 'string') {
        this.emitEvent('on-click-menu', key, text);
      } else {
        if (text.type !== 'disabled' && text.type !== 'info') {
          if (text.value || text.value === 0) {
            this.emitEvent('on-click-menu', text.value, text);
          } else {
            this.emitEvent('on-click-menu', '', text);
            this.show = false;
          }
        }
      }
    },
    onClickingMask: function onClickingMask() {
      this.$emit('on-click-mask');
      this.closeOnClickingMask && (this.show = false);
    },
    emitEvent: function emitEvent(event, menu, item) {
      if (event === 'on-click-menu' && !/.noop/.test(menu)) {
        var _item = item;
        if ((typeof _item === 'undefined' ? 'undefined' : typeof_default()(_item)) === 'object') {
          _item = JSON.parse(stringify_default()(_item));
        }
        this.$emit(event, menu, _item);
        this.$emit(event + '-' + menu);
        this.closeOnClickingMenu && (this.show = false);
      }
    },
    fixIos: function fixIos(zIndex) {
      if (this.$el.parentNode && this.$el.parentNode.className.indexOf('v-transfer-dom') !== -1) {
        return;
      }
      if (this.$tabbar && /iphone/i.test(navigator.userAgent)) {
        this.$tabbar.style.zIndex = zIndex;
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this2 = this;

      this.$emit('input', val);
      if (val) {
        this.fixIos(-1);
      } else {
        setTimeout(function () {
          _this2.fixIos(100);
        }, 200);
      }
    },

    value: {
      handler: function handler(val) {
        this.show = val;
      },
      immediate: true
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.fixIos(100);
    this.$refs.iOSMenu && this.$refs.iOSMenu.removeEventListener('transitionend', this.onTransitionEnd);
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/actionsheet/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_actionsheet = ({
  name: 'actionsheet',
  mounted: function mounted() {
    var _this = this;

    this.hasHeaderSlot = !!this.$slots.header;
    this.$nextTick(function () {
      _this.$tabbar = document.querySelector('.weui-tabbar');
      _this.$refs.iOSMenu && _this.$refs.iOSMenu.addEventListener('transitionend', _this.onTransitionEnd);
    });
  },

  props: {
    value: Boolean,
    showCancel: Boolean,
    cancelText: String,
    theme: {
      type: String,
      default: 'ios'
    },
    menus: {
      type: [Object, Array],
      default: function _default() {
        return {};
      }
    },
    closeOnClickingMask: {
      type: Boolean,
      default: true
    },
    closeOnClickingMenu: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      hasHeaderSlot: false,
      show: false
    };
  },

  methods: {
    onTransitionEnd: function onTransitionEnd() {
      this.$emit(this.show ? 'on-after-show' : 'on-after-hide');
    },
    onMenuClick: function onMenuClick(text, key) {
      if (typeof text === 'string') {
        this.emitEvent('on-click-menu', key, text);
      } else {
        if (text.type !== 'disabled' && text.type !== 'info') {
          if (text.value || text.value === 0) {
            this.emitEvent('on-click-menu', text.value, text);
          } else {
            this.emitEvent('on-click-menu', '', text);
            this.show = false;
          }
        }
      }
    },
    onClickingMask: function onClickingMask() {
      this.$emit('on-click-mask');
      this.closeOnClickingMask && (this.show = false);
    },
    emitEvent: function emitEvent(event, menu, item) {
      if (event === 'on-click-menu' && !/.noop/.test(menu)) {
        var _item = item;
        if ((typeof _item === 'undefined' ? 'undefined' : typeof_default()(_item)) === 'object') {
          _item = JSON.parse(stringify_default()(_item));
        }
        this.$emit(event, menu, _item);
        this.$emit(event + '-' + menu);
        this.closeOnClickingMenu && (this.show = false);
      }
    },
    fixIos: function fixIos(zIndex) {
      if (this.$el.parentNode && this.$el.parentNode.className.indexOf('v-transfer-dom') !== -1) {
        return;
      }
      if (this.$tabbar && /iphone/i.test(navigator.userAgent)) {
        this.$tabbar.style.zIndex = zIndex;
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this2 = this;

      this.$emit('input', val);
      if (val) {
        this.fixIos(-1);
      } else {
        setTimeout(function () {
          _this2.fixIos(100);
        }, 200);
      }
    },

    value: {
      handler: function handler(val) {
        this.show = val;
      },
      immediate: true
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.fixIos(100);
    this.$refs.iOSMenu && this.$refs.iOSMenu.removeEventListener('transitionend', this.onTransitionEnd);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-053decbd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/actionsheet/index.vue
var actionsheet_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-actionsheet"},[_c('transition',{attrs:{"name":"vux-actionsheet-mask"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-mask weui-mask_transparent",on:{"click":_vm.onClickingMask}})]),_vm._v(" "),(_vm.theme === 'android')?_c('div',{staticClass:"weui-skin_android"},[_c('transition',{attrs:{"name":"vux-android-actionsheet"},on:{"after-enter":function($event){return _vm.$emit('on-after-show')},"after-leave":function($event){return _vm.$emit('on-after-hide')}}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-actionsheet"},[_c('div',{staticClass:"weui-actionsheet__menu"},_vm._l((_vm.menus),function(text,key){return _c('div',{staticClass:"weui-actionsheet__cell",domProps:{"innerHTML":_vm._s(text.label || text)},on:{"click":function($event){return _vm.onMenuClick(text, key)}}})}),0)])])],1):_c('div',{ref:"iOSMenu",staticClass:"weui-actionsheet",class:{'weui-actionsheet_toggle': _vm.show}},[_c('div',{staticClass:"weui-actionsheet__menu"},[(_vm.hasHeaderSlot)?_c('div',{staticClass:"weui-actionsheet__cell"},[_vm._t("header")],2):_vm._e(),_vm._v(" "),_vm._l((_vm.menus),function(text,key){return _c('div',{staticClass:"weui-actionsheet__cell",class:("vux-actionsheet-menu-" + (text.type || 'default')),domProps:{"innerHTML":_vm._s(text.label || text)},on:{"click":function($event){return _vm.onMenuClick(text, key)}}})})],2),_vm._v(" "),(_vm.showCancel)?_c('div',{staticClass:"weui-actionsheet__action",on:{"click":function($event){return _vm.emitEvent('on-click-menu', 'cancel')}}},[_c('div',{staticClass:"weui-actionsheet__cell"},[_vm._v(_vm._s(_vm.cancelText || '取消'))])]):_vm._e()])],1)}
var actionsheet_staticRenderFns = []
var actionsheet_esExports = { render: actionsheet_render, staticRenderFns: actionsheet_staticRenderFns }
/* harmony default export */ var src_components_actionsheet = (actionsheet_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/actionsheet/index.vue
function actionsheet_injectStyle (ssrContext) {
  __webpack_require__("WOhk")
}
var actionsheet_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var actionsheet___vue_template_functional__ = false
/* styles */
var actionsheet___vue_styles__ = actionsheet_injectStyle
/* scopeId */
var actionsheet___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var actionsheet___vue_module_identifier__ = null
var actionsheet_Component = actionsheet_normalizeComponent(
  components_actionsheet,
  src_components_actionsheet,
  actionsheet___vue_template_functional__,
  actionsheet___vue_styles__,
  actionsheet___vue_scopeId__,
  actionsheet___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_actionsheet = (actionsheet_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/alert/index.vue + 3 modules
var components_alert = __webpack_require__("mzja");

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/multi-items.js
var multi_items = __webpack_require__("piuB");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tabbar/tabbar.vue
//
//
//
//
//
//



/* harmony default export */ var tabbar = ({
  mounted: function mounted() {
    var _this = this;

    if (false) {
      this.$nextTick(function () {
        var $el = _this.$el;
        var position = window.getComputedStyle($el).position;
        if (position === 'fixed') {
          return;
        } else if (position === 'absolute') {
          if (document.documentElement.offsetHeight !== window.innerHeight) {
            console.warn('[VUX warn] tabbar 定位默认为 absolute，如果你没有使用 100% 布局(view-box)，需要手动设置 style position 为 fixed');
          }
        }
      });
    }
  },

  name: 'tabbar',
  mixins: [multi_items["b" /* parentMixin */]],
  props: {
    iconClass: String
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tabbar/tabbar.vue
//
//
//
//
//
//



/* harmony default export */ var tabbar_tabbar = ({
  mounted: function mounted() {
    var _this = this;

    if (false) {
      this.$nextTick(function () {
        var $el = _this.$el;
        var position = window.getComputedStyle($el).position;
        if (position === 'fixed') {
          return;
        } else if (position === 'absolute') {
          if (document.documentElement.offsetHeight !== window.innerHeight) {
            console.warn('[VUX warn] tabbar 定位默认为 absolute，如果你没有使用 100% 布局(view-box)，需要手动设置 style position 为 fixed');
          }
        }
      });
    }
  },

  name: 'tabbar',
  mixins: [multi_items["b" /* parentMixin */]],
  props: {
    iconClass: String
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e44a500","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/tabbar/tabbar.vue
var tabbar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-tabbar"},[_vm._t("default")],2)}
var tabbar_staticRenderFns = []
var tabbar_esExports = { render: tabbar_render, staticRenderFns: tabbar_staticRenderFns }
/* harmony default export */ var components_tabbar_tabbar = (tabbar_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/tabbar/tabbar.vue
function tabbar_injectStyle (ssrContext) {
  __webpack_require__("kAA/")
}
var tabbar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tabbar___vue_template_functional__ = false
/* styles */
var tabbar___vue_styles__ = tabbar_injectStyle
/* scopeId */
var tabbar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tabbar___vue_module_identifier__ = null
var tabbar_Component = tabbar_normalizeComponent(
  tabbar_tabbar,
  components_tabbar_tabbar,
  tabbar___vue_template_functional__,
  tabbar___vue_styles__,
  tabbar___vue_scopeId__,
  tabbar___vue_module_identifier__
)

/* harmony default export */ var src_components_tabbar_tabbar = (tabbar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/badge/index.vue
//
//
//
//

/* harmony default export */ var badge = ({
  name: 'badge',
  props: {
    text: [String, Number]
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/badge/index.vue
//
//
//
//

/* harmony default export */ var components_badge = ({
  name: 'badge',
  props: {
    text: [String, Number]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b138ba8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/badge/index.vue
var badge_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['vux-badge', {'vux-badge-dot': typeof _vm.text === 'undefined', 'vux-badge-single': typeof _vm.text !== 'undefined' && _vm.text.toString().length === 1}],domProps:{"textContent":_vm._s(_vm.text)}})}
var badge_staticRenderFns = []
var badge_esExports = { render: badge_render, staticRenderFns: badge_staticRenderFns }
/* harmony default export */ var src_components_badge = (badge_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/badge/index.vue
function badge_injectStyle (ssrContext) {
  __webpack_require__("cJYu")
}
var badge_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var badge___vue_template_functional__ = false
/* styles */
var badge___vue_styles__ = badge_injectStyle
/* scopeId */
var badge___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var badge___vue_module_identifier__ = null
var badge_Component = badge_normalizeComponent(
  components_badge,
  src_components_badge,
  badge___vue_template_functional__,
  badge___vue_styles__,
  badge___vue_scopeId__,
  badge___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_badge = (badge_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tabbar/tabbar-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var tabbar_item = ({
  name: 'tabbar-item',
  components: {
    Badge: vux_src_components_badge
  },
  mounted: function mounted() {
    if (!this.$slots.icon) {
      this.simple = true;
    }
    if (this.$slots['icon-active']) {
      this.hasActiveIcon = true;
    }
  },

  mixins: [multi_items["a" /* childMixin */]],
  props: {
    showDot: {
      type: Boolean,
      default: false
    },
    badge: String,
    link: [String, Object],
    iconClass: String
  },
  computed: {
    isActive: function isActive() {
      return this.$parent.index === this.currentIndex;
    }
  },
  data: function data() {
    return {
      simple: false,
      hasActiveIcon: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tabbar/tabbar-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var tabbar_tabbar_item = ({
  name: 'tabbar-item',
  components: {
    Badge: vux_src_components_badge
  },
  mounted: function mounted() {
    if (!this.$slots.icon) {
      this.simple = true;
    }
    if (this.$slots['icon-active']) {
      this.hasActiveIcon = true;
    }
  },

  mixins: [multi_items["a" /* childMixin */]],
  props: {
    showDot: {
      type: Boolean,
      default: false
    },
    badge: String,
    link: [String, Object],
    iconClass: String
  },
  computed: {
    isActive: function isActive() {
      return this.$parent.index === this.currentIndex;
    }
  },
  data: function data() {
    return {
      simple: false,
      hasActiveIcon: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f54f49b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/tabbar/tabbar-item.vue
var tabbar_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"weui-tabbar__item",class:{'weui-bar__item_on': _vm.isActive, 'vux-tabbar-simple': _vm.simple},attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.onItemClick(true)}}},[(!_vm.simple)?_c('div',{staticClass:"weui-tabbar__icon",class:[_vm.iconClass || _vm.$parent.iconClass, {'vux-reddot': _vm.showDot}]},[(!_vm.simple && !(_vm.hasActiveIcon && _vm.isActive))?_vm._t("icon"):_vm._e(),_vm._v(" "),(!_vm.simple && _vm.hasActiveIcon && _vm.isActive)?_vm._t("icon-active"):_vm._e(),_vm._v(" "),(_vm.badge)?_c('sup',[_c('badge',{attrs:{"text":_vm.badge}})],1):_vm._e()],2):_vm._e(),_vm._v(" "),_c('p',{staticClass:"weui-tabbar__label"},[_vm._t("label")],2)])}
var tabbar_item_staticRenderFns = []
var tabbar_item_esExports = { render: tabbar_item_render, staticRenderFns: tabbar_item_staticRenderFns }
/* harmony default export */ var components_tabbar_tabbar_item = (tabbar_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/tabbar/tabbar-item.vue
var tabbar_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tabbar_item___vue_template_functional__ = false
/* styles */
var tabbar_item___vue_styles__ = null
/* scopeId */
var tabbar_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tabbar_item___vue_module_identifier__ = null
var tabbar_item_Component = tabbar_item_normalizeComponent(
  tabbar_tabbar_item,
  components_tabbar_tabbar_item,
  tabbar_item___vue_template_functional__,
  tabbar_item___vue_styles__,
  tabbar_item___vue_scopeId__,
  tabbar_item___vue_module_identifier__
)

/* harmony default export */ var src_components_tabbar_tabbar_item = (tabbar_item_Component.exports);

// EXTERNAL MODULE: ./node_modules/object-assign/index.js
var object_assign = __webpack_require__("BEQ0");
var object_assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_header = ({
  name: 'x-header',
  props: {
    leftOptions: Object,
    title: String,
    transition: String,
    rightOptions: {
      type: Object,
      default: function _default() {
        return {
          showMore: false
        };
      }
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots['overwrite-title']) {
      this.shouldOverWriteTitle = true;
    }
  },

  computed: {
    _leftOptions: function _leftOptions() {
      return object_assign_default()({
        showBack: true,
        preventGoBack: false
      }, this.leftOptions || {});
    }
  },
  methods: {
    onClickBack: function onClickBack() {
      if (this._leftOptions.preventGoBack) {
        this.$emit('on-click-back');
      } else {
        this.$router ? this.$router.back() : window.history.back();
      }
    }
  },
  data: function data() {
    return {
      shouldOverWriteTitle: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_header = ({
  name: 'x-header',
  props: {
    leftOptions: Object,
    title: String,
    transition: String,
    rightOptions: {
      type: Object,
      default: function _default() {
        return {
          showMore: false
        };
      }
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots['overwrite-title']) {
      this.shouldOverWriteTitle = true;
    }
  },

  computed: {
    _leftOptions: function _leftOptions() {
      return object_assign_default()({
        showBack: true,
        preventGoBack: false
      }, this.leftOptions || {});
    }
  },
  methods: {
    onClickBack: function onClickBack() {
      if (this._leftOptions.preventGoBack) {
        this.$emit('on-click-back');
      } else {
        this.$router ? this.$router.back() : window.history.back();
      }
    }
  },
  data: function data() {
    return {
      shouldOverWriteTitle: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb223dbe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-header/index.vue
var x_header_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-header"},[_c('div',{staticClass:"vux-header-left"},[_vm._t("overwrite-left",function(){return [_c('transition',{attrs:{"name":_vm.transition}},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm._leftOptions.showBack),expression:"_leftOptions.showBack"}],staticClass:"vux-header-back",on:{"click":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"preventDefault",undefined,$event.key,undefined)){ return null; }},_vm.onClickBack]}},[_vm._v(_vm._s(typeof _vm._leftOptions.backText === 'undefined' ? '返回' : _vm._leftOptions.backText))])]),_vm._v(" "),_c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm._leftOptions.showBack),expression:"_leftOptions.showBack"}],staticClass:"left-arrow",on:{"click":_vm.onClickBack}})])]}),_vm._v(" "),_vm._t("left")],2),_vm._v(" "),(!_vm.shouldOverWriteTitle)?_c('h1',{staticClass:"vux-header-title",on:{"click":function($event){return _vm.$emit('on-click-title')}}},[_vm._t("default",function(){return [_c('transition',{attrs:{"name":_vm.transition}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.title),expression:"title"}]},[_vm._v(_vm._s(_vm.title))])])]})],2):_vm._e(),_vm._v(" "),(_vm.shouldOverWriteTitle)?_c('div',{staticClass:"vux-header-title-area"},[_vm._t("overwrite-title")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"vux-header-right"},[(_vm.rightOptions.showMore)?_c('a',{staticClass:"vux-header-more",on:{"click":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"preventDefault",undefined,$event.key,undefined)){ return null; }},function($event){return _vm.$emit('on-click-more')}]}}):_vm._e(),_vm._v(" "),_vm._t("right")],2)])}
var x_header_staticRenderFns = []
var x_header_esExports = { render: x_header_render, staticRenderFns: x_header_staticRenderFns }
/* harmony default export */ var src_components_x_header = (x_header_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-header/index.vue
function x_header_injectStyle (ssrContext) {
  __webpack_require__("owug")
}
var x_header_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_header___vue_template_functional__ = false
/* styles */
var x_header___vue_styles__ = x_header_injectStyle
/* scopeId */
var x_header___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_header___vue_module_identifier__ = null
var x_header_Component = x_header_normalizeComponent(
  components_x_header,
  src_components_x_header,
  x_header___vue_template_functional__,
  x_header___vue_styles__,
  x_header___vue_scopeId__,
  x_header___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_x_header = (x_header_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/swiper/swiper.js
var swiper = __webpack_require__("NjrX");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/router.js
var libs_router = __webpack_require__("0FxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swiper/swiper.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var swiper_swiper = ({
  name: 'swiper',
  created: function created() {
    this.index = this.value || 0;
    if (this.index) {
      this.current = this.index;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.hasTwoLoopItem();
    this.$nextTick(function () {
      if (!(_this2.list && _this2.list.length === 0)) {
        _this2.render(_this2.index);
      }
      _this2.xheight = _this2.getHeight();
      _this2.$emit('on-get-height', _this2.xheight);
    });
  },

  methods: {
    hasTwoLoopItem: function hasTwoLoopItem() {
      if (this.list.length === 2 && this.loop) {
        this.listTwoLoopItem = this.list;
      } else {
        this.listTwoLoopItem = [];
      }
    },
    clickListItem: function clickListItem(item) {
      Object(libs_router["b" /* go */])(item.url, this.$router);
      this.$emit('on-click-list-item', JSON.parse(stringify_default()(item)));
    },
    buildBackgroundUrl: function buildBackgroundUrl(item) {
      return item.fallbackImg ? 'url(' + item.img + '), url(' + item.fallbackImg + ')' : 'url(' + item.img + ')';
    },
    render: function render() {
      var _this3 = this;

      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.swiper && this.swiper.destroy();
      this.swiper = new swiper["a" /* default */]({
        container: this.$el,
        direction: this.direction,
        auto: this.auto,
        loop: this.loop,
        interval: this.interval,
        threshold: this.threshold,
        duration: this.duration,
        height: this.height || this._height,
        minMovingDistance: this.minMovingDistance,
        imgList: this.imgList
      }).on('swiped', function (prev, index) {
        _this3.current = index % _this3.length;
        _this3.index = index % _this3.length;
      });
      if (index > 0) {
        this.swiper.go(index);
      }
    },
    rerender: function rerender() {
      var _this4 = this;

      if (!this.$el || this.hasRender) {
        return;
      }
      this.hasRender = true;
      this.hasTwoLoopItem();
      this.$nextTick(function () {
        _this4.index = _this4.value || 0;
        _this4.current = _this4.value || 0;
        _this4.length = _this4.list.length || _this4.$children.length;
        _this4.destroy();
        _this4.render(_this4.value);
      });
    },
    destroy: function destroy() {
      this.hasRender = false;
      this.swiper && this.swiper.destroy();
    },
    getHeight: function getHeight() {
      var hasHeight = parseInt(this.height, 10);
      if (hasHeight) return this.height;
      if (!hasHeight) {
        if (this.aspectRatio) {
          return this.$el.offsetWidth * this.aspectRatio + 'px';
        }
        return '180px';
      }
    }
  },
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    direction: {
      type: String,
      default: 'horizontal'
    },
    showDots: {
      type: Boolean,
      default: true
    },
    showDescMask: {
      type: Boolean,
      default: true
    },
    dotsPosition: {
      type: String,
      default: 'right'
    },
    dotsClass: String,
    auto: Boolean,
    loop: Boolean,
    interval: {
      type: Number,
      default: 3000
    },
    threshold: {
      type: Number,
      default: 50
    },
    duration: {
      type: Number,
      default: 300
    },
    height: {
      type: String,
      default: 'auto'
    },
    aspectRatio: Number,
    minMovingDistance: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      hasRender: false,
      current: this.index || 0,
      xheight: 'auto',
      length: this.list.length,
      index: 0,
      listTwoLoopItem: [] // issue #1484
    };
  },

  watch: {
    auto: function auto(val) {
      if (!val) {
        this.swiper && this.swiper.stop();
      } else {
        this.swiper && this.swiper._auto();
      }
    },
    list: function list(val, oldVal) {
      if (stringify_default()(val) !== stringify_default()(oldVal)) {
        this.rerender();
      }
    },
    current: function current(currentIndex) {
      this.index = currentIndex;
      this.$emit('on-index-change', currentIndex);
    },
    index: function index(val) {
      var _this = this;
      if (val !== this.current) {
        this.$nextTick(function () {
          _this.swiper && _this.swiper.go(val);
        });
      }
      this.$emit('input', val);
    },
    value: function value(val) {
      this.index = val;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swiper/swiper.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var components_swiper_swiper = ({
  name: 'swiper',
  created: function created() {
    this.index = this.value || 0;
    if (this.index) {
      this.current = this.index;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.hasTwoLoopItem();
    this.$nextTick(function () {
      if (!(_this2.list && _this2.list.length === 0)) {
        _this2.render(_this2.index);
      }
      _this2.xheight = _this2.getHeight();
      _this2.$emit('on-get-height', _this2.xheight);
    });
  },

  methods: {
    hasTwoLoopItem: function hasTwoLoopItem() {
      if (this.list.length === 2 && this.loop) {
        this.listTwoLoopItem = this.list;
      } else {
        this.listTwoLoopItem = [];
      }
    },
    clickListItem: function clickListItem(item) {
      Object(libs_router["b" /* go */])(item.url, this.$router);
      this.$emit('on-click-list-item', JSON.parse(stringify_default()(item)));
    },
    buildBackgroundUrl: function buildBackgroundUrl(item) {
      return item.fallbackImg ? 'url(' + item.img + '), url(' + item.fallbackImg + ')' : 'url(' + item.img + ')';
    },
    render: function render() {
      var _this3 = this;

      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.swiper && this.swiper.destroy();
      this.swiper = new swiper["a" /* default */]({
        container: this.$el,
        direction: this.direction,
        auto: this.auto,
        loop: this.loop,
        interval: this.interval,
        threshold: this.threshold,
        duration: this.duration,
        height: this.height || this._height,
        minMovingDistance: this.minMovingDistance,
        imgList: this.imgList
      }).on('swiped', function (prev, index) {
        _this3.current = index % _this3.length;
        _this3.index = index % _this3.length;
      });
      if (index > 0) {
        this.swiper.go(index);
      }
    },
    rerender: function rerender() {
      var _this4 = this;

      if (!this.$el || this.hasRender) {
        return;
      }
      this.hasRender = true;
      this.hasTwoLoopItem();
      this.$nextTick(function () {
        _this4.index = _this4.value || 0;
        _this4.current = _this4.value || 0;
        _this4.length = _this4.list.length || _this4.$children.length;
        _this4.destroy();
        _this4.render(_this4.value);
      });
    },
    destroy: function destroy() {
      this.hasRender = false;
      this.swiper && this.swiper.destroy();
    },
    getHeight: function getHeight() {
      var hasHeight = parseInt(this.height, 10);
      if (hasHeight) return this.height;
      if (!hasHeight) {
        if (this.aspectRatio) {
          return this.$el.offsetWidth * this.aspectRatio + 'px';
        }
        return '180px';
      }
    }
  },
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    direction: {
      type: String,
      default: 'horizontal'
    },
    showDots: {
      type: Boolean,
      default: true
    },
    showDescMask: {
      type: Boolean,
      default: true
    },
    dotsPosition: {
      type: String,
      default: 'right'
    },
    dotsClass: String,
    auto: Boolean,
    loop: Boolean,
    interval: {
      type: Number,
      default: 3000
    },
    threshold: {
      type: Number,
      default: 50
    },
    duration: {
      type: Number,
      default: 300
    },
    height: {
      type: String,
      default: 'auto'
    },
    aspectRatio: Number,
    minMovingDistance: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      hasRender: false,
      current: this.index || 0,
      xheight: 'auto',
      length: this.list.length,
      index: 0,
      listTwoLoopItem: [] // issue #1484
    };
  },

  watch: {
    auto: function auto(val) {
      if (!val) {
        this.swiper && this.swiper.stop();
      } else {
        this.swiper && this.swiper._auto();
      }
    },
    list: function list(val, oldVal) {
      if (stringify_default()(val) !== stringify_default()(oldVal)) {
        this.rerender();
      }
    },
    current: function current(currentIndex) {
      this.index = currentIndex;
      this.$emit('on-index-change', currentIndex);
    },
    index: function index(val) {
      var _this = this;
      if (val !== this.current) {
        this.$nextTick(function () {
          _this.swiper && _this.swiper.go(val);
        });
      }
      this.$emit('input', val);
    },
    value: function value(val) {
      this.index = val;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d7406b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/swiper/swiper.vue
var swiper_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-slider"},[_c('div',{staticClass:"vux-swiper",style:({height: _vm.xheight})},[_vm._t("default"),_vm._v(" "),_vm._l((_vm.list),function(item,index){return _c('div',{staticClass:"vux-swiper-item",attrs:{"data-index":index},on:{"click":function($event){return _vm.clickListItem(item)}}},[_c('a',{attrs:{"href":"javascript:"}},[_c('div',{staticClass:"vux-img",style:({backgroundImage: _vm.buildBackgroundUrl(item)})}),_vm._v(" "),(_vm.showDescMask)?_c('p',{staticClass:"vux-swiper-desc"},[_vm._v(_vm._s(item.title))]):_vm._e()])])}),_vm._v(" "),_vm._l((_vm.listTwoLoopItem),function(item,index){return (_vm.listTwoLoopItem.length > 0)?_c('div',{staticClass:"vux-swiper-item vux-swiper-item-clone",attrs:{"data-index":index},on:{"click":function($event){return _vm.clickListItem(item)}}},[_c('a',{attrs:{"href":"javascript:"}},[_c('div',{staticClass:"vux-img",style:({backgroundImage: _vm.buildBackgroundUrl(item)})}),_vm._v(" "),(_vm.showDescMask)?_c('p',{staticClass:"vux-swiper-desc"},[_vm._v(_vm._s(item.title))]):_vm._e()])]):_vm._e()})],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDots),expression:"showDots"}],class:[_vm.dotsClass, 'vux-indicator', ("vux-indicator-" + _vm.dotsPosition)]},_vm._l((_vm.length),function(key){return _c('a',{attrs:{"href":"javascript:"}},[_c('i',{staticClass:"vux-icon-dot",class:{'active': key - 1 === _vm.current}})])}),0)])}
var swiper_staticRenderFns = []
var swiper_esExports = { render: swiper_render, staticRenderFns: swiper_staticRenderFns }
/* harmony default export */ var src_components_swiper_swiper = (swiper_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/swiper/swiper.vue
function swiper_injectStyle (ssrContext) {
  __webpack_require__("03dp")
}
var swiper_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var swiper___vue_template_functional__ = false
/* styles */
var swiper___vue_styles__ = swiper_injectStyle
/* scopeId */
var swiper___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var swiper___vue_module_identifier__ = null
var swiper_Component = swiper_normalizeComponent(
  components_swiper_swiper,
  src_components_swiper_swiper,
  swiper___vue_template_functional__,
  swiper___vue_styles__,
  swiper___vue_scopeId__,
  swiper___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_swiper_swiper = (swiper_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swiper/swiper-item.vue
//
//
//
//

/* harmony default export */ var swiper_item = ({
  name: 'swiper-item',
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.$parent.rerender();
    });
  },
  beforeDestroy: function beforeDestroy() {
    var $parent = this.$parent;
    this.$nextTick(function () {
      $parent.rerender();
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swiper/swiper-item.vue
//
//
//
//

/* harmony default export */ var swiper_swiper_item = ({
  name: 'swiper-item',
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.$parent.rerender();
    });
  },
  beforeDestroy: function beforeDestroy() {
    var $parent = this.$parent;
    this.$nextTick(function () {
      $parent.rerender();
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-91b59c1c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/swiper/swiper-item.vue
var swiper_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-swiper-item"},[_vm._t("default")],2)}
var swiper_item_staticRenderFns = []
var swiper_item_esExports = { render: swiper_item_render, staticRenderFns: swiper_item_staticRenderFns }
/* harmony default export */ var components_swiper_swiper_item = (swiper_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/swiper/swiper-item.vue
var swiper_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var swiper_item___vue_template_functional__ = false
/* styles */
var swiper_item___vue_styles__ = null
/* scopeId */
var swiper_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var swiper_item___vue_module_identifier__ = null
var swiper_item_Component = swiper_item_normalizeComponent(
  swiper_swiper_item,
  components_swiper_swiper_item,
  swiper_item___vue_template_functional__,
  swiper_item___vue_styles__,
  swiper_item___vue_scopeId__,
  swiper_item___vue_module_identifier__
)

/* harmony default export */ var src_components_swiper_swiper_item = (swiper_item_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/datetime/index.js
var datetime = __webpack_require__("oVYx");

// EXTERNAL MODULE: ./node_modules/vux/src/components/confirm/index.vue + 3 modules
var components_confirm = __webpack_require__("62KO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab = ({
  name: 'tab',
  mixins: [multi_items["b" /* parentMixin */]],
  mounted: function mounted() {
    var _this = this;

    // stop bar anmination on first loading
    this.$nextTick(function () {
      setTimeout(function () {
        _this.hasReady = true;
      }, 0);
    });
  },

  props: {
    lineWidth: {
      type: Number,
      default: 3
    },
    activeColor: String,
    barActiveColor: String,
    defaultColor: String,
    disabledColor: String,
    animate: {
      type: Boolean,
      default: true
    },
    customBarWidth: [Function, String],
    preventDefault: Boolean,
    scrollThreshold: {
      type: Number,
      default: 4
    },
    barPosition: {
      type: String,
      default: 'bottom',
      validator: function validator(val) {
        return ['bottom', 'top'].indexOf(val) !== -1;
      }
    }
  },
  computed: {
    barLeft: function barLeft() {
      if (this.hasReady) {
        var nav = this.$refs.nav;
        var count = this.scrollable ? nav.offsetWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return this.currentIndex * (100 / count) + '%';
      }
    },
    barRight: function barRight() {
      if (this.hasReady) {
        var nav = this.$refs.nav;
        var count = this.scrollable ? nav.offsetWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return (count - this.currentIndex - 1) * (100 / count) + '%';
      }
    },

    // when prop:custom-bar-width
    innerBarStyle: function innerBarStyle() {
      return {
        width: typeof this.customBarWidth === 'function' ? this.customBarWidth(this.currentIndex) : this.customBarWidth,
        background: this.barActiveColor || this.activeColor
      };
    },

    // end
    barStyle: function barStyle() {
      var commonStyle = {
        left: this.barLeft,
        right: this.barRight,
        display: 'block',
        height: this.lineWidth + 'px',
        transition: !this.hasReady ? 'none' : null
      };
      if (!this.customBarWidth) {
        commonStyle.background = this.barActiveColor || this.activeColor;
      } else {
        commonStyle.background = 'transparent'; // when=prop:custom-bar-width
      }
      return commonStyle;
    },
    barClass: function barClass() {
      return {
        'vux-tab-ink-bar-transition-forward': this.direction === 'forward',
        'vux-tab-ink-bar-transition-backward': this.direction === 'backward'
      };
    },
    scrollable: function scrollable() {
      return this.number > this.scrollThreshold;
    }
  },
  watch: {
    currentIndex: function currentIndex(newIndex, oldIndex) {
      this.direction = newIndex > oldIndex ? 'forward' : 'backward';
      this.$emit('on-index-change', newIndex, oldIndex);
      this.hasReady && this.scrollToActiveTab();
    }
  },
  data: function data() {
    return {
      direction: 'forward',
      right: '100%',
      hasReady: false
    };
  },

  methods: {
    scrollToActiveTab: function scrollToActiveTab() {
      var _this2 = this;

      if (!this.scrollable || !this.$children || !this.$children.length) {
        return;
      }
      var currentIndexTab = this.$children[this.currentIndex].$el;
      var count = 0;
      // scroll animation
      var step = function step() {
        var scrollDuration = 15;
        var nav = _this2.$refs.nav;
        nav.scrollLeft += (currentIndexTab.offsetLeft - (nav.offsetWidth - currentIndexTab.offsetWidth) / 2 - nav.scrollLeft) / scrollDuration;
        if (++count < scrollDuration) {
          window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab_tab = ({
  name: 'tab',
  mixins: [multi_items["b" /* parentMixin */]],
  mounted: function mounted() {
    var _this = this;

    // stop bar anmination on first loading
    this.$nextTick(function () {
      setTimeout(function () {
        _this.hasReady = true;
      }, 0);
    });
  },

  props: {
    lineWidth: {
      type: Number,
      default: 3
    },
    activeColor: String,
    barActiveColor: String,
    defaultColor: String,
    disabledColor: String,
    animate: {
      type: Boolean,
      default: true
    },
    customBarWidth: [Function, String],
    preventDefault: Boolean,
    scrollThreshold: {
      type: Number,
      default: 4
    },
    barPosition: {
      type: String,
      default: 'bottom',
      validator: function validator(val) {
        return ['bottom', 'top'].indexOf(val) !== -1;
      }
    }
  },
  computed: {
    barLeft: function barLeft() {
      if (this.hasReady) {
        var nav = this.$refs.nav;
        var count = this.scrollable ? nav.offsetWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return this.currentIndex * (100 / count) + '%';
      }
    },
    barRight: function barRight() {
      if (this.hasReady) {
        var nav = this.$refs.nav;
        var count = this.scrollable ? nav.offsetWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return (count - this.currentIndex - 1) * (100 / count) + '%';
      }
    },

    // when prop:custom-bar-width
    innerBarStyle: function innerBarStyle() {
      return {
        width: typeof this.customBarWidth === 'function' ? this.customBarWidth(this.currentIndex) : this.customBarWidth,
        background: this.barActiveColor || this.activeColor
      };
    },

    // end
    barStyle: function barStyle() {
      var commonStyle = {
        left: this.barLeft,
        right: this.barRight,
        display: 'block',
        height: this.lineWidth + 'px',
        transition: !this.hasReady ? 'none' : null
      };
      if (!this.customBarWidth) {
        commonStyle.background = this.barActiveColor || this.activeColor;
      } else {
        commonStyle.background = 'transparent'; // when=prop:custom-bar-width
      }
      return commonStyle;
    },
    barClass: function barClass() {
      return {
        'vux-tab-ink-bar-transition-forward': this.direction === 'forward',
        'vux-tab-ink-bar-transition-backward': this.direction === 'backward'
      };
    },
    scrollable: function scrollable() {
      return this.number > this.scrollThreshold;
    }
  },
  watch: {
    currentIndex: function currentIndex(newIndex, oldIndex) {
      this.direction = newIndex > oldIndex ? 'forward' : 'backward';
      this.$emit('on-index-change', newIndex, oldIndex);
      this.hasReady && this.scrollToActiveTab();
    }
  },
  data: function data() {
    return {
      direction: 'forward',
      right: '100%',
      hasReady: false
    };
  },

  methods: {
    scrollToActiveTab: function scrollToActiveTab() {
      var _this2 = this;

      if (!this.scrollable || !this.$children || !this.$children.length) {
        return;
      }
      var currentIndexTab = this.$children[this.currentIndex].$el;
      var count = 0;
      // scroll animation
      var step = function step() {
        var scrollDuration = 15;
        var nav = _this2.$refs.nav;
        nav.scrollLeft += (currentIndexTab.offsetLeft - (nav.offsetWidth - currentIndexTab.offsetWidth) / 2 - nav.scrollLeft) / scrollDuration;
        if (++count < scrollDuration) {
          window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-039300f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/tab/tab.vue
var tab_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-tab-wrap",class:_vm.barPosition === 'top' ? 'vux-tab-bar-top' : ''},[_c('div',{staticClass:"vux-tab-container"},[_c('div',{ref:"nav",staticClass:"vux-tab",class:[{'vux-tab-no-animate': !_vm.animate},{ scrollable: _vm.scrollable }]},[_vm._t("default"),_vm._v(" "),(_vm.animate)?_c('div',{staticClass:"vux-tab-ink-bar",class:_vm.barClass,style:(_vm.barStyle)},[(_vm.customBarWidth)?_c('span',{staticClass:"vux-tab-bar-inner",style:(_vm.innerBarStyle)}):_vm._e()]):_vm._e()],2)])])}
var tab_staticRenderFns = []
var tab_esExports = { render: tab_render, staticRenderFns: tab_staticRenderFns }
/* harmony default export */ var components_tab_tab = (tab_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/tab/tab.vue
function tab_injectStyle (ssrContext) {
  __webpack_require__("9lt8")
}
var tab_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tab___vue_template_functional__ = false
/* styles */
var tab___vue_styles__ = tab_injectStyle
/* scopeId */
var tab___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tab___vue_module_identifier__ = null
var tab_Component = tab_normalizeComponent(
  tab_tab,
  components_tab_tab,
  tab___vue_template_functional__,
  tab___vue_styles__,
  tab___vue_scopeId__,
  tab___vue_module_identifier__
)

/* harmony default export */ var src_components_tab_tab = (tab_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab_item = ({
  name: 'tab-item',
  mixins: [multi_items["a" /* childMixin */]],
  props: {
    activeClass: String,
    disabled: Boolean,
    badgeBackground: {
      type: String,
      default: '#f74c31'
    },
    badgeColor: {
      type: String,
      default: '#fff'
    },
    badgeLabel: String
  },
  computed: {
    style: function style() {
      return {
        borderWidth: this.$parent.lineWidth + 'px',
        borderColor: this.$parent.activeColor,
        color: this.currentSelected ? this.$parent.activeColor : this.disabled ? this.$parent.disabledColor : this.$parent.defaultColor,
        border: this.$parent.animate ? 'none' : 'auto'
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab_tab_item = ({
  name: 'tab-item',
  mixins: [multi_items["a" /* childMixin */]],
  props: {
    activeClass: String,
    disabled: Boolean,
    badgeBackground: {
      type: String,
      default: '#f74c31'
    },
    badgeColor: {
      type: String,
      default: '#fff'
    },
    badgeLabel: String
  },
  computed: {
    style: function style() {
      return {
        borderWidth: this.$parent.lineWidth + 'px',
        borderColor: this.$parent.activeColor,
        color: this.currentSelected ? this.$parent.activeColor : this.disabled ? this.$parent.disabledColor : this.$parent.defaultColor,
        border: this.$parent.animate ? 'none' : 'auto'
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57c3c9c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/tab/tab-item.vue
var tab_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-tab-item",class:[_vm.currentSelected ? _vm.activeClass : '', {
    'vux-tab-selected': _vm.currentSelected,
    'vux-tab-disabled': _vm.disabled 
  }],style:(_vm.style),on:{"click":_vm.onItemClick}},[_vm._t("default"),_vm._v(" "),(typeof _vm.badgeLabel !== 'undefined' && _vm.badgeLabel !== '')?_c('span',{staticClass:"vux-tab-item-badge",style:({
      background: _vm.badgeBackground,
      color: _vm.badgeColor
    })},[_vm._v("\n  "+_vm._s(_vm.badgeLabel))]):_vm._e()],2)}
var tab_item_staticRenderFns = []
var tab_item_esExports = { render: tab_item_render, staticRenderFns: tab_item_staticRenderFns }
/* harmony default export */ var components_tab_tab_item = (tab_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/tab/tab-item.vue
var tab_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tab_item___vue_template_functional__ = false
/* styles */
var tab_item___vue_styles__ = null
/* scopeId */
var tab_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tab_item___vue_module_identifier__ = null
var tab_item_Component = tab_item_normalizeComponent(
  tab_tab_item,
  components_tab_tab_item,
  tab_item___vue_template_functional__,
  tab_item___vue_styles__,
  tab_item___vue_scopeId__,
  tab_item___vue_module_identifier__
)

/* harmony default export */ var src_components_tab_tab_item = (tab_item_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/panel/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var panel = ({
  name: 'panel',
  props: {
    header: String,
    footer: Object,
    list: Array,
    type: {
      type: String,
      default: '1'
    }
  },
  methods: {
    onImgError: function onImgError(item, $event) {
      this.$emit('on-img-error', JSON.parse(stringify_default()(item)), $event);
      if (item.fallbackSrc) {
        $event.target.src = item.fallbackSrc;
      }
    },
    getUrl: function getUrl(url) {
      return Object(libs_router["a" /* getUrl */])(url, this.$router);
    },
    onClickFooter: function onClickFooter() {
      this.$emit('on-click-footer');
      Object(libs_router["b" /* go */])(this.footer.url, this.$router);
    },
    onClickHeader: function onClickHeader() {
      this.$emit('on-click-header');
    },
    onItemClick: function onItemClick(item) {
      this.$emit('on-click-item', item);
      Object(libs_router["b" /* go */])(item.url, this.$router);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/panel/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_panel = ({
  name: 'panel',
  props: {
    header: String,
    footer: Object,
    list: Array,
    type: {
      type: String,
      default: '1'
    }
  },
  methods: {
    onImgError: function onImgError(item, $event) {
      this.$emit('on-img-error', JSON.parse(stringify_default()(item)), $event);
      if (item.fallbackSrc) {
        $event.target.src = item.fallbackSrc;
      }
    },
    getUrl: function getUrl(url) {
      return Object(libs_router["a" /* getUrl */])(url, this.$router);
    },
    onClickFooter: function onClickFooter() {
      this.$emit('on-click-footer');
      Object(libs_router["b" /* go */])(this.footer.url, this.$router);
    },
    onClickHeader: function onClickHeader() {
      this.$emit('on-click-header');
    },
    onItemClick: function onItemClick(item) {
      this.$emit('on-click-item', item);
      Object(libs_router["b" /* go */])(item.url, this.$router);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e261fb6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/panel/index.vue
var panel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-panel weui-panel_access"},[(_vm.header)?_c('div',{staticClass:"weui-panel__hd",domProps:{"innerHTML":_vm._s(_vm.header)},on:{"click":_vm.onClickHeader}},[_vm._t("header")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"weui-panel__bd"},[_vm._t("body",function(){return [(_vm.type === '1')?_vm._l((_vm.list),function(item){return _c('a',{staticClass:"weui-media-box weui-media-box_appmsg",attrs:{"href":_vm.getUrl(item.url)},on:{"click":function($event){$event.preventDefault();return _vm.onItemClick(item)}}},[(item.src)?_c('div',{staticClass:"weui-media-box__hd"},[_c('img',{staticClass:"weui-media-box__thumb",attrs:{"src":item.src,"alt":""},on:{"error":function($event){return _vm.onImgError(item, $event)}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"weui-media-box__bd"},[_c('h4',{staticClass:"weui-media-box__title",domProps:{"innerHTML":_vm._s(item.title)}}),_vm._v(" "),_c('p',{staticClass:"weui-media-box__desc",domProps:{"innerHTML":_vm._s(item.desc)}})])])}):_vm._e(),_vm._v(" "),(_vm.type === '2')?_vm._l((_vm.list),function(item){return _c('div',{staticClass:"weui-media-box weui-media-box_text",on:{"click":function($event){$event.preventDefault();return _vm.onItemClick(item)}}},[_c('h4',{staticClass:"weui-media-box__title",domProps:{"innerHTML":_vm._s(item.title)}}),_vm._v(" "),_c('p',{staticClass:"weui-media-box__desc",domProps:{"innerHTML":_vm._s(item.desc)}})])}):_vm._e(),_vm._v(" "),(_vm.type === '3')?[_c('div',{staticClass:"weui-media-box weui-media-box_small-appmsg"},[_c('div',{staticClass:"weui-cells"},_vm._l((_vm.list),function(item){return _c('a',{staticClass:"weui-cell weui-cell_access",attrs:{"href":_vm.getUrl(item.url)},on:{"click":function($event){$event.preventDefault();return _vm.onItemClick(item)}}},[_c('div',{staticClass:"weui-cell__hd"},[_c('img',{staticStyle:{"width":"20px","margin-right":"5px","display":"block"},attrs:{"src":item.src,"alt":""},on:{"error":function($event){return _vm.onImgError(item, $event)}}})]),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd"},[_c('p',{domProps:{"innerHTML":_vm._s(item.title)}})]),_vm._v(" "),_c('span',{staticClass:"weui-cell__ft"})])}),0)])]:_vm._e(),_vm._v(" "),(_vm.type === '4')?_vm._l((_vm.list),function(item){return _c('div',{staticClass:"weui-media-box weui-media-box_text",on:{"click":function($event){$event.preventDefault();return _vm.onItemClick(item)}}},[_c('h4',{staticClass:"weui-media-box__title",domProps:{"innerHTML":_vm._s(item.title)}}),_vm._v(" "),_c('p',{staticClass:"weui-media-box__desc",domProps:{"innerHTML":_vm._s(item.desc)}}),_vm._v(" "),(item.meta)?_c('ul',{staticClass:"weui-media-box__info"},[_c('li',{staticClass:"weui-media-box__info__meta",domProps:{"innerHTML":_vm._s(item.meta.source)}}),_vm._v(" "),_c('li',{staticClass:"weui-media-box__info__meta",domProps:{"innerHTML":_vm._s(item.meta.date)}}),_vm._v(" "),_c('li',{staticClass:"weui-media-box__info__meta weui-media-box__info__meta_extra",domProps:{"innerHTML":_vm._s(item.meta.other)}})]):_vm._e()])}):_vm._e(),_vm._v(" "),(_vm.type === '5')?_vm._l((_vm.list),function(item){return _c('div',{staticClass:"weui-media-box weui-media-box_text",on:{"click":function($event){$event.preventDefault();return _vm.onItemClick(item)}}},[_c('div',{staticClass:"weui-media-box_appmsg"},[(item.src)?_c('div',{staticClass:"weui-media-box__hd"},[_c('img',{staticClass:"weui-media-box__thumb",attrs:{"src":item.src,"alt":""},on:{"error":function($event){return _vm.onImgError(item, $event)}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"weui-media-box__bd"},[_c('h4',{staticClass:"weui-media-box__title",domProps:{"innerHTML":_vm._s(item.title)}}),_vm._v(" "),_c('p',{staticClass:"weui-media-box__desc",domProps:{"innerHTML":_vm._s(item.desc)}})])]),_vm._v(" "),(item.meta)?_c('ul',{staticClass:"weui-media-box__info"},[_c('li',{staticClass:"weui-media-box__info__meta",domProps:{"innerHTML":_vm._s(item.meta.source)}}),_vm._v(" "),_c('li',{staticClass:"weui-media-box__info__meta",domProps:{"innerHTML":_vm._s(item.meta.date)}}),_vm._v(" "),_c('li',{staticClass:"weui-media-box__info__meta weui-media-box__info__meta_extra",domProps:{"innerHTML":_vm._s(item.meta.other)}})]):_vm._e()])}):_vm._e()]})],2),_vm._v(" "),_c('div',{staticClass:"weui-panel__ft"},[(_vm.footer && _vm.footer.title && _vm.type !== '3')?_c('a',{staticClass:"weui-cell weui-cell_access weui-cell_link",attrs:{"href":_vm.getUrl(_vm.footer.url)},on:{"click":function($event){$event.preventDefault();return _vm.onClickFooter.apply(null, arguments)}}},[_c('div',{staticClass:"weui-cell__bd",domProps:{"innerHTML":_vm._s(_vm.footer.title)}})]):_vm._e()])])}
var panel_staticRenderFns = []
var panel_esExports = { render: panel_render, staticRenderFns: panel_staticRenderFns }
/* harmony default export */ var src_components_panel = (panel_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/panel/index.vue
function panel_injectStyle (ssrContext) {
  __webpack_require__("2tP1")
}
var panel_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var panel___vue_template_functional__ = false
/* styles */
var panel___vue_styles__ = panel_injectStyle
/* scopeId */
var panel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var panel___vue_module_identifier__ = null
var panel_Component = panel_normalizeComponent(
  components_panel,
  src_components_panel,
  panel___vue_template_functional__,
  panel___vue_styles__,
  panel___vue_scopeId__,
  panel___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_panel = (panel_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/ajax/index.js
var ajax = __webpack_require__("yD8N");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-button/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_button = ({
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: [String, Object],
    gradients: {
      type: Array,
      validator: function validator(val) {
        return val.length === 2;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && Object(libs_router["b" /* go */])(this.link, this.$router);
    }
  },
  computed: {
    noBorder: function noBorder() {
      return Array.isArray(this.gradients);
    },
    buttonStyle: function buttonStyle() {
      if (this.gradients) {
        return {
          background: 'linear-gradient(90deg, ' + this.gradients[0] + ', ' + this.gradients[1] + ')',
          color: '#FFFFFF'
        };
      }
    },
    classes: function classes() {
      return [{
        'weui-btn_disabled': !this.plain && this.disabled,
        'weui-btn_plain-disabled': this.plain && this.disabled,
        'weui-btn_mini': this.mini,
        'vux-x-button-no-border': this.noBorder
      }, !this.plain ? 'weui-btn_' + this.type : '', this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-button/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_button = ({
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: [String, Object],
    gradients: {
      type: Array,
      validator: function validator(val) {
        return val.length === 2;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && Object(libs_router["b" /* go */])(this.link, this.$router);
    }
  },
  computed: {
    noBorder: function noBorder() {
      return Array.isArray(this.gradients);
    },
    buttonStyle: function buttonStyle() {
      if (this.gradients) {
        return {
          background: 'linear-gradient(90deg, ' + this.gradients[0] + ', ' + this.gradients[1] + ')',
          color: '#FFFFFF'
        };
      }
    },
    classes: function classes() {
      return [{
        'weui-btn_disabled': !this.plain && this.disabled,
        'weui-btn_plain-disabled': this.plain && this.disabled,
        'weui-btn_mini': this.mini,
        'vux-x-button-no-border': this.noBorder
      }, !this.plain ? 'weui-btn_' + this.type : '', this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-283ca23f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-button/index.vue
var x_button_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"weui-btn",class:_vm.classes,style:(_vm.buttonStyle),attrs:{"disabled":_vm.disabled,"type":_vm.actionType},on:{"click":_vm.onClick}},[(_vm.showLoading)?_c('i',{staticClass:"weui-loading"}):_vm._e(),_vm._v(" "),_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2)}
var x_button_staticRenderFns = []
var x_button_esExports = { render: x_button_render, staticRenderFns: x_button_staticRenderFns }
/* harmony default export */ var src_components_x_button = (x_button_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-button/index.vue
function x_button_injectStyle (ssrContext) {
  __webpack_require__("QlJb")
}
var x_button_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_button___vue_template_functional__ = false
/* styles */
var x_button___vue_styles__ = x_button_injectStyle
/* scopeId */
var x_button___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_button___vue_module_identifier__ = null
var x_button_Component = x_button_normalizeComponent(
  components_x_button,
  src_components_x_button,
  x_button___vue_template_functional__,
  x_button___vue_styles__,
  x_button___vue_scopeId__,
  x_button___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_button = (x_button_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/libs/base.js
var libs_base = __webpack_require__("f6Hi");

// EXTERNAL MODULE: ./node_modules/vux/src/components/icon/index.vue + 3 modules
var icon = __webpack_require__("oWtu");

// EXTERNAL MODULE: ./node_modules/vux/src/components/toast/index.vue + 3 modules
var toast = __webpack_require__("rLAy");

// EXTERNAL MODULE: ./node_modules/vux/src/components/inline-desc/index.vue + 3 modules
var inline_desc = __webpack_require__("kbG3");

// EXTERNAL MODULE: ./node_modules/validator/lib/isEmail.js
var isEmail = __webpack_require__("2LX0");
var isEmail_default = /*#__PURE__*/__webpack_require__.n(isEmail);

// EXTERNAL MODULE: ./node_modules/validator/lib/isMobilePhone.js
var isMobilePhone = __webpack_require__("Ewe+");
var isMobilePhone_default = /*#__PURE__*/__webpack_require__.n(isMobilePhone);

// EXTERNAL MODULE: ./node_modules/vux/src/tools/debounce/index.js
var debounce = __webpack_require__("nror");

// EXTERNAL MODULE: ./node_modules/vanilla-masker/lib/vanilla-masker.js
var vanilla_masker = __webpack_require__("lFEC");
var vanilla_masker_default = /*#__PURE__*/__webpack_require__.n(vanilla_masker);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-input/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var validators = {
  'email': {
    fn: isEmail_default.a,
    msg: '邮箱格式'
  },
  'china-mobile': {
    fn: function fn(str) {
      return isMobilePhone_default()(str, 'zh-CN');
    },

    msg: '手机号码'
  },
  'china-name': {
    fn: function fn(str) {
      return str.length >= 2 && str.length <= 6;
    },

    msg: '中文姓名'
  }
};
/* harmony default export */ var x_input = ({
  name: 'x-input',
  created: function created() {
    var _this = this;

    this.currentValue = this.value === undefined || this.value === null ? '' : this.mask ? this.maskValue(this.value) : this.value;
    /* istanbul ignore if */
    if (false) {
      if (!this.title && !this.placeholder && !this.currentValue) {
        console.warn('no title and no placeholder?');
      }
    }

    if (this.required && (typeof this.currentValue === 'undefined' || this.currentValue === '')) {
      this.valid = false;
    }
    this.handleChangeEvent = true;
    if (this.debounce) {
      this._debounce = Object(debounce["a" /* default */])(function () {
        _this.$emit('on-change', _this.currentValue);
      }, this.debounce);
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    if (this.$slots && this.$slots['right-full-height']) {
      this.hasRightFullHeightSlot = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this._debounce) {
      this._debounce.cancel();
    }
  },

  mixins: [libs_base["a" /* default */]],
  components: {
    Icon: icon["a" /* default */],
    InlineDesc: inline_desc["a" /* default */],
    Toast: toast["a" /* default */]
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: String,
    value: [String, Number],
    name: String,
    readonly: Boolean,
    disabled: Boolean,
    keyboard: String,
    inlineDesc: String,
    isType: [String, Function],
    min: Number,
    max: Number,
    showClear: {
      type: Boolean,
      default: true
    },
    equalWith: String,
    textAlign: String,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    novalidate: {
      type: Boolean,
      default: false
    },
    iconType: String,
    debounce: Number,
    placeholderAlign: String,
    labelWidth: String,
    mask: String,
    shouldToastError: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    labelStyles: function labelStyles() {
      var _$parent = this.$parent,
          $parent = _$parent === undefined ? {} : _$parent;

      return {
        width: this.labelWidthComputed || $parent.labelWidth || this.labelWidthComputed,
        textAlign: $parent.labelAlign,
        marginRight: $parent.labelMarginRight
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    pattern: function pattern() {
      if (this.keyboard === 'number' || this.isType === 'china-mobile') {
        return '[0-9]*';
      }
    },
    labelWidthComputed: function labelWidthComputed() {
      var width = this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
      if (width < 10) {
        return width + 'em';
      }
    },
    hasErrors: function hasErrors() {
      return keys_default()(this.errors).length > 0;
    },
    inputStyle: function inputStyle() {
      if (this.textAlign) {
        return {
          textAlign: this.textAlign
        };
      }
    },
    showWarn: function showWarn() {
      return !this.novalidate && !this.equalWith && !this.valid && this.firstError && (this.touched || this.forceShowError);
    }
  },
  methods: {
    scrollIntoView: function scrollIntoView() {
      var _this2 = this;

      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      // alert('scroll into view')
      if (/iphone/i.test(navigator.userAgent)) {
        // return
      }
      if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
        // alert('will scroll')
        setTimeout(function () {
          // alert(this.$refs.input.length)
          _this2.$refs.input.scrollIntoViewIfNeeded(true);
        }, time);
      }
    },
    onClickErrorIcon: function onClickErrorIcon() {
      if (this.shouldToastError && this.firstError) {
        this.showErrorToast = true;
      }
      this.$emit('on-click-error-icon', this.firstError);
    },
    maskValue: function maskValue(val) {
      var val1 = this.mask ? vanilla_masker_default.a.toPattern(val, this.mask) : val;
      return val1;
    },
    reset: function reset() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.dirty = false;
      this.currentValue = value;
      this.firstError = '';
      this.valid = true;
    },
    clear: function clear() {
      this.currentValue = '';
      this.focus();
      this.$emit('on-click-clear-icon');
    },
    focus: function focus() {
      this.$refs.input.focus();
    },
    blur: function blur() {
      this.$refs.input.blur();
    },
    focusHandler: function focusHandler($event) {
      var _this3 = this;

      this.$emit('on-focus', this.currentValue, $event);
      this.isFocus = true;
      // this.scrollIntoView(500)
      // this.scrollIntoView(5000)
      setTimeout(function () {
        // 因为有1秒的延迟，如果切换了页面，input已经不存在，所以加个判断
        !_this3.$refs.input || _this3.$refs.input.scrollIntoViewIfNeeded(false);
        // this.$refs.input.scrollIntoViewIfNeeded()
      }, 1000);
      // $event.target.
    },
    onBlur: function onBlur($event) {
      this.setTouched();
      this.validate();
      this.isFocus = false;
      this.$emit('on-blur', this.currentValue, $event);
    },
    onKeyUp: function onKeyUp(e) {
      if (e.key === 'Enter') {
        e.target.blur();
        this.$emit('on-enter', this.currentValue, e);
      }
    },
    getError: function getError() {
      var key = keys_default()(this.errors)[0];
      this.firstError = this.errors[key];
    },
    validate: function validate() {
      if (typeof this.equalWith !== 'undefined') {
        this.validateEqual();
        return;
      }
      this.errors = {};

      if (!this.currentValue && !this.required) {
        this.valid = true;
        return;
      }

      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填哦';
        this.getError();
        return;
      }

      if (typeof this.isType === 'string') {
        var validator = validators[this.isType];
        if (validator) {
          var value = this.currentValue;

          if (this.isType === 'china-mobile' && this.mask === '999 9999 9999') {
            value = this.currentValue.replace(/\s+/g, '');
          }

          this.valid = validator['fn'](value);
          if (!this.valid) {
            this.forceShowError = true;
            this.errors.format = validator['msg'] + '格式不对哦~';
            this.getError();
            return;
          } else {
            delete this.errors.format;
          }
        }
      }

      if (typeof this.isType === 'function') {
        var validStatus = this.isType(this.currentValue);
        this.valid = validStatus.valid;
        if (!this.valid) {
          this.errors.format = validStatus.msg;
          this.forceShowError = true;
          this.getError();
          return;
        } else {
          delete this.errors.format;
        }
      }

      if (this.min) {
        if (this.currentValue.length < this.min) {
          this.errors.min = '\u6700\u5C11\u5E94\u8BE5\u8F93\u5165' + this.min + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.getError();
          return;
        } else {
          delete this.errors.min;
        }
      }

      if (this.max) {
        if (this.currentValue.length > this.max) {
          this.errors.max = '\u6700\u591A\u53EF\u4EE5\u8F93\u5165' + this.max + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.forceShowError = true;
          return;
        } else {
          this.forceShowError = false;
          delete this.errors.max;
        }
      }

      this.valid = true;
    },
    validateEqual: function validateEqual() {
      if (!this.equalWith && this.currentValue) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      }
      var willCheck = this.dirty || this.currentValue.length >= this.equalWith.length;
      // 只在长度符合时显示正确与否
      if (willCheck && this.currentValue !== this.equalWith) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      } else {
        if (!this.currentValue && this.required) {
          this.valid = false;
        } else {
          this.valid = true;
          delete this.errors.equal;
        }
      }
    },

    // #2810
    _getInputMaskSelection: function _getInputMaskSelection(selection, direction, maskVal, loop) {
      if (!this.mask || loop && direction === 0) {
        return selection;
      }
      if (direction === 0) {
        direction = this.lastDirection;
      }
      if (direction > 0) {
        var maskChar = this.mask.substr(selection - direction, 1);
        if (!maskChar.match(/[9SA]/)) {
          return this._getInputMaskSelection(selection + 1, direction, maskVal, true);
        }
      }
      return selection;
    }
  },
  data: function data() {
    return {
      hasRightFullHeightSlot: false,
      hasRestrictedLabel: false,
      firstError: '',
      forceShowError: false,
      hasLengthEqual: false,
      valid: true,
      currentValue: '',
      showErrorToast: false,
      isFocus: false
    };
  },

  watch: {
    mask: function mask(val) {
      if (val && this.currentValue) {
        this.currentValue = this.maskValue(this.currentValue);
      }
    },
    valid: function valid() {
      this.getError();
    },
    value: function value(val) {
      this.currentValue = val;
    },
    equalWith: function equalWith(newVal) {
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
    },
    currentValue: function currentValue(newVal, oldVal) {
      var _this4 = this;

      var selection = null;
      if (!this.equalWith && newVal) {
        this.validateEqual();
      }
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
      // #2960
      try {
        selection = this.$refs.input.selectionStart;
        var direction = newVal.length - oldVal.length;
        selection = this._getInputMaskSelection(selection, direction, this.maskValue(newVal));
        this.lastDirection = direction;
      } catch (e) {}
      this.$emit('input', this.maskValue(newVal));
      // #2810
      this.$nextTick(function () {
        if (_this4.$refs.input.selectionStart !== selection) {
          _this4.$refs.input.selectionStart = selection;
          _this4.$refs.input.selectionEnd = selection;
        }
        if (_this4.currentValue !== _this4.maskValue(newVal)) {
          _this4.currentValue = _this4.maskValue(newVal);
        }
      });

      if (this._debounce) {
        this._debounce();
      } else {
        this.$emit('on-change', newVal);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-input/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var x_input_validators = {
  'email': {
    fn: isEmail_default.a,
    msg: '邮箱格式'
  },
  'china-mobile': {
    fn: function fn(str) {
      return isMobilePhone_default()(str, 'zh-CN');
    },

    msg: '手机号码'
  },
  'china-name': {
    fn: function fn(str) {
      return str.length >= 2 && str.length <= 6;
    },

    msg: '中文姓名'
  }
};
/* harmony default export */ var components_x_input = ({
  name: 'x-input',
  created: function created() {
    var _this = this;

    this.currentValue = this.value === undefined || this.value === null ? '' : this.mask ? this.maskValue(this.value) : this.value;
    /* istanbul ignore if */
    if (false) {
      if (!this.title && !this.placeholder && !this.currentValue) {
        console.warn('no title and no placeholder?');
      }
    }

    if (this.required && (typeof this.currentValue === 'undefined' || this.currentValue === '')) {
      this.valid = false;
    }
    this.handleChangeEvent = true;
    if (this.debounce) {
      this._debounce = Object(debounce["a" /* default */])(function () {
        _this.$emit('on-change', _this.currentValue);
      }, this.debounce);
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    if (this.$slots && this.$slots['right-full-height']) {
      this.hasRightFullHeightSlot = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this._debounce) {
      this._debounce.cancel();
    }
  },

  mixins: [libs_base["a" /* default */]],
  components: {
    Icon: icon["a" /* default */],
    InlineDesc: inline_desc["a" /* default */],
    Toast: toast["a" /* default */]
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: String,
    value: [String, Number],
    name: String,
    readonly: Boolean,
    disabled: Boolean,
    keyboard: String,
    inlineDesc: String,
    isType: [String, Function],
    min: Number,
    max: Number,
    showClear: {
      type: Boolean,
      default: true
    },
    equalWith: String,
    textAlign: String,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    novalidate: {
      type: Boolean,
      default: false
    },
    iconType: String,
    debounce: Number,
    placeholderAlign: String,
    labelWidth: String,
    mask: String,
    shouldToastError: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    labelStyles: function labelStyles() {
      var _$parent = this.$parent,
          $parent = _$parent === undefined ? {} : _$parent;

      return {
        width: this.labelWidthComputed || $parent.labelWidth || this.labelWidthComputed,
        textAlign: $parent.labelAlign,
        marginRight: $parent.labelMarginRight
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    pattern: function pattern() {
      if (this.keyboard === 'number' || this.isType === 'china-mobile') {
        return '[0-9]*';
      }
    },
    labelWidthComputed: function labelWidthComputed() {
      var width = this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
      if (width < 10) {
        return width + 'em';
      }
    },
    hasErrors: function hasErrors() {
      return keys_default()(this.errors).length > 0;
    },
    inputStyle: function inputStyle() {
      if (this.textAlign) {
        return {
          textAlign: this.textAlign
        };
      }
    },
    showWarn: function showWarn() {
      return !this.novalidate && !this.equalWith && !this.valid && this.firstError && (this.touched || this.forceShowError);
    }
  },
  methods: {
    scrollIntoView: function scrollIntoView() {
      var _this2 = this;

      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      // alert('scroll into view')
      if (/iphone/i.test(navigator.userAgent)) {
        // return
      }
      if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
        // alert('will scroll')
        setTimeout(function () {
          // alert(this.$refs.input.length)
          _this2.$refs.input.scrollIntoViewIfNeeded(true);
        }, time);
      }
    },
    onClickErrorIcon: function onClickErrorIcon() {
      if (this.shouldToastError && this.firstError) {
        this.showErrorToast = true;
      }
      this.$emit('on-click-error-icon', this.firstError);
    },
    maskValue: function maskValue(val) {
      var val1 = this.mask ? vanilla_masker_default.a.toPattern(val, this.mask) : val;
      return val1;
    },
    reset: function reset() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.dirty = false;
      this.currentValue = value;
      this.firstError = '';
      this.valid = true;
    },
    clear: function clear() {
      this.currentValue = '';
      this.focus();
      this.$emit('on-click-clear-icon');
    },
    focus: function focus() {
      this.$refs.input.focus();
    },
    blur: function blur() {
      this.$refs.input.blur();
    },
    focusHandler: function focusHandler($event) {
      var _this3 = this;

      this.$emit('on-focus', this.currentValue, $event);
      this.isFocus = true;
      // this.scrollIntoView(500)
      // this.scrollIntoView(5000)
      setTimeout(function () {
        // 因为有1秒的延迟，如果切换了页面，input已经不存在，所以加个判断
        !_this3.$refs.input || _this3.$refs.input.scrollIntoViewIfNeeded(false);
        // this.$refs.input.scrollIntoViewIfNeeded()
      }, 1000);
      // $event.target.
    },
    onBlur: function onBlur($event) {
      this.setTouched();
      this.validate();
      this.isFocus = false;
      this.$emit('on-blur', this.currentValue, $event);
    },
    onKeyUp: function onKeyUp(e) {
      if (e.key === 'Enter') {
        e.target.blur();
        this.$emit('on-enter', this.currentValue, e);
      }
    },
    getError: function getError() {
      var key = keys_default()(this.errors)[0];
      this.firstError = this.errors[key];
    },
    validate: function validate() {
      if (typeof this.equalWith !== 'undefined') {
        this.validateEqual();
        return;
      }
      this.errors = {};

      if (!this.currentValue && !this.required) {
        this.valid = true;
        return;
      }

      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填哦';
        this.getError();
        return;
      }

      if (typeof this.isType === 'string') {
        var validator = x_input_validators[this.isType];
        if (validator) {
          var value = this.currentValue;

          if (this.isType === 'china-mobile' && this.mask === '999 9999 9999') {
            value = this.currentValue.replace(/\s+/g, '');
          }

          this.valid = validator['fn'](value);
          if (!this.valid) {
            this.forceShowError = true;
            this.errors.format = validator['msg'] + '格式不对哦~';
            this.getError();
            return;
          } else {
            delete this.errors.format;
          }
        }
      }

      if (typeof this.isType === 'function') {
        var validStatus = this.isType(this.currentValue);
        this.valid = validStatus.valid;
        if (!this.valid) {
          this.errors.format = validStatus.msg;
          this.forceShowError = true;
          this.getError();
          return;
        } else {
          delete this.errors.format;
        }
      }

      if (this.min) {
        if (this.currentValue.length < this.min) {
          this.errors.min = '\u6700\u5C11\u5E94\u8BE5\u8F93\u5165' + this.min + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.getError();
          return;
        } else {
          delete this.errors.min;
        }
      }

      if (this.max) {
        if (this.currentValue.length > this.max) {
          this.errors.max = '\u6700\u591A\u53EF\u4EE5\u8F93\u5165' + this.max + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.forceShowError = true;
          return;
        } else {
          this.forceShowError = false;
          delete this.errors.max;
        }
      }

      this.valid = true;
    },
    validateEqual: function validateEqual() {
      if (!this.equalWith && this.currentValue) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      }
      var willCheck = this.dirty || this.currentValue.length >= this.equalWith.length;
      // 只在长度符合时显示正确与否
      if (willCheck && this.currentValue !== this.equalWith) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      } else {
        if (!this.currentValue && this.required) {
          this.valid = false;
        } else {
          this.valid = true;
          delete this.errors.equal;
        }
      }
    },

    // #2810
    _getInputMaskSelection: function _getInputMaskSelection(selection, direction, maskVal, loop) {
      if (!this.mask || loop && direction === 0) {
        return selection;
      }
      if (direction === 0) {
        direction = this.lastDirection;
      }
      if (direction > 0) {
        var maskChar = this.mask.substr(selection - direction, 1);
        if (!maskChar.match(/[9SA]/)) {
          return this._getInputMaskSelection(selection + 1, direction, maskVal, true);
        }
      }
      return selection;
    }
  },
  data: function data() {
    return {
      hasRightFullHeightSlot: false,
      hasRestrictedLabel: false,
      firstError: '',
      forceShowError: false,
      hasLengthEqual: false,
      valid: true,
      currentValue: '',
      showErrorToast: false,
      isFocus: false
    };
  },

  watch: {
    mask: function mask(val) {
      if (val && this.currentValue) {
        this.currentValue = this.maskValue(this.currentValue);
      }
    },
    valid: function valid() {
      this.getError();
    },
    value: function value(val) {
      this.currentValue = val;
    },
    equalWith: function equalWith(newVal) {
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
    },
    currentValue: function currentValue(newVal, oldVal) {
      var _this4 = this;

      var selection = null;
      if (!this.equalWith && newVal) {
        this.validateEqual();
      }
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
      // #2960
      try {
        selection = this.$refs.input.selectionStart;
        var direction = newVal.length - oldVal.length;
        selection = this._getInputMaskSelection(selection, direction, this.maskValue(newVal));
        this.lastDirection = direction;
      } catch (e) {}
      this.$emit('input', this.maskValue(newVal));
      // #2810
      this.$nextTick(function () {
        if (_this4.$refs.input.selectionStart !== selection) {
          _this4.$refs.input.selectionStart = selection;
          _this4.$refs.input.selectionEnd = selection;
        }
        if (_this4.currentValue !== _this4.maskValue(newVal)) {
          _this4.currentValue = _this4.maskValue(newVal);
        }
      });

      if (this._debounce) {
        this._debounce();
      } else {
        this.$emit('on-change', newVal);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c8c8891a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-input/index.vue
var x_input_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-input weui-cell",class:{
			'weui-cell_warn': _vm.showWarn,
			'disabled': _vm.disabled,
			'vux-x-input-has-right-full': _vm.hasRightFullHeightSlot
		}},[_c('div',{staticClass:"weui-cell__hd"},[(_vm.hasRestrictedLabel)?_c('div',{style:(_vm.labelStyles)},[_vm._t("restricted-label")],2):_vm._e(),_vm._v(" "),_vm._t("label",function(){return [(_vm.title)?_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:({width: _vm.labelWidth || _vm.$parent.labelWidth || _vm.labelWidthComputed, textAlign: _vm.$parent.labelAlign, marginRight: _vm.$parent.labelMarginRight}),attrs:{"for":("vux-x-input-" + _vm.uuid)},domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()]})],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd weui-cell__primary",class:_vm.placeholderAlign ? ("vux-x-input-placeholder-" + _vm.placeholderAlign) : ''},[(!_vm.type || _vm.type === 'text')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"text","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'number')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"number","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'email')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"email","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'password')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"password","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'tel')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"tel","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"},[_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hasRightFullHeightSlot && !_vm.equalWith && _vm.showClear && _vm.currentValue !== '' && !_vm.readonly && !_vm.disabled && _vm.isFocus),expression:"!hasRightFullHeightSlot && !equalWith && showClear && currentValue !== '' && !readonly && !disabled && isFocus"}],attrs:{"type":"clear"},nativeOn:{"touchstart":function($event){return _vm.clear.apply(null, arguments)}}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.showWarn),expression:"showWarn"}],staticClass:"vux-input-icon",attrs:{"type":"warn","title":!_vm.valid ? _vm.firstError : ''},nativeOn:{"click":function($event){return _vm.onClickErrorIcon.apply(null, arguments)}}}),_vm._v(" "),(!_vm.novalidate && _vm.hasLengthEqual && _vm.dirty && _vm.equalWith && !_vm.valid)?_c('icon',{staticClass:"vux-input-icon",attrs:{"type":"warn"},nativeOn:{"click":function($event){return _vm.onClickErrorIcon.apply(null, arguments)}}}):_vm._e(),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.novalidate && _vm.equalWith && _vm.equalWith === _vm.currentValue && _vm.valid),expression:"!novalidate && equalWith && equalWith === currentValue && valid"}],attrs:{"type":"success"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.novalidate && _vm.iconType === 'success'),expression:"novalidate && iconType === 'success'"}],staticClass:"vux-input-icon",attrs:{"type":"success"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.novalidate && _vm.iconType === 'error'),expression:"novalidate && iconType === 'error'"}],staticClass:"vux-input-icon",attrs:{"type":"warn"}}),_vm._v(" "),_vm._t("right"),_vm._v(" "),(_vm.hasRightFullHeightSlot)?_c('div',{staticClass:"vux-x-input-right-full"},[_vm._t("right-full-height")],2):_vm._e()],2),_vm._v(" "),_c('toast',{attrs:{"type":"text","width":"auto","time":600},model:{value:(_vm.showErrorToast),callback:function ($$v) {_vm.showErrorToast=$$v},expression:"showErrorToast"}},[_vm._v(_vm._s(_vm.firstError))])],1)}
var x_input_staticRenderFns = []
var x_input_esExports = { render: x_input_render, staticRenderFns: x_input_staticRenderFns }
/* harmony default export */ var src_components_x_input = (x_input_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-input/index.vue
function x_input_injectStyle (ssrContext) {
  __webpack_require__("+LB2")
}
var x_input_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_input___vue_template_functional__ = false
/* styles */
var x_input___vue_styles__ = x_input_injectStyle
/* scopeId */
var x_input___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_input___vue_module_identifier__ = null
var x_input_Component = x_input_normalizeComponent(
  components_x_input,
  src_components_x_input,
  x_input___vue_template_functional__,
  x_input___vue_styles__,
  x_input___vue_scopeId__,
  x_input___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_input = (x_input_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/group/index.vue + 3 modules
var group = __webpack_require__("rHil");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/group-title/index.vue
//
//
//
//
//
//

/* harmony default export */ var group_title = ({
  name: 'group-title'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/group-title/index.vue
//
//
//
//
//
//

/* harmony default export */ var components_group_title = ({
  name: 'group-title'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3c88812","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/group-title/index.vue
var group_title_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cells__title"},[_vm._t("default")],2)}
var group_title_staticRenderFns = []
var group_title_esExports = { render: group_title_render, staticRenderFns: group_title_staticRenderFns }
/* harmony default export */ var src_components_group_title = (group_title_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/group-title/index.vue
function group_title_injectStyle (ssrContext) {
  __webpack_require__("4WEX")
}
var group_title_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var group_title___vue_template_functional__ = false
/* styles */
var group_title___vue_styles__ = group_title_injectStyle
/* scopeId */
var group_title___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var group_title___vue_module_identifier__ = null
var group_title_Component = group_title_normalizeComponent(
  components_group_title,
  src_components_group_title,
  group_title___vue_template_functional__,
  group_title___vue_styles__,
  group_title___vue_scopeId__,
  group_title___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_group_title = (group_title_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/alert/index.js + 1 modules
var plugins_alert = __webpack_require__("Peep");

// EXTERNAL MODULE: ./node_modules/vux/src/filters/name2value.js
var name2value = __webpack_require__("dH7R");

// EXTERNAL MODULE: ./node_modules/vux/src/filters/value2name.js
var value2name = __webpack_require__("NE4E");

// EXTERNAL MODULE: ./node_modules/vux/src/components/picker/scroller.js + 2 modules
var scroller = __webpack_require__("+geU");

// EXTERNAL MODULE: ./node_modules/vux/src/components/flexbox/index.js
var flexbox = __webpack_require__("F3HL");

// EXTERNAL MODULE: ./node_modules/vux/src/components/picker/chain.js
var chain = __webpack_require__("zDi5");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/is-array.js
var is_array = __webpack_require__("cEdU");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/picker/index.vue


//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var picker = ({
  name: 'picker',
  components: {
    Flexbox: flexbox["a" /* Flexbox */],
    FlexboxItem: flexbox["b" /* FlexboxItem */]
  },
  created: function created() {
    if (this.columns !== 0) {
      var length = this.columns;
      this.store = new chain["a" /* default */](this.data, length, this.fixedColumns || this.columns);
      this.currentData = this.store.getColumns(this.value);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.uuid = Math.random().toString(36).substring(3, 8);
    this.$nextTick(function () {
      _this2.render(_this2.currentData, _this2.currentValue);
    });
  },

  props: {
    data: Array,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: Array,
    itemClass: {
      type: String,
      default: 'scroller-item'
    },
    columnWidth: Array
  },
  methods: {
    getNameValues: function getNameValues() {
      return Object(value2name["a" /* default */])(this.currentValue, this.data);
    },
    getId: function getId(i) {
      return '#vux-picker-' + this.uuid + '-' + i;
    },
    render: function render(data, value) {
      this.count = this.currentData.length;
      var _this = this;
      if (!data || !data.length) {
        return;
      }
      var count = this.currentData.length;
      // set first item as value
      if (value.length < count) {
        for (var i = 0; i < count; i++) {
          if (false) {
            console.error('[VUX error] 渲染出错，如果为联动模式，需要指定 columns(列数)');
          }
          this.$set(_this.currentValue, i, data[i][0].value || data[i][0]);
        }
      }

      var _loop = function _loop(_i) {
        /**
        * Still don't know why this happens
        */
        if (!document.querySelector(_this.getId(_i))) {
          return {
            v: void 0
          };
        }

        _this.scroller[_i] && _this.scroller[_i].destroy();
        _this.scroller[_i] = new scroller["a" /* default */](_this.getId(_i), {
          data: data[_i],
          defaultValue: value[_i] || data[_i][0].value,
          itemClass: _this.itemClass,
          onSelect: function onSelect(value) {
            _this.$set(_this.currentValue, _i, value);
            if (!this.columns || this.columns && _this.getValue().length === _this.store.count) {
              _this.$nextTick(function () {
                _this.$emit('on-change', _this.getValue());
              });
            }
            if (_this.columns !== 0) {
              _this.renderChain(_i + 1);
            }
          }
        });
        if (_this.currentValue) {
          _this.scroller[_i].select(value[_i]);
        }
      };

      for (var _i = 0; _i < data.length; _i++) {
        var _ret = _loop(_i);

        if ((typeof _ret === 'undefined' ? 'undefined' : typeof_default()(_ret)) === "object") return _ret.v;
      }
    },
    renderChain: function renderChain(i) {
      if (!this.columns) {
        return;
      }

      // do not render for last scroller
      if (i > this.count - 1) {
        return;
      }

      var _this = this;
      var ID = this.getId(i);
      // destroy old one
      this.scroller[i].destroy();
      var list = this.store.getChildren(_this.getValue()[i - 1]);
      this.scroller[i] = new scroller["a" /* default */](ID, {
        data: list,
        itemClass: _this.item_class,
        onSelect: function onSelect(value) {
          _this.$set(_this.currentValue, i, value);
          _this.$nextTick(function () {
            _this.$emit('on-change', _this.getValue());
          });
          _this.renderChain(i + 1);
        }
      });
      // list is Array(empty) as maybe
      if (list.length) {
        this.$set(this.currentValue, i, list[0].value);
        this.renderChain(i + 1);
      } else {
        this.$set(this.currentValue, i, null);
      }
    },
    getValue: function getValue() {
      var data = [];
      for (var i = 0; i < this.currentData.length; i++) {
        if (this.scroller[i]) {
          data.push(this.scroller[i].value);
        } else {
          return [];
        }
      }
      return data;
    },
    emitValueChange: function emitValueChange(val) {
      if (!this.columns || this.columns && val.length === this.store.count) {
        this.$emit('on-change', val);
      }
    }
  },
  data: function data() {
    return {
      scroller: [],
      count: 0,
      uuid: '',
      currentData: this.data,
      currentValue: this.value
    };
  },

  watch: {
    value: function value(val) {
      if (stringify_default()(val) !== stringify_default()(this.currentValue)) {
        this.currentValue = val;
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      // render all the scroller for chain datas
      if (this.columns !== 0) {
        if (val.length > 0) {
          if (stringify_default()(val) !== stringify_default()(oldVal)) {
            this.currentData = this.store.getColumns(val);
            this.$nextTick(function () {
              this.render(this.currentData, val);
            });
          }
        } else {
          this.render(this.currentData, []);
        }
      } else {
        if (val.length) {
          for (var i = 0; i < val.length; i++) {
            if (this.scroller[i] && this.scroller[i].value !== val[i]) {
              this.scroller[i].select(val[i]);
            }
          }
        } else {
          this.render(this.currentData, []);
        }
      }
    },
    data: function data(val) {
      if (stringify_default()(val) !== stringify_default()(this.currentData)) {
        this.currentData = val;
      }
    },
    currentData: function currentData(newData) {
      var _this3 = this;

      if (Object.prototype.toString.call(newData[0]) === '[object Array]') {
        this.$nextTick(function () {
          _this3.render(newData, _this3.currentValue);
          // emit on-change after rerender
          _this3.$nextTick(function () {
            _this3.emitValueChange(_this3.getValue());

            if (stringify_default()(_this3.getValue()) !== stringify_default()(_this3.currentValue)) {
              if (!_this3.columns || _this3.columns && _this3.getValue().length === _this3.store.count) {
                _this3.currentValue = _this3.getValue();
              }
            }
          });
        });
      } else {
        if (this.columns !== 0) {
          if (!newData.length) {
            return;
          }
          var length = this.columns;
          this.store = new chain["a" /* default */](newData, length, this.fixedColumns || this.columns);
          this.currentData = this.store.getColumns(this.currentValue);
        }
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    for (var i = 0; i < this.count; i++) {
      this.scroller[i] && this.scroller[i].destroy();
      this.scroller[i] = null;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/picker/index.vue


//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var components_picker = ({
  name: 'picker',
  components: {
    Flexbox: flexbox["a" /* Flexbox */],
    FlexboxItem: flexbox["b" /* FlexboxItem */]
  },
  created: function created() {
    if (this.columns !== 0) {
      var length = this.columns;
      this.store = new chain["a" /* default */](this.data, length, this.fixedColumns || this.columns);
      this.currentData = this.store.getColumns(this.value);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.uuid = Math.random().toString(36).substring(3, 8);
    this.$nextTick(function () {
      _this2.render(_this2.currentData, _this2.currentValue);
    });
  },

  props: {
    data: Array,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: Array,
    itemClass: {
      type: String,
      default: 'scroller-item'
    },
    columnWidth: Array
  },
  methods: {
    getNameValues: function getNameValues() {
      return Object(value2name["a" /* default */])(this.currentValue, this.data);
    },
    getId: function getId(i) {
      return '#vux-picker-' + this.uuid + '-' + i;
    },
    render: function render(data, value) {
      this.count = this.currentData.length;
      var _this = this;
      if (!data || !data.length) {
        return;
      }
      var count = this.currentData.length;
      // set first item as value
      if (value.length < count) {
        for (var i = 0; i < count; i++) {
          if (false) {
            console.error('[VUX error] 渲染出错，如果为联动模式，需要指定 columns(列数)');
          }
          this.$set(_this.currentValue, i, data[i][0].value || data[i][0]);
        }
      }

      var _loop = function _loop(_i) {
        /**
        * Still don't know why this happens
        */
        if (!document.querySelector(_this.getId(_i))) {
          return {
            v: void 0
          };
        }

        _this.scroller[_i] && _this.scroller[_i].destroy();
        _this.scroller[_i] = new scroller["a" /* default */](_this.getId(_i), {
          data: data[_i],
          defaultValue: value[_i] || data[_i][0].value,
          itemClass: _this.itemClass,
          onSelect: function onSelect(value) {
            _this.$set(_this.currentValue, _i, value);
            if (!this.columns || this.columns && _this.getValue().length === _this.store.count) {
              _this.$nextTick(function () {
                _this.$emit('on-change', _this.getValue());
              });
            }
            if (_this.columns !== 0) {
              _this.renderChain(_i + 1);
            }
          }
        });
        if (_this.currentValue) {
          _this.scroller[_i].select(value[_i]);
        }
      };

      for (var _i = 0; _i < data.length; _i++) {
        var _ret = _loop(_i);

        if ((typeof _ret === 'undefined' ? 'undefined' : typeof_default()(_ret)) === "object") return _ret.v;
      }
    },
    renderChain: function renderChain(i) {
      if (!this.columns) {
        return;
      }

      // do not render for last scroller
      if (i > this.count - 1) {
        return;
      }

      var _this = this;
      var ID = this.getId(i);
      // destroy old one
      this.scroller[i].destroy();
      var list = this.store.getChildren(_this.getValue()[i - 1]);
      this.scroller[i] = new scroller["a" /* default */](ID, {
        data: list,
        itemClass: _this.item_class,
        onSelect: function onSelect(value) {
          _this.$set(_this.currentValue, i, value);
          _this.$nextTick(function () {
            _this.$emit('on-change', _this.getValue());
          });
          _this.renderChain(i + 1);
        }
      });
      // list is Array(empty) as maybe
      if (list.length) {
        this.$set(this.currentValue, i, list[0].value);
        this.renderChain(i + 1);
      } else {
        this.$set(this.currentValue, i, null);
      }
    },
    getValue: function getValue() {
      var data = [];
      for (var i = 0; i < this.currentData.length; i++) {
        if (this.scroller[i]) {
          data.push(this.scroller[i].value);
        } else {
          return [];
        }
      }
      return data;
    },
    emitValueChange: function emitValueChange(val) {
      if (!this.columns || this.columns && val.length === this.store.count) {
        this.$emit('on-change', val);
      }
    }
  },
  data: function data() {
    return {
      scroller: [],
      count: 0,
      uuid: '',
      currentData: this.data,
      currentValue: this.value
    };
  },

  watch: {
    value: function value(val) {
      if (stringify_default()(val) !== stringify_default()(this.currentValue)) {
        this.currentValue = val;
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      // render all the scroller for chain datas
      if (this.columns !== 0) {
        if (val.length > 0) {
          if (stringify_default()(val) !== stringify_default()(oldVal)) {
            this.currentData = this.store.getColumns(val);
            this.$nextTick(function () {
              this.render(this.currentData, val);
            });
          }
        } else {
          this.render(this.currentData, []);
        }
      } else {
        if (val.length) {
          for (var i = 0; i < val.length; i++) {
            if (this.scroller[i] && this.scroller[i].value !== val[i]) {
              this.scroller[i].select(val[i]);
            }
          }
        } else {
          this.render(this.currentData, []);
        }
      }
    },
    data: function data(val) {
      if (stringify_default()(val) !== stringify_default()(this.currentData)) {
        this.currentData = val;
      }
    },
    currentData: function currentData(newData) {
      var _this3 = this;

      if (Object.prototype.toString.call(newData[0]) === '[object Array]') {
        this.$nextTick(function () {
          _this3.render(newData, _this3.currentValue);
          // emit on-change after rerender
          _this3.$nextTick(function () {
            _this3.emitValueChange(_this3.getValue());

            if (stringify_default()(_this3.getValue()) !== stringify_default()(_this3.currentValue)) {
              if (!_this3.columns || _this3.columns && _this3.getValue().length === _this3.store.count) {
                _this3.currentValue = _this3.getValue();
              }
            }
          });
        });
      } else {
        if (this.columns !== 0) {
          if (!newData.length) {
            return;
          }
          var length = this.columns;
          this.store = new chain["a" /* default */](newData, length, this.fixedColumns || this.columns);
          this.currentData = this.store.getColumns(this.currentValue);
        }
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    for (var i = 0; i < this.count; i++) {
      this.scroller[i] && this.scroller[i].destroy();
      this.scroller[i] = null;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa2c7d66","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/picker/index.vue
var picker_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-picker"},[_c('flexbox',{attrs:{"gutter":0}},_vm._l((_vm.currentData),function(one,index){return _c('flexbox-item',{key:index,staticStyle:{"margin-left":"0"},attrs:{"span":_vm.columnWidth && _vm.columnWidth[index]}},[_c('div',{staticClass:"vux-picker-item",attrs:{"id":("vux-picker-" + _vm.uuid + "-" + index)}})])}),1)],1)}
var picker_staticRenderFns = []
var picker_esExports = { render: picker_render, staticRenderFns: picker_staticRenderFns }
/* harmony default export */ var src_components_picker = (picker_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/picker/index.vue
function picker_injectStyle (ssrContext) {
  __webpack_require__("Q7uw")
}
var picker_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var picker___vue_template_functional__ = false
/* styles */
var picker___vue_styles__ = picker_injectStyle
/* scopeId */
var picker___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var picker___vue_module_identifier__ = null
var picker_Component = picker_normalizeComponent(
  components_picker,
  src_components_picker,
  picker___vue_template_functional__,
  picker___vue_styles__,
  picker___vue_scopeId__,
  picker___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_picker = (picker_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/cell/props.js
var props = __webpack_require__("2IIR");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/clean-style.js
var clean_style = __webpack_require__("wmxo");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/get-parent-prop.js
var get_parent_prop = __webpack_require__("vLYD");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var cell = ({
  name: 'cell',
  components: {
    InlineDesc: inline_desc["a" /* default */]
  },
  props: Object(props["a" /* default */])(),
  created: function created() {
    /* istanbul ignore if */
    if (false) {
      console.warn('[VUX] 抱歉，当前组件[cell]要求更新依赖 vux-loader@latest');
    }
  },
  beforeMount: function beforeMount() {
    this.hasTitleSlot = !!this.$slots.title;
    /* istanbul ignore if */
    if (this.$slots.value && "production" === 'development') {
      console.warn('[VUX] [cell] slot=value 已经废弃，请使用默认 slot 替代');
    }
  },

  computed: {
    labelStyles: function labelStyles() {
      return Object(clean_style["a" /* default */])({
        width: Object(get_parent_prop["a" /* default */])(this, 'labelWidth'),
        textAlign: Object(get_parent_prop["a" /* default */])(this, 'labelAlign'),
        marginRight: Object(get_parent_prop["a" /* default */])(this, 'labelMarginRight')
      });
    },
    valueClass: function valueClass() {
      return {
        'vux-cell-primary': this.primary === 'content' || this.valueAlign === 'left',
        'vux-cell-align-left': this.valueAlign === 'left',
        'vux-cell-arrow-transition': !!this.arrowDirection,
        'vux-cell-arrow-up': this.arrowDirection === 'up',
        'vux-cell-arrow-down': this.arrowDirection === 'down'
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    style: function style() {
      if (this.alignItems) {
        return {
          alignItems: this.alignItems
        };
      }
    }
  },
  methods: {
    onClick: function onClick() {
      /* istanbul ignore next */
      !this.disabled && Object(libs_router["b" /* go */])(this.link, this.$router);
    }
  },
  data: function data() {
    return {
      hasTitleSlot: true,
      hasMounted: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var components_cell = ({
  name: 'cell',
  components: {
    InlineDesc: inline_desc["a" /* default */]
  },
  props: Object(props["a" /* default */])(),
  created: function created() {
    /* istanbul ignore if */
    if (false) {
      console.warn('[VUX] 抱歉，当前组件[cell]要求更新依赖 vux-loader@latest');
    }
  },
  beforeMount: function beforeMount() {
    this.hasTitleSlot = !!this.$slots.title;
    /* istanbul ignore if */
    if (this.$slots.value && "production" === 'development') {
      console.warn('[VUX] [cell] slot=value 已经废弃，请使用默认 slot 替代');
    }
  },

  computed: {
    labelStyles: function labelStyles() {
      return Object(clean_style["a" /* default */])({
        width: Object(get_parent_prop["a" /* default */])(this, 'labelWidth'),
        textAlign: Object(get_parent_prop["a" /* default */])(this, 'labelAlign'),
        marginRight: Object(get_parent_prop["a" /* default */])(this, 'labelMarginRight')
      });
    },
    valueClass: function valueClass() {
      return {
        'vux-cell-primary': this.primary === 'content' || this.valueAlign === 'left',
        'vux-cell-align-left': this.valueAlign === 'left',
        'vux-cell-arrow-transition': !!this.arrowDirection,
        'vux-cell-arrow-up': this.arrowDirection === 'up',
        'vux-cell-arrow-down': this.arrowDirection === 'down'
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    style: function style() {
      if (this.alignItems) {
        return {
          alignItems: this.alignItems
        };
      }
    }
  },
  methods: {
    onClick: function onClick() {
      /* istanbul ignore next */
      !this.disabled && Object(libs_router["b" /* go */])(this.link, this.$router);
    }
  },
  data: function data() {
    return {
      hasTitleSlot: true,
      hasMounted: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-921916da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/cell/index.vue
var cell_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cell",class:{
    'vux-tap-active': _vm.isLink || !!_vm.link,
    'weui-cell_access': _vm.isLink || !!_vm.link,
    'vux-cell-no-border-intent': !_vm.borderIntent,
    'vux-cell-disabled': _vm.disabled
  },style:(_vm.style),on:{"click":_vm.onClick}},[_c('div',{staticClass:"weui-cell__hd"},[_vm._t("icon")],2),_vm._v(" "),_c('div',{staticClass:"vux-cell-bd",class:{'vux-cell-primary': _vm.primary === 'title' && _vm.valueAlign !== 'left'}},[_c('p',[(_vm.title || _vm.hasTitleSlot)?_c('label',{staticClass:"vux-label",class:_vm.labelClass,style:(_vm.labelStyles)},[_vm._t("title",function(){return [_vm._v(_vm._s(_vm.title))]})],2):_vm._e(),_vm._v(" "),_vm._t("after-title")],2),_vm._v(" "),_c('inline-desc',[_vm._t("inline-desc",function(){return [_vm._v(_vm._s(_vm.inlineDesc))]})],2)],1),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft",class:_vm.valueClass},[_vm._t("value"),_vm._v(" "),_vm._t("default",function(){return [_vm._v(_vm._s(_vm.value))]}),_vm._v(" "),(_vm.isLoading)?_c('i',{staticClass:"weui-loading"}):_vm._e()],2),_vm._v(" "),_vm._t("child")],2)}
var cell_staticRenderFns = []
var cell_esExports = { render: cell_render, staticRenderFns: cell_staticRenderFns }
/* harmony default export */ var src_components_cell = (cell_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/cell/index.vue
function cell_injectStyle (ssrContext) {
  __webpack_require__("uwyH")
}
var cell_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var cell___vue_template_functional__ = false
/* styles */
var cell___vue_styles__ = cell_injectStyle
/* scopeId */
var cell___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var cell___vue_module_identifier__ = null
var cell_Component = cell_normalizeComponent(
  components_cell,
  src_components_cell,
  cell___vue_template_functional__,
  cell___vue_styles__,
  cell___vue_scopeId__,
  cell___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_cell = (cell_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/popup/popup.js
var popup = __webpack_require__("+v63");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/dom.js
var dom = __webpack_require__("te2A");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var components_popup = ({
  name: 'popup',
  props: {
    value: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    width: {
      type: String,
      default: 'auto'
    },
    showMask: {
      type: Boolean,
      default: true
    },
    isTransparent: Boolean,
    hideOnBlur: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'bottom'
    },
    maxHeight: String,
    popupStyle: Object,
    hideOnDeactivated: {
      type: Boolean,
      default: true
    },
    shouldRerenderOnShow: {
      type: Boolean,
      default: false
    },
    shouldScrollTopOnShow: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    // get global layout config
    if (this.$vux && this.$vux.config && this.$vux.config.$layout === 'VIEW_BOX') {
      this.layout = 'VIEW_BOX';
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$overflowScrollingList = document.querySelectorAll('.vux-fix-safari-overflow-scrolling');
    this.$nextTick(function () {
      var _this = _this2;
      _this2.popup = new popup["a" /* default */]({
        showMask: _this.showMask,
        container: _this.$el,
        hideOnBlur: _this.hideOnBlur,
        onOpen: function onOpen() {
          _this.fixSafariOverflowScrolling('auto');
          _this.show = true;
        },
        onClose: function onClose() {
          _this.show = false;
          if (window.__$vuxPopups && keys_default()(window.__$vuxPopups).length > 1) return;
          if (document.querySelector('.vux-popup-dialog.vux-popup-mask-disabled')) return;
          setTimeout(function () {
            _this.fixSafariOverflowScrolling('touch');
          }, 300);
        }
      });
      if (_this2.value) {
        _this2.popup.show();
      }
      _this2.initialShow = false;
    });
  },
  deactivated: function deactivated() {
    if (this.hideOnDeactivated) {
      this.show = false;
    }
    this.removeModalClassName();
  },

  methods: {
    /**
    * https://github.com/airyland/vux/issues/311
    * https://benfrain.com/z-index-stacking-contexts-experimental-css-and-ios-safari/
    */
    fixSafariOverflowScrolling: function fixSafariOverflowScrolling(type) {
      if (!this.$overflowScrollingList.length) return;
      // if (!/iphone/i.test(navigator.userAgent)) return
      for (var i = 0; i < this.$overflowScrollingList.length; i++) {
        this.$overflowScrollingList[i].style.webkitOverflowScrolling = type;
      }
    },
    removeModalClassName: function removeModalClassName() {
      this.layout === 'VIEW_BOX' && dom["a" /* default */].removeClass(document.body, 'vux-modal-open');
    },
    doShow: function doShow() {
      this.popup && this.popup.show();
      this.$emit('on-show');
      this.fixSafariOverflowScrolling('auto');
      this.layout === 'VIEW_BOX' && dom["a" /* default */].addClass(document.body, 'vux-modal-open');
      if (!this.hasFirstShow) {
        this.$emit('on-first-show');
        this.hasFirstShow = true;
      }
    },
    scrollTop: function scrollTop() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$el.scrollTop = 0;
        var box = _this3.$el.querySelectorAll('.vux-scrollable');
        if (box.length) {
          for (var i = 0; i < box.length; i++) {
            box[i].scrollTop = 0;
          }
        }
      });
    }
  },
  data: function data() {
    return {
      layout: '',
      initialShow: true,
      hasFirstShow: false,
      shouldRenderBody: true,
      show: this.value
    };
  },

  computed: {
    styles: function styles() {
      var styles = {};
      if (!this.position || this.position === 'bottom' || this.position === 'top') {
        styles.height = this.height;
      } else {
        styles.width = this.width;
      }

      if (this.maxHeight) {
        styles['max-height'] = this.maxHeight;
      }

      this.isTransparent && (styles['background'] = 'transparent');
      if (this.popupStyle) {
        for (var i in this.popupStyle) {
          styles[i] = this.popupStyle[i];
        }
      }
      return styles;
    }
  },
  watch: {
    value: function value(val) {
      this.show = val;
    },
    show: function show(val) {
      var _this4 = this;

      this.$emit('input', val);
      if (val) {
        // rerender body
        if (this.shouldRerenderOnShow) {
          this.shouldRenderBody = false;
          this.$nextTick(function () {
            _this4.scrollTop();
            _this4.shouldRenderBody = true;
            _this4.doShow();
          });
        } else {
          if (this.shouldScrollTopOnShow) {
            this.scrollTop();
          }
          this.doShow();
        }
      } else {
        this.$emit('on-hide');
        this.show = false;
        this.popup.hide(false);
        setTimeout(function () {
          if (!document.querySelector('.vux-popup-dialog.vux-popup-show')) {
            _this4.fixSafariOverflowScrolling('touch');
          }
          _this4.removeModalClassName();
        }, 200);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.popup && this.popup.destroy();
    this.fixSafariOverflowScrolling('touch');
    this.removeModalClassName();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var src_components_popup = ({
  name: 'popup',
  props: {
    value: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    width: {
      type: String,
      default: 'auto'
    },
    showMask: {
      type: Boolean,
      default: true
    },
    isTransparent: Boolean,
    hideOnBlur: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'bottom'
    },
    maxHeight: String,
    popupStyle: Object,
    hideOnDeactivated: {
      type: Boolean,
      default: true
    },
    shouldRerenderOnShow: {
      type: Boolean,
      default: false
    },
    shouldScrollTopOnShow: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    // get global layout config
    if (this.$vux && this.$vux.config && this.$vux.config.$layout === 'VIEW_BOX') {
      this.layout = 'VIEW_BOX';
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$overflowScrollingList = document.querySelectorAll('.vux-fix-safari-overflow-scrolling');
    this.$nextTick(function () {
      var _this = _this2;
      _this2.popup = new popup["a" /* default */]({
        showMask: _this.showMask,
        container: _this.$el,
        hideOnBlur: _this.hideOnBlur,
        onOpen: function onOpen() {
          _this.fixSafariOverflowScrolling('auto');
          _this.show = true;
        },
        onClose: function onClose() {
          _this.show = false;
          if (window.__$vuxPopups && keys_default()(window.__$vuxPopups).length > 1) return;
          if (document.querySelector('.vux-popup-dialog.vux-popup-mask-disabled')) return;
          setTimeout(function () {
            _this.fixSafariOverflowScrolling('touch');
          }, 300);
        }
      });
      if (_this2.value) {
        _this2.popup.show();
      }
      _this2.initialShow = false;
    });
  },
  deactivated: function deactivated() {
    if (this.hideOnDeactivated) {
      this.show = false;
    }
    this.removeModalClassName();
  },

  methods: {
    /**
    * https://github.com/airyland/vux/issues/311
    * https://benfrain.com/z-index-stacking-contexts-experimental-css-and-ios-safari/
    */
    fixSafariOverflowScrolling: function fixSafariOverflowScrolling(type) {
      if (!this.$overflowScrollingList.length) return;
      // if (!/iphone/i.test(navigator.userAgent)) return
      for (var i = 0; i < this.$overflowScrollingList.length; i++) {
        this.$overflowScrollingList[i].style.webkitOverflowScrolling = type;
      }
    },
    removeModalClassName: function removeModalClassName() {
      this.layout === 'VIEW_BOX' && dom["a" /* default */].removeClass(document.body, 'vux-modal-open');
    },
    doShow: function doShow() {
      this.popup && this.popup.show();
      this.$emit('on-show');
      this.fixSafariOverflowScrolling('auto');
      this.layout === 'VIEW_BOX' && dom["a" /* default */].addClass(document.body, 'vux-modal-open');
      if (!this.hasFirstShow) {
        this.$emit('on-first-show');
        this.hasFirstShow = true;
      }
    },
    scrollTop: function scrollTop() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$el.scrollTop = 0;
        var box = _this3.$el.querySelectorAll('.vux-scrollable');
        if (box.length) {
          for (var i = 0; i < box.length; i++) {
            box[i].scrollTop = 0;
          }
        }
      });
    }
  },
  data: function data() {
    return {
      layout: '',
      initialShow: true,
      hasFirstShow: false,
      shouldRenderBody: true,
      show: this.value
    };
  },

  computed: {
    styles: function styles() {
      var styles = {};
      if (!this.position || this.position === 'bottom' || this.position === 'top') {
        styles.height = this.height;
      } else {
        styles.width = this.width;
      }

      if (this.maxHeight) {
        styles['max-height'] = this.maxHeight;
      }

      this.isTransparent && (styles['background'] = 'transparent');
      if (this.popupStyle) {
        for (var i in this.popupStyle) {
          styles[i] = this.popupStyle[i];
        }
      }
      return styles;
    }
  },
  watch: {
    value: function value(val) {
      this.show = val;
    },
    show: function show(val) {
      var _this4 = this;

      this.$emit('input', val);
      if (val) {
        // rerender body
        if (this.shouldRerenderOnShow) {
          this.shouldRenderBody = false;
          this.$nextTick(function () {
            _this4.scrollTop();
            _this4.shouldRenderBody = true;
            _this4.doShow();
          });
        } else {
          if (this.shouldScrollTopOnShow) {
            this.scrollTop();
          }
          this.doShow();
        }
      } else {
        this.$emit('on-hide');
        this.show = false;
        this.popup.hide(false);
        setTimeout(function () {
          if (!document.querySelector('.vux-popup-dialog.vux-popup-show')) {
            _this4.fixSafariOverflowScrolling('touch');
          }
          _this4.removeModalClassName();
        }, 200);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.popup && this.popup.destroy();
    this.fixSafariOverflowScrolling('touch');
    this.removeModalClassName();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-696d4120","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/popup/index.vue
var popup_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":("vux-popup-animate-" + _vm.position)}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show && !_vm.initialShow),expression:"show && !initialShow"}],staticClass:"vux-popup-dialog",class:[("vux-popup-" + _vm.position), _vm.show ? 'vux-popup-show' : ''],style:(_vm.styles)},[(_vm.shouldRenderBody)?_vm._t("default"):_vm._e()],2)])}
var popup_staticRenderFns = []
var popup_esExports = { render: popup_render, staticRenderFns: popup_staticRenderFns }
/* harmony default export */ var vux_src_components_popup = (popup_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/popup/index.vue
function popup_injectStyle (ssrContext) {
  __webpack_require__("gsj7")
}
var popup_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var popup___vue_template_functional__ = false
/* styles */
var popup___vue_styles__ = popup_injectStyle
/* scopeId */
var popup___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var popup___vue_module_identifier__ = null
var popup_Component = popup_normalizeComponent(
  src_components_popup,
  vux_src_components_popup,
  popup___vue_template_functional__,
  popup___vue_styles__,
  popup___vue_scopeId__,
  popup___vue_module_identifier__
)

/* harmony default export */ var node_modules_vux_src_components_popup = (popup_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var popup_header = ({
  name: 'popup-header',
  props: {
    leftText: String,
    rightText: String,
    title: String,
    showBottomBorder: {
      type: Boolean,
      default: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_popup_header = ({
  name: 'popup-header',
  props: {
    leftText: String,
    rightText: String,
    title: String,
    showBottomBorder: {
      type: Boolean,
      default: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27223f69","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/popup-header/index.vue
var popup_header_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-popup-header",class:_vm.showBottomBorder ? 'vux-1px-b' : ''},[_c('div',{staticClass:"vux-popup-header-left",on:{"click":function($event){return _vm.$emit('on-click-left')}}},[_vm._t("left-text",function(){return [_vm._v(_vm._s(_vm.leftText))]})],2),_vm._v(" "),_c('div',{staticClass:"vux-popup-header-title"},[_vm._t("title",function(){return [_vm._v(_vm._s(_vm.title))]})],2),_vm._v(" "),_c('div',{staticClass:"vux-popup-header-right",on:{"click":function($event){return _vm.$emit('on-click-right')}}},[_vm._t("right-text",function(){return [_vm._v(_vm._s(_vm.rightText))]})],2)])}
var popup_header_staticRenderFns = []
var popup_header_esExports = { render: popup_header_render, staticRenderFns: popup_header_staticRenderFns }
/* harmony default export */ var src_components_popup_header = (popup_header_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/popup-header/index.vue
function popup_header_injectStyle (ssrContext) {
  __webpack_require__("XZOv")
}
var popup_header_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var popup_header___vue_template_functional__ = false
/* styles */
var popup_header___vue_styles__ = popup_header_injectStyle
/* scopeId */
var popup_header___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var popup_header___vue_module_identifier__ = null
var popup_header_Component = popup_header_normalizeComponent(
  components_popup_header,
  src_components_popup_header,
  popup_header___vue_template_functional__,
  popup_header___vue_styles__,
  popup_header___vue_scopeId__,
  popup_header___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_popup_header = (popup_header_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/filters/array2String.js
var array2String = __webpack_require__("LsKW");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/mixin_uuid.js
var mixin_uuid = __webpack_require__("OFgA");

// EXTERNAL MODULE: ./node_modules/vux/src/directives/transfer-dom/index.js
var transfer_dom = __webpack_require__("63CM");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-picker/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var popup_picker_getObject = function getObject(obj) {
  return JSON.parse(stringify_default()(obj));
};

/* harmony default export */ var popup_picker = ({
  name: 'popup-picker',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  created: function created() {
    if (typeof this.show !== 'undefined') {
      this.showValue = this.show;
    }
  },

  mixins: [mixin_uuid["a" /* default */]],
  components: {
    Picker: vux_src_components_picker,
    Cell: vux_src_components_cell,
    Popup: node_modules_vux_src_components_popup,
    PopupHeader: vux_src_components_popup_header,
    Flexbox: flexbox["a" /* Flexbox */],
    FlexboxItem: flexbox["b" /* FlexboxItem */],
    InlineDesc: inline_desc["a" /* default */]
  },
  filters: {
    array2string: array2String["a" /* default */],
    value2name: value2name["a" /* default */]
  },
  props: {
    valueTextAlign: {
      type: String,
      default: 'right'
    },
    title: String,
    cancelText: String,
    confirmText: String,
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    placeholder: String,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showName: Boolean,
    inlineDesc: [String, Number, Array, Object, Boolean],
    showCell: {
      type: Boolean,
      default: true
    },
    show: Boolean,
    displayFormat: Function,
    isTransferDom: {
      type: Boolean,
      default: true
    },
    columnWidth: Array,
    popupStyle: Object,
    popupTitle: String,
    disabled: Boolean
  },
  computed: {
    labelStyles: function labelStyles() {
      return {
        display: 'block',
        width: this.$parent && (this.$parent.labelWidth || this.$parent.$parent.labelWidth) || 'auto',
        textAlign: this.$parent && (this.$parent.labelAlign || this.$parent.$parent.labelAlign),
        marginRight: this.$parent && (this.$parent.labelMarginRight || this.$parent.$parent.labelMarginRight)
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    }
  },
  methods: {
    value2name: value2name["a" /* default */],
    getNameValues: function getNameValues() {
      return Object(value2name["a" /* default */])(this.currentValue, this.data);
    },
    onClick: function onClick() {
      if (!this.disabled) {
        this.showValue = true;
      }
    },
    onHide: function onHide(type) {
      this.showValue = false;
      if (type) {
        this.closeType = true;
        this.currentValue = popup_picker_getObject(this.tempValue);
      }
      if (!type) {
        this.closeType = false;
        if (this.value.length > 0) {
          this.tempValue = popup_picker_getObject(this.currentValue);
        }
      }
    },
    onPopupShow: function onPopupShow() {
      // reset close type to false
      this.closeType = false;
      this.$emit('on-show');
    },
    onPopupHide: function onPopupHide(val) {
      if (this.value.length > 0) {
        this.tempValue = popup_picker_getObject(this.currentValue);
      }
      this.$emit('on-hide', this.closeType);
    },
    onPickerChange: function onPickerChange(val) {
      if (stringify_default()(this.currentValue) !== stringify_default()(val)) {
        // if has value, replace it
        if (this.value.length) {
          var nowData = stringify_default()(this.data);
          if (nowData !== this.currentData && this.currentData !== '[]') {
            this.tempValue = popup_picker_getObject(val);
          }
          this.currentData = nowData;
        } else {// if no value, stay quiet
          // if set to auto update, do update the value
        }
      }
      var _val = popup_picker_getObject(val);
      this.$emit('on-shadow-change', _val, Object(value2name["a" /* default */])(_val, this.data).split(' '));
    }
  },
  watch: {
    value: function value(val) {
      if (stringify_default()(val) !== stringify_default()(this.tempValue)) {
        this.tempValue = popup_picker_getObject(val);
        this.currentValue = popup_picker_getObject(val);
      }
    },
    currentValue: function currentValue(val) {
      this.$emit('input', popup_picker_getObject(val));
      this.$emit('on-change', popup_picker_getObject(val));
    },
    show: function show(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('update:show', val);
    }
  },
  data: function data() {
    return {
      onShowProcess: false,
      tempValue: popup_picker_getObject(this.value),
      closeType: false,
      currentData: stringify_default()(this.data), // used for detecting if it is after data change
      showValue: false,
      currentValue: this.value
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-picker/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var components_popup_picker_getObject = function getObject(obj) {
  return JSON.parse(stringify_default()(obj));
};

/* harmony default export */ var components_popup_picker = ({
  name: 'popup-picker',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  created: function created() {
    if (typeof this.show !== 'undefined') {
      this.showValue = this.show;
    }
  },

  mixins: [mixin_uuid["a" /* default */]],
  components: {
    Picker: vux_src_components_picker,
    Cell: vux_src_components_cell,
    Popup: node_modules_vux_src_components_popup,
    PopupHeader: vux_src_components_popup_header,
    Flexbox: flexbox["a" /* Flexbox */],
    FlexboxItem: flexbox["b" /* FlexboxItem */],
    InlineDesc: inline_desc["a" /* default */]
  },
  filters: {
    array2string: array2String["a" /* default */],
    value2name: value2name["a" /* default */]
  },
  props: {
    valueTextAlign: {
      type: String,
      default: 'right'
    },
    title: String,
    cancelText: String,
    confirmText: String,
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    placeholder: String,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showName: Boolean,
    inlineDesc: [String, Number, Array, Object, Boolean],
    showCell: {
      type: Boolean,
      default: true
    },
    show: Boolean,
    displayFormat: Function,
    isTransferDom: {
      type: Boolean,
      default: true
    },
    columnWidth: Array,
    popupStyle: Object,
    popupTitle: String,
    disabled: Boolean
  },
  computed: {
    labelStyles: function labelStyles() {
      return {
        display: 'block',
        width: this.$parent && (this.$parent.labelWidth || this.$parent.$parent.labelWidth) || 'auto',
        textAlign: this.$parent && (this.$parent.labelAlign || this.$parent.$parent.labelAlign),
        marginRight: this.$parent && (this.$parent.labelMarginRight || this.$parent.$parent.labelMarginRight)
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    }
  },
  methods: {
    value2name: value2name["a" /* default */],
    getNameValues: function getNameValues() {
      return Object(value2name["a" /* default */])(this.currentValue, this.data);
    },
    onClick: function onClick() {
      if (!this.disabled) {
        this.showValue = true;
      }
    },
    onHide: function onHide(type) {
      this.showValue = false;
      if (type) {
        this.closeType = true;
        this.currentValue = components_popup_picker_getObject(this.tempValue);
      }
      if (!type) {
        this.closeType = false;
        if (this.value.length > 0) {
          this.tempValue = components_popup_picker_getObject(this.currentValue);
        }
      }
    },
    onPopupShow: function onPopupShow() {
      // reset close type to false
      this.closeType = false;
      this.$emit('on-show');
    },
    onPopupHide: function onPopupHide(val) {
      if (this.value.length > 0) {
        this.tempValue = components_popup_picker_getObject(this.currentValue);
      }
      this.$emit('on-hide', this.closeType);
    },
    onPickerChange: function onPickerChange(val) {
      if (stringify_default()(this.currentValue) !== stringify_default()(val)) {
        // if has value, replace it
        if (this.value.length) {
          var nowData = stringify_default()(this.data);
          if (nowData !== this.currentData && this.currentData !== '[]') {
            this.tempValue = components_popup_picker_getObject(val);
          }
          this.currentData = nowData;
        } else {// if no value, stay quiet
          // if set to auto update, do update the value
        }
      }
      var _val = components_popup_picker_getObject(val);
      this.$emit('on-shadow-change', _val, Object(value2name["a" /* default */])(_val, this.data).split(' '));
    }
  },
  watch: {
    value: function value(val) {
      if (stringify_default()(val) !== stringify_default()(this.tempValue)) {
        this.tempValue = components_popup_picker_getObject(val);
        this.currentValue = components_popup_picker_getObject(val);
      }
    },
    currentValue: function currentValue(val) {
      this.$emit('input', components_popup_picker_getObject(val));
      this.$emit('on-change', components_popup_picker_getObject(val));
    },
    show: function show(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('update:show', val);
    }
  },
  data: function data() {
    return {
      onShowProcess: false,
      tempValue: components_popup_picker_getObject(this.value),
      closeType: false,
      currentData: stringify_default()(this.data), // used for detecting if it is after data change
      showValue: false,
      currentValue: this.value
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-413ccea6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/popup-picker/index.vue
var popup_picker_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-cell-box"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCell),expression:"showCell"}],staticClass:"weui-cell vux-tap-active",class:{'weui-cell_access': !_vm.disabled},on:{"click":_vm.onClick}},[_c('div',{staticClass:"weui-cell__hd"},[_vm._t("title",function(){return [(_vm.title)?_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:(_vm.labelStyles),domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e()]},{"labelClass":"weui-label","labelStyle":_vm.labelStyles,"labelTitle":_vm.title}),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"vux-cell-primary vux-popup-picker-select-box"},[_c('div',{staticClass:"vux-popup-picker-select",style:({textAlign: _vm.valueTextAlign})},[(!_vm.displayFormat && !_vm.showName && _vm.value.length)?_c('span',{staticClass:"vux-popup-picker-value vux-cell-value"},[_vm._v(_vm._s(_vm._f("array2string")(_vm.value)))]):_vm._e(),_vm._v(" "),(!_vm.displayFormat && _vm.showName && _vm.value.length)?_c('span',{staticClass:"vux-popup-picker-value vux-cell-value"},[_vm._v(_vm._s(_vm._f("value2name")(_vm.value,_vm.data)))]):_vm._e(),_vm._v(" "),(_vm.displayFormat && _vm.value.length)?_c('span',{staticClass:"vux-popup-picker-value vux-cell-value"},[_vm._v(_vm._s(_vm.displayFormat(_vm.value, _vm.value2name(_vm.value, _vm.data))))]):_vm._e(),_vm._v(" "),(!_vm.value.length && _vm.placeholder)?_c('span',{staticClass:"vux-popup-picker-placeholder vux-cell-placeholder",domProps:{"textContent":_vm._s(_vm.placeholder)}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"})]),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom",value:(_vm.isTransferDom),expression:"isTransferDom"}]},[_c('popup',{staticClass:"vux-popup-picker",attrs:{"id":("vux-popup-picker-" + _vm.uuid),"popup-style":_vm.popupStyle},on:{"on-hide":_vm.onPopupHide,"on-show":_vm.onPopupShow},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[_c('div',{staticClass:"vux-popup-picker-container"},[_c('popup-header',{attrs:{"left-text":_vm.cancelText || '取消',"right-text":_vm.confirmText || '完成',"title":_vm.popupTitle},on:{"on-click-left":function($event){return _vm.onHide(false)},"on-click-right":function($event){return _vm.onHide(true)}}}),_vm._v(" "),_c('picker',{attrs:{"data":_vm.data,"columns":_vm.columns,"fixed-columns":_vm.fixedColumns,"container":'#vux-popup-picker-'+_vm.uuid,"column-width":_vm.columnWidth},on:{"on-change":_vm.onPickerChange},model:{value:(_vm.tempValue),callback:function ($$v) {_vm.tempValue=$$v},expression:"tempValue"}})],1)])],1)])}
var popup_picker_staticRenderFns = []
var popup_picker_esExports = { render: popup_picker_render, staticRenderFns: popup_picker_staticRenderFns }
/* harmony default export */ var src_components_popup_picker = (popup_picker_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/popup-picker/index.vue
function popup_picker_injectStyle (ssrContext) {
  __webpack_require__("5jbP")
}
var popup_picker_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var popup_picker___vue_template_functional__ = false
/* styles */
var popup_picker___vue_styles__ = popup_picker_injectStyle
/* scopeId */
var popup_picker___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var popup_picker___vue_module_identifier__ = null
var popup_picker_Component = popup_picker_normalizeComponent(
  components_popup_picker,
  src_components_popup_picker,
  popup_picker___vue_template_functional__,
  popup_picker___vue_styles__,
  popup_picker___vue_scopeId__,
  popup_picker___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_popup_picker = (popup_picker_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-address/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var x_address = ({
  name: 'x-address',
  components: {
    PopupPicker: vux_src_components_popup_picker
  },
  props: {
    title: {
      type: String,
      required: true
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    columns: {
      type: Number,
      default: function _default() {
        return 3;
      }
    },
    rawValue: Boolean,
    list: {
      type: Array,
      required: true
    },
    labelWidth: String,
    inlineDesc: String,
    placeholder: String,
    hideDistrict: Boolean,
    valueTextAlign: String,
    confirmText: String,
    cancelText: String,
    displayFormat: {
      type: Function,
      default: function _default(val, names) {
        return names;
      }
    },
    popupStyle: Object,
    popupTitle: String,
    show: Boolean,
    disabled: Boolean
  },
  created: function created() {
    if (this.currentValue.length && this.rawValue) {
      var parsedVal = Object(name2value["a" /* default */])(this.currentValue, this.list);
      if (/__/.test(parsedVal)) {
        console.error('[VUX] Wrong address value', this.currentValue);
        this.currentValue = [];
      } else {
        this.currentValue = parsedVal.split(' ');
      }
    }
    if (this.show) {
      this.showValue = true;
    }
  },

  methods: {
    emitHide: function emitHide(val) {
      this.$emit('on-hide', val);
    },
    getAddressName: function getAddressName() {
      return Object(value2name["a" /* default */])(this.value, this.list);
    },
    onShadowChange: function onShadowChange(ids, names) {
      this.$emit('on-shadow-change', ids, names);
    }
  },
  data: function data() {
    return {
      currentValue: this.value,
      showValue: false
    };
  },

  computed: {
    nameValue: function nameValue() {
      return Object(value2name["a" /* default */])(this.currentValue, this.list);
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    }
  },
  watch: {
    currentValue: function currentValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (val.length && !/\d+/.test(val[0])) {
        var id = Object(name2value["a" /* default */])(val, this.list).split(' ');
        if (id[0] !== '__' && id[1] !== '__') {
          this.currentValue = id;
          return;
        }
      }
      this.currentValue = val;
    },
    show: function show(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-address/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var components_x_address = ({
  name: 'x-address',
  components: {
    PopupPicker: vux_src_components_popup_picker
  },
  props: {
    title: {
      type: String,
      required: true
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    columns: {
      type: Number,
      default: function _default() {
        return 3;
      }
    },
    rawValue: Boolean,
    list: {
      type: Array,
      required: true
    },
    labelWidth: String,
    inlineDesc: String,
    placeholder: String,
    hideDistrict: Boolean,
    valueTextAlign: String,
    confirmText: String,
    cancelText: String,
    displayFormat: {
      type: Function,
      default: function _default(val, names) {
        return names;
      }
    },
    popupStyle: Object,
    popupTitle: String,
    show: Boolean,
    disabled: Boolean
  },
  created: function created() {
    if (this.currentValue.length && this.rawValue) {
      var parsedVal = Object(name2value["a" /* default */])(this.currentValue, this.list);
      if (/__/.test(parsedVal)) {
        console.error('[VUX] Wrong address value', this.currentValue);
        this.currentValue = [];
      } else {
        this.currentValue = parsedVal.split(' ');
      }
    }
    if (this.show) {
      this.showValue = true;
    }
  },

  methods: {
    emitHide: function emitHide(val) {
      this.$emit('on-hide', val);
    },
    getAddressName: function getAddressName() {
      return Object(value2name["a" /* default */])(this.value, this.list);
    },
    onShadowChange: function onShadowChange(ids, names) {
      this.$emit('on-shadow-change', ids, names);
    }
  },
  data: function data() {
    return {
      currentValue: this.value,
      showValue: false
    };
  },

  computed: {
    nameValue: function nameValue() {
      return Object(value2name["a" /* default */])(this.currentValue, this.list);
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    }
  },
  watch: {
    currentValue: function currentValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (val.length && !/\d+/.test(val[0])) {
        var id = Object(name2value["a" /* default */])(val, this.list).split(' ');
        if (id[0] !== '__' && id[1] !== '__') {
          this.currentValue = id;
          return;
        }
      }
      this.currentValue = val;
    },
    show: function show(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e0cd6bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-address/index.vue
var x_address_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('popup-picker',{attrs:{"fixed-columns":_vm.hideDistrict ? 2 : 0,"columns":_vm.columns,"data":_vm.list,"title":_vm.title,"show-name":"","inline-desc":_vm.inlineDesc,"placeholder":_vm.placeholder,"value-text-align":_vm.valueTextAlign,"confirm-text":_vm.confirmText,"cancel-text":_vm.cancelText,"display-format":_vm.displayFormat,"popup-style":_vm.popupStyle,"popup-title":_vm.popupTitle,"show":_vm.showValue,"disabled":_vm.disabled},on:{"update:show":function($event){_vm.showValue=$event},"on-shadow-change":_vm.onShadowChange,"on-hide":_vm.emitHide,"on-show":function($event){return _vm.$emit('on-show')}},scopedSlots:_vm._u([{key:"title",fn:function(props){return [_vm._t("title",function(){return [(props.labelTitle)?_c('label',{class:[props.labelClass,_vm.labelClass],style:(props.labelStyle),domProps:{"innerHTML":_vm._s(props.labelTitle)}}):_vm._e()]},{"labelClass":props.labelClass,"labelStyle":props.labelStyles,"labelTitle":props.title})]}}],null,true),model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}})}
var x_address_staticRenderFns = []
var x_address_esExports = { render: x_address_render, staticRenderFns: x_address_staticRenderFns }
/* harmony default export */ var src_components_x_address = (x_address_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-address/index.vue
var x_address_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_address___vue_template_functional__ = false
/* styles */
var x_address___vue_styles__ = null
/* scopeId */
var x_address___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_address___vue_module_identifier__ = null
var x_address_Component = x_address_normalizeComponent(
  components_x_address,
  src_components_x_address,
  x_address___vue_template_functional__,
  x_address___vue_styles__,
  x_address___vue_scopeId__,
  x_address___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_address = (x_address_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/box/index.vue
//
//
//
//

/* harmony default export */ var box = ({
  name: 'box',
  props: {
    gap: String
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/box/index.vue
//
//
//
//

/* harmony default export */ var components_box = ({
  name: 'box',
  props: {
    gap: String
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d06311b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/box/index.vue
var box_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({margin:_vm.gap})},[_vm._t("default")],2)}
var box_staticRenderFns = []
var box_esExports = { render: box_render, staticRenderFns: box_staticRenderFns }
/* harmony default export */ var src_components_box = (box_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/box/index.vue
var box_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var box___vue_template_functional__ = false
/* styles */
var box___vue_styles__ = null
/* scopeId */
var box___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var box___vue_module_identifier__ = null
var box_Component = box_normalizeComponent(
  components_box,
  src_components_box,
  box___vue_template_functional__,
  box___vue_styles__,
  box___vue_scopeId__,
  box___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_box = (box_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/vux/src/components/datetime/format.js
var format = __webpack_require__("ghQH");

// EXTERNAL MODULE: ./node_modules/vux/src/components/inline-calendar/util.js
var util = __webpack_require__("1bLG");

// EXTERNAL MODULE: ./node_modules/vux/src/components/inline-calendar/props.js
var inline_calendar_props = __webpack_require__("0sN4");

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/calendar-marks.js
var calendar_marks = __webpack_require__("o6oK");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-calendar/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var inline_calendar = ({
  name: 'inline-calendar',
  mixins: [calendar_marks["a" /* default */]],
  props: Object(inline_calendar_props["a" /* default */])(),
  data: function data() {
    return {
      multi: false,
      year: 0,
      month: 0,
      days: [],
      today: Object(format["a" /* default */])(new Date(), 'YYYY-MM-DD'),
      months: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
      currentValue: '',
      viewChangeEventCount: -1
    };
  },
  created: function created() {
    this.currentValue = this.value;
    this.multi = Object.prototype.toString.call(this.currentValue) === '[object Array]';

    if (this.multi) {
      for (var i = 0; i < this.currentValue.length; i++) {
        this.$set(this.currentValue, i, this.convertDate(this.currentValue[i]));
      }
    } else {
      this.currentValue = this.convertDate(this.currentValue);
    }

    this.render(this.renderMonth[0], this.renderMonth[1] - 1);
  },

  computed: {
    _weeksList: function _weeksList() {
      if (this.weeksList && this.weeksList.length) {
        return this.weeksList;
      }
      if (!this.weeksList || !this.weeksList.length) {
        // tip for older vux-loader
        if (false) {
          if (process.env.NODE_ENV === 'development') {
            console.warn('[VUX warn] 抱歉，inline-calendar 组件需要升级 vux-loader 到最新版本才能正常使用');
          }
          return ['日', '一', '二', '三', '四', '五', '六'];
        } else {
          if (false) {
            // eslint-disable-line
            return ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
          } else if (true) {
            // eslint-disable-line
            return ['日', '一', '二', '三', '四', '五', '六'];
          } else if (V_LOCALE === 'MULTI') {
            // eslint-disable-line
            return [0, 0, 0, 0, 0, 0, 0];
          }
        }
      }
    },
    _replaceTextList: function _replaceTextList() {
      var rs = {};
      for (var i in this.replaceTextList) {
        rs[this.convertDate(i)] = this.replaceTextList[i];
      }
      return rs;
    },
    currentYearMonth: function currentYearMonth() {
      return this.year + this.month;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = this.multi ? val : this.convertDate(val);
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', this.currentValue);
      this.$emit('on-change', this.currentValue);

      if (this.renderOnValueChange) {
        // if on the same year+month, stay quiet
        if (val && oldVal && val.slice(0, 7) === oldVal.slice(0, 7)) {
          return;
        }
        this.render(null, null, 'value change');
      }
    },
    renderFunction: function renderFunction() {
      this.render(this.year, this.month, this.currentValue);
    },
    renderMonth: function renderMonth(val) {
      if (val && val.length === 2) {
        this.render(val[0], val[1] - 1);
      }
    },
    returnSixRows: function returnSixRows(val) {
      this.render(this.year, this.month);
    },
    startDate: function startDate(val) {
      this.render(this.year, this.month);
    },
    endDate: function endDate(val) {
      this.render(this.year, this.month);
    },
    disablePast: function disablePast() {
      this.render(this.year, this.month);
    },
    disableFuture: function disableFuture() {
      this.render(this.year, this.month);
    },
    currentYearMonth: function currentYearMonth() {
      var lastLine = this.days[this.days.length - 1];
      var lastDate = lastLine[lastLine.length - 1];

      var days = [];
      this.days.forEach(function (line) {
        days = days.concat(line);
      });
      days = days.filter(function (date) {
        return !date.isLastMonth && !date.isNextMonth;
      });
      this.viewChangeEventCount++;
      this.$emit('on-view-change', {
        year: this.year,
        month: this.month + 1,
        firstDate: this.days[0][0].formatedDate,
        lastDate: lastDate.formatedDate,
        firstCurrentMonthDate: days[0].formatedDate,
        lastCurrentMonthDate: days[days.length - 1].formatedDate,
        allDates: this.days
      }, this.viewChangeEventCount);
    }
  },
  methods: {
    processDateItem: function processDateItem(item) {
      var temp = JSON.parse(stringify_default()(item));
      temp.isDisabled = this.isDisabled(item);
      temp.isBetween = this.isBetween(item.formatedDate);
      return temp;
    },
    isBetween: function isBetween(formatedDate) {
      return Object(util["b" /* isBetween */])(formatedDate, this.disablePast, this.disableFuture, this.startDate, this.endDate);
    },
    isDisabled: function isDisabled(date) {
      var disabled = !this.isBetween(date.formatedDate);
      disabled = disabled || date.isWeekend && this.disableWeekend;
      disabled = disabled || date.isNextMonth || date.isLastMonth;

      if (!this.disableDateFunction) {
        return disabled;
      } else {
        var value = this.disableDateFunction(date);
        if (typeof value === 'undefined') {
          return disabled;
        } else {
          return value;
        }
      }
    },
    switchViewToToday: function switchViewToToday() {
      var today = new Date();
      this.render(today.getFullYear(), today.getMonth());
    },
    switchViewToCurrentValue: function switchViewToCurrentValue() {
      if (!this.currentValue || this.multi && !this.currentValue.length) {
        return;
      }

      var value = void 0;
      var year = void 0;
      var month = void 0;
      if (typeof this.currentValue === 'string') {
        value = this.currentValue;
      } else {
        value = this.currentValue[0];
      }
      var splitList = value.split('-');
      year = parseInt(splitList[0], 10);
      month = parseInt(splitList[1], 10);
      this.switchViewToMonth(year, month);
    },
    switchViewToMonth: function switchViewToMonth(year, month) {
      if (!year || !month) {
        return this.switchViewToToday();
      }
      this.render(year, month - 1);
    },
    getDates: function getDates() {
      return this.days;
    },
    replaceText: function replaceText(day, formatDay) {
      var text = this._replaceTextList[formatDay];
      if (!text && typeof text === 'undefined') {
        return day;
      } else {
        return text;
      }
    },
    convertDate: function convertDate(date) {
      return date === 'TODAY' ? this.today : date;
    },
    buildClass: function buildClass(index, child) {
      var isCurrent = false;
      if (!child.isLastMonth && !child.isNextMonth) {
        if (this.multi && this.currentValue.length > 0) {
          isCurrent = this.currentValue.indexOf(this.formatDate(this.year, this.month, child)) > -1;
        } else {
          isCurrent = this.currentValue === this.formatDate(this.year, this.month, child);
        }
      }
      var className = defineProperty_default()({
        'current': isCurrent,
        'is-disabled': this.isDisabled(child),
        'is-today': child.isToday
      }, 'is-week-' + index, true);
      return className;
    },
    render: function render(year, month) {
      var force = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      var data = null;
      var value = this.multi ? this.currentValue[this.currentValue.length - 1] : this.currentValue;
      data = Object(util["a" /* getDays */])({
        year: year,
        month: month,
        value: value,
        rangeBegin: this.convertDate(this.startDate),
        rangeEnd: this.convertDate(this.endDate),
        returnSixRows: this.returnSixRows,
        disablePast: this.disablePast,
        disableFuture: this.disableFuture
      });

      if (this.year === data.year && this.month === data.month && !force) {
        return;
      }
      this.year = data.year;
      this.month = data.month;
      this.days = data.days;
    },

    formatDate: function formatDate(year, month, child) {
      return [year, Object(util["c" /* zero */])(child.month + 1), Object(util["c" /* zero */])(child.day)].join('-');
    },
    prev: function prev() {
      if (this.month === 0) {
        this.month = 11;
        this.year = this.year - 1;
      } else {
        this.month = this.month - 1;
      }
      this.render(this.year, this.month, true);
    },
    next: function next() {
      if (this.month === 11) {
        this.month = 0;
        this.year = this.year + 1;
      } else {
        this.month = this.month + 1;
      }
      this.render(this.year, this.month, true);
    },
    go: function go(year, month) {
      this.render(year, month, true);
    },
    select: function select(k1, k2, data) {
      if (data.isLastMonth && !this.showLastMonth) {
        return;
      }
      if (data.isNextMonth && !this.showNextMonth) {
        return;
      }
      if (!this.isBetween(data.formatedDate)) {
        return;
      }

      if (this.isDisabled(data)) {
        // not in range
        if (!this.isBetween(data.formatedDate)) {
          return;
        } else {
          // in range but disabled by disableDateFunction
          if (this.disableDateFunction && this.disableDateFunction(data)) {
            return;
          }
          if (data.isWeekend && this.disableWeekend) {
            return;
          }
        }
      }
      var _currentValue = null;
      if (!data.isLastMonth && !data.isNextMonth) {
        this.days[k1][k2].current = true;
        _currentValue = [this.year, Object(util["c" /* zero */])(this.month + 1), Object(util["c" /* zero */])(this.days[k1][k2].day)].join('-');
      } else {
        _currentValue = [data.year, Object(util["c" /* zero */])(data.month + 1), Object(util["c" /* zero */])(data.day)].join('-');
      }
      if (this.multi) {
        var index = this.currentValue.indexOf(_currentValue);
        if (index > -1) {
          this.currentValue.splice(index, 1);
        } else {
          this.currentValue.push(_currentValue);
        }
      } else {
        this.currentValue = _currentValue;
        this.$emit('on-select-single-date', this.currentValue);
      }

      if (this.multi) {
        for (var i = 0; i < this.currentValue.length; i++) {
          this.$set(this.currentValue, i, this.convertDate(this.currentValue[i]));
        }
      } else {
        this.currentValue = this.convertDate(this.currentValue);
      }

      if (this.renderOnValueChange) {
        this.render(null, null);
      }
    },
    showChild: function showChild(year, month, child) {
      if (this.replaceText(child.day, this.formatDate(year, month, child))) {
        return !child.isLastMonth && !child.isNextMonth || child.isLastMonth && this.showLastMonth || child.isNextMonth && this.showNextMonth;
      } else {
        return false;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-calendar/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var components_inline_calendar = ({
  name: 'inline-calendar',
  mixins: [calendar_marks["a" /* default */]],
  props: Object(inline_calendar_props["a" /* default */])(),
  data: function data() {
    return {
      multi: false,
      year: 0,
      month: 0,
      days: [],
      today: Object(format["a" /* default */])(new Date(), 'YYYY-MM-DD'),
      months: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
      currentValue: '',
      viewChangeEventCount: -1
    };
  },
  created: function created() {
    this.currentValue = this.value;
    this.multi = Object.prototype.toString.call(this.currentValue) === '[object Array]';

    if (this.multi) {
      for (var i = 0; i < this.currentValue.length; i++) {
        this.$set(this.currentValue, i, this.convertDate(this.currentValue[i]));
      }
    } else {
      this.currentValue = this.convertDate(this.currentValue);
    }

    this.render(this.renderMonth[0], this.renderMonth[1] - 1);
  },

  computed: {
    _weeksList: function _weeksList() {
      if (this.weeksList && this.weeksList.length) {
        return this.weeksList;
      }
      if (!this.weeksList || !this.weeksList.length) {
        // tip for older vux-loader
        if (false) {
          if (process.env.NODE_ENV === 'development') {
            console.warn('[VUX warn] 抱歉，inline-calendar 组件需要升级 vux-loader 到最新版本才能正常使用');
          }
          return ['日', '一', '二', '三', '四', '五', '六'];
        } else {
          if (false) {
            // eslint-disable-line
            return ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
          } else if (true) {
            // eslint-disable-line
            return ['日', '一', '二', '三', '四', '五', '六'];
          } else if (V_LOCALE === 'MULTI') {
            // eslint-disable-line
            return [0, 0, 0, 0, 0, 0, 0];
          }
        }
      }
    },
    _replaceTextList: function _replaceTextList() {
      var rs = {};
      for (var i in this.replaceTextList) {
        rs[this.convertDate(i)] = this.replaceTextList[i];
      }
      return rs;
    },
    currentYearMonth: function currentYearMonth() {
      return this.year + this.month;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = this.multi ? val : this.convertDate(val);
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', this.currentValue);
      this.$emit('on-change', this.currentValue);

      if (this.renderOnValueChange) {
        // if on the same year+month, stay quiet
        if (val && oldVal && val.slice(0, 7) === oldVal.slice(0, 7)) {
          return;
        }
        this.render(null, null, 'value change');
      }
    },
    renderFunction: function renderFunction() {
      this.render(this.year, this.month, this.currentValue);
    },
    renderMonth: function renderMonth(val) {
      if (val && val.length === 2) {
        this.render(val[0], val[1] - 1);
      }
    },
    returnSixRows: function returnSixRows(val) {
      this.render(this.year, this.month);
    },
    startDate: function startDate(val) {
      this.render(this.year, this.month);
    },
    endDate: function endDate(val) {
      this.render(this.year, this.month);
    },
    disablePast: function disablePast() {
      this.render(this.year, this.month);
    },
    disableFuture: function disableFuture() {
      this.render(this.year, this.month);
    },
    currentYearMonth: function currentYearMonth() {
      var lastLine = this.days[this.days.length - 1];
      var lastDate = lastLine[lastLine.length - 1];

      var days = [];
      this.days.forEach(function (line) {
        days = days.concat(line);
      });
      days = days.filter(function (date) {
        return !date.isLastMonth && !date.isNextMonth;
      });
      this.viewChangeEventCount++;
      this.$emit('on-view-change', {
        year: this.year,
        month: this.month + 1,
        firstDate: this.days[0][0].formatedDate,
        lastDate: lastDate.formatedDate,
        firstCurrentMonthDate: days[0].formatedDate,
        lastCurrentMonthDate: days[days.length - 1].formatedDate,
        allDates: this.days
      }, this.viewChangeEventCount);
    }
  },
  methods: {
    processDateItem: function processDateItem(item) {
      var temp = JSON.parse(stringify_default()(item));
      temp.isDisabled = this.isDisabled(item);
      temp.isBetween = this.isBetween(item.formatedDate);
      return temp;
    },
    isBetween: function isBetween(formatedDate) {
      return Object(util["b" /* isBetween */])(formatedDate, this.disablePast, this.disableFuture, this.startDate, this.endDate);
    },
    isDisabled: function isDisabled(date) {
      var disabled = !this.isBetween(date.formatedDate);
      disabled = disabled || date.isWeekend && this.disableWeekend;
      disabled = disabled || date.isNextMonth || date.isLastMonth;

      if (!this.disableDateFunction) {
        return disabled;
      } else {
        var value = this.disableDateFunction(date);
        if (typeof value === 'undefined') {
          return disabled;
        } else {
          return value;
        }
      }
    },
    switchViewToToday: function switchViewToToday() {
      var today = new Date();
      this.render(today.getFullYear(), today.getMonth());
    },
    switchViewToCurrentValue: function switchViewToCurrentValue() {
      if (!this.currentValue || this.multi && !this.currentValue.length) {
        return;
      }

      var value = void 0;
      var year = void 0;
      var month = void 0;
      if (typeof this.currentValue === 'string') {
        value = this.currentValue;
      } else {
        value = this.currentValue[0];
      }
      var splitList = value.split('-');
      year = parseInt(splitList[0], 10);
      month = parseInt(splitList[1], 10);
      this.switchViewToMonth(year, month);
    },
    switchViewToMonth: function switchViewToMonth(year, month) {
      if (!year || !month) {
        return this.switchViewToToday();
      }
      this.render(year, month - 1);
    },
    getDates: function getDates() {
      return this.days;
    },
    replaceText: function replaceText(day, formatDay) {
      var text = this._replaceTextList[formatDay];
      if (!text && typeof text === 'undefined') {
        return day;
      } else {
        return text;
      }
    },
    convertDate: function convertDate(date) {
      return date === 'TODAY' ? this.today : date;
    },
    buildClass: function buildClass(index, child) {
      var isCurrent = false;
      if (!child.isLastMonth && !child.isNextMonth) {
        if (this.multi && this.currentValue.length > 0) {
          isCurrent = this.currentValue.indexOf(this.formatDate(this.year, this.month, child)) > -1;
        } else {
          isCurrent = this.currentValue === this.formatDate(this.year, this.month, child);
        }
      }
      var className = defineProperty_default()({
        'current': isCurrent,
        'is-disabled': this.isDisabled(child),
        'is-today': child.isToday
      }, 'is-week-' + index, true);
      return className;
    },
    render: function render(year, month) {
      var force = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      var data = null;
      var value = this.multi ? this.currentValue[this.currentValue.length - 1] : this.currentValue;
      data = Object(util["a" /* getDays */])({
        year: year,
        month: month,
        value: value,
        rangeBegin: this.convertDate(this.startDate),
        rangeEnd: this.convertDate(this.endDate),
        returnSixRows: this.returnSixRows,
        disablePast: this.disablePast,
        disableFuture: this.disableFuture
      });

      if (this.year === data.year && this.month === data.month && !force) {
        return;
      }
      this.year = data.year;
      this.month = data.month;
      this.days = data.days;
    },

    formatDate: function formatDate(year, month, child) {
      return [year, Object(util["c" /* zero */])(child.month + 1), Object(util["c" /* zero */])(child.day)].join('-');
    },
    prev: function prev() {
      if (this.month === 0) {
        this.month = 11;
        this.year = this.year - 1;
      } else {
        this.month = this.month - 1;
      }
      this.render(this.year, this.month, true);
    },
    next: function next() {
      if (this.month === 11) {
        this.month = 0;
        this.year = this.year + 1;
      } else {
        this.month = this.month + 1;
      }
      this.render(this.year, this.month, true);
    },
    go: function go(year, month) {
      this.render(year, month, true);
    },
    select: function select(k1, k2, data) {
      if (data.isLastMonth && !this.showLastMonth) {
        return;
      }
      if (data.isNextMonth && !this.showNextMonth) {
        return;
      }
      if (!this.isBetween(data.formatedDate)) {
        return;
      }

      if (this.isDisabled(data)) {
        // not in range
        if (!this.isBetween(data.formatedDate)) {
          return;
        } else {
          // in range but disabled by disableDateFunction
          if (this.disableDateFunction && this.disableDateFunction(data)) {
            return;
          }
          if (data.isWeekend && this.disableWeekend) {
            return;
          }
        }
      }
      var _currentValue = null;
      if (!data.isLastMonth && !data.isNextMonth) {
        this.days[k1][k2].current = true;
        _currentValue = [this.year, Object(util["c" /* zero */])(this.month + 1), Object(util["c" /* zero */])(this.days[k1][k2].day)].join('-');
      } else {
        _currentValue = [data.year, Object(util["c" /* zero */])(data.month + 1), Object(util["c" /* zero */])(data.day)].join('-');
      }
      if (this.multi) {
        var index = this.currentValue.indexOf(_currentValue);
        if (index > -1) {
          this.currentValue.splice(index, 1);
        } else {
          this.currentValue.push(_currentValue);
        }
      } else {
        this.currentValue = _currentValue;
        this.$emit('on-select-single-date', this.currentValue);
      }

      if (this.multi) {
        for (var i = 0; i < this.currentValue.length; i++) {
          this.$set(this.currentValue, i, this.convertDate(this.currentValue[i]));
        }
      } else {
        this.currentValue = this.convertDate(this.currentValue);
      }

      if (this.renderOnValueChange) {
        this.render(null, null);
      }
    },
    showChild: function showChild(year, month, child) {
      if (this.replaceText(child.day, this.formatDate(year, month, child))) {
        return !child.isLastMonth && !child.isNextMonth || child.isLastMonth && this.showLastMonth || child.isNextMonth && this.showNextMonth;
      } else {
        return false;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26161b74","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/inline-calendar/index.vue
var inline_calendar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inline-calendar",class:{'is-weekend-highlight': _vm.highlightWeekend}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hideHeader),expression:"!hideHeader"}],staticClass:"calendar-header"},[_c('div',{staticClass:"calendar-year"},[_c('span',{on:{"click":function($event){return _vm.go(_vm.year - 1, _vm.month)}}},[_c('a',{staticClass:"year-prev vux-prev-icon",attrs:{"href":"javascript:"}})]),_vm._v(" "),_c('a',{staticClass:"calendar-year-txt calendar-title",attrs:{"href":"javascript:"}},[_vm._v(_vm._s(_vm.year))]),_vm._v(" "),_c('span',{staticClass:"calendar-header-right-arrow",on:{"click":function($event){return _vm.go(_vm.year + 1, _vm.month)}}},[_c('a',{staticClass:"year-next vux-next-icon",attrs:{"href":"javascript:"}})])]),_vm._v(" "),_c('div',{staticClass:"calendar-month"},[_c('span',{on:{"click":_vm.prev}},[_c('a',{staticClass:"month-prev vux-prev-icon",attrs:{"href":"javascript:"}})]),_vm._v(" "),_c('a',{staticClass:"calendar-month-txt calendar-title",attrs:{"href":"javascript:"}},[_vm._v(_vm._s(_vm.months[_vm.month]))]),_vm._v(" "),_c('span',{staticClass:"calendar-header-right-arrow",on:{"click":_vm.next}},[_c('a',{staticClass:"month-next vux-next-icon",attrs:{"href":"javascript:"}})])])]),_vm._v(" "),_c('table',[_c('thead',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hideWeekList),expression:"!hideWeekList"}]},[_c('tr',_vm._l((_vm._weeksList),function(week,index){return _c('th',{staticClass:"week",class:("is-week-list-" + index)},[_vm._v(_vm._s(week || week))])}),0)]),_vm._v(" "),_c('tbody',_vm._l((_vm.days),function(day,k1){return _c('tr',_vm._l((day),function(child,k2){return _c('td',{class:_vm.buildClass(k2, child),attrs:{"data-date":_vm.formatDate(_vm.year, _vm.month, child),"data-current":_vm.currentValue},on:{"click":function($event){return _vm.select(k1, k2, child)}}},[_vm._t("each-day",function(){return [_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.showChild(_vm.year, _vm.month, child)),expression:"showChild(year, month, child)"}],staticClass:"vux-calendar-each-date",style:(_vm.getMarkStyle(child))},[_vm._v("\n              "+_vm._s(_vm.replaceText(child.day, _vm.formatDate(_vm.year, _vm.month, child)))+"\n              "),(_vm.isShowTopTip(child))?_c('span',{staticClass:"vux-calendar-top-tip",style:(_vm.isShowTopTip(child, 'style'))},[_c('span',[_vm._v(_vm._s(_vm.isShowTopTip(child, 'text')))])]):_vm._e()]),_vm._v(" "),(_vm.isShowBottomDot(child))?_c('span',{staticClass:"vux-calendar-dot"}):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showChild(_vm.year, _vm.month, child)),expression:"showChild(year, month, child)"}],domProps:{"innerHTML":_vm._s(_vm.renderFunction(k1, k2, child))}})]},{"year":_vm.year,"month":_vm.month,"child":_vm.processDateItem(child)/* deprecated, use date instead */,"date":_vm.processDateItem(child),"className":"vux-calendar-each-date","row":k1,"col":k2,"rawDate":_vm.formatDate(_vm.year, _vm.month, child),"showDate":_vm.replaceText(child.day, _vm.formatDate(_vm.year, _vm.month, child)),"isShow":_vm.showChild(_vm.year, _vm.month, child)})],2)}),0)}),0)])])}
var inline_calendar_staticRenderFns = []
var inline_calendar_esExports = { render: inline_calendar_render, staticRenderFns: inline_calendar_staticRenderFns }
/* harmony default export */ var src_components_inline_calendar = (inline_calendar_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/inline-calendar/index.vue
function inline_calendar_injectStyle (ssrContext) {
  __webpack_require__("W2k9")
}
var inline_calendar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var inline_calendar___vue_template_functional__ = false
/* styles */
var inline_calendar___vue_styles__ = inline_calendar_injectStyle
/* scopeId */
var inline_calendar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var inline_calendar___vue_module_identifier__ = null
var inline_calendar_Component = inline_calendar_normalizeComponent(
  components_inline_calendar,
  src_components_inline_calendar,
  inline_calendar___vue_template_functional__,
  inline_calendar___vue_styles__,
  inline_calendar___vue_scopeId__,
  inline_calendar___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_inline_calendar = (inline_calendar_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/tools/date/format.js
var date_format = __webpack_require__("ODCk");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/calendar/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var getType = function getType(value) {
  if (typeof value === 'string') {
    return 'string';
  }
  if (Object.prototype.toString.call(value) === '[object Array]') {
    return 'array';
  }
};

var calendar_pure = function pure(value) {
  var type = getType(value);
  if (type === 'string') {
    return value;
  } else if (type === 'array') {
    return JSON.parse(stringify_default()(value));
  }
};

var Props = extends_default()({}, Object(inline_calendar_props["a" /* default */])(), {
  title: {
    type: String,
    required: true
  },
  placeholder: String,
  showPopupHeader: Boolean,
  popupHeaderTitle: String,
  displayFormat: {
    type: Function,
    default: function _default(value) {
      return typeof value === 'string' ? value : value.join(', ');
    }
  },
  // for test only
  shouldTransferDom: {
    type: Boolean,
    default: true
  },
  readonly: Boolean
});

/* harmony default export */ var calendar = ({
  name: 'calendar',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    InlineCalendar: vux_src_components_inline_calendar,
    Popup: node_modules_vux_src_components_popup,
    PopupHeader: vux_src_components_popup_header,
    Cell: vux_src_components_cell
  },
  computed: {
    shouldConfirm: function shouldConfirm() {
      return this.showPopupHeader || this.getType(this.value) === 'array';
    },
    shouldShowPlaceholder: function shouldShowPlaceholder() {
      if (typeof this.value === 'string' && !this.value) {
        return true;
      }
      if (getType(this.value) === 'array' && !this.value.length) {
        return true;
      }
      return false;
    }
  },
  created: function created() {
    if (this.value === 'TODAY') {
      this.currentValue = Object(date_format["a" /* default */])(new Date(), 'YYYY-MM-DD');
      this.$emit('input', this.currentValue);
    } else {
      if (this.getType(this.value) === 'string') {
        this.currentValue = this.value;
      } else {
        this.currentValue = calendar_pure(this.value);
      }
    }
  },

  props: Props,
  methods: {
    onPopupShow: function onPopupShow() {
      this.$emit('on-show');
    },
    onPopupHide: function onPopupHide() {
      this.$emit('on-hide');
      // reset value to show value
      this.currentValue = calendar_pure(this.value);
    },

    getType: getType,
    onClickLeft: function onClickLeft() {
      this.show = false;
      this.currentValue = calendar_pure(this.value);
    },
    onClickRight: function onClickRight() {
      this.show = false;
      var value = calendar_pure(this.currentValue);
      this.$emit('input', value);
    },
    onClick: function onClick() {
      if (!this.readonly) {
        this.show = true;
      }
    },
    onCalendarValueChange: function onCalendarValueChange(val) {
      if (!this.shouldConfirm) {
        this.show = false;
        this.$emit('input', calendar_pure(val));
      }
    },
    onSelectSingleDate: function onSelectSingleDate() {
      if (!this.shouldConfirm) {
        this.show = false;
      }
    }
  },
  watch: {
    value: function value(newVal, oldVal) {
      if (this.getType(this.value) === 'string') {
        this.currentValue = newVal;
        this.$emit('on-change', newVal);
      } else {
        if (stringify_default()(newVal) !== stringify_default()(oldVal)) {
          this.$emit('on-change', calendar_pure(newVal));
        }
        this.currentValue = calendar_pure(newVal);
      }
    }
  },
  data: function data() {
    return {
      show: false,
      currentValue: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/calendar/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var calendar_getType = function getType(value) {
  if (typeof value === 'string') {
    return 'string';
  }
  if (Object.prototype.toString.call(value) === '[object Array]') {
    return 'array';
  }
};

var components_calendar_pure = function pure(value) {
  var type = calendar_getType(value);
  if (type === 'string') {
    return value;
  } else if (type === 'array') {
    return JSON.parse(stringify_default()(value));
  }
};

var calendar_Props = extends_default()({}, Object(inline_calendar_props["a" /* default */])(), {
  title: {
    type: String,
    required: true
  },
  placeholder: String,
  showPopupHeader: Boolean,
  popupHeaderTitle: String,
  displayFormat: {
    type: Function,
    default: function _default(value) {
      return typeof value === 'string' ? value : value.join(', ');
    }
  },
  // for test only
  shouldTransferDom: {
    type: Boolean,
    default: true
  },
  readonly: Boolean
});

/* harmony default export */ var components_calendar = ({
  name: 'calendar',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    InlineCalendar: vux_src_components_inline_calendar,
    Popup: node_modules_vux_src_components_popup,
    PopupHeader: vux_src_components_popup_header,
    Cell: vux_src_components_cell
  },
  computed: {
    shouldConfirm: function shouldConfirm() {
      return this.showPopupHeader || this.getType(this.value) === 'array';
    },
    shouldShowPlaceholder: function shouldShowPlaceholder() {
      if (typeof this.value === 'string' && !this.value) {
        return true;
      }
      if (calendar_getType(this.value) === 'array' && !this.value.length) {
        return true;
      }
      return false;
    }
  },
  created: function created() {
    if (this.value === 'TODAY') {
      this.currentValue = Object(date_format["a" /* default */])(new Date(), 'YYYY-MM-DD');
      this.$emit('input', this.currentValue);
    } else {
      if (this.getType(this.value) === 'string') {
        this.currentValue = this.value;
      } else {
        this.currentValue = components_calendar_pure(this.value);
      }
    }
  },

  props: calendar_Props,
  methods: {
    onPopupShow: function onPopupShow() {
      this.$emit('on-show');
    },
    onPopupHide: function onPopupHide() {
      this.$emit('on-hide');
      // reset value to show value
      this.currentValue = components_calendar_pure(this.value);
    },

    getType: calendar_getType,
    onClickLeft: function onClickLeft() {
      this.show = false;
      this.currentValue = components_calendar_pure(this.value);
    },
    onClickRight: function onClickRight() {
      this.show = false;
      var value = components_calendar_pure(this.currentValue);
      this.$emit('input', value);
    },
    onClick: function onClick() {
      if (!this.readonly) {
        this.show = true;
      }
    },
    onCalendarValueChange: function onCalendarValueChange(val) {
      if (!this.shouldConfirm) {
        this.show = false;
        this.$emit('input', components_calendar_pure(val));
      }
    },
    onSelectSingleDate: function onSelectSingleDate() {
      if (!this.shouldConfirm) {
        this.show = false;
      }
    }
  },
  watch: {
    value: function value(newVal, oldVal) {
      if (this.getType(this.value) === 'string') {
        this.currentValue = newVal;
        this.$emit('on-change', newVal);
      } else {
        if (stringify_default()(newVal) !== stringify_default()(oldVal)) {
          this.$emit('on-change', components_calendar_pure(newVal));
        }
        this.currentValue = components_calendar_pure(newVal);
      }
    }
  },
  data: function data() {
    return {
      show: false,
      currentValue: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ff97488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/calendar/index.vue
var calendar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-calendar"},[_c('cell',{attrs:{"title":_vm.title,"primary":"content","is-link":!_vm.readonly},nativeOn:{"click":function($event){return _vm.onClick.apply(null, arguments)}}},[(_vm.shouldShowPlaceholder)?_c('span',{staticClass:"vux-cell-placeholder"},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_vm._v(" "),(!_vm.shouldShowPlaceholder)?_c('span',{staticClass:"vux-cell-value"},[_vm._v(_vm._s(_vm.displayFormat(_vm.value, _vm.getType(_vm.value))))]):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom",value:(_vm.shouldTransferDom),expression:"shouldTransferDom"}]},[_c('popup',{on:{"on-show":_vm.onPopupShow,"on-hide":_vm.onPopupHide},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[(_vm.shouldConfirm)?_c('popup-header',{attrs:{"title":_vm.popupHeaderTitle,"left-text":'取消',"right-text":'确定'},on:{"on-click-left":_vm.onClickLeft,"on-click-right":_vm.onClickRight}}):_vm._e(),_vm._v(" "),_vm._t("popup-before-calendar"),_vm._v(" "),_c('inline-calendar',{attrs:{"render-month":_vm.renderMonth,"start-date":_vm.startDate,"end-date":_vm.endDate,"show-last-month":_vm.showLastMonth,"show-next-month":_vm.showNextMonth,"highlight-weekend":_vm.highlightWeekend,"return-six-rows":_vm.returnSixRows,"hide-header":_vm.hideHeader,"hide-week-list":_vm.hideWeekList,"replace-text-list":_vm.replaceTextList,"weeks-list":_vm.weeksList,"render-function":_vm.renderFunction,"render-on-value-change":_vm.renderOnValueChange,"disable-past":_vm.disablePast,"disable-future":_vm.disableFuture,"marks":_vm.marks,"disable-weekend":_vm.disableWeekend,"disable-date-function":_vm.disableDateFunction},on:{"on-change":_vm.onCalendarValueChange,"on-select-single-date":_vm.onSelectSingleDate},model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}})],2)],1)],1)}
var calendar_staticRenderFns = []
var calendar_esExports = { render: calendar_render, staticRenderFns: calendar_staticRenderFns }
/* harmony default export */ var src_components_calendar = (calendar_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/calendar/index.vue
function calendar_injectStyle (ssrContext) {
  __webpack_require__("wRzN")
}
var calendar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var calendar___vue_template_functional__ = false
/* styles */
var calendar___vue_styles__ = calendar_injectStyle
/* scopeId */
var calendar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var calendar___vue_module_identifier__ = null
var calendar_Component = calendar_normalizeComponent(
  components_calendar,
  src_components_calendar,
  calendar___vue_template_functional__,
  calendar___vue_styles__,
  calendar___vue_scopeId__,
  calendar___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_calendar = (calendar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/checker/checker.vue
//
//
//
//
//
//

/* harmony default export */ var checker = ({
  name: 'checker',
  props: {
    defaultItemClass: String,
    selectedItemClass: String,
    disabledItemClass: String,
    type: {
      type: String,
      default: 'radio'
    },
    value: [String, Number, Array, Object],
    max: Number,
    radioRequired: Boolean
  },
  watch: {
    value: function value(newValue) {
      this.currentValue = newValue;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  data: function data() {
    return {
      currentValue: this.value
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/checker/checker.vue
//
//
//
//
//
//

/* harmony default export */ var checker_checker = ({
  name: 'checker',
  props: {
    defaultItemClass: String,
    selectedItemClass: String,
    disabledItemClass: String,
    type: {
      type: String,
      default: 'radio'
    },
    value: [String, Number, Array, Object],
    max: Number,
    radioRequired: Boolean
  },
  watch: {
    value: function value(newValue) {
      this.currentValue = newValue;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  data: function data() {
    return {
      currentValue: this.value
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e5beda2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/checker/checker.vue
var checker_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-checker-box"},[_vm._t("default")],2)}
var checker_staticRenderFns = []
var checker_esExports = { render: checker_render, staticRenderFns: checker_staticRenderFns }
/* harmony default export */ var components_checker_checker = (checker_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/checker/checker.vue
function checker_injectStyle (ssrContext) {
  __webpack_require__("9mUp")
}
var checker_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var checker___vue_template_functional__ = false
/* styles */
var checker___vue_styles__ = checker_injectStyle
/* scopeId */
var checker___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var checker___vue_module_identifier__ = null
var checker_Component = checker_normalizeComponent(
  checker_checker,
  components_checker_checker,
  checker___vue_template_functional__,
  checker___vue_styles__,
  checker___vue_scopeId__,
  checker___vue_module_identifier__
)

/* harmony default export */ var src_components_checker_checker = (checker_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/checker/checker-item.vue


//
//
//
//
//
//

/* harmony default export */ var checker_item = ({
  name: 'checker-item',
  props: {
    value: {
      type: [String, Number, Object],
      required: true
    },
    disabled: Boolean
  },
  watch: {
    disabled: function disabled(val) {
      if (val && this.$parent.type === 'radio' && this.value === this.$parent.currentValue) {
        this.$parent.currentValue = '';
      }
    }
  },
  computed: {
    classNames: function classNames() {
      var _this = this;

      var isSimpleValue = typeof this.value === 'string' || typeof this.value === 'number';
      var names = {
        'vux-tap-active': !this.disabled
      };

      if (this.$parent.defaultItemClass) {
        names[this.$parent.defaultItemClass] = true;
      }

      if (this.$parent.selectedItemClass) {
        var selected = false;
        if (this.$parent.type === 'radio') {
          if (isSimpleValue && this.$parent.currentValue === this.value) {
            selected = true;
          } else if (typeof_default()(this.value) === 'object' && isEqual(this.$parent.currentValue, this.value)) {
            selected = true;
          }
        } else {
          if (typeof this.value === 'string') {
            if (this.$parent.currentValue.indexOf(this.value) > -1) {
              selected = true;
            }
          } else if (this.$parent.currentValue && this.$parent.currentValue.length) {
            var match = this.$parent.currentValue.filter(function (one) {
              return isEqual(one, _this.value);
            });
            selected = match.length > 0;
          }
        }
        names[this.$parent.selectedItemClass] = selected;
      }

      if (this.$parent.disabledItemClass) {
        names[this.$parent.disabledItemClass] = this.disabled;
      }

      return names;
    }
  },
  methods: {
    select: function select() {
      if (this.$parent.type === 'radio') {
        this.selectRadio();
      } else {
        this.selectCheckbox();
      }
    },
    selectRadio: function selectRadio() {
      if (!this.disabled) {
        if (this.$parent.currentValue === this.value) {
          if (!this.$parent.radioRequired) {
            this.$parent.currentValue = '';
          }
        } else {
          this.$parent.currentValue = this.value;
        }
      }
      this.$emit('on-item-click', this.value, this.disabled);
    },
    selectCheckbox: function selectCheckbox() {
      if (!this.$parent.currentValue || this.$parent.currentValue === null) {
        this.$parent.currentValue = [];
      }
      var isSimpleValue = typeof this.value === 'string' || typeof this.value === 'number';
      if (!this.disabled) {
        var index = -1;
        if (isSimpleValue) {
          index = this.$parent.currentValue.indexOf(this.value);
        } else {
          index = this.$parent.currentValue.map(function (one) {
            return stringify_default()(one);
          }).indexOf(stringify_default()(this.value));
        }
        if (index > -1) {
          this.$parent.currentValue.splice(index, 1);
        } else {
          if (!this.$parent.max || this.$parent.max && this.$parent.currentValue !== null && this.$parent.currentValue.length < this.$parent.max) {
            if (!this.$parent.currentValue || !this.$parent.currentValue.length) {
              this.$parent.currentValue = [];
            }
            this.$parent.currentValue.push(this.value);
          }
        }
      }
      this.$emit('on-item-click', this.value, this.disabled);
    }
  }
});

function isEqual(obj1, obj2) {
  return stringify_default()(obj1) === stringify_default()(obj2);
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/checker/checker-item.vue


//
//
//
//
//
//

/* harmony default export */ var checker_checker_item = ({
  name: 'checker-item',
  props: {
    value: {
      type: [String, Number, Object],
      required: true
    },
    disabled: Boolean
  },
  watch: {
    disabled: function disabled(val) {
      if (val && this.$parent.type === 'radio' && this.value === this.$parent.currentValue) {
        this.$parent.currentValue = '';
      }
    }
  },
  computed: {
    classNames: function classNames() {
      var _this = this;

      var isSimpleValue = typeof this.value === 'string' || typeof this.value === 'number';
      var names = {
        'vux-tap-active': !this.disabled
      };

      if (this.$parent.defaultItemClass) {
        names[this.$parent.defaultItemClass] = true;
      }

      if (this.$parent.selectedItemClass) {
        var selected = false;
        if (this.$parent.type === 'radio') {
          if (isSimpleValue && this.$parent.currentValue === this.value) {
            selected = true;
          } else if (typeof_default()(this.value) === 'object' && checker_item_isEqual(this.$parent.currentValue, this.value)) {
            selected = true;
          }
        } else {
          if (typeof this.value === 'string') {
            if (this.$parent.currentValue.indexOf(this.value) > -1) {
              selected = true;
            }
          } else if (this.$parent.currentValue && this.$parent.currentValue.length) {
            var match = this.$parent.currentValue.filter(function (one) {
              return checker_item_isEqual(one, _this.value);
            });
            selected = match.length > 0;
          }
        }
        names[this.$parent.selectedItemClass] = selected;
      }

      if (this.$parent.disabledItemClass) {
        names[this.$parent.disabledItemClass] = this.disabled;
      }

      return names;
    }
  },
  methods: {
    select: function select() {
      if (this.$parent.type === 'radio') {
        this.selectRadio();
      } else {
        this.selectCheckbox();
      }
    },
    selectRadio: function selectRadio() {
      if (!this.disabled) {
        if (this.$parent.currentValue === this.value) {
          if (!this.$parent.radioRequired) {
            this.$parent.currentValue = '';
          }
        } else {
          this.$parent.currentValue = this.value;
        }
      }
      this.$emit('on-item-click', this.value, this.disabled);
    },
    selectCheckbox: function selectCheckbox() {
      if (!this.$parent.currentValue || this.$parent.currentValue === null) {
        this.$parent.currentValue = [];
      }
      var isSimpleValue = typeof this.value === 'string' || typeof this.value === 'number';
      if (!this.disabled) {
        var index = -1;
        if (isSimpleValue) {
          index = this.$parent.currentValue.indexOf(this.value);
        } else {
          index = this.$parent.currentValue.map(function (one) {
            return stringify_default()(one);
          }).indexOf(stringify_default()(this.value));
        }
        if (index > -1) {
          this.$parent.currentValue.splice(index, 1);
        } else {
          if (!this.$parent.max || this.$parent.max && this.$parent.currentValue !== null && this.$parent.currentValue.length < this.$parent.max) {
            if (!this.$parent.currentValue || !this.$parent.currentValue.length) {
              this.$parent.currentValue = [];
            }
            this.$parent.currentValue.push(this.value);
          }
        }
      }
      this.$emit('on-item-click', this.value, this.disabled);
    }
  }
});

function checker_item_isEqual(obj1, obj2) {
  return stringify_default()(obj1) === stringify_default()(obj2);
}
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1942c497","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/checker/checker-item.vue
var checker_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-checker-item",class:_vm.classNames,on:{"click":_vm.select}},[_vm._t("default")],2)}
var checker_item_staticRenderFns = []
var checker_item_esExports = { render: checker_item_render, staticRenderFns: checker_item_staticRenderFns }
/* harmony default export */ var components_checker_checker_item = (checker_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/checker/checker-item.vue
function checker_item_injectStyle (ssrContext) {
  __webpack_require__("Bdcp")
}
var checker_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var checker_item___vue_template_functional__ = false
/* styles */
var checker_item___vue_styles__ = checker_item_injectStyle
/* scopeId */
var checker_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var checker_item___vue_module_identifier__ = null
var checker_item_Component = checker_item_normalizeComponent(
  checker_checker_item,
  components_checker_checker_item,
  checker_item___vue_template_functional__,
  checker_item___vue_styles__,
  checker_item___vue_scopeId__,
  checker_item___vue_module_identifier__
)

/* harmony default export */ var src_components_checker_checker_item = (checker_item_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/divider/index.vue + 3 modules
var divider = __webpack_require__("rGqP");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell-box/index.vue
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var cell_box = ({
  name: 'cell-box',
  props: {
    isLink: Boolean,
    link: [String, Object],
    borderIntent: {
      type: Boolean,
      default: true
    },
    noFlex: Boolean,
    alignItems: String
  },
  computed: {
    style: function style() {
      if (this.alignItems) {
        return {
          'align-items': this.alignItems
        };
      }
    },
    className: function className() {
      return {
        'vux-tap-active': this.isLink || !!this.link,
        'weui-cell_access': this.isLink || !!this.link,
        'vux-cell-no-border-intent': !this.borderIntent
      };
    }
  },
  methods: {
    onClick: function onClick() {
      this.link && Object(libs_router["b" /* go */])(this.link, this.$router);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell-box/index.vue
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_cell_box = ({
  name: 'cell-box',
  props: {
    isLink: Boolean,
    link: [String, Object],
    borderIntent: {
      type: Boolean,
      default: true
    },
    noFlex: Boolean,
    alignItems: String
  },
  computed: {
    style: function style() {
      if (this.alignItems) {
        return {
          'align-items': this.alignItems
        };
      }
    },
    className: function className() {
      return {
        'vux-tap-active': this.isLink || !!this.link,
        'weui-cell_access': this.isLink || !!this.link,
        'vux-cell-no-border-intent': !this.borderIntent
      };
    }
  },
  methods: {
    onClick: function onClick() {
      this.link && Object(libs_router["b" /* go */])(this.link, this.$router);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65737ba9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/cell-box/index.vue
var cell_box_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-cell-box weui-cell",class:_vm.className,style:(_vm.style),on:{"click":_vm.onClick}},[_vm._t("default")],2)}
var cell_box_staticRenderFns = []
var cell_box_esExports = { render: cell_box_render, staticRenderFns: cell_box_staticRenderFns }
/* harmony default export */ var src_components_cell_box = (cell_box_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/cell-box/index.vue
function cell_box_injectStyle (ssrContext) {
  __webpack_require__("tZYb")
}
var cell_box_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var cell_box___vue_template_functional__ = false
/* styles */
var cell_box___vue_styles__ = cell_box_injectStyle
/* scopeId */
var cell_box___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var cell_box___vue_module_identifier__ = null
var cell_box_Component = cell_box_normalizeComponent(
  components_cell_box,
  src_components_cell_box,
  cell_box___vue_template_functional__,
  cell_box___vue_styles__,
  cell_box___vue_scopeId__,
  cell_box___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_cell_box = (cell_box_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/directives/click-outside/index.js
var click_outside = __webpack_require__("A1NS");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popover/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var popover = ({
  name: 'popover',
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.init();
      window.addEventListener('resize', _this.reset);
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.reset);
  },

  directives: {
    TransferDom: transfer_dom["a" /* default */],
    ClickOutside: click_outside["a" /* default */]
  },
  props: {
    content: String,
    placement: String,
    gutter: {
      type: Number,
      default: 5
    }
  },
  methods: {
    reset: function reset() {
      if (this.show) {
        this.init(true);
      }
    },
    init: function init(isReset) {
      var trigger = this.$refs.trigger.children[0];
      var popover = this.$refs.popover;
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      switch (this.placement) {
        case 'top':
          this.position.left = trigger.offsetLeft - popover.offsetWidth / 2 + trigger.offsetWidth / 2;
          this.position.top = scrollTop + trigger.getBoundingClientRect().top - popover.offsetHeight - this.gutter;
          break;
        case 'left':
          this.position.left = trigger.offsetLeft - popover.offsetWidth - this.gutter;
          this.position.top = scrollTop + trigger.getBoundingClientRect().top + trigger.offsetHeight / 2 - popover.offsetHeight / 2;
          break;
        case 'right':
          this.position.left = trigger.offsetLeft + trigger.offsetWidth + this.gutter;
          this.position.top = scrollTop + trigger.getBoundingClientRect().top + trigger.offsetHeight / 2 - popover.offsetHeight / 2;
          break;
        case 'bottom':
          this.position.left = trigger.offsetLeft - popover.offsetWidth / 2 + trigger.offsetWidth / 2;
          this.position.top = scrollTop + trigger.getBoundingClientRect().top + trigger.offsetHeight + this.gutter;
          break;
        default:
          console.warn('Wrong placement prop');
      }
      if (!isReset) {
        this.show = false;
      }

      this.popoverStyle = {
        top: this.position.top + 'px',
        left: this.position.left + 'px',
        display: isReset ? this.popoverStyle.display : 'none'
      };
    },
    onClickedOutside: function onClickedOutside() {
      if (this.show) {
        this.show = false;
        this.$emit('on-hide');
      }
    },
    toggle: function toggle() {
      var _this2 = this;

      this.show = !this.show;
      if (this.show) {
        this.$nextTick(function () {
          _this2.init(true);
        });
      }
      this.$emit('on-' + (this.show === true ? 'show' : 'hide'));
    }
  },
  data: function data() {
    return {
      position: {
        top: 0,
        left: 0
      },
      show: true,
      popoverStyle: {}
    };
  },

  computed: {
    arrowClass: function arrowClass() {
      return {
        'vux-popover-arrow': true,
        'vux-popover-arrow-up': this.placement === 'bottom',
        'vux-popover-arrow-right': this.placement === 'left',
        'vux-popover-arrow-left': this.placement === 'right',
        'vux-popover-arrow-down': this.placement === 'top'
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popover/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var components_popover = ({
  name: 'popover',
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.init();
      window.addEventListener('resize', _this.reset);
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.reset);
  },

  directives: {
    TransferDom: transfer_dom["a" /* default */],
    ClickOutside: click_outside["a" /* default */]
  },
  props: {
    content: String,
    placement: String,
    gutter: {
      type: Number,
      default: 5
    }
  },
  methods: {
    reset: function reset() {
      if (this.show) {
        this.init(true);
      }
    },
    init: function init(isReset) {
      var trigger = this.$refs.trigger.children[0];
      var popover = this.$refs.popover;
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      switch (this.placement) {
        case 'top':
          this.position.left = trigger.offsetLeft - popover.offsetWidth / 2 + trigger.offsetWidth / 2;
          this.position.top = scrollTop + trigger.getBoundingClientRect().top - popover.offsetHeight - this.gutter;
          break;
        case 'left':
          this.position.left = trigger.offsetLeft - popover.offsetWidth - this.gutter;
          this.position.top = scrollTop + trigger.getBoundingClientRect().top + trigger.offsetHeight / 2 - popover.offsetHeight / 2;
          break;
        case 'right':
          this.position.left = trigger.offsetLeft + trigger.offsetWidth + this.gutter;
          this.position.top = scrollTop + trigger.getBoundingClientRect().top + trigger.offsetHeight / 2 - popover.offsetHeight / 2;
          break;
        case 'bottom':
          this.position.left = trigger.offsetLeft - popover.offsetWidth / 2 + trigger.offsetWidth / 2;
          this.position.top = scrollTop + trigger.getBoundingClientRect().top + trigger.offsetHeight + this.gutter;
          break;
        default:
          console.warn('Wrong placement prop');
      }
      if (!isReset) {
        this.show = false;
      }

      this.popoverStyle = {
        top: this.position.top + 'px',
        left: this.position.left + 'px',
        display: isReset ? this.popoverStyle.display : 'none'
      };
    },
    onClickedOutside: function onClickedOutside() {
      if (this.show) {
        this.show = false;
        this.$emit('on-hide');
      }
    },
    toggle: function toggle() {
      var _this2 = this;

      this.show = !this.show;
      if (this.show) {
        this.$nextTick(function () {
          _this2.init(true);
        });
      }
      this.$emit('on-' + (this.show === true ? 'show' : 'hide'));
    }
  },
  data: function data() {
    return {
      position: {
        top: 0,
        left: 0
      },
      show: true,
      popoverStyle: {}
    };
  },

  computed: {
    arrowClass: function arrowClass() {
      return {
        'vux-popover-arrow': true,
        'vux-popover-arrow-up': this.placement === 'bottom',
        'vux-popover-arrow-right': this.placement === 'left',
        'vux-popover-arrow-left': this.placement === 'right',
        'vux-popover-arrow-down': this.placement === 'top'
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ebeebde","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/popover/index.vue
var popover_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.onClickedOutside),expression:"onClickedOutside"}]},[_c('span',{ref:"trigger",on:{"click":_vm.toggle}},[_vm._t("default")],2),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"},{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],ref:"popover",staticClass:"vux-popover",style:(_vm.popoverStyle)},[_c('div',{class:_vm.arrowClass}),_vm._v(" "),_c('div',{on:{"click":function($event){return _vm.$emit('on-click-content')}}},[_vm._t("content",function(){return [_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})]})],2)])])}
var popover_staticRenderFns = []
var popover_esExports = { render: popover_render, staticRenderFns: popover_staticRenderFns }
/* harmony default export */ var src_components_popover = (popover_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/popover/index.vue
function popover_injectStyle (ssrContext) {
  __webpack_require__("u6MN")
}
var popover_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var popover___vue_template_functional__ = false
/* styles */
var popover___vue_styles__ = popover_injectStyle
/* scopeId */
var popover___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var popover___vue_module_identifier__ = null
var popover_Component = popover_normalizeComponent(
  components_popover,
  src_components_popover,
  popover___vue_template_functional__,
  popover___vue_styles__,
  popover___vue_scopeId__,
  popover___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_popover = (popover_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/checklist/object-filter.js
var object_filter = __webpack_require__("q5lo");

// EXTERNAL MODULE: ./node_modules/vux/src/components/radio/props.js
var radio_props = __webpack_require__("Zor0");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/radio/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var components_radio = ({
  name: 'radio',
  mixins: [libs_base["a" /* default */]],
  filters: {
    getValue: object_filter["e" /* getValue */],
    getKey: object_filter["b" /* getKey */]
  },
  props: Object(radio_props["a" /* default */])(),
  created: function created() {
    this.handleChangeEvent = true;
  },

  methods: {
    getValue: object_filter["e" /* getValue */],
    getKey: object_filter["b" /* getKey */],
    onFocus: function onFocus() {
      this.currentValue = this.fillValue || '';
      this.isFocus = true;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(newVal) {
      var isOption = contains(this.options, newVal);
      if (newVal !== '' && isOption) {
        this.fillValue = '';
      }
      this.$emit('on-change', newVal, Object(object_filter["c" /* getLabel */])(this.options, newVal));
      this.$emit('input', newVal);
    },
    fillValue: function fillValue(newVal) {
      if (this.fillMode && this.isFocus) {
        this.currentValue = newVal;
      }
    }
  },
  data: function data() {
    return {
      fillValue: '',
      isFocus: false,
      currentValue: this.value
    };
  }
});

function contains(a, obj) {
  var i = a.length;
  while (i--) {
    if (a[i] === obj) {
      return true;
    }
  }
  return false;
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/radio/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var src_components_radio = ({
  name: 'radio',
  mixins: [libs_base["a" /* default */]],
  filters: {
    getValue: object_filter["e" /* getValue */],
    getKey: object_filter["b" /* getKey */]
  },
  props: Object(radio_props["a" /* default */])(),
  created: function created() {
    this.handleChangeEvent = true;
  },

  methods: {
    getValue: object_filter["e" /* getValue */],
    getKey: object_filter["b" /* getKey */],
    onFocus: function onFocus() {
      this.currentValue = this.fillValue || '';
      this.isFocus = true;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(newVal) {
      var isOption = radio_contains(this.options, newVal);
      if (newVal !== '' && isOption) {
        this.fillValue = '';
      }
      this.$emit('on-change', newVal, Object(object_filter["c" /* getLabel */])(this.options, newVal));
      this.$emit('input', newVal);
    },
    fillValue: function fillValue(newVal) {
      if (this.fillMode && this.isFocus) {
        this.currentValue = newVal;
      }
    }
  },
  data: function data() {
    return {
      fillValue: '',
      isFocus: false,
      currentValue: this.value
    };
  }
});

function radio_contains(a, obj) {
  var i = a.length;
  while (i--) {
    if (a[i] === obj) {
      return true;
    }
  }
  return false;
}
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0506500e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/radio/index.vue
var radio_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cells_radio",class:_vm.disabled ? 'vux-radio-disabled' : ''},[_vm._l((_vm.options),function(one,index){return _c('label',{staticClass:"weui-cell weui-cell_radio weui-check__label",attrs:{"for":("radio_" + _vm.uuid + "_" + index)}},[_c('div',{staticClass:"weui-cell__bd"},[_vm._t("each-item",function(){return [_c('p',[_c('img',{directives:[{name:"show",rawName:"v-show",value:(one && one.icon),expression:"one && one.icon"}],staticClass:"vux-radio-icon",attrs:{"src":one.icon}}),_vm._v(" "),_c('span',{staticClass:"vux-radio-label",style:(_vm.currentValue === _vm.getKey(one) ? (_vm.selectedLabelStyle || '') : '')},[_vm._v(_vm._s(_vm._f("getValue")(one)))])])]},{"icon":one.icon,"label":_vm.getValue(one),"index":index,"selected":_vm.currentValue === _vm.getKey(one)})],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"weui-check",attrs:{"type":"radio","id":_vm.disabled ? '' : ("radio_" + _vm.uuid + "_" + index)},domProps:{"value":_vm.getKey(one),"checked":_vm._q(_vm.currentValue,_vm.getKey(one))},on:{"change":function($event){_vm.currentValue=_vm.getKey(one)}}}),_vm._v(" "),_c('span',{staticClass:"weui-icon-checked"})])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.fillMode),expression:"fillMode"}],staticClass:"weui-cell"},[_c('div',{staticClass:"weui-cell__hd"},[_c('label',{staticClass:"weui-label",attrs:{"for":""}},[_vm._v(_vm._s(_vm.fillLabel))])]),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fillValue),expression:"fillValue"}],staticClass:"weui-input needsclick",attrs:{"type":"text","placeholder":_vm.fillPlaceholder},domProps:{"value":(_vm.fillValue)},on:{"blur":function($event){_vm.isFocus=false},"focus":function($event){return _vm.onFocus()},"input":function($event){if($event.target.composing){ return; }_vm.fillValue=$event.target.value}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.value==='' && !_vm.isFocus),expression:"value==='' && !isFocus"}],staticClass:"weui-cell__ft"},[_c('i',{staticClass:"weui-icon-warn"})])])],2)}
var radio_staticRenderFns = []
var radio_esExports = { render: radio_render, staticRenderFns: radio_staticRenderFns }
/* harmony default export */ var vux_src_components_radio = (radio_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/radio/index.vue
function radio_injectStyle (ssrContext) {
  __webpack_require__("HH82")
}
var radio_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var radio___vue_template_functional__ = false
/* styles */
var radio___vue_styles__ = radio_injectStyle
/* scopeId */
var radio___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var radio___vue_module_identifier__ = null
var radio_Component = radio_normalizeComponent(
  src_components_radio,
  vux_src_components_radio,
  radio___vue_template_functional__,
  radio___vue_styles__,
  radio___vue_scopeId__,
  radio___vue_module_identifier__
)

/* harmony default export */ var node_modules_vux_src_components_radio = (radio_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/msg/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var msg = ({
  name: 'msg',
  props: ['icon', 'title', 'description', 'buttons'],
  methods: {
    onClick: function onClick(handler, link) {
      typeof handler === 'function' && handler();
      link && Object(libs_router["b" /* go */])(link, this.$router);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/msg/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_msg = ({
  name: 'msg',
  props: ['icon', 'title', 'description', 'buttons'],
  methods: {
    onClick: function onClick(handler, link) {
      typeof handler === 'function' && handler();
      link && Object(libs_router["b" /* go */])(link, this.$router);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8fb41afc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/msg/index.vue
var msg_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-msg"},[_c('div',{staticClass:"weui-msg__icon-area"},[_c('i',{staticClass:"weui-icon_msg",class:("weui-icon-" + (_vm.icon || 'success'))})]),_vm._v(" "),_c('div',{staticClass:"weui-msg__text-area"},[_c('h2',{staticClass:"weui-msg__title",domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),_c('p',{staticClass:"weui-msg__desc"},[_vm._t("description")],2),_vm._v(" "),(_vm.description)?_c('p',{staticClass:"weui-msg__desc",domProps:{"innerHTML":_vm._s(_vm.description)}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"weui-msg__opr-area"},[_c('p',{staticClass:"weui-btn-area"},[_vm._t("buttons",function(){return _vm._l((_vm.buttons),function(button){return _c('a',{staticClass:"weui-btn",class:("weui-btn_" + (button.type)),attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.onClick(button.onClick, button.link)}}},[_vm._v(_vm._s(button.text))])})})],2)])])}
var msg_staticRenderFns = []
var msg_esExports = { render: msg_render, staticRenderFns: msg_staticRenderFns }
/* harmony default export */ var src_components_msg = (msg_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/msg/index.vue
function msg_injectStyle (ssrContext) {
  __webpack_require__("Te/k")
}
var msg_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var msg___vue_template_functional__ = false
/* styles */
var msg___vue_styles__ = msg_injectStyle
/* scopeId */
var msg___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var msg___vue_module_identifier__ = null
var msg_Component = msg_normalizeComponent(
  components_msg,
  src_components_msg,
  msg___vue_template_functional__,
  msg___vue_styles__,
  msg___vue_scopeId__,
  msg___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_msg = (msg_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/grid/grid.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var grid = ({
  name: 'grid',
  methods: {
    countColumn: function countColumn() {
      this.childrenSize = this.$children.length;
      this.$children.forEach(function (c, index) {
        return c.index = index;
      });
    }
  },
  props: {
    rows: {
      type: Number,
      validator: function validator() {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] Grid rows 属性已经废弃，使用 cols 代替。单行列数为自动计算');
        }
        return true;
      }
    },
    cols: {
      type: Number
    },
    showLrBorders: {
      type: Boolean,
      default: true
    },
    showVerticalDividers: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    column: function column() {
      return this.cols || this.childrenSize;
    }
  },
  data: function data() {
    return {
      childrenSize: 3
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/grid/grid.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var grid_grid = ({
  name: 'grid',
  methods: {
    countColumn: function countColumn() {
      this.childrenSize = this.$children.length;
      this.$children.forEach(function (c, index) {
        return c.index = index;
      });
    }
  },
  props: {
    rows: {
      type: Number,
      validator: function validator() {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] Grid rows 属性已经废弃，使用 cols 代替。单行列数为自动计算');
        }
        return true;
      }
    },
    cols: {
      type: Number
    },
    showLrBorders: {
      type: Boolean,
      default: true
    },
    showVerticalDividers: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    column: function column() {
      return this.cols || this.childrenSize;
    }
  },
  data: function data() {
    return {
      childrenSize: 3
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06a8526d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/grid/grid.vue
var grid_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-grids",class:{
    'vux-grid-no-lr-borders': !_vm.showLrBorders
  }},[_vm._t("default")],2)}
var grid_staticRenderFns = []
var grid_esExports = { render: grid_render, staticRenderFns: grid_staticRenderFns }
/* harmony default export */ var components_grid_grid = (grid_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/grid/grid.vue
function grid_injectStyle (ssrContext) {
  __webpack_require__("JvV8")
}
var grid_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var grid___vue_template_functional__ = false
/* styles */
var grid___vue_styles__ = grid_injectStyle
/* scopeId */
var grid___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var grid___vue_module_identifier__ = null
var grid_Component = grid_normalizeComponent(
  grid_grid,
  components_grid_grid,
  grid___vue_template_functional__,
  grid___vue_styles__,
  grid___vue_scopeId__,
  grid___vue_module_identifier__
)

/* harmony default export */ var src_components_grid_grid = (grid_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/grid/grid-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var grid_item = ({
  name: 'grid-item',
  props: ['icon', 'label', 'link', 'disabled'],
  created: function created() {
    this.$parent.countColumn();
  },
  mounted: function mounted() {
    this.$slots.icon && (this.hasIconSlot = true);
    this.$slots.label && (this.hasLabelSlot = true);
  },
  destroyed: function destroyed() {
    this.$parent.countColumn();
  },

  computed: {
    isLast: function isLast() {
      return !((this.index + 1) % this.$parent.column);
    },
    style: function style() {
      var column = this.$parent.column;
      if (!column || column === 3) {
        return;
      }
      var styles = {};
      styles.width = 100 / column + '%';
      return styles;
    }
  },
  methods: {
    onClick: function onClick() {
      if (!this.disabled && !this.$parent.disabled) {
        this.$emit('on-item-click');
        Object(libs_router["b" /* go */])(this.link, this.$router);
      }
    }
  },
  data: function data() {
    return {
      index: 0,
      hasIconSlot: false,
      hasLabelSlot: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/grid/grid-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var grid_grid_item = ({
  name: 'grid-item',
  props: ['icon', 'label', 'link', 'disabled'],
  created: function created() {
    this.$parent.countColumn();
  },
  mounted: function mounted() {
    this.$slots.icon && (this.hasIconSlot = true);
    this.$slots.label && (this.hasLabelSlot = true);
  },
  destroyed: function destroyed() {
    this.$parent.countColumn();
  },

  computed: {
    isLast: function isLast() {
      return !((this.index + 1) % this.$parent.column);
    },
    style: function style() {
      var column = this.$parent.column;
      if (!column || column === 3) {
        return;
      }
      var styles = {};
      styles.width = 100 / column + '%';
      return styles;
    }
  },
  methods: {
    onClick: function onClick() {
      if (!this.disabled && !this.$parent.disabled) {
        this.$emit('on-item-click');
        Object(libs_router["b" /* go */])(this.link, this.$router);
      }
    }
  },
  data: function data() {
    return {
      index: 0,
      hasIconSlot: false,
      hasLabelSlot: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-681f818f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/grid/grid-item.vue
var grid_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"weui-grid",class:{
    'vux-grid-item-no-border': (_vm.isLast && !_vm.$parent.showLrBorders) || (!_vm.isLast && !_vm.$parent.showVerticalDividers),
  },style:(_vm.style),attrs:{"href":"javascript:;"},on:{"click":_vm.onClick}},[(_vm.hasIconSlot || _vm.icon)?_c('div',{staticClass:"weui-grid__icon"},[_vm._t("icon",function(){return [_c('img',{attrs:{"src":_vm.icon,"alt":""}})]})],2):_vm._e(),_vm._v(" "),(_vm.hasLabelSlot || _vm.label)?_c('p',{staticClass:"weui-grid__label"},[_vm._t("label",function(){return [_c('span',{domProps:{"innerHTML":_vm._s(_vm.label)}})]})],2):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var grid_item_staticRenderFns = []
var grid_item_esExports = { render: grid_item_render, staticRenderFns: grid_item_staticRenderFns }
/* harmony default export */ var components_grid_grid_item = (grid_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/grid/grid-item.vue
function grid_item_injectStyle (ssrContext) {
  __webpack_require__("Ckmr")
}
var grid_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var grid_item___vue_template_functional__ = false
/* styles */
var grid_item___vue_styles__ = grid_item_injectStyle
/* scopeId */
var grid_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var grid_item___vue_module_identifier__ = null
var grid_item_Component = grid_item_normalizeComponent(
  grid_grid_item,
  components_grid_grid_item,
  grid_item___vue_template_functional__,
  grid_item___vue_styles__,
  grid_item___vue_scopeId__,
  grid_item___vue_module_identifier__
)

/* harmony default export */ var src_components_grid_grid_item = (grid_item_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/datetime/index.vue + 3 modules
var components_datetime = __webpack_require__("UNGY");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-switch/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var x_switch = ({
  name: 'x-switch',
  components: {
    InlineDesc: inline_desc["a" /* default */]
  },
  computed: {
    parent: function parent() {
      var $parent = this.$parent;

      return $parent || {};
    },
    labelStyle: function labelStyle() {
      var isHTML = /<\/?[^>]*>/.test(this.title);
      var width = Math.min(isHTML ? 5 : this.title.length + 1, 14) + 'em';
      return Object(clean_style["a" /* default */])({
        display: 'block',
        width: this.parent.labelWidth || width,
        textAlign: this.parent.labelAlign
      });
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    onClick: function onClick() {
      this.$emit('on-click', !this.currentValue, this.currentValue);
    },
    toBoolean: function toBoolean(val) {
      if (!this.valueMap) {
        return val;
      } else {
        var index = this.valueMap.indexOf(val);
        return index === 1;
      }
    },
    toRaw: function toRaw(val) {
      if (!this.valueMap) {
        return val;
      } else {
        return this.valueMap[val ? 1 : 0];
      }
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    disabled: Boolean,
    value: {
      type: [Boolean, String, Number],
      default: false
    },
    inlineDesc: [String, Boolean, Number],
    preventDefault: Boolean,
    valueMap: {
      type: Array,
      default: function _default() {
        return [false, true];
      }
    }
  },
  data: function data() {
    return {
      currentValue: this.toBoolean(this.value)
    };
  },

  watch: {
    currentValue: function currentValue(val) {
      var rawValue = this.toRaw(val);
      this.$emit('input', rawValue);
      this.$emit('on-change', rawValue);
    },
    value: function value(val) {
      this.currentValue = this.toBoolean(val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-switch/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var components_x_switch = ({
  name: 'x-switch',
  components: {
    InlineDesc: inline_desc["a" /* default */]
  },
  computed: {
    parent: function parent() {
      var $parent = this.$parent;

      return $parent || {};
    },
    labelStyle: function labelStyle() {
      var isHTML = /<\/?[^>]*>/.test(this.title);
      var width = Math.min(isHTML ? 5 : this.title.length + 1, 14) + 'em';
      return Object(clean_style["a" /* default */])({
        display: 'block',
        width: this.parent.labelWidth || width,
        textAlign: this.parent.labelAlign
      });
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    onClick: function onClick() {
      this.$emit('on-click', !this.currentValue, this.currentValue);
    },
    toBoolean: function toBoolean(val) {
      if (!this.valueMap) {
        return val;
      } else {
        var index = this.valueMap.indexOf(val);
        return index === 1;
      }
    },
    toRaw: function toRaw(val) {
      if (!this.valueMap) {
        return val;
      } else {
        return this.valueMap[val ? 1 : 0];
      }
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    disabled: Boolean,
    value: {
      type: [Boolean, String, Number],
      default: false
    },
    inlineDesc: [String, Boolean, Number],
    preventDefault: Boolean,
    valueMap: {
      type: Array,
      default: function _default() {
        return [false, true];
      }
    }
  },
  data: function data() {
    return {
      currentValue: this.toBoolean(this.value)
    };
  },

  watch: {
    currentValue: function currentValue(val) {
      var rawValue = this.toRaw(val);
      this.$emit('input', rawValue);
      this.$emit('on-change', rawValue);
    },
    value: function value(val) {
      this.currentValue = this.toBoolean(val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-042f4abc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-switch/index.vue
var x_switch_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-switch weui-cell weui-cell_switch"},[_c('div',{staticClass:"vux-cell-bd"},[_c('label',{staticClass:"weui-label",class:_vm.labelClass,staticStyle:{"margin-right":"1em"},style:(_vm.labelStyle),domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft vux-cell-primary",staticStyle:{"text-align":"left"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"weui-switch",attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":Array.isArray(_vm.currentValue)?_vm._i(_vm.currentValue,null)>-1:(_vm.currentValue)},on:{"change":function($event){var $$a=_vm.currentValue,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.currentValue=$$a.concat([$$v]))}else{$$i>-1&&(_vm.currentValue=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.currentValue=$$c}}}}),_vm._v(" "),(_vm.preventDefault)?_c('div',{staticClass:"vux-x-switch-overlay",on:{"click":_vm.onClick}}):_vm._e()])])}
var x_switch_staticRenderFns = []
var x_switch_esExports = { render: x_switch_render, staticRenderFns: x_switch_staticRenderFns }
/* harmony default export */ var src_components_x_switch = (x_switch_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-switch/index.vue
function x_switch_injectStyle (ssrContext) {
  __webpack_require__("lmDi")
}
var x_switch_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_switch___vue_template_functional__ = false
/* styles */
var x_switch___vue_styles__ = x_switch_injectStyle
/* scopeId */
var x_switch___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_switch___vue_module_identifier__ = null
var x_switch_Component = x_switch_normalizeComponent(
  components_x_switch,
  src_components_x_switch,
  x_switch___vue_template_functional__,
  x_switch___vue_styles__,
  x_switch___vue_scopeId__,
  x_switch___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_switch = (x_switch_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/node_modules/big.js/big.js
var big = __webpack_require__("GL6u");
var big_default = /*#__PURE__*/__webpack_require__.n(big);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-number/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var x_number = ({
  name: 'x-number',
  props: {
    min: Number,
    max: Number,
    readonly: Boolean,
    step: {
      type: Number,
      default: 1
    },
    value: {
      validator: function validator(value) {
        if (typeof value === 'number') {
          return true;
        } else if (typeof value === 'string') {
          return value === '';
        }
        return false;
      },

      default: 0
    },
    name: String,
    title: String,
    fillable: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '50px'
    },
    buttonStyle: {
      type: String,
      default: 'square'
    },
    align: {
      type: String,
      default: 'right'
    }
  },
  created: function created() {
    this.currentValue = this.value;
  },
  data: function data() {
    return {
      currentValue: 0
    };
  },

  computed: {
    disabledMin: function disabledMin() {
      return typeof this.min === 'undefined' ? false : this.currentValue === '' ? true : this.currentValue <= this.min;
    },
    disabledMax: function disabledMax() {
      return typeof this.max === 'undefined' ? false : this.currentValue === '' ? true : this.currentValue >= this.max;
    },
    labelClass: function labelClass() {
      if (!this.$parent) return {};
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  watch: {
    currentValue: function currentValue(newValue, old) {
      if (newValue !== '') {
        if (typeof this.min !== 'undefined' && this.currentValue < this.min) {
          this.currentValue = this.min;
        }
        if (this.max && this.currentValue > this.max) {
          this.currentValue = this.max;
        }
      }
      this.$emit('input', this.currentValue);
    },
    value: function value(newValue) {
      this.currentValue = newValue;
      this.$emit('on-change', newValue);
    }
  },
  methods: {
    add: function add() {
      if (!this.disabledMax) {
        var x = new big_default.a(this.currentValue);
        this.currentValue = x.plus(this.step) * 1;
      }
    },
    sub: function sub() {
      if (!this.disabledMin) {
        var x = new big_default.a(this.currentValue);
        this.currentValue = x.minus(this.step) * 1;
      }
    },
    blur: function blur() {
      if (this.currentValue === '') {
        this.currentValue = 0;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-number/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var components_x_number = ({
  name: 'x-number',
  props: {
    min: Number,
    max: Number,
    readonly: Boolean,
    step: {
      type: Number,
      default: 1
    },
    value: {
      validator: function validator(value) {
        if (typeof value === 'number') {
          return true;
        } else if (typeof value === 'string') {
          return value === '';
        }
        return false;
      },

      default: 0
    },
    name: String,
    title: String,
    fillable: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '50px'
    },
    buttonStyle: {
      type: String,
      default: 'square'
    },
    align: {
      type: String,
      default: 'right'
    }
  },
  created: function created() {
    this.currentValue = this.value;
  },
  data: function data() {
    return {
      currentValue: 0
    };
  },

  computed: {
    disabledMin: function disabledMin() {
      return typeof this.min === 'undefined' ? false : this.currentValue === '' ? true : this.currentValue <= this.min;
    },
    disabledMax: function disabledMax() {
      return typeof this.max === 'undefined' ? false : this.currentValue === '' ? true : this.currentValue >= this.max;
    },
    labelClass: function labelClass() {
      if (!this.$parent) return {};
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  watch: {
    currentValue: function currentValue(newValue, old) {
      if (newValue !== '') {
        if (typeof this.min !== 'undefined' && this.currentValue < this.min) {
          this.currentValue = this.min;
        }
        if (this.max && this.currentValue > this.max) {
          this.currentValue = this.max;
        }
      }
      this.$emit('input', this.currentValue);
    },
    value: function value(newValue) {
      this.currentValue = newValue;
      this.$emit('on-change', newValue);
    }
  },
  methods: {
    add: function add() {
      if (!this.disabledMax) {
        var x = new big_default.a(this.currentValue);
        this.currentValue = x.plus(this.step) * 1;
      }
    },
    sub: function sub() {
      if (!this.disabledMin) {
        var x = new big_default.a(this.currentValue);
        this.currentValue = x.minus(this.step) * 1;
      }
    },
    blur: function blur() {
      if (this.currentValue === '') {
        this.currentValue = 0;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17ee4921","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-number/index.vue
var x_number_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cell"},[_c('div',[_c('p',{class:_vm.labelClass,style:({width: _vm.$parent.labelWidth, textAlign: _vm.$parent.labelAlign, marginRight: _vm.$parent.labelMarginRight}),domProps:{"innerHTML":_vm._s(_vm.title)}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.readonly),expression:"!readonly"}],staticClass:"weui-cell__ft vux-cell-primary",class:{'vux-number-round': _vm.buttonStyle === 'round'},staticStyle:{"font-size":"0"}},[_c('div',{style:({float:_vm.align})},[_c('a',{staticClass:"vux-number-selector vux-number-selector-sub",class:{'vux-number-disabled':_vm.disabledMin},on:{"click":_vm.sub}},[_c('svg',{attrs:{"viewBox":"0 0 1024 1024","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"18","height":"18"}},[_c('defs'),_c('path',{attrs:{"d":"M863.74455 544.00086 163.424056 544.00086c-17.664722 0-32.00086-14.336138-32.00086-32.00086s14.336138-32.00086 32.00086-32.00086l700.320495 0c17.695686 0 31.99914 14.336138 31.99914 32.00086S881.440237 544.00086 863.74455 544.00086z"}})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.currentValue),expression:"currentValue",modifiers:{"number":true}}],staticClass:"vux-number-input",style:({width: _vm.width}),attrs:{"name":_vm.name,"readonly":!_vm.fillable,"pattern":"[0-9]*","type":"number"},domProps:{"value":(_vm.currentValue)},on:{"blur":[_vm.blur,function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.currentValue=_vm._n($event.target.value)}}}),_vm._v(" "),_c('a',{staticClass:"vux-number-selector vux-number-selector-plus",class:{'vux-number-disabled':_vm.disabledMax},on:{"click":_vm.add}},[_c('svg',{attrs:{"viewBox":"0 0 1024 1024","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"20","height":"20"}},[_c('defs'),_c('path',{attrs:{"d":"M863.328262 481.340895l-317.344013 0.099772L545.984249 162.816826c0-17.664722-14.336138-32.00086-32.00086-32.00086s-31.99914 14.336138-31.99914 32.00086l0 318.400215-322.368714-0.17718c-0.032684 0-0.063647 0-0.096331 0-17.632039 0-31.935493 14.239806-32.00086 31.904529-0.096331 17.664722 14.208843 32.031824 31.871845 32.095471l322.59234 0.17718 0 319.167424c0 17.695686 14.336138 32.00086 31.99914 32.00086s32.00086-14.303454 32.00086-32.00086L545.982529 545.440667l317.087703-0.099772c0.063647 0 0.096331 0 0.127295 0 17.632039 0 31.935493-14.239806 32.00086-31.904529S880.960301 481.404542 863.328262 481.340895z"}})])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.readonly),expression:"readonly"}],staticClass:"weui-cell__ft vux-cell-primary"},[_vm._v("\n    "+_vm._s(_vm.value)+"\n  ")])])}
var x_number_staticRenderFns = []
var x_number_esExports = { render: x_number_render, staticRenderFns: x_number_staticRenderFns }
/* harmony default export */ var src_components_x_number = (x_number_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-number/index.vue
function x_number_injectStyle (ssrContext) {
  __webpack_require__("YqUT")
}
var x_number_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_number___vue_template_functional__ = false
/* styles */
var x_number___vue_styles__ = x_number_injectStyle
/* scopeId */
var x_number___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_number___vue_module_identifier__ = null
var x_number_Component = x_number_normalizeComponent(
  components_x_number,
  src_components_x_number,
  x_number___vue_template_functional__,
  x_number___vue_styles__,
  x_number___vue_scopeId__,
  x_number___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_number = (x_number_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-loading/index.vue
//
//
//
//

/* harmony default export */ var inline_loading = ({
  name: 'inline-loading'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-loading/index.vue
//
//
//
//

/* harmony default export */ var components_inline_loading = ({
  name: 'inline-loading'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1426a676","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/inline-loading/index.vue
var inline_loading_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"weui-loading"})}
var inline_loading_staticRenderFns = []
var inline_loading_esExports = { render: inline_loading_render, staticRenderFns: inline_loading_staticRenderFns }
/* harmony default export */ var src_components_inline_loading = (inline_loading_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/inline-loading/index.vue
function inline_loading_injectStyle (ssrContext) {
  __webpack_require__("6ReU")
}
var inline_loading_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var inline_loading___vue_template_functional__ = false
/* styles */
var inline_loading___vue_styles__ = inline_loading_injectStyle
/* scopeId */
var inline_loading___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var inline_loading___vue_module_identifier__ = null
var inline_loading_Component = inline_loading_normalizeComponent(
  components_inline_loading,
  src_components_inline_loading,
  inline_loading___vue_template_functional__,
  inline_loading___vue_styles__,
  inline_loading___vue_scopeId__,
  inline_loading___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_inline_loading = (inline_loading_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-x-switch/index.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var inline_x_switch = ({
  name: 'x-switch',
  methods: {
    toBoolean: function toBoolean(val) {
      if (!this.valueMap) {
        return val;
      } else {
        var index = this.valueMap.indexOf(val);
        return index === 1;
      }
    },
    toRaw: function toRaw(val) {
      if (!this.valueMap) {
        return val;
      } else {
        return this.valueMap[val ? 1 : 0];
      }
    }
  },
  props: {
    disabled: Boolean,
    value: {
      type: [Boolean, String, Number],
      default: false
    },
    valueMap: {
      type: Array,
      default: function _default() {
        return [false, true];
      }
    }
  },
  data: function data() {
    return {
      currentValue: this.toBoolean(this.value)
    };
  },

  watch: {
    currentValue: function currentValue(val) {
      var rawValue = this.toRaw(val);
      this.$emit('input', rawValue);
      this.$emit('on-change', rawValue);
    },
    value: function value(val) {
      this.currentValue = this.toBoolean(val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-x-switch/index.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var components_inline_x_switch = ({
  name: 'x-switch',
  methods: {
    toBoolean: function toBoolean(val) {
      if (!this.valueMap) {
        return val;
      } else {
        var index = this.valueMap.indexOf(val);
        return index === 1;
      }
    },
    toRaw: function toRaw(val) {
      if (!this.valueMap) {
        return val;
      } else {
        return this.valueMap[val ? 1 : 0];
      }
    }
  },
  props: {
    disabled: Boolean,
    value: {
      type: [Boolean, String, Number],
      default: false
    },
    valueMap: {
      type: Array,
      default: function _default() {
        return [false, true];
      }
    }
  },
  data: function data() {
    return {
      currentValue: this.toBoolean(this.value)
    };
  },

  watch: {
    currentValue: function currentValue(val) {
      var rawValue = this.toRaw(val);
      this.$emit('input', rawValue);
      this.$emit('on-change', rawValue);
    },
    value: function value(val) {
      this.currentValue = this.toBoolean(val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-98b20894","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/inline-x-switch/index.vue
var inline_x_switch_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"inline-x-switch weui-switch",attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":Array.isArray(_vm.currentValue)?_vm._i(_vm.currentValue,null)>-1:(_vm.currentValue)},on:{"change":function($event){var $$a=_vm.currentValue,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.currentValue=$$a.concat([$$v]))}else{$$i>-1&&(_vm.currentValue=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.currentValue=$$c}}}})}
var inline_x_switch_staticRenderFns = []
var inline_x_switch_esExports = { render: inline_x_switch_render, staticRenderFns: inline_x_switch_staticRenderFns }
/* harmony default export */ var src_components_inline_x_switch = (inline_x_switch_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/inline-x-switch/index.vue
function inline_x_switch_injectStyle (ssrContext) {
  __webpack_require__("Liau")
}
var inline_x_switch_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var inline_x_switch___vue_template_functional__ = false
/* styles */
var inline_x_switch___vue_styles__ = inline_x_switch_injectStyle
/* scopeId */
var inline_x_switch___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var inline_x_switch___vue_module_identifier__ = null
var inline_x_switch_Component = inline_x_switch_normalizeComponent(
  components_inline_x_switch,
  src_components_inline_x_switch,
  inline_x_switch___vue_template_functional__,
  inline_x_switch___vue_styles__,
  inline_x_switch___vue_scopeId__,
  inline_x_switch___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_inline_x_switch = (inline_x_switch_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-x-number/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var inline_x_number = ({
  name: 'inline-x-number',
  extends: vux_src_components_x_number
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-x-number/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_inline_x_number = ({
  name: 'inline-x-number',
  extends: vux_src_components_x_number
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-572c6eea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/inline-x-number/index.vue
var inline_x_number_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-inline-x-number",class:{'vux-number-round': _vm.buttonStyle === 'round'}},[_c('div',[_c('a',{staticClass:"vux-number-selector vux-number-selector-sub",class:{'vux-number-disabled':_vm.disabledMin},on:{"click":_vm.sub}},[_c('svg',{attrs:{"viewBox":"0 0 1024 1024","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"18","height":"18"}},[_c('defs'),_c('path',{attrs:{"d":"M863.74455 544.00086 163.424056 544.00086c-17.664722 0-32.00086-14.336138-32.00086-32.00086s14.336138-32.00086 32.00086-32.00086l700.320495 0c17.695686 0 31.99914 14.336138 31.99914 32.00086S881.440237 544.00086 863.74455 544.00086z"}})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.currentValue),expression:"currentValue",modifiers:{"number":true}}],staticClass:"vux-number-input",style:({width: _vm.width}),attrs:{"name":_vm.name,"readonly":!_vm.fillable,"pattern":"[0-9]*","type":"number"},domProps:{"value":(_vm.currentValue)},on:{"blur":[_vm.blur,function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.currentValue=_vm._n($event.target.value)}}}),_vm._v(" "),_c('a',{staticClass:"vux-number-selector vux-number-selector-plus",class:{'vux-number-disabled':_vm.disabledMax},on:{"click":_vm.add}},[_c('svg',{attrs:{"viewBox":"0 0 1024 1024","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"20","height":"20"}},[_c('defs'),_c('path',{attrs:{"d":"M863.328262 481.340895l-317.344013 0.099772L545.984249 162.816826c0-17.664722-14.336138-32.00086-32.00086-32.00086s-31.99914 14.336138-31.99914 32.00086l0 318.400215-322.368714-0.17718c-0.032684 0-0.063647 0-0.096331 0-17.632039 0-31.935493 14.239806-32.00086 31.904529-0.096331 17.664722 14.208843 32.031824 31.871845 32.095471l322.59234 0.17718 0 319.167424c0 17.695686 14.336138 32.00086 31.99914 32.00086s32.00086-14.303454 32.00086-32.00086L545.982529 545.440667l317.087703-0.099772c0.063647 0 0.096331 0 0.127295 0 17.632039 0 31.935493-14.239806 32.00086-31.904529S880.960301 481.404542 863.328262 481.340895z"}})])])])])}
var inline_x_number_staticRenderFns = []
var inline_x_number_esExports = { render: inline_x_number_render, staticRenderFns: inline_x_number_staticRenderFns }
/* harmony default export */ var src_components_inline_x_number = (inline_x_number_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/inline-x-number/index.vue
function inline_x_number_injectStyle (ssrContext) {
  __webpack_require__("F+qD")
}
var inline_x_number_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var inline_x_number___vue_template_functional__ = false
/* styles */
var inline_x_number___vue_styles__ = inline_x_number_injectStyle
/* scopeId */
var inline_x_number___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var inline_x_number___vue_module_identifier__ = null
var inline_x_number_Component = inline_x_number_normalizeComponent(
  components_inline_x_number,
  src_components_inline_x_number,
  inline_x_number___vue_template_functional__,
  inline_x_number___vue_styles__,
  inline_x_number___vue_scopeId__,
  inline_x_number___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_inline_x_number = (inline_x_number_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/flexbox/flexbox.vue + 3 modules
var flexbox_flexbox = __webpack_require__("YxJB");

// EXTERNAL MODULE: ./node_modules/vux/src/components/flexbox/flexbox-item.vue + 3 modules
var flexbox_item = __webpack_require__("3Lt7");

// EXTERNAL MODULE: ./node_modules/autosize/dist/autosize.js
var autosize = __webpack_require__("JnrT");
var autosize_default = /*#__PURE__*/__webpack_require__.n(autosize);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-textarea/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



 // prop.autosize

/* harmony default export */ var x_textarea = ({
  name: 'x-textarea',
  minxins: [libs_base["a" /* default */]],
  mounted: function mounted() {
    var _this = this;

    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    // prop.autosize
    this.$nextTick(function () {
      if (_this.autosize) {
        _this.bindAutosize();
      }
    });
    // prop.autosize
  },

  components: {
    InlineDesc: inline_desc["a" /* default */]
  },
  props: {
    title: String,
    inlineDesc: String,
    showCounter: {
      type: Boolean,
      default: true
    },
    max: Number,
    value: String,
    name: String,
    placeholder: String,
    readonly: Boolean,
    disabled: Boolean,
    rows: {
      type: Number,
      default: 3
    },
    cols: {
      type: Number,
      default: 30
    },
    height: Number,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    autosize: Boolean // prop.autosize
  },
  created: function created() {
    this.currentValue = this.value;
  },

  watch: {
    // prop.autosize
    autosize: function autosize(val) {
      this.unbindAutosize();
      if (val) {
        this.bindAutosize();
      }
    },

    // prop.autosize
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(newVal) {
      var _this2 = this;

      if (this.max && newVal) {
        if (newVal.length > this.max) {
          var newLines = newVal.match(/\n/g).length;
          this.currentValue = newVal.slice(0, this.max - newLines);
          this.$nextTick(function () {
            if (_this2.autosize) {
              _this2.updateAutosize();
            }
          });
        } else {
          this.$nextTick(function () {
            if (_this2.autosize) {
              _this2.updateAutosize();
            }
          });
        }
      }
      this.$emit('input', this.currentValue);
      this.$emit('on-change', this.currentValue);
    }
  },
  data: function data() {
    return {
      hasRestrictedLabel: false,
      currentValue: ''
    };
  },

  computed: {
    count: function count() {
      var len = this.currentValue ? this.currentValue.length : 0;
      return len > this.max ? this.max : len;
    },
    textareaStyle: function textareaStyle() {
      if (this.height) {
        return {
          height: this.height + 'px'
        };
      }
    },
    labelStyles: function labelStyles() {
      var _$parent = this.$parent,
          $parent = _$parent === undefined ? {} : _$parent;

      return {
        width: $parent.labelWidth || this.labelWidth + 'em',
        textAlign: $parent.labelAlign,
        marginRight: $parent.labelMarginRight
      };
    },
    labelWidth: function labelWidth() {
      return this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
    },
    labelClass: function labelClass() {
      if (!this.$parent) return {};
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    updateAutosize: function updateAutosize() {
      autosize_default.a.update(this.$refs.textarea);
    },

    // prop.autosize
    bindAutosize: function bindAutosize() {
      autosize_default()(this.$refs.textarea);
    },
    unbindAutosize: function unbindAutosize() {
      autosize_default.a.destroy(this.$refs.textarea);
    },

    // prop.autosize
    focus: function focus() {
      this.$refs.textarea.focus();
    }
  },
  // prop.autosize
  beforeDestroy: function beforeDestroy() {
    this.unbindAutosize();
  }
  // prop.autosize

});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-textarea/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



 // prop.autosize

/* harmony default export */ var components_x_textarea = ({
  name: 'x-textarea',
  minxins: [libs_base["a" /* default */]],
  mounted: function mounted() {
    var _this = this;

    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    // prop.autosize
    this.$nextTick(function () {
      if (_this.autosize) {
        _this.bindAutosize();
      }
    });
    // prop.autosize
  },

  components: {
    InlineDesc: inline_desc["a" /* default */]
  },
  props: {
    title: String,
    inlineDesc: String,
    showCounter: {
      type: Boolean,
      default: true
    },
    max: Number,
    value: String,
    name: String,
    placeholder: String,
    readonly: Boolean,
    disabled: Boolean,
    rows: {
      type: Number,
      default: 3
    },
    cols: {
      type: Number,
      default: 30
    },
    height: Number,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    autosize: Boolean // prop.autosize
  },
  created: function created() {
    this.currentValue = this.value;
  },

  watch: {
    // prop.autosize
    autosize: function autosize(val) {
      this.unbindAutosize();
      if (val) {
        this.bindAutosize();
      }
    },

    // prop.autosize
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(newVal) {
      var _this2 = this;

      if (this.max && newVal) {
        if (newVal.length > this.max) {
          var newLines = newVal.match(/\n/g).length;
          this.currentValue = newVal.slice(0, this.max - newLines);
          this.$nextTick(function () {
            if (_this2.autosize) {
              _this2.updateAutosize();
            }
          });
        } else {
          this.$nextTick(function () {
            if (_this2.autosize) {
              _this2.updateAutosize();
            }
          });
        }
      }
      this.$emit('input', this.currentValue);
      this.$emit('on-change', this.currentValue);
    }
  },
  data: function data() {
    return {
      hasRestrictedLabel: false,
      currentValue: ''
    };
  },

  computed: {
    count: function count() {
      var len = this.currentValue ? this.currentValue.length : 0;
      return len > this.max ? this.max : len;
    },
    textareaStyle: function textareaStyle() {
      if (this.height) {
        return {
          height: this.height + 'px'
        };
      }
    },
    labelStyles: function labelStyles() {
      var _$parent = this.$parent,
          $parent = _$parent === undefined ? {} : _$parent;

      return {
        width: $parent.labelWidth || this.labelWidth + 'em',
        textAlign: $parent.labelAlign,
        marginRight: $parent.labelMarginRight
      };
    },
    labelWidth: function labelWidth() {
      return this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
    },
    labelClass: function labelClass() {
      if (!this.$parent) return {};
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    updateAutosize: function updateAutosize() {
      autosize_default.a.update(this.$refs.textarea);
    },

    // prop.autosize
    bindAutosize: function bindAutosize() {
      autosize_default()(this.$refs.textarea);
    },
    unbindAutosize: function unbindAutosize() {
      autosize_default.a.destroy(this.$refs.textarea);
    },

    // prop.autosize
    focus: function focus() {
      this.$refs.textarea.focus();
    }
  },
  // prop.autosize
  beforeDestroy: function beforeDestroy() {
    this.unbindAutosize();
  }
  // prop.autosize

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b98ae186","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-textarea/index.vue
var x_textarea_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cell vux-x-textarea"},[_c('div',{staticClass:"weui-cell__hd"},[(_vm.hasRestrictedLabel)?_c('div',{style:(_vm.labelStyles)},[_vm._t("restricted-label")],2):_vm._e(),_vm._v(" "),_vm._t("label",function(){return [(_vm.title)?_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:({width: _vm.$parent.labelWidth || (_vm.labelWidth + 'em'), textAlign: _vm.$parent.labelAlign, marginRight: _vm.$parent.labelMarginRight}),domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()]})],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"textarea",staticClass:"weui-textarea",style:(_vm.textareaStyle),attrs:{"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled,"name":_vm.name,"rows":_vm.rows,"cols":_vm.cols,"maxlength":_vm.max},domProps:{"value":(_vm.currentValue)},on:{"focus":function($event){return _vm.$emit('on-focus')},"blur":function($event){return _vm.$emit('on-blur')},"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCounter && _vm.max),expression:"showCounter && max"}],staticClass:"weui-textarea-counter",on:{"click":_vm.focus}},[_c('span',[_vm._v(_vm._s(_vm.count))]),_vm._v("/"+_vm._s(_vm.max)+"\n    ")])])])}
var x_textarea_staticRenderFns = []
var x_textarea_esExports = { render: x_textarea_render, staticRenderFns: x_textarea_staticRenderFns }
/* harmony default export */ var src_components_x_textarea = (x_textarea_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-textarea/index.vue
function x_textarea_injectStyle (ssrContext) {
  __webpack_require__("BsF3")
}
var x_textarea_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_textarea___vue_template_functional__ = false
/* styles */
var x_textarea___vue_styles__ = x_textarea_injectStyle
/* scopeId */
var x_textarea___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_textarea___vue_module_identifier__ = null
var x_textarea_Component = x_textarea_normalizeComponent(
  components_x_textarea,
  src_components_x_textarea,
  x_textarea___vue_template_functional__,
  x_textarea___vue_styles__,
  x_textarea___vue_scopeId__,
  x_textarea___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_textarea = (x_textarea_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/form-preview/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var form_preview = ({
  name: 'form-preview',
  props: ['headerLabel', 'headerValue', 'bodyItems', 'footerButtons', 'name'],
  methods: {
    onButtonClick: function onButtonClick(cb, link) {
      cb && cb(this.name);
      if (link) {
        Object(libs_router["b" /* go */])(link, this.$router);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/form-preview/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_form_preview = ({
  name: 'form-preview',
  props: ['headerLabel', 'headerValue', 'bodyItems', 'footerButtons', 'name'],
  methods: {
    onButtonClick: function onButtonClick(cb, link) {
      cb && cb(this.name);
      if (link) {
        Object(libs_router["b" /* go */])(link, this.$router);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b9e91c0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/form-preview/index.vue
var form_preview_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-form-preview weui-form-preview"},[_c('div',{staticClass:"weui-form-preview__hd"},[_c('label',{staticClass:"weui-form-preview__label",domProps:{"innerHTML":_vm._s(_vm.headerLabel)}}),_vm._v(" "),_c('em',{staticClass:"weui-form-preview__value",domProps:{"innerHTML":_vm._s(_vm.headerValue || '&nbsp;')}})]),_vm._v(" "),_c('div',{staticClass:"weui-form-preview__bd"},_vm._l((_vm.bodyItems),function(item){return _c('div',{staticClass:"weui-form-preview__item"},[_c('label',{staticClass:"weui-form-preview__label"},[_vm._v(_vm._s(item.label))]),_vm._v(" "),_c('span',{staticClass:"weui-form-preview__value"},[_vm._v(_vm._s(item.value))])])}),0),_vm._v(" "),_c('div',{staticClass:"weui-form-preview__ft"},_vm._l((_vm.footerButtons),function(button){return _c('a',{staticClass:"weui-form-preview__btn",class:{'weui-form-preview__btn_default': button.style==='default', 'weui-form-preview__btn_primary': button.style === 'primary'},attrs:{"href":"javascript:"},on:{"click":function($event){return _vm.onButtonClick(button.onButtonClick, button.link)}}},[_vm._v(_vm._s(button.text))])}),0)])}
var form_preview_staticRenderFns = []
var form_preview_esExports = { render: form_preview_render, staticRenderFns: form_preview_staticRenderFns }
/* harmony default export */ var src_components_form_preview = (form_preview_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/form-preview/index.vue
function form_preview_injectStyle (ssrContext) {
  __webpack_require__("CloN")
}
var form_preview_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var form_preview___vue_template_functional__ = false
/* styles */
var form_preview___vue_styles__ = form_preview_injectStyle
/* scopeId */
var form_preview___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var form_preview___vue_module_identifier__ = null
var form_preview_Component = form_preview_normalizeComponent(
  components_form_preview,
  src_components_form_preview,
  form_preview___vue_template_functional__,
  form_preview___vue_styles__,
  form_preview___vue_scopeId__,
  form_preview___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_form_preview = (form_preview_Component.exports);

// EXTERNAL MODULE: ./node_modules/x-photoswipe/dist/photoswipe.js
var photoswipe = __webpack_require__("i7N3");
var photoswipe_default = /*#__PURE__*/__webpack_require__.n(photoswipe);

// EXTERNAL MODULE: ./node_modules/x-photoswipe/dist/photoswipe-ui-default.js
var photoswipe_ui_default = __webpack_require__("72M0");
var photoswipe_ui_default_default = /*#__PURE__*/__webpack_require__.n(photoswipe_ui_default);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/previewer/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var previewer = ({
  name: 'previewer',
  computed: {
    imgs: function imgs() {
      return this.list.map(function (one) {
        if (!one.msrc) {
          one.msrc = one.src;
        }
        if (typeof one.w === 'undefined') {
          one.w = 0;
          one.h = 0;
        }
        return one;
      });
    }
  },
  watch: {
    imgs: function imgs(newVal, oldVal) {
      if (!this.photoswipe) {
        return;
      }
      if (newVal.length && newVal.length - oldVal.length === -1) {
        var index = this.photoswipe.getCurrentIndex();
        this.photoswipe.invalidateCurrItems();
        this.photoswipe.items.splice(index, 1);
        var goToIndex = index;
        if (goToIndex > this.photoswipe.items.length - 1) {
          goToIndex = 0;
        }
        this.photoswipe.goTo(goToIndex);
        this.photoswipe.updateSize(true);
        this.photoswipe.ui.update();
      } else if (!newVal.length) {
        this.close();
      }
    }
  },
  methods: {
    init: function init(index) {
      var self = this;
      var showItem = this.imgs[index];
      if (!showItem.w || !showItem.h || showItem.w < 5 || showItem.h < 5) {
        var img = new Image();
        img.onload = function () {
          showItem.w = this.width;
          showItem.h = this.height;
          self.doInit(index);
        };
        img.src = showItem.src;
      } else {
        this.doInit(index);
      }
    },
    doInit: function doInit(index) {
      var _this = this;

      var self = this;
      var options = object_assign_default()({
        history: false,
        shareEl: false,
        tapToClose: true,
        index: index
      }, this.options);
      this.photoswipe = new photoswipe_default.a(this.$el, photoswipe_ui_default_default.a, this.imgs, options);

      this.photoswipe.listen('gettingData', function (index, item) {
        if (!item.w || !item.h || item.w < 1 || item.h < 1) {
          var img = new Image();
          img.onload = function () {
            item.w = this.width;
            item.h = this.height;
            self.photoswipe.updateSize(true);
          };
          img.src = item.src;
        }
      });

      this.photoswipe.init();
      this.photoswipe.listen('close', function () {
        _this.$emit('on-close');
        _this.photoswipe = null;
      });
      this.photoswipe.listen('afterChange', function (a, b) {
        _this.$emit('on-index-change', {
          currentIndex: _this.photoswipe.getCurrentIndex()
        });
      });
    },
    show: function show(index) {
      this.init(index);
    },
    getCurrentIndex: function getCurrentIndex() {
      if (this.photoswipe) {
        return this.photoswipe.getCurrentIndex();
      }
    },
    close: function close() {
      this.photoswipe && this.photoswipe.close();
    },
    goTo: function goTo(index) {
      this.photoswipe && this.photoswipe.goTo(index);
    },
    prev: function prev() {
      this.photoswipe && this.photoswipe.prev();
    },
    next: function next() {
      this.photoswipe && this.photoswipe.next();
    }
  },
  props: {
    list: {
      type: Array,
      required: true
    },
    index: {
      type: Number,
      default: 0
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/previewer/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var components_previewer = ({
  name: 'previewer',
  computed: {
    imgs: function imgs() {
      return this.list.map(function (one) {
        if (!one.msrc) {
          one.msrc = one.src;
        }
        if (typeof one.w === 'undefined') {
          one.w = 0;
          one.h = 0;
        }
        return one;
      });
    }
  },
  watch: {
    imgs: function imgs(newVal, oldVal) {
      if (!this.photoswipe) {
        return;
      }
      if (newVal.length && newVal.length - oldVal.length === -1) {
        var index = this.photoswipe.getCurrentIndex();
        this.photoswipe.invalidateCurrItems();
        this.photoswipe.items.splice(index, 1);
        var goToIndex = index;
        if (goToIndex > this.photoswipe.items.length - 1) {
          goToIndex = 0;
        }
        this.photoswipe.goTo(goToIndex);
        this.photoswipe.updateSize(true);
        this.photoswipe.ui.update();
      } else if (!newVal.length) {
        this.close();
      }
    }
  },
  methods: {
    init: function init(index) {
      var self = this;
      var showItem = this.imgs[index];
      if (!showItem.w || !showItem.h || showItem.w < 5 || showItem.h < 5) {
        var img = new Image();
        img.onload = function () {
          showItem.w = this.width;
          showItem.h = this.height;
          self.doInit(index);
        };
        img.src = showItem.src;
      } else {
        this.doInit(index);
      }
    },
    doInit: function doInit(index) {
      var _this = this;

      var self = this;
      var options = object_assign_default()({
        history: false,
        shareEl: false,
        tapToClose: true,
        index: index
      }, this.options);
      this.photoswipe = new photoswipe_default.a(this.$el, photoswipe_ui_default_default.a, this.imgs, options);

      this.photoswipe.listen('gettingData', function (index, item) {
        if (!item.w || !item.h || item.w < 1 || item.h < 1) {
          var img = new Image();
          img.onload = function () {
            item.w = this.width;
            item.h = this.height;
            self.photoswipe.updateSize(true);
          };
          img.src = item.src;
        }
      });

      this.photoswipe.init();
      this.photoswipe.listen('close', function () {
        _this.$emit('on-close');
        _this.photoswipe = null;
      });
      this.photoswipe.listen('afterChange', function (a, b) {
        _this.$emit('on-index-change', {
          currentIndex: _this.photoswipe.getCurrentIndex()
        });
      });
    },
    show: function show(index) {
      this.init(index);
    },
    getCurrentIndex: function getCurrentIndex() {
      if (this.photoswipe) {
        return this.photoswipe.getCurrentIndex();
      }
    },
    close: function close() {
      this.photoswipe && this.photoswipe.close();
    },
    goTo: function goTo(index) {
      this.photoswipe && this.photoswipe.goTo(index);
    },
    prev: function prev() {
      this.photoswipe && this.photoswipe.prev();
    },
    next: function next() {
      this.photoswipe && this.photoswipe.next();
    }
  },
  props: {
    list: {
      type: Array,
      required: true
    },
    index: {
      type: Number,
      default: 0
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df9eff9a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/previewer/index.vue
var previewer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pswp vux-previewer",attrs:{"tabindex":"-1","role":"dialog","aria-hidden":"true"}},[_c('div',{staticClass:"pswp__bg"}),_vm._v(" "),_c('div',{staticClass:"pswp__scroll-wrap"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"pswp__ui pswp__ui--hidden"},[_c('div',{staticClass:"pswp__top-bar"},[_c('div',{staticClass:"pswp__counter"}),_vm._v(" "),_vm._t("button-after"),_vm._v(" "),_c('button',{staticClass:"pswp__button pswp__button--close",attrs:{"title":"Close (Esc)"}}),_vm._v(" "),_c('button',{staticClass:"pswp__button pswp__button--share",attrs:{"title":"Share"}}),_vm._v(" "),_c('button',{staticClass:"pswp__button pswp__button--fs",attrs:{"title":"Toggle fullscreen"}}),_vm._v(" "),_c('button',{staticClass:"pswp__button pswp__button--zoom",attrs:{"title":"Zoom in/out"}}),_vm._v(" "),_vm._t("button-before"),_vm._v(" "),_vm._m(1)],2),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('button',{staticClass:"pswp__button pswp__button--arrow--left",attrs:{"title":"Previous (arrow left)"}}),_vm._v(" "),_c('button',{staticClass:"pswp__button pswp__button--arrow--right",attrs:{"title":"Next (arrow right)"}}),_vm._v(" "),_vm._m(3)])]),_vm._v(" "),_vm._t("wrap-after")],2)}
var previewer_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pswp__container"},[_c('div',{staticClass:"pswp__item"}),_vm._v(" "),_c('div',{staticClass:"pswp__item"}),_vm._v(" "),_c('div',{staticClass:"pswp__item"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pswp__preloader"},[_c('div',{staticClass:"pswp__preloader__icn"},[_c('div',{staticClass:"pswp__preloader__cut"},[_c('div',{staticClass:"pswp__preloader__donut"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pswp__share-modal pswp__share-modal--hidden pswp__single-tap"},[_c('div',{staticClass:"pswp__share-tooltip"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pswp__caption"},[_c('div',{staticClass:"pswp__caption__center"})])}]
var previewer_esExports = { render: previewer_render, staticRenderFns: previewer_staticRenderFns }
/* harmony default export */ var src_components_previewer = (previewer_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/previewer/index.vue
function previewer_injectStyle (ssrContext) {
  __webpack_require__("xhby")
  __webpack_require__("z/9y")
}
var previewer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var previewer___vue_template_functional__ = false
/* styles */
var previewer___vue_styles__ = previewer_injectStyle
/* scopeId */
var previewer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var previewer___vue_module_identifier__ = null
var previewer_Component = previewer_normalizeComponent(
  components_previewer,
  src_components_previewer,
  previewer___vue_template_functional__,
  previewer___vue_styles__,
  previewer___vue_scopeId__,
  previewer___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_previewer = (previewer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/card/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var card = ({
  name: 'card',
  props: {
    header: Object,
    footer: Object
  },
  methods: {
    onClickFooter: function onClickFooter() {
      this.footer.link && Object(libs_router["b" /* go */])(this.footer.link, this.$router);
      this.$emit('on-click-footer');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/card/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_card = ({
  name: 'card',
  props: {
    header: Object,
    footer: Object
  },
  methods: {
    onClickFooter: function onClickFooter() {
      this.footer.link && Object(libs_router["b" /* go */])(this.footer.link, this.$router);
      this.$emit('on-click-footer');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56b3faf0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/card/index.vue
var card_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-panel weui-panel_access"},[(_vm.header && _vm.header.title)?_c('div',{staticClass:"weui-panel__hd",domProps:{"innerHTML":_vm._s(_vm.header.title)},on:{"click":function($event){return _vm.$emit('on-click-header')}}}):_vm._e(),_vm._v(" "),_vm._t("header"),_vm._v(" "),_c('div',{staticClass:"weui-panel__bd"},[_c('div',{staticClass:"vux-card-content"},[_vm._t("content")],2)]),_vm._v(" "),_c('div',{staticClass:"weui-panel__ft"},[(_vm.footer && _vm.footer.title)?_c('a',{staticClass:"weui-cell weui-cell_access weui-cell_link",attrs:{"href":"javascript:"},on:{"click":_vm.onClickFooter}},[_c('div',{staticClass:"weui-cell__bd",domProps:{"innerHTML":_vm._s(_vm.footer.title)}})]):_vm._e()]),_vm._v(" "),_vm._t("footer")],2)}
var card_staticRenderFns = []
var card_esExports = { render: card_render, staticRenderFns: card_staticRenderFns }
/* harmony default export */ var src_components_card = (card_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/card/index.vue
function card_injectStyle (ssrContext) {
  __webpack_require__("/4VV")
}
var card_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var card___vue_template_functional__ = false
/* styles */
var card___vue_styles__ = card_injectStyle
/* scopeId */
var card___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var card___vue_module_identifier__ = null
var card_Component = card_normalizeComponent(
  components_card,
  src_components_card,
  card___vue_template_functional__,
  card___vue_styles__,
  card___vue_scopeId__,
  card___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_card = (card_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-table/index.vue
//
//
//
//
//
//

/* harmony default export */ var x_table = ({
  name: 'x-table',
  props: {
    fullBordered: Boolean,
    cellBordered: {
      type: Boolean,
      default: true
    },
    contentBordered: {
      type: Boolean,
      default: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-table/index.vue
//
//
//
//
//
//

/* harmony default export */ var components_x_table = ({
  name: 'x-table',
  props: {
    fullBordered: Boolean,
    cellBordered: {
      type: Boolean,
      default: true
    },
    contentBordered: {
      type: Boolean,
      default: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2264b9b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-table/index.vue
var x_table_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"vux-table",class:{'vux-table-bordered': _vm.fullBordered, 'vux-table-no-cell-bordered': !_vm.cellBordered, 'vux-table-no-content-bordered': !_vm.contentBordered}},[_vm._t("default")],2)}
var x_table_staticRenderFns = []
var x_table_esExports = { render: x_table_render, staticRenderFns: x_table_staticRenderFns }
/* harmony default export */ var src_components_x_table = (x_table_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-table/index.vue
function x_table_injectStyle (ssrContext) {
  __webpack_require__("sVzw")
}
var x_table_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_table___vue_template_functional__ = false
/* styles */
var x_table___vue_styles__ = x_table_injectStyle
/* scopeId */
var x_table___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_table___vue_module_identifier__ = null
var x_table_Component = x_table_normalizeComponent(
  components_x_table,
  src_components_x_table,
  x_table___vue_template_functional__,
  x_table___vue_styles__,
  x_table___vue_scopeId__,
  x_table___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_table = (x_table_Component.exports);

// EXTERNAL MODULE: ./node_modules/array-find/find.js
var find = __webpack_require__("NXHL");
var find_default = /*#__PURE__*/__webpack_require__.n(find);

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/uuid.js
var uuid = __webpack_require__("KRg4");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/selector/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var selector_findByKey = function findByKey(key, options) {
  var _rs = find_default()(options, function (item) {
    return item.key === key;
  });
  return _rs ? _rs.value : key;
};

/* harmony default export */ var selector = ({
  name: 'selector',
  mixins: [uuid["a" /* default */]],
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.currentValue = this.value;
    }
  },
  beforeMount: function beforeMount() {
    this.isIOS = /iPad|iPhone|iPod/.test(window.navigator.userAgent);
  },

  computed: {
    fixIos: function fixIos() {
      return !this.placeholder && this.isEmptyValue(this.value) && this.isIOS && this.title;
    },
    color: function color() {
      return this.showPlaceholder ? '#A9A9A9' : '';
    },
    processOptions: function processOptions() {
      var _this = this;

      if (!this.options.length) {
        return [];
      }

      var isObject = typeof_default()(this.options[0]) === 'object';

      if (isObject && !this.valueMap) {
        return this.options;
      }

      if (isObject && this.valueMap) {
        return this.options.map(function (item) {
          return {
            key: item[_this.valueMap[0]],
            value: item[_this.valueMap[1]]
          };
        });
      }

      return this.options.map(function (item) {
        return {
          key: item,
          value: item
        };
      });
    },
    showPlaceholder: function showPlaceholder() {
      if (this.isEmptyValue(this.value) && this.placeholder) {
        return true;
      }
      return false;
    },
    labelClass: function labelClass() {
      if (!this.$parent) return {};
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    isEmptyValue: function isEmptyValue(val) {
      return typeof val === 'undefined' || val === '' || val === null;
    },

    cleanStyle: clean_style["a" /* default */],
    getFullValue: function getFullValue() {
      var _this2 = this;

      if (!this.value) {
        return null;
      }
      if (!this.options.length) {
        return null;
      }
      if (typeof_default()(this.options[0]) !== 'object') {
        return this.value;
      } else {
        if (!this.valueMap) {
          return this.options.filter(function (one) {
            return one.key === _this2.value;
          });
        } else {
          return this.options.filter(function (one) {
            return one[_this2.valueMap[0]] === _this2.value;
          });
        }
      }
    }
  },
  filters: {
    findByKey: selector_findByKey
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  props: {
    title: String,
    direction: String,
    options: {
      type: Array,
      required: true
    },
    name: String,
    placeholder: String,
    readonly: Boolean,
    value: [String, Number, Object, Boolean],
    valueMap: {
      type: Array,
      validator: function validator(val) {
        if (!val.length || val.length !== 2) {
          if (false) {
            console.error('[VUX error] selector prop:valueMap\'s length should be 2');
          }
          return false;
        }
        return true;
      }
    }
  },
  data: function data() {
    return {
      currentValue: '',
      isIOS: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/selector/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var components_selector_findByKey = function findByKey(key, options) {
  var _rs = find_default()(options, function (item) {
    return item.key === key;
  });
  return _rs ? _rs.value : key;
};

/* harmony default export */ var components_selector = ({
  name: 'selector',
  mixins: [uuid["a" /* default */]],
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.currentValue = this.value;
    }
  },
  beforeMount: function beforeMount() {
    this.isIOS = /iPad|iPhone|iPod/.test(window.navigator.userAgent);
  },

  computed: {
    fixIos: function fixIos() {
      return !this.placeholder && this.isEmptyValue(this.value) && this.isIOS && this.title;
    },
    color: function color() {
      return this.showPlaceholder ? '#A9A9A9' : '';
    },
    processOptions: function processOptions() {
      var _this = this;

      if (!this.options.length) {
        return [];
      }

      var isObject = typeof_default()(this.options[0]) === 'object';

      if (isObject && !this.valueMap) {
        return this.options;
      }

      if (isObject && this.valueMap) {
        return this.options.map(function (item) {
          return {
            key: item[_this.valueMap[0]],
            value: item[_this.valueMap[1]]
          };
        });
      }

      return this.options.map(function (item) {
        return {
          key: item,
          value: item
        };
      });
    },
    showPlaceholder: function showPlaceholder() {
      if (this.isEmptyValue(this.value) && this.placeholder) {
        return true;
      }
      return false;
    },
    labelClass: function labelClass() {
      if (!this.$parent) return {};
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    isEmptyValue: function isEmptyValue(val) {
      return typeof val === 'undefined' || val === '' || val === null;
    },

    cleanStyle: clean_style["a" /* default */],
    getFullValue: function getFullValue() {
      var _this2 = this;

      if (!this.value) {
        return null;
      }
      if (!this.options.length) {
        return null;
      }
      if (typeof_default()(this.options[0]) !== 'object') {
        return this.value;
      } else {
        if (!this.valueMap) {
          return this.options.filter(function (one) {
            return one.key === _this2.value;
          });
        } else {
          return this.options.filter(function (one) {
            return one[_this2.valueMap[0]] === _this2.value;
          });
        }
      }
    }
  },
  filters: {
    findByKey: components_selector_findByKey
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  props: {
    title: String,
    direction: String,
    options: {
      type: Array,
      required: true
    },
    name: String,
    placeholder: String,
    readonly: Boolean,
    value: [String, Number, Object, Boolean],
    valueMap: {
      type: Array,
      validator: function validator(val) {
        if (!val.length || val.length !== 2) {
          if (false) {
            console.error('[VUX error] selector prop:valueMap\'s length should be 2');
          }
          return false;
        }
        return true;
      }
    }
  },
  data: function data() {
    return {
      currentValue: '',
      isIOS: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e0012d80","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/selector/index.vue
var selector_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-selector weui-cell",class:{
    'weui-cell_select': !_vm.readonly,
    'weui-cell_select-after': _vm.title
  }},[(_vm.title)?_c('div',{staticClass:"weui-cell__hd"},[_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:(_vm.cleanStyle({
        width: _vm.$parent.labelWidth,
        textAlign: _vm.$parent.labelAlign,
        marginRight: _vm.$parent.labelMarginRight
      })),attrs:{"for":("vux-selector-" + _vm.uuid)},domProps:{"innerHTML":_vm._s(_vm.title)}})]):_vm._e(),_vm._v(" "),(!_vm.readonly)?_c('div',{staticClass:"weui-cell__bd"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"weui-select",style:(_vm.cleanStyle({
        direction: _vm.direction,
        color: _vm.color
      })),attrs:{"id":("vux-selector-" + _vm.uuid),"name":_vm.name},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.currentValue=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[(_vm.showPlaceholder)?_c('option',{domProps:{"value":_vm.value === null ? 'null' : '',"selected":_vm.isEmptyValue(_vm.value) && !!_vm.placeholder}},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_vm._v(" "),(_vm.fixIos)?_c('option',{attrs:{"disabled":""}}):_vm._e(),_vm._v(" "),_vm._l((_vm.processOptions),function(one){return _c('option',{domProps:{"value":one.key}},[_vm._v(_vm._s(_vm.direction === 'rtl' ? one.value + '‎' : one.value))])})],2)]):_c('div',{staticClass:"weui-cell__ft vux-selector-readonly"},[_vm._v("\n    "+_vm._s(_vm._f("findByKey")(_vm.value,_vm.processOptions))+"\n  ")])])}
var selector_staticRenderFns = []
var selector_esExports = { render: selector_render, staticRenderFns: selector_staticRenderFns }
/* harmony default export */ var src_components_selector = (selector_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/selector/index.vue
function selector_injectStyle (ssrContext) {
  __webpack_require__("G6U3")
}
var selector_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var selector___vue_template_functional__ = false
/* styles */
var selector___vue_styles__ = selector_injectStyle
/* scopeId */
var selector___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var selector___vue_module_identifier__ = null
var selector_Component = selector_normalizeComponent(
  components_selector,
  src_components_selector,
  selector___vue_template_functional__,
  selector___vue_styles__,
  selector___vue_scopeId__,
  selector___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_selector = (selector_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/search/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var search = ({
  name: 'search',
  mixins: [uuid["a" /* default */]],
  props: {
    type: {
      type: String,
      default: 'search'
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: String,
    cancelText: String,
    value: {
      type: String,
      default: ''
    },
    results: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    autoFixed: {
      type: Boolean,
      default: true
    },
    top: {
      type: String,
      default: '0px'
    },
    position: {
      type: String,
      default: 'fixed'
    },
    autoScrollToTop: Boolean
  },
  created: function created() {
    if (this.value) {
      this.currentValue = this.value;
    }
  },

  computed: {
    fixPosition: function fixPosition() {
      if (this.isFixed) {
        return this.position === 'absolute' ? 'absolute' : 'fixed';
      }
      return 'static';
    }
  },
  methods: {
    emitEvent: function emitEvent() {
      var _this = this;

      this.$nextTick(function () {
        _this.$emit('input', _this.currentValue);
        _this.$emit('on-change', _this.currentValue);
      });
    },
    onComposition: function onComposition($event, type) {
      if (type === 'start') {
        this.onInput = true;
      }
      if (type === 'end') {
        this.onInput = false;
        this.emitEvent();
      }
      if (type === 'input') {
        if (!this.onInput) {
          this.emitEvent();
        }
      }
    },
    clear: function clear() {
      this.currentValue = '';
      this.emitEvent();
      this.isFocus = true;
      this.setFocus();
      if (this.autoFixed && !this.isFixed) {
        this.isFixed = true;
      }
      this.$emit('on-clear');
    },
    cancel: function cancel() {
      this.isCancel = true;
      this.currentValue = '';
      this.emitEvent();
      this.isFixed = false;
      this.$emit('on-cancel');
    },
    handleResultClick: function handleResultClick(item) {
      this.$emit('result-click', item); // just for compatibility
      this.$emit('on-result-click', item);
      this.isCancel = true;
      this.isFixed = false;
    },
    touch: function touch() {
      this.isCancel = false;
      if (this.autoFixed) {
        this.isFixed = true;
      }
      this.$emit('on-touch');
    },
    setFocus: function setFocus() {
      this.$refs.input.focus();
    },
    setBlur: function setBlur() {
      this.$refs.input.blur();
    },
    onFocus: function onFocus() {
      this.isFocus = true;
      this.$emit('on-focus');
      this.touch();
    },
    onBlur: function onBlur() {
      this.isFocus = false;
      this.$emit('on-blur');
    }
  },
  data: function data() {
    return {
      onInput: false,
      currentValue: '',
      isCancel: true,
      isFocus: false,
      isFixed: false
    };
  },

  watch: {
    isFixed: function isFixed(val) {
      if (val === true) {
        this.setFocus();
        this.isFocus = true;

        if (this.autoScrollToTop) {
          setTimeout(function () {
            window.scrollTo(0, 0);
          }, 150);
        }
      } else {}
    },
    value: function value(val) {
      this.currentValue = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/search/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_search = ({
  name: 'search',
  mixins: [uuid["a" /* default */]],
  props: {
    type: {
      type: String,
      default: 'search'
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: String,
    cancelText: String,
    value: {
      type: String,
      default: ''
    },
    results: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    autoFixed: {
      type: Boolean,
      default: true
    },
    top: {
      type: String,
      default: '0px'
    },
    position: {
      type: String,
      default: 'fixed'
    },
    autoScrollToTop: Boolean
  },
  created: function created() {
    if (this.value) {
      this.currentValue = this.value;
    }
  },

  computed: {
    fixPosition: function fixPosition() {
      if (this.isFixed) {
        return this.position === 'absolute' ? 'absolute' : 'fixed';
      }
      return 'static';
    }
  },
  methods: {
    emitEvent: function emitEvent() {
      var _this = this;

      this.$nextTick(function () {
        _this.$emit('input', _this.currentValue);
        _this.$emit('on-change', _this.currentValue);
      });
    },
    onComposition: function onComposition($event, type) {
      if (type === 'start') {
        this.onInput = true;
      }
      if (type === 'end') {
        this.onInput = false;
        this.emitEvent();
      }
      if (type === 'input') {
        if (!this.onInput) {
          this.emitEvent();
        }
      }
    },
    clear: function clear() {
      this.currentValue = '';
      this.emitEvent();
      this.isFocus = true;
      this.setFocus();
      if (this.autoFixed && !this.isFixed) {
        this.isFixed = true;
      }
      this.$emit('on-clear');
    },
    cancel: function cancel() {
      this.isCancel = true;
      this.currentValue = '';
      this.emitEvent();
      this.isFixed = false;
      this.$emit('on-cancel');
    },
    handleResultClick: function handleResultClick(item) {
      this.$emit('result-click', item); // just for compatibility
      this.$emit('on-result-click', item);
      this.isCancel = true;
      this.isFixed = false;
    },
    touch: function touch() {
      this.isCancel = false;
      if (this.autoFixed) {
        this.isFixed = true;
      }
      this.$emit('on-touch');
    },
    setFocus: function setFocus() {
      this.$refs.input.focus();
    },
    setBlur: function setBlur() {
      this.$refs.input.blur();
    },
    onFocus: function onFocus() {
      this.isFocus = true;
      this.$emit('on-focus');
      this.touch();
    },
    onBlur: function onBlur() {
      this.isFocus = false;
      this.$emit('on-blur');
    }
  },
  data: function data() {
    return {
      onInput: false,
      currentValue: '',
      isCancel: true,
      isFocus: false,
      isFixed: false
    };
  },

  watch: {
    isFixed: function isFixed(val) {
      if (val === true) {
        this.setFocus();
        this.isFocus = true;

        if (this.autoScrollToTop) {
          setTimeout(function () {
            window.scrollTo(0, 0);
          }, 150);
        }
      } else {}
    },
    value: function value(val) {
      this.currentValue = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d29452ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/search/index.vue
var search_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-search-box",class:{ 'vux-search-fixed':_vm.isFixed },style:({ top: _vm.isFixed ? _vm.top : '', position: _vm.fixPosition })},[_c('div',{staticClass:"weui-search-bar",class:{'weui-search-bar_focusing': !_vm.isCancel || _vm.currentValue}},[_vm._t("left"),_vm._v(" "),_c('form',{staticClass:"weui-search-bar__form",attrs:{"action":"."},on:{"submit":function($event){$event.preventDefault();return _vm.$emit('on-submit', _vm.value)}}},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isFixed && _vm.autoFixed),expression:"!isFixed && autoFixed"}],staticClass:"vux-search-mask",attrs:{"for":("search_input_" + _vm.uuid)},on:{"click":_vm.touch}}),_vm._v(" "),_c('div',{staticClass:"weui-search-bar__box"},[_c('i',{staticClass:"weui-icon-search"}),_vm._v(" "),((_vm.type)==='checkbox')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-search-bar__input",attrs:{"autocomplete":"off","id":("search_input_" + _vm.uuid),"placeholder":_vm.placeholder,"required":_vm.required,"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.currentValue)?_vm._i(_vm.currentValue,null)>-1:(_vm.currentValue)},on:{"focus":_vm.onFocus,"blur":_vm.onBlur,"compositionstart":function($event){return _vm.onComposition($event, 'start')},"compositionend":function($event){return _vm.onComposition($event, 'end')},"input":function($event){return _vm.onComposition($event, 'input')},"change":function($event){var $$a=_vm.currentValue,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.currentValue=$$a.concat([$$v]))}else{$$i>-1&&(_vm.currentValue=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.currentValue=$$c}}}}):((_vm.type)==='radio')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-search-bar__input",attrs:{"autocomplete":"off","id":("search_input_" + _vm.uuid),"placeholder":_vm.placeholder,"required":_vm.required,"type":"radio"},domProps:{"checked":_vm._q(_vm.currentValue,null)},on:{"focus":_vm.onFocus,"blur":_vm.onBlur,"compositionstart":function($event){return _vm.onComposition($event, 'start')},"compositionend":function($event){return _vm.onComposition($event, 'end')},"input":function($event){return _vm.onComposition($event, 'input')},"change":function($event){_vm.currentValue=null}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-search-bar__input",attrs:{"autocomplete":"off","id":("search_input_" + _vm.uuid),"placeholder":_vm.placeholder,"required":_vm.required,"type":_vm.type},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.onFocus,"blur":_vm.onBlur,"compositionstart":function($event){return _vm.onComposition($event, 'start')},"compositionend":function($event){return _vm.onComposition($event, 'end')},"input":[function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value},function($event){return _vm.onComposition($event, 'input')}]}}),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"weui-icon-clear",attrs:{"href":"javascript:"},on:{"click":_vm.clear}})]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isFocus && !_vm.value),expression:"!isFocus && !value"}],staticClass:"weui-search-bar__label",attrs:{"for":("search_input_" + _vm.uuid)}},[_c('i',{staticClass:"weui-icon-search"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.placeholder || '搜索'))])])]),_vm._v(" "),_c('a',{staticClass:"weui-search-bar__cancel-btn",attrs:{"href":"javascript:"},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText || '取消')+"\n    ")]),_vm._v(" "),_vm._t("right")],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isFixed),expression:"isFixed"}],staticClass:"weui-cells vux-search_show"},[_vm._t("default"),_vm._v(" "),_vm._l((_vm.results),function(item){return _c('div',{staticClass:"weui-cell weui-cell_access",on:{"click":function($event){return _vm.handleResultClick(item)}}},[_c('div',{staticClass:"weui-cell__bd weui-cell_primary"},[_c('p',[_vm._v(_vm._s(item.title))])])])})],2)])}
var search_staticRenderFns = []
var search_esExports = { render: search_render, staticRenderFns: search_staticRenderFns }
/* harmony default export */ var src_components_search = (search_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/search/index.vue
function search_injectStyle (ssrContext) {
  __webpack_require__("fFU4")
}
var search_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var search___vue_template_functional__ = false
/* styles */
var search___vue_styles__ = search_injectStyle
/* scopeId */
var search___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var search___vue_module_identifier__ = null
var search_Component = search_normalizeComponent(
  components_search,
  src_components_search,
  search___vue_template_functional__,
  search___vue_styles__,
  search___vue_scopeId__,
  search___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_search = (search_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/step/step.vue
//
//
//
//
//
//

/* harmony default export */ var step = ({
  name: 'step',
  props: {
    value: Number,
    backgroundColor: {
      type: String,
      default: '#fff'
    },
    gutter: {
      type: String,
      default: '10px'
    }
  },
  created: function created() {
    this.current = this.value;
  },
  mounted: function mounted() {
    this._mapPropsToChildComponent();
  },

  watch: {
    value: function value(val) {
      this.current = val;
    },
    current: function current(val) {
      this._mapPropsToChildComponent();
      this.$emit('input', val);
    }
  },
  data: function data() {
    return {
      current: 0
    };
  },

  methods: {
    _mapPropsToChildComponent: function _mapPropsToChildComponent() {
      var _this = this;
      var len = this.$children.length - 1;
      this.$children.forEach(function (child, index) {
        child.currentStepNumber = (index + 1).toString();
        child.currentStepLast = index === len;

        if (index === _this.current) {
          child.currentStatus = 'process';
        } else if (index < _this.current) {
          child.currentStatus = 'finish';
        } else {
          child.currentStatus = 'wait';
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/step/step.vue
//
//
//
//
//
//

/* harmony default export */ var step_step = ({
  name: 'step',
  props: {
    value: Number,
    backgroundColor: {
      type: String,
      default: '#fff'
    },
    gutter: {
      type: String,
      default: '10px'
    }
  },
  created: function created() {
    this.current = this.value;
  },
  mounted: function mounted() {
    this._mapPropsToChildComponent();
  },

  watch: {
    value: function value(val) {
      this.current = val;
    },
    current: function current(val) {
      this._mapPropsToChildComponent();
      this.$emit('input', val);
    }
  },
  data: function data() {
    return {
      current: 0
    };
  },

  methods: {
    _mapPropsToChildComponent: function _mapPropsToChildComponent() {
      var _this = this;
      var len = this.$children.length - 1;
      this.$children.forEach(function (child, index) {
        child.currentStepNumber = (index + 1).toString();
        child.currentStepLast = index === len;

        if (index === _this.current) {
          child.currentStatus = 'process';
        } else if (index < _this.current) {
          child.currentStatus = 'finish';
        } else {
          child.currentStatus = 'wait';
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a92ccd5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/step/step.vue
var step_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-step"},[_vm._t("default")],2)}
var step_staticRenderFns = []
var step_esExports = { render: step_render, staticRenderFns: step_staticRenderFns }
/* harmony default export */ var components_step_step = (step_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/step/step.vue
function step_injectStyle (ssrContext) {
  __webpack_require__("/iSo")
}
var step_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var step___vue_template_functional__ = false
/* styles */
var step___vue_styles__ = step_injectStyle
/* scopeId */
var step___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var step___vue_module_identifier__ = null
var step_Component = step_normalizeComponent(
  step_step,
  components_step_step,
  step___vue_template_functional__,
  step___vue_styles__,
  step___vue_scopeId__,
  step___vue_module_identifier__
)

/* harmony default export */ var src_components_step_step = (step_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/step/step-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var step_item = ({
  name: 'step-item',
  props: {
    title: String,
    description: String,
    stepNumber: Number,
    stepLast: Boolean,
    icon: String,
    status: String,
    tailWidth: Object
  },
  computed: {
    iconName: function iconName() {
      return this.icon || 'check';
    }
  },
  created: function created() {
    this.currentStatus = this.status;
    this.currentStepLast = this.stepLast;
    this.currentStepNumber = this.stepNumber;
  },
  data: function data() {
    return {
      currentStatus: '',
      currentStepLast: false,
      currentStepNumber: 0
    };
  },

  components: {
    Icon: icon["a" /* default */]
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/step/step-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var step_step_item = ({
  name: 'step-item',
  props: {
    title: String,
    description: String,
    stepNumber: Number,
    stepLast: Boolean,
    icon: String,
    status: String,
    tailWidth: Object
  },
  computed: {
    iconName: function iconName() {
      return this.icon || 'check';
    }
  },
  created: function created() {
    this.currentStatus = this.status;
    this.currentStepLast = this.stepLast;
    this.currentStepNumber = this.stepNumber;
  },
  data: function data() {
    return {
      currentStatus: '',
      currentStepLast: false,
      currentStepNumber: 0
    };
  },

  components: {
    Icon: icon["a" /* default */]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06387731","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/step/step-item.vue
var step_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-step-item",class:{ 'vux-step-item-with-tail' : !_vm.currentStepLast}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.currentStepLast),expression:"!currentStepLast"}],class:'vux-step-item-tail ' + 'vux-step-item-tail-' + _vm.currentStatus,style:({right: _vm.$parent.gutter})}),_vm._v(" "),_c('div',{class:'vux-step-item-head ' + 'vux-step-item-head-' + _vm.currentStatus},[_c('div',{staticClass:"vux-step-item-head-inner"},[(!_vm.icon && _vm.currentStatus!='finish')?_c('span',{staticClass:"vux-step-item-icon"},[_vm._v(_vm._s(_vm.currentStepNumber))]):_c('span',{class:'vux-step-item-icon ' + 'vux-step-item-' + _vm.iconName},[_c('icon',{staticClass:"vux-step-item-checked",attrs:{"type":"success_no_circle"}})],1)])]),_vm._v(" "),_c('div',{class:'vux-step-item-main ' + 'vux-step-item-main-' + _vm.currentStatus,style:({backgroundColor: _vm.$parent.backgroundColor, paddingRight: _vm.currentStepLast ? 0 : _vm.$parent.gutter})},[_c('span',{staticClass:"vux-step-item-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"vux-step-item-description"},[_vm._v(_vm._s(_vm.description))])])])}
var step_item_staticRenderFns = []
var step_item_esExports = { render: step_item_render, staticRenderFns: step_item_staticRenderFns }
/* harmony default export */ var components_step_step_item = (step_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/step/step-item.vue
var step_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var step_item___vue_template_functional__ = false
/* styles */
var step_item___vue_styles__ = null
/* scopeId */
var step_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var step_item___vue_module_identifier__ = null
var step_item_Component = step_item_normalizeComponent(
  step_step_item,
  components_step_step_item,
  step_item___vue_template_functional__,
  step_item___vue_styles__,
  step_item___vue_scopeId__,
  step_item___vue_module_identifier__
)

/* harmony default export */ var src_components_step_step_item = (step_item_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/blur/blur.js + 1 modules
var blur_blur = __webpack_require__("1IcW");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/blur/index.vue
//
//
//
//
//
//



/* harmony default export */ var components_blur = ({
  name: 'blur',
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this._blur = new blur_blur["a" /* default */](_this.$el, {
        url: _this.url,
        blurAmount: _this.blurAmount,
        imageClass: 'vux-bg-blur',
        duration: 100, // If the image needs to be faded in, how long that should take
        opacity: 1 // Specify the final opacity that the image will have
      });
    });
  },

  props: {
    blurAmount: {
      type: Number,
      default: 10
    },
    url: {
      type: String,
      required: true
    },
    height: {
      type: Number,
      default: 200
    }
  },
  watch: {
    blurAmount: function blurAmount(_blurAmount) {
      this._blur.setBlurAmount(_blurAmount);
      this._blur.generateBlurredImage(this.url);
    },
    url: function url(_url) {
      this._blur.generateBlurredImage(_url);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/blur/index.vue
//
//
//
//
//
//



/* harmony default export */ var src_components_blur = ({
  name: 'blur',
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this._blur = new blur_blur["a" /* default */](_this.$el, {
        url: _this.url,
        blurAmount: _this.blurAmount,
        imageClass: 'vux-bg-blur',
        duration: 100, // If the image needs to be faded in, how long that should take
        opacity: 1 // Specify the final opacity that the image will have
      });
    });
  },

  props: {
    blurAmount: {
      type: Number,
      default: 10
    },
    url: {
      type: String,
      required: true
    },
    height: {
      type: Number,
      default: 200
    }
  },
  watch: {
    blurAmount: function blurAmount(_blurAmount) {
      this._blur.setBlurAmount(_blurAmount);
      this._blur.generateBlurredImage(this.url);
    },
    url: function url(_url) {
      this._blur.generateBlurredImage(_url);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fb835eba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/blur/index.vue
var blur_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({height: _vm.height + 'px',position: 'relative', overflow: 'hidden'})},[_vm._t("default")],2)}
var blur_staticRenderFns = []
var blur_esExports = { render: blur_render, staticRenderFns: blur_staticRenderFns }
/* harmony default export */ var vux_src_components_blur = (blur_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/blur/index.vue
function blur_injectStyle (ssrContext) {
  __webpack_require__("1uDx")
}
var blur_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var blur___vue_template_functional__ = false
/* styles */
var blur___vue_styles__ = blur_injectStyle
/* scopeId */
var blur___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var blur___vue_module_identifier__ = null
var blur_Component = blur_normalizeComponent(
  src_components_blur,
  vux_src_components_blur,
  blur___vue_template_functional__,
  blur___vue_styles__,
  blur___vue_scopeId__,
  blur___vue_module_identifier__
)

/* harmony default export */ var node_modules_vux_src_components_blur = (blur_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/button-tab/button-tab.vue
//
//
//
//
//
//



/* harmony default export */ var button_tab = ({
  name: 'button-tab',
  mixins: [multi_items["b" /* parentMixin */]],
  props: {
    height: Number
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/button-tab/button-tab.vue
//
//
//
//
//
//



/* harmony default export */ var button_tab_button_tab = ({
  name: 'button-tab',
  mixins: [multi_items["b" /* parentMixin */]],
  props: {
    height: Number
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45ac43c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/button-tab/button-tab.vue
var button_tab_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-button-group"},[_vm._t("default")],2)}
var button_tab_staticRenderFns = []
var button_tab_esExports = { render: button_tab_render, staticRenderFns: button_tab_staticRenderFns }
/* harmony default export */ var components_button_tab_button_tab = (button_tab_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/button-tab/button-tab.vue
function button_tab_injectStyle (ssrContext) {
  __webpack_require__("P7KP")
}
var button_tab_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var button_tab___vue_template_functional__ = false
/* styles */
var button_tab___vue_styles__ = button_tab_injectStyle
/* scopeId */
var button_tab___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var button_tab___vue_module_identifier__ = null
var button_tab_Component = button_tab_normalizeComponent(
  button_tab_button_tab,
  components_button_tab_button_tab,
  button_tab___vue_template_functional__,
  button_tab___vue_styles__,
  button_tab___vue_scopeId__,
  button_tab___vue_module_identifier__
)

/* harmony default export */ var src_components_button_tab_button_tab = (button_tab_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/button-tab/button-tab-item.vue
//
//
//
//
//
//



/* harmony default export */ var button_tab_item = ({
  name: 'button-tab-item',
  mixins: [multi_items["a" /* childMixin */]],
  computed: {
    classes: function classes() {
      return {
        'vux-button-group-current': this.currentIndex === this.$parent.currentIndex,
        'vux-button-tab-item-first': this.currentIndex === 0,
        'vux-button-tab-item-last': this.currentIndex === this.$parent.$children.length - 1,
        'vux-button-tab-item-middle': this.currentIndex > 0 && this.currentIndex !== this.$parent.$children.length - 1
      };
    },
    style: function style() {
      if (this.$parent.height) {
        return {
          height: this.$parent.height + 'px',
          lineHeight: this.$parent.height + 'px'
        };
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/button-tab/button-tab-item.vue
//
//
//
//
//
//



/* harmony default export */ var button_tab_button_tab_item = ({
  name: 'button-tab-item',
  mixins: [multi_items["a" /* childMixin */]],
  computed: {
    classes: function classes() {
      return {
        'vux-button-group-current': this.currentIndex === this.$parent.currentIndex,
        'vux-button-tab-item-first': this.currentIndex === 0,
        'vux-button-tab-item-last': this.currentIndex === this.$parent.$children.length - 1,
        'vux-button-tab-item-middle': this.currentIndex > 0 && this.currentIndex !== this.$parent.$children.length - 1
      };
    },
    style: function style() {
      if (this.$parent.height) {
        return {
          height: this.$parent.height + 'px',
          lineHeight: this.$parent.height + 'px'
        };
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-350dcdc4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/button-tab/button-tab-item.vue
var button_tab_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"vux-button-tab-item",class:_vm.classes,style:(_vm.style),attrs:{"href":"javascript:"},on:{"click":_vm.onItemClick}},[_vm._t("default")],2)}
var button_tab_item_staticRenderFns = []
var button_tab_item_esExports = { render: button_tab_item_render, staticRenderFns: button_tab_item_staticRenderFns }
/* harmony default export */ var components_button_tab_button_tab_item = (button_tab_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/button-tab/button-tab-item.vue
var button_tab_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var button_tab_item___vue_template_functional__ = false
/* styles */
var button_tab_item___vue_styles__ = null
/* scopeId */
var button_tab_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var button_tab_item___vue_module_identifier__ = null
var button_tab_item_Component = button_tab_item_normalizeComponent(
  button_tab_button_tab_item,
  components_button_tab_button_tab_item,
  button_tab_item___vue_template_functional__,
  button_tab_item___vue_styles__,
  button_tab_item___vue_scopeId__,
  button_tab_item___vue_module_identifier__
)

/* harmony default export */ var src_components_button_tab_button_tab_item = (button_tab_item_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/timeline/timeline.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var timeline = ({
  name: 'timeline',
  props: {
    color: String,
    isShowIcon: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    setChildProps: function setChildProps() {
      if (!this.$children) return;
      var len = this.$children.length;
      this.$children.forEach(function (child, index) {
        child.isLast = index === len - 1;
        child.isFirst = index === 0;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/timeline/timeline.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var timeline_timeline = ({
  name: 'timeline',
  props: {
    color: String,
    isShowIcon: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    setChildProps: function setChildProps() {
      if (!this.$children) return;
      var len = this.$children.length;
      this.$children.forEach(function (child, index) {
        child.isLast = index === len - 1;
        child.isFirst = index === 0;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3b989b4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/timeline/timeline.vue
var timeline_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-timeline"},[_c('ul',[_vm._t("default")],2)])}
var timeline_staticRenderFns = []
var timeline_esExports = { render: timeline_render, staticRenderFns: timeline_staticRenderFns }
/* harmony default export */ var components_timeline_timeline = (timeline_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/timeline/timeline.vue
function timeline_injectStyle (ssrContext) {
  __webpack_require__("VWqx")
}
var timeline_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var timeline___vue_template_functional__ = false
/* styles */
var timeline___vue_styles__ = timeline_injectStyle
/* scopeId */
var timeline___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var timeline___vue_module_identifier__ = null
var timeline_Component = timeline_normalizeComponent(
  timeline_timeline,
  components_timeline_timeline,
  timeline___vue_template_functional__,
  timeline___vue_styles__,
  timeline___vue_scopeId__,
  timeline___vue_module_identifier__
)

/* harmony default export */ var src_components_timeline_timeline = (timeline_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/timeline/timeline-item.vue + 3 modules
var timeline_item = __webpack_require__("AoBP");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tip/index.vue
//
//
//
//
//
//

/* harmony default export */ var tip = ({
  name: 'tip',
  props: {
    align: {
      type: String,
      default: 'left'
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tip/index.vue
//
//
//
//
//
//

/* harmony default export */ var components_tip = ({
  name: 'tip',
  props: {
    align: {
      type: String,
      default: 'left'
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2282ea60","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/tip/index.vue
var tip_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-group-tip",style:({'text-align':_vm.align})},[_vm._t("default")],2)}
var tip_staticRenderFns = []
var tip_esExports = { render: tip_render, staticRenderFns: tip_staticRenderFns }
/* harmony default export */ var src_components_tip = (tip_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/tip/index.vue
function tip_injectStyle (ssrContext) {
  __webpack_require__("cu/V")
}
var tip_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tip___vue_template_functional__ = false
/* styles */
var tip___vue_styles__ = tip_injectStyle
/* scopeId */
var tip___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tip___vue_module_identifier__ = null
var tip_Component = tip_normalizeComponent(
  components_tip,
  src_components_tip,
  tip___vue_template_functional__,
  tip___vue_styles__,
  tip___vue_scopeId__,
  tip___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_tip = (tip_Component.exports);

// EXTERNAL MODULE: ./node_modules/array-shuffle/index.js
var array_shuffle = __webpack_require__("HHx2");
var array_shuffle_default = /*#__PURE__*/__webpack_require__.n(array_shuffle);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/checklist/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var checklist = ({
  name: 'checklist',
  components: {
    Tip: vux_src_components_tip,
    Icon: icon["a" /* default */],
    InlineDesc: inline_desc["a" /* default */]
  },
  filters: {
    getValue: object_filter["e" /* getValue */],
    getKey: object_filter["b" /* getKey */]
  },
  mixins: [libs_base["a" /* default */]],
  props: {
    name: String,
    showError: Boolean,
    title: String,
    required: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      required: true
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    max: Number,
    min: Number,
    fillMode: Boolean,
    randomOrder: Boolean,
    checkDisabled: {
      type: Boolean,
      default: true
    },
    labelPosition: {
      type: String,
      default: 'right'
    },
    disabled: Boolean
  },
  data: function data() {
    return {
      currentValue: [],
      currentOptions: this.options,
      tempValue: '' // used only for radio mode
    };
  },
  beforeUpdate: function beforeUpdate() {
    if (this.isRadio) {
      var length = this.currentValue.length;
      if (length > 1) {
        this.currentValue = [this.currentValue[length - 1]];
      }
      var val = checklist_pure(this.currentValue);
      this.tempValue = val.length ? val[0] : '';
    }
  },
  created: function created() {
    this.handleChangeEvent = true;
    if (this.value) {
      this.currentValue = this.value;
      if (this.isRadio) {
        this.tempValue = this.isRadio ? this.value[0] : this.value;
      }
    }
    if (this.randomOrder) {
      this.currentOptions = array_shuffle_default()(this.options);
    } else {
      this.currentOptions = this.options;
    }
  },

  methods: {
    getValue: object_filter["e" /* getValue */],
    getKey: object_filter["b" /* getKey */],
    getInlineDesc: object_filter["a" /* getInlineDesc */],
    getFullValue: function getFullValue() {
      var labels = Object(object_filter["d" /* getLabels */])(this.options, this.value);
      return this.currentValue.map(function (one, index) {
        return {
          value: one,
          label: labels[index]
        };
      });
    },
    isDisabled: function isDisabled(key) {
      if (!this.checkDisabled) {
        return false;
      }
      if (this._max > 1) {
        return this.currentValue.indexOf(key) === -1 && this.currentValue.length === this._max;
      }
      return false;
    }
  },
  computed: {
    isRadio: function isRadio() {
      if (typeof this.max === 'undefined') {
        return false;
      } else {
        return this.max === 1;
      }
    },
    _total: function _total() {
      return this.fillMode ? this.options.length + 1 : this.options.length;
    },
    _min: function _min() {
      if (!this.required && !this.min) {
        return 0;
      }
      if (!this.required && this.min) {
        return Math.min(this._total, this.min);
      }
      if (this.required) {
        if (this.min) {
          var max = Math.max(1, this.min);
          return Math.min(this._total, max);
        } else {
          return 1;
        }
      }
    },
    _max: function _max() {
      if (!this.required && !this.max) {
        return this._total;
      }
      if (this.max) {
        if (this.max > this._total) {
          return this._total;
        }
        return this.max;
      } else {
        return this._total;
      }
    },
    valid: function valid() {
      return this.currentValue.length >= this._min && this.currentValue.length <= this._max;
    }
  },
  watch: {
    tempValue: function tempValue(val) {
      var _val = val ? [val] : [];
      this.$emit('input', _val);
      this.$emit('on-change', _val, Object(object_filter["d" /* getLabels */])(this.options, _val));
    },
    value: function value(newVal) {
      if (stringify_default()(newVal) !== stringify_default()(this.currentValue)) {
        this.currentValue = newVal;
      }
    },
    options: function options(val) {
      this.currentOptions = val;
    },
    currentValue: function currentValue(newVal) {
      var val = checklist_pure(newVal);

      if (!this.isRadio) {
        this.$emit('input', val);
        this.$emit('on-change', val, Object(object_filter["d" /* getLabels */])(this.options, val));
        var err = {};
        if (this._min) {
          if (this.required) {
            if (this.currentValue.length < this._min) {
              err = {
                min: this._min
              };
            }
          } else {
            if (this.currentValue.length && this.currentValue.length < this._min) {
              err = {
                min: this._min
              };
            }
          }
        }
        if (!this.valid && this.dirty && keys_default()(err).length) {
          this.$emit('on-error', err);
        } else {
          this.$emit('on-clear-error');
        }
      }
    }
  }
});
function checklist_pure(obj) {
  return JSON.parse(stringify_default()(obj));
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/checklist/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var components_checklist = ({
  name: 'checklist',
  components: {
    Tip: vux_src_components_tip,
    Icon: icon["a" /* default */],
    InlineDesc: inline_desc["a" /* default */]
  },
  filters: {
    getValue: object_filter["e" /* getValue */],
    getKey: object_filter["b" /* getKey */]
  },
  mixins: [libs_base["a" /* default */]],
  props: {
    name: String,
    showError: Boolean,
    title: String,
    required: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      required: true
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    max: Number,
    min: Number,
    fillMode: Boolean,
    randomOrder: Boolean,
    checkDisabled: {
      type: Boolean,
      default: true
    },
    labelPosition: {
      type: String,
      default: 'right'
    },
    disabled: Boolean
  },
  data: function data() {
    return {
      currentValue: [],
      currentOptions: this.options,
      tempValue: '' // used only for radio mode
    };
  },
  beforeUpdate: function beforeUpdate() {
    if (this.isRadio) {
      var length = this.currentValue.length;
      if (length > 1) {
        this.currentValue = [this.currentValue[length - 1]];
      }
      var val = components_checklist_pure(this.currentValue);
      this.tempValue = val.length ? val[0] : '';
    }
  },
  created: function created() {
    this.handleChangeEvent = true;
    if (this.value) {
      this.currentValue = this.value;
      if (this.isRadio) {
        this.tempValue = this.isRadio ? this.value[0] : this.value;
      }
    }
    if (this.randomOrder) {
      this.currentOptions = array_shuffle_default()(this.options);
    } else {
      this.currentOptions = this.options;
    }
  },

  methods: {
    getValue: object_filter["e" /* getValue */],
    getKey: object_filter["b" /* getKey */],
    getInlineDesc: object_filter["a" /* getInlineDesc */],
    getFullValue: function getFullValue() {
      var labels = Object(object_filter["d" /* getLabels */])(this.options, this.value);
      return this.currentValue.map(function (one, index) {
        return {
          value: one,
          label: labels[index]
        };
      });
    },
    isDisabled: function isDisabled(key) {
      if (!this.checkDisabled) {
        return false;
      }
      if (this._max > 1) {
        return this.currentValue.indexOf(key) === -1 && this.currentValue.length === this._max;
      }
      return false;
    }
  },
  computed: {
    isRadio: function isRadio() {
      if (typeof this.max === 'undefined') {
        return false;
      } else {
        return this.max === 1;
      }
    },
    _total: function _total() {
      return this.fillMode ? this.options.length + 1 : this.options.length;
    },
    _min: function _min() {
      if (!this.required && !this.min) {
        return 0;
      }
      if (!this.required && this.min) {
        return Math.min(this._total, this.min);
      }
      if (this.required) {
        if (this.min) {
          var max = Math.max(1, this.min);
          return Math.min(this._total, max);
        } else {
          return 1;
        }
      }
    },
    _max: function _max() {
      if (!this.required && !this.max) {
        return this._total;
      }
      if (this.max) {
        if (this.max > this._total) {
          return this._total;
        }
        return this.max;
      } else {
        return this._total;
      }
    },
    valid: function valid() {
      return this.currentValue.length >= this._min && this.currentValue.length <= this._max;
    }
  },
  watch: {
    tempValue: function tempValue(val) {
      var _val = val ? [val] : [];
      this.$emit('input', _val);
      this.$emit('on-change', _val, Object(object_filter["d" /* getLabels */])(this.options, _val));
    },
    value: function value(newVal) {
      if (stringify_default()(newVal) !== stringify_default()(this.currentValue)) {
        this.currentValue = newVal;
      }
    },
    options: function options(val) {
      this.currentOptions = val;
    },
    currentValue: function currentValue(newVal) {
      var val = components_checklist_pure(newVal);

      if (!this.isRadio) {
        this.$emit('input', val);
        this.$emit('on-change', val, Object(object_filter["d" /* getLabels */])(this.options, val));
        var err = {};
        if (this._min) {
          if (this.required) {
            if (this.currentValue.length < this._min) {
              err = {
                min: this._min
              };
            }
          } else {
            if (this.currentValue.length && this.currentValue.length < this._min) {
              err = {
                min: this._min
              };
            }
          }
        }
        if (!this.valid && this.dirty && keys_default()(err).length) {
          this.$emit('on-error', err);
        } else {
          this.$emit('on-clear-error');
        }
      }
    }
  }
});
function components_checklist_pure(obj) {
  return JSON.parse(stringify_default()(obj));
}
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7307e378","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/checklist/index.vue
var checklist_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.disabled ? 'vux-checklist-disabled' : ''},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.title),expression:"title"}],staticClass:"weui-cells__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._t("after-title"),_vm._v(" "),_c('div',{staticClass:"weui-cells weui-cells_checkbox"},_vm._l((_vm.currentOptions),function(one,index){return _c('label',{staticClass:"weui-cell weui-check_label",class:{
        'vux-checklist-label-left': _vm.labelPosition === 'left'
      },attrs:{"for":("checkbox_" + _vm.uuid + "_" + index)}},[_c('div',{staticClass:"weui-cell__hd"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"weui-check",attrs:{"type":"checkbox","name":("vux-checkbox-" + _vm.uuid),"id":_vm.disabled ? '' : ("checkbox_" + _vm.uuid + "_" + index),"disabled":_vm.isDisabled(_vm.getKey(one))},domProps:{"value":_vm.getKey(one),"checked":Array.isArray(_vm.currentValue)?_vm._i(_vm.currentValue,_vm.getKey(one))>-1:(_vm.currentValue)},on:{"change":function($event){var $$a=_vm.currentValue,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=_vm.getKey(one),$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.currentValue=$$a.concat([$$v]))}else{$$i>-1&&(_vm.currentValue=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.currentValue=$$c}}}}),_vm._v(" "),_c('i',{staticClass:"weui-icon-checked vux-checklist-icon-checked"})]),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd"},[_c('div',{staticStyle:{"display":"flex","align-items":"center"},domProps:{"innerHTML":_vm._s(_vm.getValue(one))}}),_vm._v(" "),(_vm.getInlineDesc(one))?_c('inline-desc',[_vm._v(_vm._s(_vm.getInlineDesc(one)))]):_vm._e()],1)])}),0),_vm._v(" "),_vm._t("footer")],2)}
var checklist_staticRenderFns = []
var checklist_esExports = { render: checklist_render, staticRenderFns: checklist_staticRenderFns }
/* harmony default export */ var src_components_checklist = (checklist_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/checklist/index.vue
function checklist_injectStyle (ssrContext) {
  __webpack_require__("ZLZR")
}
var checklist_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var checklist___vue_template_functional__ = false
/* styles */
var checklist___vue_styles__ = checklist_injectStyle
/* scopeId */
var checklist___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var checklist___vue_module_identifier__ = null
var checklist_Component = checklist_normalizeComponent(
  components_checklist,
  src_components_checklist,
  checklist___vue_template_functional__,
  checklist___vue_styles__,
  checklist___vue_scopeId__,
  checklist___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_checklist = (checklist_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux-xscroll/build/cmd/xscroll.js
var xscroll = __webpack_require__("WTNC");
var xscroll_default = /*#__PURE__*/__webpack_require__.n(xscroll);

// EXTERNAL MODULE: ./node_modules/vux-xscroll/build/cmd/plugins/pulldown.js
var pulldown = __webpack_require__("ypEt");
var pulldown_default = /*#__PURE__*/__webpack_require__.n(pulldown);

// EXTERNAL MODULE: ./node_modules/vux-xscroll/build/cmd/plugins/pullup.js
var pullup = __webpack_require__("qbvd");
var pullup_default = /*#__PURE__*/__webpack_require__.n(pullup);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/scroller/index.vue

//
//
//
//
//
//
//
//
//
//






var pulldownDefaultConfig = function pulldownDefaultConfig() {
  return {
    content: 'Pull Down To Refresh',
    height: 60,
    autoRefresh: false,
    downContent: 'Pull Down To Refresh',
    upContent: 'Release To Refresh',
    loadingContent: 'Loading...',
    clsPrefix: 'xs-plugin-pulldown-'
  };
};

var pullupDefaultConfig = function pullupDefaultConfig() {
  return {
    content: 'Pull Up To Refresh',
    pullUpHeight: 60,
    height: 40,
    autoRefresh: false,
    downContent: 'Release To Refresh',
    upContent: 'Pull Up To Refresh',
    loadingContent: 'Loading...',
    clsPrefix: 'xs-plugin-pullup-'
  };
};

/* harmony default export */ var components_scroller = ({
  name: 'scroller',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {
          pulldownStatus: '',
          pullupStatus: ''
        };
      }
    },
    height: String,
    lockX: Boolean,
    lockY: Boolean,
    scrollbarX: Boolean,
    scrollbarY: Boolean,
    bounce: {
      type: Boolean,
      default: true
    },
    useOriginScroll: {
      type: Boolean,
      default: false
    },
    useTransition: {
      type: Boolean,
      default: true
    },
    preventDefault: {
      type: Boolean,
      default: false
    },
    stopPropagation: Boolean,
    boundryCheck: {
      type: Boolean,
      default: true
    },
    gpuAcceleration: {
      type: Boolean,
      default: true
    },
    usePulldown: {
      type: Boolean,
      default: false
    },
    usePullup: {
      type: Boolean,
      default: false
    },
    /**
    * refer to: http://xscroll.github.io/node_modules/xscroll/doc/PullDown.html
    */
    pulldownConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    pullupConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    enableHorizontalSwiping: {
      type: Boolean,
      default: false
    },
    scrollBottomOffset: {
      type: Number,
      default: 0
    }
  },
  methods: {
    reset: function reset(scrollPosition, duration, easing) {
      if (scrollPosition) {
        if (typeof scrollPosition.left !== 'undefined') {
          this._xscroll.scrollLeft(scrollPosition.left, duration, easing);
        }
        if (typeof scrollPosition.top !== 'undefined') {
          this._xscroll.scrollTop(scrollPosition.top, duration, easing);
        }
      }
      this._xscroll && this._xscroll.resetSize();
    },
    donePulldown: function donePulldown() {
      var _this = this;

      this.pulldown.reset(function () {
        // repaint
        _this.reset();
      });
      this.currentValue.pulldownStatus = 'default';
    },
    disablePullup: function disablePullup() {
      // this._xscroll.unplug(this.pullup)
      this.pullup.stop();
      this.currentValue.pullupStatus = 'disabled';
    },
    enablePullup: function enablePullup() {
      this.currentValue.pullupStatus = 'default';
      this.pullup.restart();
    },
    donePullup: function donePullup() {
      this.pullup.complete();
      this.reset();
      this.currentValue.pullupStatus = 'default';
    },
    getStyles: function getStyles() {
      var height = this.height;
      if (!this.height && this.$el && !this.$el.style.height && this.lockX) {
        height = document.documentElement.clientHeight + 'px';
        this.reset();
      }

      if (this.height && this.height.indexOf('-') === 0) {
        height = document.documentElement.clientHeight + parseInt(this.height) + 'px';
      }
      this.styles = {
        height: '' + height
      };
    }
  },
  created: function created() {
    var _this2 = this;

    if (!this.value) {
      this.currentValue = {
        pulldownStatus: '',
        pullupStatus: ''
      };
    } else {
      this.currentValue = this.value;
    }
    this.handleOrientationchange = function () {
      setTimeout(function () {
        _this2.reset();
      }, 100);
    };
  },
  data: function data() {
    return {
      currentValue: {},
      styles: {}
    };
  },

  watch: {
    currentValue: {
      handler: function handler(val) {
        this.$emit('input', scroller_pure(val));
      },
      deep: true
    },
    height: function height() {
      this.getStyles();
    },

    value: {
      handler: function handler(val) {
        if (val.pullupStatus === 'default' && this.currentValue.pullupStatus !== 'default') {
          this.donePullup();
        }
        if (val.pulldownStatus === 'default' && this.currentValue.pulldownStatus !== 'default') {
          this.donePulldown();
        }
        if (val.pullupStatus === 'disabled' && this.currentValue.pullupStatus !== 'disabled') {
          this.disablePullup();
        }
        if (val.pullupStatus === 'enabled' && this.currentValue.pullupStatus === 'disabled') {
          this.enablePullup();
        }
      },
      deep: true
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.uuid = Math.random().toString(36).substring(3, 8);
    this.$nextTick(function () {
      _this3.$el.setAttribute('id', 'vux-scroller-' + _this3.uuid);
      var content = null;
      if (_this3.$slots.default) {
        content = _this3.$slots.default[0].elm;
      }
      if (!content) {
        throw new Error('no content is found');
      }

      _this3._xscroll = new xscroll_default.a({
        renderTo: '#vux-scroller-' + _this3.uuid,
        lockX: _this3.lockX,
        lockY: _this3.lockY,
        scrollbarX: _this3.scrollbarX,
        scrollbarY: _this3.scrollbarY,
        content: content,
        bounce: _this3.bounce,
        useOriginScroll: _this3.useOriginScroll,
        useTransition: _this3.useTransition,
        preventDefault: _this3.preventDefault,
        boundryCheck: _this3.boundryCheck,
        gpuAcceleration: _this3.gpuAcceleration,
        stopPropagation: _this3.stopPropagation
      });

      _this3._xscroll.on('scroll', function () {
        if (_this3._xscroll) {
          var top = _this3._xscroll.getScrollTop();
          _this3.$emit('on-scroll', {
            top: top,
            left: _this3._xscroll.getScrollLeft()
          });
          var containerHeight = _this3._xscroll.containerHeight;
          var scrollHeight = _this3._xscroll.height;
          if (top >= containerHeight - scrollHeight - _this3.scrollBottomOffset) {
            _this3.$emit('on-scroll-bottom');
          }
        }
      });

      if (_this3.usePulldown) {
        // if use slot=pulldown
        var container = _this3.$slots.pulldown;
        var config = object_assign_default()(pulldownDefaultConfig(), _this3.pulldownConfig);
        if (container) {
          config.container = container[0].elm;
        }
        _this3.pulldown = new pulldown_default.a(config);
        _this3._xscroll.plug(_this3.pulldown);
        _this3.pulldown.on('loading', function (e) {
          _this3.$emit('on-pulldown-loading', _this3.uuid);
        });
        _this3.pulldown.on('statuschange', function (val) {
          _this3.currentValue.pulldownStatus = val.newVal;
        });
      }

      if (_this3.usePullup) {
        // if use slot=pullup
        var _container = _this3.$slots.pullup;
        var _config = object_assign_default()(pullupDefaultConfig(), _this3.pullupConfig);

        if (_container) {
          _config.container = _container[0].elm;
        }
        _this3.pullup = new pullup_default.a(_config);
        _this3._xscroll.plug(_this3.pullup);
        _this3.pullup.on('loading', function (e) {
          _this3.$emit('on-pullup-loading', _this3.uuid);
        });
        _this3.pullup.on('statuschange', function (val) {
          _this3.currentValue.pullupStatus = val.newVal;
        });
      }

      if (_this3.enableHorizontalSwiping) {
        _this3._xscroll.on('panstart', function (e) {
          if (e.direction === 2 || e.direction === 4) {
            e.preventDefault();
            if (_this3.scrollbarY) {
              _this3._xscroll.userConfig.scrollbarY = false;
            }
            _this3._xscroll.userConfig.lockY = true;
          }
        });
        _this3._xscroll.on('panend', function () {
          if (_this3.scrollbarY) {
            _this3._xscroll.userConfig.scrollbarY = true;
          }
          _this3._xscroll.userConfig.lockY = false;
        });
      }

      _this3._xscroll.render();
      window.addEventListener('orientationchange', _this3.handleOrientationchange, false);
    });
    this.getStyles();
  },
  updated: function updated() {
    this.reset();
  },
  destroyed: function destroyed() {
    if (this.pullup) {
      this._xscroll.unplug(this.pullup);
      this.pullup.pluginDestructor();
    }
    if (this.pulldown) {
      this._xscroll.unplug(this.pulldown);
      this.pulldown.pluginDestructor();
    }
    window.removeEventListener('orientationchange', this.handleOrientationchange, false);
    this._xscroll.destroy();
    this._xscroll = null;
  }
});

function scroller_pure(obj) {
  return JSON.parse(stringify_default()(obj));
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/scroller/index.vue

//
//
//
//
//
//
//
//
//
//






var scroller_pulldownDefaultConfig = function pulldownDefaultConfig() {
  return {
    content: 'Pull Down To Refresh',
    height: 60,
    autoRefresh: false,
    downContent: 'Pull Down To Refresh',
    upContent: 'Release To Refresh',
    loadingContent: 'Loading...',
    clsPrefix: 'xs-plugin-pulldown-'
  };
};

var scroller_pullupDefaultConfig = function pullupDefaultConfig() {
  return {
    content: 'Pull Up To Refresh',
    pullUpHeight: 60,
    height: 40,
    autoRefresh: false,
    downContent: 'Release To Refresh',
    upContent: 'Pull Up To Refresh',
    loadingContent: 'Loading...',
    clsPrefix: 'xs-plugin-pullup-'
  };
};

/* harmony default export */ var src_components_scroller = ({
  name: 'scroller',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {
          pulldownStatus: '',
          pullupStatus: ''
        };
      }
    },
    height: String,
    lockX: Boolean,
    lockY: Boolean,
    scrollbarX: Boolean,
    scrollbarY: Boolean,
    bounce: {
      type: Boolean,
      default: true
    },
    useOriginScroll: {
      type: Boolean,
      default: false
    },
    useTransition: {
      type: Boolean,
      default: true
    },
    preventDefault: {
      type: Boolean,
      default: false
    },
    stopPropagation: Boolean,
    boundryCheck: {
      type: Boolean,
      default: true
    },
    gpuAcceleration: {
      type: Boolean,
      default: true
    },
    usePulldown: {
      type: Boolean,
      default: false
    },
    usePullup: {
      type: Boolean,
      default: false
    },
    /**
    * refer to: http://xscroll.github.io/node_modules/xscroll/doc/PullDown.html
    */
    pulldownConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    pullupConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    enableHorizontalSwiping: {
      type: Boolean,
      default: false
    },
    scrollBottomOffset: {
      type: Number,
      default: 0
    }
  },
  methods: {
    reset: function reset(scrollPosition, duration, easing) {
      if (scrollPosition) {
        if (typeof scrollPosition.left !== 'undefined') {
          this._xscroll.scrollLeft(scrollPosition.left, duration, easing);
        }
        if (typeof scrollPosition.top !== 'undefined') {
          this._xscroll.scrollTop(scrollPosition.top, duration, easing);
        }
      }
      this._xscroll && this._xscroll.resetSize();
    },
    donePulldown: function donePulldown() {
      var _this = this;

      this.pulldown.reset(function () {
        // repaint
        _this.reset();
      });
      this.currentValue.pulldownStatus = 'default';
    },
    disablePullup: function disablePullup() {
      // this._xscroll.unplug(this.pullup)
      this.pullup.stop();
      this.currentValue.pullupStatus = 'disabled';
    },
    enablePullup: function enablePullup() {
      this.currentValue.pullupStatus = 'default';
      this.pullup.restart();
    },
    donePullup: function donePullup() {
      this.pullup.complete();
      this.reset();
      this.currentValue.pullupStatus = 'default';
    },
    getStyles: function getStyles() {
      var height = this.height;
      if (!this.height && this.$el && !this.$el.style.height && this.lockX) {
        height = document.documentElement.clientHeight + 'px';
        this.reset();
      }

      if (this.height && this.height.indexOf('-') === 0) {
        height = document.documentElement.clientHeight + parseInt(this.height) + 'px';
      }
      this.styles = {
        height: '' + height
      };
    }
  },
  created: function created() {
    var _this2 = this;

    if (!this.value) {
      this.currentValue = {
        pulldownStatus: '',
        pullupStatus: ''
      };
    } else {
      this.currentValue = this.value;
    }
    this.handleOrientationchange = function () {
      setTimeout(function () {
        _this2.reset();
      }, 100);
    };
  },
  data: function data() {
    return {
      currentValue: {},
      styles: {}
    };
  },

  watch: {
    currentValue: {
      handler: function handler(val) {
        this.$emit('input', components_scroller_pure(val));
      },
      deep: true
    },
    height: function height() {
      this.getStyles();
    },

    value: {
      handler: function handler(val) {
        if (val.pullupStatus === 'default' && this.currentValue.pullupStatus !== 'default') {
          this.donePullup();
        }
        if (val.pulldownStatus === 'default' && this.currentValue.pulldownStatus !== 'default') {
          this.donePulldown();
        }
        if (val.pullupStatus === 'disabled' && this.currentValue.pullupStatus !== 'disabled') {
          this.disablePullup();
        }
        if (val.pullupStatus === 'enabled' && this.currentValue.pullupStatus === 'disabled') {
          this.enablePullup();
        }
      },
      deep: true
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.uuid = Math.random().toString(36).substring(3, 8);
    this.$nextTick(function () {
      _this3.$el.setAttribute('id', 'vux-scroller-' + _this3.uuid);
      var content = null;
      if (_this3.$slots.default) {
        content = _this3.$slots.default[0].elm;
      }
      if (!content) {
        throw new Error('no content is found');
      }

      _this3._xscroll = new xscroll_default.a({
        renderTo: '#vux-scroller-' + _this3.uuid,
        lockX: _this3.lockX,
        lockY: _this3.lockY,
        scrollbarX: _this3.scrollbarX,
        scrollbarY: _this3.scrollbarY,
        content: content,
        bounce: _this3.bounce,
        useOriginScroll: _this3.useOriginScroll,
        useTransition: _this3.useTransition,
        preventDefault: _this3.preventDefault,
        boundryCheck: _this3.boundryCheck,
        gpuAcceleration: _this3.gpuAcceleration,
        stopPropagation: _this3.stopPropagation
      });

      _this3._xscroll.on('scroll', function () {
        if (_this3._xscroll) {
          var top = _this3._xscroll.getScrollTop();
          _this3.$emit('on-scroll', {
            top: top,
            left: _this3._xscroll.getScrollLeft()
          });
          var containerHeight = _this3._xscroll.containerHeight;
          var scrollHeight = _this3._xscroll.height;
          if (top >= containerHeight - scrollHeight - _this3.scrollBottomOffset) {
            _this3.$emit('on-scroll-bottom');
          }
        }
      });

      if (_this3.usePulldown) {
        // if use slot=pulldown
        var container = _this3.$slots.pulldown;
        var config = object_assign_default()(scroller_pulldownDefaultConfig(), _this3.pulldownConfig);
        if (container) {
          config.container = container[0].elm;
        }
        _this3.pulldown = new pulldown_default.a(config);
        _this3._xscroll.plug(_this3.pulldown);
        _this3.pulldown.on('loading', function (e) {
          _this3.$emit('on-pulldown-loading', _this3.uuid);
        });
        _this3.pulldown.on('statuschange', function (val) {
          _this3.currentValue.pulldownStatus = val.newVal;
        });
      }

      if (_this3.usePullup) {
        // if use slot=pullup
        var _container = _this3.$slots.pullup;
        var _config = object_assign_default()(scroller_pullupDefaultConfig(), _this3.pullupConfig);

        if (_container) {
          _config.container = _container[0].elm;
        }
        _this3.pullup = new pullup_default.a(_config);
        _this3._xscroll.plug(_this3.pullup);
        _this3.pullup.on('loading', function (e) {
          _this3.$emit('on-pullup-loading', _this3.uuid);
        });
        _this3.pullup.on('statuschange', function (val) {
          _this3.currentValue.pullupStatus = val.newVal;
        });
      }

      if (_this3.enableHorizontalSwiping) {
        _this3._xscroll.on('panstart', function (e) {
          if (e.direction === 2 || e.direction === 4) {
            e.preventDefault();
            if (_this3.scrollbarY) {
              _this3._xscroll.userConfig.scrollbarY = false;
            }
            _this3._xscroll.userConfig.lockY = true;
          }
        });
        _this3._xscroll.on('panend', function () {
          if (_this3.scrollbarY) {
            _this3._xscroll.userConfig.scrollbarY = true;
          }
          _this3._xscroll.userConfig.lockY = false;
        });
      }

      _this3._xscroll.render();
      window.addEventListener('orientationchange', _this3.handleOrientationchange, false);
    });
    this.getStyles();
  },
  updated: function updated() {
    this.reset();
  },
  destroyed: function destroyed() {
    if (this.pullup) {
      this._xscroll.unplug(this.pullup);
      this.pullup.pluginDestructor();
    }
    if (this.pulldown) {
      this._xscroll.unplug(this.pulldown);
      this.pulldown.pluginDestructor();
    }
    window.removeEventListener('orientationchange', this.handleOrientationchange, false);
    this._xscroll.destroy();
    this._xscroll = null;
  }
});

function components_scroller_pure(obj) {
  return JSON.parse(stringify_default()(obj));
}
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7769fa5b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/scroller/index.vue
var scroller_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.styles)},[_c('div',{staticClass:"xs-container"},[_vm._t("default"),_vm._v(" "),_vm._t("pulldown"),_vm._v(" "),_vm._t("pullup")],2)])}
var scroller_staticRenderFns = []
var scroller_esExports = { render: scroller_render, staticRenderFns: scroller_staticRenderFns }
/* harmony default export */ var vux_src_components_scroller = (scroller_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/scroller/index.vue
function scroller_injectStyle (ssrContext) {
  __webpack_require__("CMiz")
}
var scroller_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var scroller___vue_template_functional__ = false
/* styles */
var scroller___vue_styles__ = scroller_injectStyle
/* scopeId */
var scroller___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var scroller___vue_module_identifier__ = null
var scroller_Component = scroller_normalizeComponent(
  src_components_scroller,
  vux_src_components_scroller,
  scroller___vue_template_functional__,
  scroller___vue_styles__,
  scroller___vue_scopeId__,
  scroller___vue_module_identifier__
)

/* harmony default export */ var node_modules_vux_src_components_scroller = (scroller_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/x-dialog/index.vue + 3 modules
var x_dialog = __webpack_require__("/kga");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/toast/index.js
var plugins_toast = __webpack_require__("3BeM");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/wechat/index.js + 1 modules
var wechat = __webpack_require__("n6Wb");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/confirm/index.js
var plugins_confirm = __webpack_require__("NXWw");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/loading/index.js
var loading = __webpack_require__("Y+qm");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/config/index.js
var plugins_config = __webpack_require__("bSmc");

// EXTERNAL MODULE: ./node_modules/vux/src/components/loading/index.vue + 3 modules
var components_loading = __webpack_require__("Bfwr");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-progress/index.vue
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_progress = ({
  name: 'x-progress',
  mixins: [libs_base["a" /* default */]],
  props: {
    percent: {
      type: Number,
      default: 0
    },
    showCancel: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    cancel: function cancel() {
      this.$emit('on-cancel');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-progress/index.vue
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_progress = ({
  name: 'x-progress',
  mixins: [libs_base["a" /* default */]],
  props: {
    percent: {
      type: Number,
      default: 0
    },
    showCancel: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    cancel: function cancel() {
      this.$emit('on-cancel');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01124028","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-progress/index.vue
var x_progress_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-progress"},[_c('div',{staticClass:"weui-progress__bar"},[_c('div',{staticClass:"weui-progress__inner-bar",style:({width: _vm.percent + '%'})})]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCancel),expression:"showCancel"}],staticClass:"weui-progress_opr",attrs:{"href":"javascript:;"}},[_c('i',{staticClass:"weui-icon-cancel",on:{"click":_vm.cancel}})])])}
var x_progress_staticRenderFns = []
var x_progress_esExports = { render: x_progress_render, staticRenderFns: x_progress_staticRenderFns }
/* harmony default export */ var src_components_x_progress = (x_progress_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-progress/index.vue
function x_progress_injectStyle (ssrContext) {
  __webpack_require__("n4IK")
}
var x_progress_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_progress___vue_template_functional__ = false
/* styles */
var x_progress___vue_styles__ = x_progress_injectStyle
/* scopeId */
var x_progress___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_progress___vue_module_identifier__ = null
var x_progress_Component = x_progress_normalizeComponent(
  components_x_progress,
  src_components_x_progress,
  x_progress___vue_template_functional__,
  x_progress___vue_styles__,
  x_progress___vue_scopeId__,
  x_progress___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_progress = (x_progress_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/view-box/index.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var view_box = ({
  name: 'view-box',
  props: ['bodyPaddingTop', 'bodyPaddingBottom'],
  methods: {
    scrollTo: function scrollTo(top) {
      this.$refs.viewBoxBody.scrollTop = top;
    },
    getScrollTop: function getScrollTop() {
      return this.$refs.viewBoxBody.scrollTop;
    },
    getScrollBody: function getScrollBody() {
      return this.$refs.viewBoxBody;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/view-box/index.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_view_box = ({
  name: 'view-box',
  props: ['bodyPaddingTop', 'bodyPaddingBottom'],
  methods: {
    scrollTo: function scrollTo(top) {
      this.$refs.viewBoxBody.scrollTop = top;
    },
    getScrollTop: function getScrollTop() {
      return this.$refs.viewBoxBody.scrollTop;
    },
    getScrollBody: function getScrollBody() {
      return this.$refs.viewBoxBody;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6dfa359e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/view-box/index.vue
var view_box_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-tab"},[_vm._t("header"),_vm._v(" "),_c('div',{ref:"viewBoxBody",staticClass:"weui-tab__panel vux-fix-safari-overflow-scrolling",style:({paddingTop: _vm.bodyPaddingTop, paddingBottom: _vm.bodyPaddingBottom}),attrs:{"id":"vux_view_box_body"}},[_vm._t("default")],2),_vm._v(" "),_vm._t("bottom")],2)}
var view_box_staticRenderFns = []
var view_box_esExports = { render: view_box_render, staticRenderFns: view_box_staticRenderFns }
/* harmony default export */ var src_components_view_box = (view_box_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/view-box/index.vue
function view_box_injectStyle (ssrContext) {
  __webpack_require__("b8LD")
}
var view_box_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var view_box___vue_template_functional__ = false
/* styles */
var view_box___vue_styles__ = view_box_injectStyle
/* scopeId */
var view_box___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var view_box___vue_module_identifier__ = null
var view_box_Component = view_box_normalizeComponent(
  components_view_box,
  src_components_view_box,
  view_box___vue_template_functional__,
  view_box___vue_styles__,
  view_box___vue_scopeId__,
  view_box___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_view_box = (view_box_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/sticky/sticky.js
var sticky = __webpack_require__("58JO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/sticky/index.vue
//
//
//
//
//
//



/* harmony default export */ var components_sticky = ({
  name: 'sticky',
  data: function data() {
    return {
      initTimes: 0
    };
  },
  created: function created() {
    this.$vux && this.$vux.bus && this.$vux.bus.$on('vux:after-view-enter', this.bindSticky);
  },
  activated: function activated() {
    if (this.initTimes > 0) {
      this.bindSticky();
    }
    this.initTimes++;
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.bindSticky();
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.$vux && this.$vux.bus && this.$vux.bus.$off('vux:after-view-enter', this.bindSticky);
  },

  methods: {
    bindSticky: function bindSticky() {
      var _this2 = this;

      if (this.disabled) {
        return;
      }
      this.$nextTick(function () {
        Object(sticky["a" /* default */])(_this2.$el, {
          scrollBox: _this2.scrollBox,
          offset: _this2.offset,
          checkStickySupport: typeof _this2.checkStickySupport === 'undefined' ? true : _this2.checkStickySupport
        });
      });
    }
  },
  props: ['scrollBox', 'offset', 'checkStickySupport', 'disabled']
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/sticky/index.vue
//
//
//
//
//
//



/* harmony default export */ var src_components_sticky = ({
  name: 'sticky',
  data: function data() {
    return {
      initTimes: 0
    };
  },
  created: function created() {
    this.$vux && this.$vux.bus && this.$vux.bus.$on('vux:after-view-enter', this.bindSticky);
  },
  activated: function activated() {
    if (this.initTimes > 0) {
      this.bindSticky();
    }
    this.initTimes++;
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.bindSticky();
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.$vux && this.$vux.bus && this.$vux.bus.$off('vux:after-view-enter', this.bindSticky);
  },

  methods: {
    bindSticky: function bindSticky() {
      var _this2 = this;

      if (this.disabled) {
        return;
      }
      this.$nextTick(function () {
        Object(sticky["a" /* default */])(_this2.$el, {
          scrollBox: _this2.scrollBox,
          offset: _this2.offset,
          checkStickySupport: typeof _this2.checkStickySupport === 'undefined' ? true : _this2.checkStickySupport
        });
      });
    }
  },
  props: ['scrollBox', 'offset', 'checkStickySupport', 'disabled']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c4f146b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/sticky/index.vue
var sticky_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-sticky-box"},[_vm._t("default")],2)}
var sticky_staticRenderFns = []
var sticky_esExports = { render: sticky_render, staticRenderFns: sticky_staticRenderFns }
/* harmony default export */ var vux_src_components_sticky = (sticky_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/sticky/index.vue
function sticky_injectStyle (ssrContext) {
  __webpack_require__("C19j")
}
var sticky_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var sticky___vue_template_functional__ = false
/* styles */
var sticky___vue_styles__ = sticky_injectStyle
/* scopeId */
var sticky___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var sticky___vue_module_identifier__ = null
var sticky_Component = sticky_normalizeComponent(
  src_components_sticky,
  vux_src_components_sticky,
  sticky___vue_template_functional__,
  sticky___vue_styles__,
  sticky___vue_scopeId__,
  sticky___vue_module_identifier__
)

/* harmony default export */ var node_modules_vux_src_components_sticky = (sticky_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/range/powerange.js + 10 modules
var powerange = __webpack_require__("oCMX");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/range/index.vue
//
//
//
//
//
//



/* harmony default export */ var range = ({
  name: 'range',
  props: {
    decimal: Boolean,
    value: {
      default: 0,
      type: Number
    },
    min: {
      type: Number,
      default: 0
    },
    minHTML: String,
    maxHTML: String,
    max: {
      type: Number,
      default: 100
    },
    step: {
      type: Number,
      default: 1
    },
    disabled: Boolean,
    disabledOpacity: Number,
    rangeBarHeight: {
      type: Number,
      default: 1
    },
    rangeHandleHeight: {
      type: Number,
      default: 30
    }
  },
  created: function created() {
    this.currentValue = this.value;
  },
  mounted: function mounted() {
    var _this2 = this;

    var _this = this;
    this.$nextTick(function () {
      var options = {
        callback: function callback(value) {
          _this.currentValue = value;
        },
        decimal: _this2.decimal,
        start: _this2.currentValue,
        min: _this2.min,
        max: _this2.max,
        minHTML: _this2.minHTML,
        maxHTML: _this2.maxHTML,
        disable: _this2.disabled,
        disabledOpacity: _this2.disabledOpacity,
        initialBarWidth: window.getComputedStyle(_this2.$el.parentNode).width.replace('px', '') - 80,
        onTouchstart: function onTouchstart(e) {
          _this.$emit('on-touchstart', e);
        },
        onTouchend: function onTouchend(e) {
          _this.$emit('on-touchend', e);
        }
      };
      if (_this2.step !== 0) {
        options.step = _this2.step;
      }
      _this2.range = new powerange["a" /* default */](_this2.$el.querySelector('.vux-range-input'), options);
      var handleTop = (_this2.rangeHandleHeight - _this2.rangeBarHeight) / 2;
      _this2.$el.querySelector('.range-handle').style.top = '-' + handleTop + 'px';
      _this2.$el.querySelector('.range-bar').style.height = _this2.rangeBarHeight + 'px';
      _this2.handleOrientationchange = function () {
        _this2.update();
      };
      window.addEventListener('orientationchange', _this2.handleOrientationchange, false);
    });
  },

  methods: {
    update: function update() {
      console.log('update', this.currentValue);
      var value = this.currentValue;
      if (value < this.min) {
        value = this.min;
      }
      if (value > this.max) {
        value = this.max;
      }
      this.range.reInit({
        min: this.min,
        max: this.max,
        step: this.step,
        value: value
      });
      this.currentValue = value;
      this.range.setStart(this.currentValue);
      this.range.setStep();
    }
  },
  data: function data() {
    return {
      currentValue: 0
    };
  },

  watch: {
    currentValue: function currentValue(val) {
      this.range && this.range.setStart(val);
      this.$emit('input', val);
      this.$emit('on-change', val);
    },
    value: function value(val) {
      this.currentValue = val;
    },
    min: function min() {
      this.update();
    },
    step: function step() {
      this.update();
    },
    max: function max() {
      this.update();
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('orientationchange', this.handleOrientationchange, false);
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/range/index.vue
//
//
//
//
//
//



/* harmony default export */ var components_range = ({
  name: 'range',
  props: {
    decimal: Boolean,
    value: {
      default: 0,
      type: Number
    },
    min: {
      type: Number,
      default: 0
    },
    minHTML: String,
    maxHTML: String,
    max: {
      type: Number,
      default: 100
    },
    step: {
      type: Number,
      default: 1
    },
    disabled: Boolean,
    disabledOpacity: Number,
    rangeBarHeight: {
      type: Number,
      default: 1
    },
    rangeHandleHeight: {
      type: Number,
      default: 30
    }
  },
  created: function created() {
    this.currentValue = this.value;
  },
  mounted: function mounted() {
    var _this2 = this;

    var _this = this;
    this.$nextTick(function () {
      var options = {
        callback: function callback(value) {
          _this.currentValue = value;
        },
        decimal: _this2.decimal,
        start: _this2.currentValue,
        min: _this2.min,
        max: _this2.max,
        minHTML: _this2.minHTML,
        maxHTML: _this2.maxHTML,
        disable: _this2.disabled,
        disabledOpacity: _this2.disabledOpacity,
        initialBarWidth: window.getComputedStyle(_this2.$el.parentNode).width.replace('px', '') - 80,
        onTouchstart: function onTouchstart(e) {
          _this.$emit('on-touchstart', e);
        },
        onTouchend: function onTouchend(e) {
          _this.$emit('on-touchend', e);
        }
      };
      if (_this2.step !== 0) {
        options.step = _this2.step;
      }
      _this2.range = new powerange["a" /* default */](_this2.$el.querySelector('.vux-range-input'), options);
      var handleTop = (_this2.rangeHandleHeight - _this2.rangeBarHeight) / 2;
      _this2.$el.querySelector('.range-handle').style.top = '-' + handleTop + 'px';
      _this2.$el.querySelector('.range-bar').style.height = _this2.rangeBarHeight + 'px';
      _this2.handleOrientationchange = function () {
        _this2.update();
      };
      window.addEventListener('orientationchange', _this2.handleOrientationchange, false);
    });
  },

  methods: {
    update: function update() {
      console.log('update', this.currentValue);
      var value = this.currentValue;
      if (value < this.min) {
        value = this.min;
      }
      if (value > this.max) {
        value = this.max;
      }
      this.range.reInit({
        min: this.min,
        max: this.max,
        step: this.step,
        value: value
      });
      this.currentValue = value;
      this.range.setStart(this.currentValue);
      this.range.setStep();
    }
  },
  data: function data() {
    return {
      currentValue: 0
    };
  },

  watch: {
    currentValue: function currentValue(val) {
      this.range && this.range.setStart(val);
      this.$emit('input', val);
      this.$emit('on-change', val);
    },
    value: function value(val) {
      this.currentValue = val;
    },
    min: function min() {
      this.update();
    },
    step: function step() {
      this.update();
    },
    max: function max() {
      this.update();
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('orientationchange', this.handleOrientationchange, false);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78bcb783","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/range/index.vue
var range_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-range-input-box",staticStyle:{"position":"relative","margin-right":"30px","margin-left":"50px"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.currentValue),expression:"currentValue",modifiers:{"number":true}}],staticClass:"vux-range-input",domProps:{"value":(_vm.currentValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.currentValue=_vm._n($event.target.value)},"blur":function($event){return _vm.$forceUpdate()}}})])}
var range_staticRenderFns = []
var range_esExports = { render: range_render, staticRenderFns: range_staticRenderFns }
/* harmony default export */ var src_components_range = (range_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/range/index.vue
function range_injectStyle (ssrContext) {
  __webpack_require__("P3La")
}
var range_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var range___vue_template_functional__ = false
/* styles */
var range___vue_styles__ = range_injectStyle
/* scopeId */
var range___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var range___vue_module_identifier__ = null
var range_Component = range_normalizeComponent(
  components_range,
  src_components_range,
  range___vue_template_functional__,
  range___vue_styles__,
  range___vue_scopeId__,
  range___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_range = (range_Component.exports);

// EXTERNAL MODULE: ./src/components/Footer.vue + 3 modules
var Footer = __webpack_require__("TVmP");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Header.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Header = ({
  name: 'AppHeader',
  props: {
    title: {
      type: String
    },
    showBack: {
      type: Boolean,
      default: true
    },
    showSearch: {
      type: Boolean,
      default: false
    },
    showMore: {
      type: Boolean,
      default: true
    },
    preventBack: {
      type: Boolean,
      default: true
    },
    backRouter: {
      type: Object
    },
    redefineClickBack: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showMenus: false,
      menus: {}
    };
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['language'])),
  created: function created() {
    if (this.language) {
      this.initMenus();
    }
  },

  methods: {
    initMenus: function initMenus() {
      this.menus = {};
      this.$set(this.menus, 'home', this.$t('home'));
      // this.$set(this.menus, 'language', this.language === 'zh' ? 'Language: English' : '语言：中文')
    },
    handleSearch: function handleSearch() {
      this.$router.push({ name: 'SearchIndex' });
    },
    handleHome: function handleHome() {
      this.$router.push({ name: 'TopicIndex' });
    },
    handleClickMore: function handleClickMore() {
      this.showMenus = true;
    },
    handleClickMenu: function handleClickMenu(key, item) {
      if (key === 'home') {
        this.handleHome();
      } else if (key === 'language') {
        this.$i18n.locale = this.language === 'zh' ? 'en' : 'zh';
        this.$store.commit('SET_LANGUAGE', this.language === 'zh' ? 'en' : 'zh');
      }
      this.showMenus = false;
      this.initMenus();
    },
    handleClickBack: function handleClickBack() {
      if (this.redefineClickBack) {
        this.$emit('on-click-back');
      } else {
        if (this.backRouter) {
          this.$router.push(this.backRouter);
        } else if (history.length <= 2) {
          this.$router.replace(this.$store.getters.token ? { path: '/contacts' } : { path: '/t' });
        } else if (this.$route.query.hasOwnProperty('oauth')) {
          this.$router.replace(this.$store.getters.token ? { path: '/contacts' } : { path: '/t' });
        } else {
          history.back();
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Header.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_Header = ({
  name: 'AppHeader',
  props: {
    title: {
      type: String
    },
    showBack: {
      type: Boolean,
      default: true
    },
    showSearch: {
      type: Boolean,
      default: false
    },
    showMore: {
      type: Boolean,
      default: true
    },
    preventBack: {
      type: Boolean,
      default: true
    },
    backRouter: {
      type: Object
    },
    redefineClickBack: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showMenus: false,
      menus: {}
    };
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['language'])),
  created: function created() {
    if (this.language) {
      this.initMenus();
    }
  },

  methods: {
    initMenus: function initMenus() {
      this.menus = {};
      this.$set(this.menus, 'home', this.$t('home'));
      // this.$set(this.menus, 'language', this.language === 'zh' ? 'Language: English' : '语言：中文')
    },
    handleSearch: function handleSearch() {
      this.$router.push({ name: 'SearchIndex' });
    },
    handleHome: function handleHome() {
      this.$router.push({ name: 'TopicIndex' });
    },
    handleClickMore: function handleClickMore() {
      this.showMenus = true;
    },
    handleClickMenu: function handleClickMenu(key, item) {
      if (key === 'home') {
        this.handleHome();
      } else if (key === 'language') {
        this.$i18n.locale = this.language === 'zh' ? 'en' : 'zh';
        this.$store.commit('SET_LANGUAGE', this.language === 'zh' ? 'en' : 'zh');
      }
      this.showMenus = false;
      this.initMenus();
    },
    handleClickBack: function handleClickBack() {
      if (this.redefineClickBack) {
        this.$emit('on-click-back');
      } else {
        if (this.backRouter) {
          this.$router.push(this.backRouter);
        } else if (history.length <= 2) {
          this.$router.replace(this.$store.getters.token ? { path: '/contacts' } : { path: '/t' });
        } else if (this.$route.query.hasOwnProperty('oauth')) {
          this.$router.replace(this.$store.getters.token ? { path: '/contacts' } : { path: '/t' });
        } else {
          history.back();
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-473a68a9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
var Header_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{staticClass:"fixed",attrs:{"slot":"header","left-options":{showBack: _vm.showBack, preventGoBack: _vm.preventBack, backText: ''}},on:{"on-click-back":_vm.handleClickBack},slot:"header"},[(_vm.showSearch)?_c('svg',{staticClass:"vux-x-icon vux-x-icon-ios-search",attrs:{"slot":"right","type":"ios-search","xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 512 512"},on:{"click":_vm.handleSearch},slot:"right"},[_c('path',{attrs:{"d":"M448.3 424.7L335 311.3c20.8-26 33.3-59.1 33.3-95.1 0-84.1-68.1-152.2-152-152.2-84 0-152 68.2-152 152.2s68.1 152.2 152 152.2c36.2 0 69.4-12.7 95.5-33.8L425 448l23.3-23.3zM120.1 312.6c-25.7-25.7-39.8-59.9-39.8-96.3s14.2-70.6 39.8-96.3 59.9-40 96.2-40c36.3 0 70.5 14.2 96.2 39.9s39.8 59.9 39.8 96.3-14.2 70.6-39.8 96.3c-25.7 25.7-59.9 39.9-96.2 39.9-36.3.1-70.5-14.1-96.2-39.8z"}})]):_vm._e(),_vm._v(" "),(_vm.showMore)?_c('svg',{staticClass:"vux-x-icon vux-x-icon-home",attrs:{"slot":"right","type":"home","size":"20","viewBox":"0 0 1024 1024","xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20"},on:{"click":_vm.handleHome},slot:"right"},[_c('path',{attrs:{"d":"M1015.095652 532.034783l-122.434783-122.434783c0 0 0 0 0 0L529.808696 44.521739c-8.904348-8.904348-24.486957-8.904348-33.391304 0L129.113043 409.6c0 0 0 0 0 0l-122.434783 122.434783c-8.904348 8.904348-8.904348 24.486957 0 33.391304 8.904348 8.904348 24.486957 8.904348 33.391304 0l80.13913-80.13913L120.208696 890.434783c0 53.426087 44.521739 97.947826 97.947826 97.947826l171.408696 0c13.356522 0 24.486957-11.130435 24.486957-24.486957L414.052174 719.026087l195.895652 0 0 242.643478c0 0 0 0 0 0 0 0 0 0 0 0 0 13.356522 11.130435 24.486957 24.486957 24.486957l171.408696 0c53.426087 0 97.947826-44.521739 97.947826-97.947826L903.791304 485.286957l80.13913 80.13913c4.452174 4.452174 11.130435 6.678261 17.808696 6.678261 6.678261 0 13.356522-2.226087 17.808696-6.678261C1026.226087 556.521739 1026.226087 540.93913 1015.095652 532.034783zM852.591304 621.078261C852.591304 621.078261 852.591304 621.078261 852.591304 621.078261l0 267.130435c0 26.713043-22.26087 48.973913-48.973913 48.973913l-146.921739 0L656.695652 694.53913c0 0 0 0 0 0s0 0 0 0c0-13.356522-11.130435-24.486957-24.486957-24.486957L389.565217 670.052174c-13.356522 0-24.486957 11.130435-24.486957 24.486957l0 242.643478L220.382609 937.182609c-26.713043 0-48.973913-22.26087-48.973913-48.973913L171.408696 436.313043 512 95.721739l340.591304 340.591304L852.591304 621.078261z","p-id":"4051"}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"header-title",attrs:{"slot":"overwrite-title"},slot:"overwrite-title"},[_c('img',{staticStyle:{"height":"22px"},attrs:{"src":__webpack_require__("7Otq")}}),_vm._v("\n       "+_vm._s(_vm.title)+"\n    ")]),_vm._v(" "),_vm._t("left",null,{"slot":"overwrite-left"}),_vm._v(" "),_vm._t("right",null,{"slot":"right"})],2),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('actionsheet',{attrs:{"menus":_vm.menus},on:{"on-click-menu":_vm.handleClickMenu},model:{value:(_vm.showMenus),callback:function ($$v) {_vm.showMenus=$$v},expression:"showMenus"}})],1)],1)}
var Header_staticRenderFns = []
var Header_esExports = { render: Header_render, staticRenderFns: Header_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Header = (Header_esExports);
// CONCATENATED MODULE: ./src/components/Header.vue
function Header_injectStyle (ssrContext) {
  __webpack_require__("+LE5")
}
var Header_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Header___vue_template_functional__ = false
/* styles */
var Header___vue_styles__ = Header_injectStyle
/* scopeId */
var Header___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Header___vue_module_identifier__ = null
var Header_Component = Header_normalizeComponent(
  components_Header,
  selectortype_template_index_0_src_components_Header,
  Header___vue_template_functional__,
  Header___vue_styles__,
  Header___vue_scopeId__,
  Header___vue_module_identifier__
)

/* harmony default export */ var src_components_Header = (Header_Component.exports);

// CONCATENATED MODULE: ./src/vux_import.js












































































vue_esm["default"].use(plugins_config["a" /* default */], {
  $layout: 'VIEW_BOX'
});
vue_esm["default"].use(ajax["a" /* default */]);
vue_esm["default"].use(plugins_alert["a" /* default */]);
vue_esm["default"].use(datetime["a" /* default */]);
vue_esm["default"].use(plugins_toast["a" /* default */]);
vue_esm["default"].use(wechat["a" /* default */]);
vue_esm["default"].use(plugins_confirm["a" /* default */]);
vue_esm["default"].use(loading["a" /* default */]);
vue_esm["default"].directive('transfer-dom', transfer_dom["a" /* default */]);
vue_esm["default"].component('actionsheet', vux_src_components_actionsheet);
vue_esm["default"].component('alert', components_alert["a" /* default */]);
vue_esm["default"].component('badge', vux_src_components_badge);
vue_esm["default"].component('blur', node_modules_vux_src_components_blur);
vue_esm["default"].component('box', vux_src_components_box);
vue_esm["default"].component('button-tab', src_components_button_tab_button_tab);
vue_esm["default"].component('button-tab-item', src_components_button_tab_button_tab_item);
vue_esm["default"].component('calendar', vux_src_components_calendar);
vue_esm["default"].component('card', vux_src_components_card);
vue_esm["default"].component('cell', vux_src_components_cell);
vue_esm["default"].component('divider', divider["a" /* default */]);
vue_esm["default"].component('cell-box', vux_src_components_cell_box);
vue_esm["default"].component('checker', src_components_checker_checker);
vue_esm["default"].component('checker-item', src_components_checker_checker_item);
vue_esm["default"].component('datetime', components_datetime["a" /* default */]);
vue_esm["default"].component('checklist', vux_src_components_checklist);
vue_esm["default"].component('range', vux_src_components_range);
vue_esm["default"].component('flexbox', flexbox_flexbox["a" /* default */]);
vue_esm["default"].component('previewer', vux_src_components_previewer);
vue_esm["default"].component('flexbox-item', flexbox_item["a" /* default */]);
vue_esm["default"].component('form-preview', vux_src_components_form_preview);
vue_esm["default"].component('grid', src_components_grid_grid);
vue_esm["default"].component('grid-item', src_components_grid_grid_item);
vue_esm["default"].component('group', group["a" /* default */]);
vue_esm["default"].component('group-title', vux_src_components_group_title);
vue_esm["default"].component('loading', components_loading["a" /* default */]);
vue_esm["default"].component('msg', vux_src_components_msg);
vue_esm["default"].component('panel', vux_src_components_panel);
vue_esm["default"].component('popup', node_modules_vux_src_components_popup);
vue_esm["default"].component('search', vux_src_components_search);
vue_esm["default"].component('selector', vux_src_components_selector);
vue_esm["default"].component('scroller', node_modules_vux_src_components_scroller);
vue_esm["default"].component('step', src_components_step_step);
vue_esm["default"].component('icon', icon["a" /* default */]);
vue_esm["default"].component('confirm', components_confirm["a" /* default */]);
vue_esm["default"].component('step-item', src_components_step_step_item);
vue_esm["default"].component('swiper', vux_src_components_swiper_swiper);
vue_esm["default"].component('swiper-item', src_components_swiper_swiper_item);
vue_esm["default"].component('inline-loading', vux_src_components_inline_loading);
vue_esm["default"].component('inline-x-number', vux_src_components_inline_x_number);
vue_esm["default"].component('inline-x-switch', vux_src_components_inline_x_switch);
vue_esm["default"].component('tab', src_components_tab_tab);
vue_esm["default"].component('popup-header', vux_src_components_popup_header);
vue_esm["default"].component('tab-item', src_components_tab_tab_item);
vue_esm["default"].component('sticky', node_modules_vux_src_components_sticky);
vue_esm["default"].component('tabbar', src_components_tabbar_tabbar);
vue_esm["default"].component('tabbar-item', src_components_tabbar_tabbar_item);
vue_esm["default"].component('timeline', src_components_timeline_timeline);
vue_esm["default"].component('timeline-item', timeline_item["a" /* default */]);
vue_esm["default"].component('x-address', vux_src_components_x_address);
vue_esm["default"].component('x-button', vux_src_components_x_button);
vue_esm["default"].component('x-dialog', x_dialog["a" /* default */]);
vue_esm["default"].component('x-header', vux_src_components_x_header);
vue_esm["default"].component('x-input', vux_src_components_x_input);
vue_esm["default"].component('radio', node_modules_vux_src_components_radio);
vue_esm["default"].component('x-number', vux_src_components_x_number);
vue_esm["default"].component('x-switch', vux_src_components_x_switch);
vue_esm["default"].component('x-textarea', vux_src_components_x_textarea);
vue_esm["default"].component('popover', vux_src_components_popover);
vue_esm["default"].component('x-table', vux_src_components_x_table);
vue_esm["default"].component('view-box', vux_src_components_view_box);
vue_esm["default"].component('x-progress', vux_src_components_x_progress);

vue_esm["default"].component('app-header', src_components_Header);
vue_esm["default"].component('app-footer', Footer["a" /* default */]);
// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./src/api/wx.js
var api_wx = __webpack_require__("SDXL");

// EXTERNAL MODULE: ./src/api/admin/index.js
var admin = __webpack_require__("tRmb");

// EXTERNAL MODULE: ./src/api/upload.js
var upload = __webpack_require__("uzBN");

// CONCATENATED MODULE: ./src/wx_share.js









var dt = '艾邦360';
var dd = '艾邦360，企业的朋友圈';
var di = 'https://ww1.sinaimg.cn/large/005YhI8igy1fvp4jszet1j305k05kaa5';

vue_esm["default"].prototype.wxConfig = function (apiList) {
  var that = this;
  return new promise_default.a(function () {
    var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(resolve, reject) {
      var wx, currentUrl, signUrl, jsApiList, _ref2, data;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              wx = vue_esm["default"].wechat;
              currentUrl = global["a" /* default */].domain + that.$route.fullPath;
              signUrl = currentUrl;
              jsApiList = ['checkJsApi'].concat(apiList);
              _context.prev = 4;
              _context.next = 7;
              return Object(api_wx["b" /* fetchWxSign */])(signUrl);

            case 7:
              _ref2 = _context.sent;
              data = _ref2.data;

              if (data.message === 'ok') {
                wx.config({
                  debug: false,
                  appId: global["a" /* default */].appid,
                  timestamp: data.rst.timestamp,
                  nonceStr: data.rst.nonceStr,
                  signature: data.rst.signature,
                  jsApiList: jsApiList
                });
                resolve(data.rst);
              }
              _context.next = 15;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context['catch'](4);

              reject(_context.t0);

            case 15:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this, [[4, 12]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
};

vue_esm["default"].prototype.wxChooseImage = function (imgNum) {
  return new promise_default.a(function (resolve, reject) {
    var wx = vue_esm["default"].wechat;
    wx.chooseImage({
      count: imgNum,
      sizeType: ['original', 'compressed'],
      sourceType: ['album', 'camera'],
      success: function success(res) {
        resolve({ 'rst': res.localIds });
      },
      cancel: function cancel(error) {
        reject(error);
      }
    });
  });
};

vue_esm["default"].prototype.wxUploadImage = function (image) {
  return new promise_default.a(function (resolve, reject) {
    var wx = vue_esm["default"].wechat;
    wx.uploadImage({
      localId: image,
      isShowProgressTips: 0,
      success: function success(res) {
        resolve({ 'rst': res.serverId });
      },
      fail: function fail(error) {
        reject(error);
      }
    });
  });
};

vue_esm["default"].prototype.wxUploadImage2Url = function (image) {
  return new promise_default.a(function (resolve, reject) {
    var wx = vue_esm["default"].wechat;
    wx.uploadImage({
      localId: image,
      isShowProgressTips: 0,
      success: function () {
        var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2(res) {
          var _ref4, data;

          return regenerator_default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.prev = 0;
                  _context2.next = 3;
                  return Object(upload["b" /* transferMedia2Url */])(res.serverId);

                case 3:
                  _ref4 = _context2.sent;
                  data = _ref4.data;

                  if (data.message === 'ok') {
                    resolve({ 'rst': data.rst.url });
                  }
                  _context2.next = 11;
                  break;

                case 8:
                  _context2.prev = 8;
                  _context2.t0 = _context2['catch'](0);

                  reject(_context2.t0);

                case 11:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, this, [[0, 8]]);
        }));

        function success(_x3) {
          return _ref3.apply(this, arguments);
        }

        return success;
      }(),
      fail: function fail(error) {
        reject(error);
      }
    });
  });
};

vue_esm["default"].prototype.wxAdminUploadImage2Url = function (image) {
  return new promise_default.a(function (resolve, reject) {
    var wx = vue_esm["default"].wechat;
    wx.uploadImage({
      localId: image,
      isShowProgressTips: 0,
      success: function () {
        var _ref5 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(res) {
          var _ref6, data;

          return regenerator_default.a.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.prev = 0;
                  _context3.next = 3;
                  return Object(admin["f" /* transferAdminMedia2Url */])(res.serverId);

                case 3:
                  _ref6 = _context3.sent;
                  data = _ref6.data;

                  if (data.message === 'ok') {
                    resolve({ 'rst': data.rst.url });
                  }
                  _context3.next = 11;
                  break;

                case 8:
                  _context3.prev = 8;
                  _context3.t0 = _context3['catch'](0);

                  reject(_context3.t0);

                case 11:
                case 'end':
                  return _context3.stop();
              }
            }
          }, _callee3, this, [[0, 8]]);
        }));

        function success(_x4) {
          return _ref5.apply(this, arguments);
        }

        return success;
      }(),
      fail: function fail(error) {
        reject(error);
      }
    });
  });
};

vue_esm["default"].prototype.wxShare = function () {
  var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : dt;
  var desc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : dd;
  var imgUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : di;
  var timeLineTitle = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var path = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

  if (timeLineTitle === null || timeLineTitle === '') {
    timeLineTitle = title;
  }
  if (!imgUrl) {
    imgUrl = di;
  }
  var wx = vue_esm["default"].wechat;
  var sharePath = path;
  if (!path) {
    sharePath = this.$route.fullPath;
  }
  var currentUrl = encodeURI(global["a" /* default */].domain + sharePath);
  var wxTicket = this.wxConfig(['onMenuShareTimeline', 'onMenuShareAppMessage']);
  desc = desc.replace(/<[^>]+>/g, '');
  desc = desc.trim() !== '' ? desc : '艾邦360，企业的朋友圈';
  // uploadLog(
  //   'wxShare||' + title + '||' + desc + '||' + imgUrl + '||' + timeLineTitle +
  //   '||' +
  //   currentUrl)
  wx.ready(function () {
    // 分享给朋友
    // alert('6:' + title + ';' + timeLineTitle)
    wx.onMenuShareAppMessage({
      title: title,
      desc: desc,
      link: currentUrl,
      imgUrl: imgUrl,
      success: function success(res) {
        // alert('已分享')
      }
    });
    // 分享到朋友圈
    wx.onMenuShareTimeline({
      title: timeLineTitle,
      link: currentUrl,
      imgUrl: imgUrl,
      success: function success(res) {
        // alert('已分享')
      }
    });
  });
  return wxTicket;
};
// EXTERNAL MODULE: ./src/filters/index.js
var filters = __webpack_require__("Q0Ca");

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/get-iterator.js
var get_iterator = __webpack_require__("BO1k");
var get_iterator_default = /*#__PURE__*/__webpack_require__.n(get_iterator);

// EXTERNAL MODULE: ./node_modules/vue-i18n/dist/vue-i18n.esm.js
var vue_i18n_esm = __webpack_require__("TXmL");

// CONCATENATED MODULE: ./src/lang/en.js
/* harmony default export */ var en = ({
  home: 'Home',
  login: 'Login',
  region: 'Region',
  mobile: 'Mobile',
  smsCode: 'SMS Code',
  backText: 'Back',
  sendSmsCode: 'Send',
  resendSmsCode: 'Resend',
  register: 'Register',
  submit: 'Submit',
  required: 'Required',
  personalInfo: 'Personal Info',
  name: 'Name',
  position: 'Position',
  note: 'Note',
  companyInfo: 'Company Info',
  companyTitle: 'Title',
  product: 'Product',
  website: 'Website',
  address: 'Address',
  provinceCity: 'Country',
  optional: 'Optional',
  userServicesAgreement: 'User Services Agreement',
  readAndAgree: 'Readed and agree',
  notice: 'Notice',
  loginWithSms: 'Login by SMS',
  loginWithWechat: 'Login by Wechat Oauth',
  loginRegister: 'Un-registered mobile phone number will registered automatically when logging, at the same time means you agreed',
  registerError: 'Register error',
  tryLater: 'try later please',
  wxAuthError: 'Weixin authorized error',
  checkAndSubmit: 'please check again before submitting',
  inputError: 'Input error',
  proviceCityPlaceholder: 'Optional',
  mobileError: 'Mobile error',
  updatePersonalInfo: 'Update personal info'
});
// CONCATENATED MODULE: ./src/lang/zh.js
/* harmony default export */ var zh = ({
  home: '主页',
  login: '登录',
  region: '国家/地区',
  mobile: '手机号码',
  smsCode: '验证码',
  backText: '返回',
  sendSmsCode: '获取验证码',
  resendSmsCode: '重获验证码',
  register: '注册',
  submit: '提交',
  required: '必填',
  personalInfo: '个人信息',
  name: '姓名',
  position: '职位',
  note: '备注',
  companyInfo: '公司信息',
  companyTitle: '名称',
  product: '主营产品',
  website: '官网地址',
  address: '地址',
  provinceCity: '省份城市',
  optional: '选填',
  userServicesAgreement: '用户服务协议',
  readAndAgree: '阅读并同意',
  notice: '温馨提示',
  loginWithSms: '短信登录',
  loginWithWechat: '微信登录',
  loginRegister: '未注册艾邦360账号的手机号，登录时将自动注册，且代表您已同意',
  registerError: '注册异常',
  tryLater: '请稍后再试',
  wxAuthError: '微信授权有问题',
  checkAndSubmit: '请检查后再提交',
  inputError: '输入错误',
  proviceCityPlaceholder: '必填',
  mobileError: '手机号码输入有误',
  updatePersonalInfo: '更新个人资料'
});
// CONCATENATED MODULE: ./src/lang/index.js









vue_esm["default"].use(vue_i18n_esm["a" /* default */]);

var messages = {
  en: extends_default()({}, en),
  zh: extends_default()({}, zh)
};

function getLanguage() {
  var lang = 'zh';
  var language = (navigator.language || navigator.browserLanguage).toLowerCase();
  var locales = keys_default()(messages);
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = get_iterator_default()(locales), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var locale = _step.value;

      if (language.indexOf(locale) > -1) {
        lang = locale;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  store["a" /* default */].commit('SET_LANGUAGE', lang);
  return lang;
}

var i18n = new vue_i18n_esm["a" /* default */]({
  // set locale
  // options: en | zh | es
  locale: getLanguage(),
  // set locale messages
  messages: messages
});

/* harmony default export */ var src_lang = (i18n);
// EXTERNAL MODULE: ./node_modules/vue-simple-uploader/dist/vue-uploader.js
var vue_uploader = __webpack_require__("LgDO");
var vue_uploader_default = /*#__PURE__*/__webpack_require__.n(vue_uploader);

// EXTERNAL MODULE: ./src/style/index.less
var style = __webpack_require__("eDDz");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// CONCATENATED MODULE: ./src/main.js

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








 // permission control


 // global filters






fastclick_default.a.attach(document.body);
vue_esm["default"].config.productionTip = false;

vue_esm["default"].use(vue_touch_default.a, { name: 'v-touch' });

vue_esm["default"].use(vue_uploader_default.a);

vue_esm["default"].use(vue_infinite_loading_default.a, {
  props: {
    direction: 'bottom',
    distance: 1000
  },
  slots: {
    noMore: '全部加载完成', // you can pass a string value,
    noResults: '全部加载完成'
  }
});

keys_default()(filters).forEach(function (key) {
  vue_esm["default"].filter(key, filters[key]);
});

vue_esm["default"].prototype.GLOBAL = global["a" /* default */];

/* eslint-disable no-new */
new vue_esm["default"]({
  router: router["a" /* default */],
  store: store["a" /* default */],
  i18n: src_lang,
  render: function render(h) {
    return h(src_App);
  }
}).$mount('#app-box');

/***/ }),

/***/ "P3La":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P7KP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Pfph":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = sendSMSCaptcha;
/* harmony export (immutable) */ __webpack_exports__["a"] = loginByMobile;
/* harmony export (immutable) */ __webpack_exports__["d"] = register;
/* harmony export (immutable) */ __webpack_exports__["b"] = logout;
/* harmony export (immutable) */ __webpack_exports__["c"] = queryCompany;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_request__ = __webpack_require__("vLgD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");



function sendSMSCaptcha(item) {
  item['count'] = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.smsCount;
  __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('INCR_SMS_COUNT');
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/auth/send_sms',
    method: 'post',
    data: item
  });
}

function loginByMobile(item) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/auth/login',
    method: 'post',
    data: item
  });
}

function register(item) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/auth/reg',
    method: 'post',
    data: item
  });
}

function logout() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/auth/logout',
    method: 'post'
  });
}

function queryCompany(keyword) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/auth/company/query',
    method: 'get',
    params: { keyword: keyword }
  });
}

/***/ }),

/***/ "Q0Ca":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["parseTime"] = parseTime;
/* harmony export (immutable) */ __webpack_exports__["formatTime"] = formatTime;
/* harmony export (immutable) */ __webpack_exports__["orderStatusFilter"] = orderStatusFilter;
/* harmony export (immutable) */ __webpack_exports__["vipOrderStatusFilter"] = vipOrderStatusFilter;
/* harmony export (immutable) */ __webpack_exports__["vipFilter"] = vipFilter;
/* harmony export (immutable) */ __webpack_exports__["mobileFilter"] = mobileFilter;
/* harmony export (immutable) */ __webpack_exports__["exhibitorImageTypeFilter"] = exhibitorImageTypeFilter;
/* harmony export (immutable) */ __webpack_exports__["statusFilter"] = statusFilter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }

  if ((time + '').length === 10) {
    time = +time * 1000;
  }

  var format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  var date = void 0;
  if ((typeof time === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(time)) === 'object') {
    date = time;
  } else {
    date = new Date(parseInt(time));
  }
  var formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  var timeStr = format.replace(/{(y|m|d|h|i|s|a)+}/g, function (result, key) {
    var value = formatObj[key];
    if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1];
    if (result.length > 0 && value < 10) {
      value = '0' + value;
    }
    return value || 0;
  });
  return timeStr;
}

function formatTime(time, option) {
  if (time === 0) {
    return '';
  }
  time = +time * 1000;
  var d = new Date(time);
  var now = Date.now();

  var diff = (now - d) / 1000;

  if (diff < 30) {
    return '刚刚';
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前';
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前';
  } else if (diff < 3600 * 24 * 2) {
    return '1天前';
  } else if (diff < 3600 * 24 * 3) {
    return '2天前';
  } else if (diff < 3600 * 24 * 4) {
    return '3天前';
  } else if (diff < 3600 * 24 * 5) {
    return '4天前';
  } else if (diff < 3600 * 24 * 6) {
    return '5天前';
  } else if (diff < 3600 * 24 * 7) {
    return '6天前';
  } else if (diff < 3600 * 24 * 8) {
    return '7天前';
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分';
  }
}

function orderStatusFilter(status) {
  var statusMap = {
    'apply': '已报名，待选会议服务',
    'paid': '已付款',
    'unpaid': '已报名，未付款',
    'seat': '付款并选好座位',
    'service': '已选会议服务',
    'signed': '已签到',
    'offline': '线下支付，等待确认',
    'paying': '付款等待后台确认',
    'trash': '回收站',
    'audit': '审核中'
  };
  return statusMap[status];
}

function vipOrderStatusFilter(status) {
  var statusMap = {
    'apply': '已申请',
    'paid': '已付款',
    'paying': '付款等待后台确认',
    'audit': '等待审核',
    'unpaid': '未支付',
    'trash': '回收站'
  };
  return statusMap[status];
}

function vipFilter(vip) {
  var vipMap = {
    '3': '合作伙伴',
    '2': '超级会员',
    '1': '普通会员',
    '0': '免费用户'
  };
  return vipMap[vip];
}

function mobileFilter(mobile) {
  return mobile.replace(/-+/g, '');
}

function exhibitorImageTypeFilter(type) {
  var map = {
    'speech': '演讲',
    'booth': '展台',
    'conference': '会刊',
    'publicity': '宣传图',
    'other': '其他'
  };
  return map[type] ? map[type] : type;
}

function statusFilter(status) {
  var statusMap = {
    'show': '公开',
    'hide': '隐藏',
    'trash': '回收站'
  };
  return statusMap[status];
}

/***/ }),

/***/ "Q7uw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QlJb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SDXL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchWxSign;
/* unused harmony export fetchWxPay */
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchWxAuth;
/* harmony export (immutable) */ __webpack_exports__["c"] = uploadLog;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_request__ = __webpack_require__("vLgD");


function fetchWxSign(url) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/wx/sign?url=' + encodeURIComponent(url)
  });
}

function fetchWxPay(orderID) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/wx/pay/' + orderID,
    method: 'get'
  });
}

function fetchWxAuth(query) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/wx/auth',
    method: 'get',
    params: query
  });
}

function uploadLog(content) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/auth/msg',
    method: 'post',
    data: { msg: content }
  });
}

/***/ }),

/***/ "T5Vs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TIfe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getToken;
/* harmony export (immutable) */ __webpack_exports__["c"] = setToken;
/* harmony export (immutable) */ __webpack_exports__["b"] = removeToken;
/* unused harmony export resetToken */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_wx__ = __webpack_require__("SDXL");





var TokenKey = 'aabb';

function getToken() {
  var rst = __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get(TokenKey);
  if (rst === 'ab') {
    return null;
  } else {
    return rst;
  }
}

function setToken(token) {
  __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set(TokenKey, token, {
    expires: 7
  });
}

function removeToken() {
  console.log('removeToken');
  Object(__WEBPACK_IMPORTED_MODULE_2__api_wx__["c" /* uploadLog */])('Remove Token Now !!! ' + getToken());
  __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set(TokenKey, 'ab', { expires: 1 });
}

function resetToken() {
  if (getToken()) {
    return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set(TokenKey, getToken(), {
      expires: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.tokenExpired
    });
  }
}

/***/ }),

/***/ "TVmP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Footer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Footer = ({
  name: 'AppFooter',
  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['user']))
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Footer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_Footer = ({
  name: 'AppFooter',
  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['user']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f374a4a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('tabbar',{staticStyle:{"position":"fixed"},attrs:{"slot":"bottom"},slot:"bottom"},[_c('tabbar-item',{attrs:{"selected":_vm.$route.path == '/e',"link":"/e"}},[_c('svg',{staticClass:"vux-x-icon vux-x-icon-ios-world-outline",attrs:{"slot":"icon","type":"ios-world-outline","size":"30","xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 512 512"},slot:"icon"},[_c('path',{attrs:{"d":"M256 48h-.5C140.8 48.3 48 141.3 48 256s92.8 207.7 207.5 208h.5c114.9 0 208-93.1 208-208S370.9 48 256 48zm8.3 124.5c22.1-.6 43.5-3.5 64.2-8.5 6.2 24.5 10.1 52.8 10.7 83.8h-74.9v-75.3zm0-16.7V66c22.4 6.2 45.2 36.1 59.6 82-19.2 4.6-39.1 7.2-59.6 7.8zm-16.6-90v90.1c-20.7-.6-40.8-3.3-60.1-8 14.6-46.2 37.5-76.3 60.1-82.1zm0 106.7v75.2h-75.4c.6-31 4.5-59.3 10.7-83.8 20.8 5 42.5 8 64.7 8.6zm-92.2 75.2H64.9c1.8-42.8 17.8-82 43.3-113 18.5 10.2 38.2 18.6 58.8 24.8-6.8 26.5-10.8 56.4-11.5 88.2zm0 16.6c.6 31.7 4.6 61.7 11.4 88.2-20.6 6.3-40.2 14.6-58.8 24.8-25.5-31-41.4-70.2-43.3-113h90.7zm16.8 0h75.4v75.1c-22.2.6-43.9 3.6-64.7 8.7-6.2-24.5-10.1-52.8-10.7-83.8zm75.4 91.8v90.2c-22.6-5.9-45.5-35.9-60.1-82.1 19.3-4.8 39.4-7.5 60.1-8.1zm16.6 89.9v-90c20.5.6 40.4 3.3 59.7 7.9-14.5 46-37.2 75.9-59.7 82.1zm0-106.6v-75.1h74.9c-.6 30.9-4.5 59.2-10.7 83.7-20.7-5-42.1-8-64.2-8.6zm91.6-75.1h91.2c-1.8 42.8-17.8 81.9-43.3 113-18.7-10.3-38.5-18.7-59.3-25 6.8-26.5 10.8-56.3 11.4-88zm0-16.6c-.6-31.7-4.6-61.6-11.3-88.1 20.8-6.3 40.6-14.7 59.2-24.9 25.5 31 41.5 70.2 43.3 113.1h-91.2zm36.5-125.8c-16.6 8.8-34 16.1-52.3 21.6-9.7-31.3-23.4-56.8-39.5-73.6 35.4 8.5 67 26.9 91.8 52zM210.8 70.1c-16.1 16.7-29.7 42.2-39.3 73.3-18.1-5.5-35.4-12.7-51.8-21.5 24.5-25 55.9-43.3 91.1-51.8zM119.6 390c16.4-8.8 33.8-16 51.8-21.5 9.7 31.2 23.3 56.6 39.4 73.4-35.2-8.5-66.6-26.8-91.2-51.9zm181 52.1c16.2-16.8 29.8-42.3 39.6-73.7 18.3 5.5 35.7 12.8 52.3 21.6-24.8 25.2-56.5 43.6-91.9 52.1z"}})]),_vm._v(" "),_c('svg',{staticClass:"vux-x-icon vux-x-icon-ios-world",attrs:{"slot":"icon-active","type":"ios-world","size":"30","xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 512 512"},slot:"icon-active"},[_c('path',{attrs:{"d":"M256 48h-.5C140.8 48.3 48 141.3 48 256s92.8 207.7 207.5 208h.5c114.9 0 208-93.1 208-208S370.9 48 256 48zm0 399.4h-.5C150.1 447.1 64.6 361.5 64.6 256S150 64.9 255.5 64.7h.5c105.7 0 191.4 85.7 191.4 191.4 0 105.6-85.7 191.3-191.4 191.3z"}}),_c('path',{attrs:{"d":"M322.3 171.8c-18.7 4.5-38 7.2-57.9 7.8v68.1H332c-.6-28.1-4.1-53.6-9.7-75.9zm-58-89.3v81.9c18.5-.6 36.5-3 53.8-7.2-13.1-41.4-33.5-68.6-53.8-74.7zm-70.9 74.6c17.5 4.2 35.6 6.7 54.2 7.3V82.3c-20.3 5.9-41 33.1-54.2 74.8zm187.2-23.7c-22.6-23-51.5-39.8-83.9-47.5 14.8 15.3 27.2 38.7 36.1 67.3 16.7-5.1 32.7-11.7 47.8-19.8zm-33.3 114.3h83.3c-1.8-38.8-16.3-74.4-39.5-102.6-17.1 9.4-35.2 17.1-54.1 22.8 6.1 24 9.7 51.1 10.3 79.8zm-167.8 0h68.2v-68.1c-20.1-.6-39.6-3.3-58.4-7.9-5.7 22.3-9.2 47.9-9.8 76zM332 264.3h-67.7v68c19.9.6 39.3 3.2 58 7.8 5.6-22.2 9.1-47.8 9.7-75.8zm-142.7 75.9c18.8-4.6 38.3-7.3 58.4-7.9v-68h-68.2c.6 28.1 4.1 53.7 9.8 75.9zm58.4 89.4v-82.1c-18.6.6-36.8 3.1-54.3 7.3 13.2 41.7 33.9 69 54.3 74.8zm49-3.5c32.4-7.8 61.3-24.5 84-47.6-15.1-8.1-31.1-14.7-47.8-19.8-8.9 28.7-21.4 52-36.2 67.4zm-82-340c-32.1 7.8-60.8 24.5-83.3 47.4 15 8 30.8 14.6 47.3 19.6 8.9-28.5 21.3-51.7 36-67zm122.3 258c19 5.7 37.1 13.4 54.2 22.8 23.2-28.2 37.7-63.8 39.5-102.6h-83.3c-.7 28.7-4.3 55.7-10.4 79.8zm-72.7 3.4v82c20.3-6.1 40.7-33.3 53.8-74.8-17.3-4.2-35.3-6.6-53.8-7.2zm-89.7-179.7c-18.8-5.7-36.8-13.3-53.7-22.7-23.2 28.2-37.7 63.8-39.5 102.6h82.9c.5-28.8 4.2-55.9 10.3-79.9zm-10.4 96.5H81.3c1.8 38.8 16.3 74.4 39.5 102.6 16.9-9.3 34.9-17 53.7-22.7-6-24-9.7-51.1-10.3-79.9zm-32.9 114.2c22.5 22.9 51.2 39.6 83.4 47.4-14.7-15.3-27.1-38.6-36-67.1-16.5 5.1-32.4 11.7-47.4 19.7z"}})]),_vm._v(" "),_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("线上展")])]),_vm._v(" "),_c('tabbar-item',{attrs:{"selected":_vm.$route.path == '/m',"link":"/m"}},[_c('svg',{staticClass:"vux-x-icon vux-x-icon-ios-people-outline",attrs:{"slot":"icon","type":"ios-people-outline","size":"30","xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 512 512"},slot:"icon"},[_c('path',{attrs:{"d":"M256 112zm93.2 222.8c-13.5-4.7-28.1-5-41.6-9.7-4.1-1.4-12.2-3.1-13.9-7.8-1.6-4.6-1.6-10-1.9-14.8-.2-3.8-.3-7.6-.3-11.4 0-2.5 6.4-7.8 7.8-10.1 5.4-9 5.9-21.1 6.9-31.3 8.7 2.4 9.8-13.7 11.3-18.6 1.1-3.4 7.8-26.8-2.6-23.6 2.5-4.4 3.5-9.8 4.2-14.7 2-12.8 2.8-26.8-1.1-39.3-8.1-26-33-40.6-59.3-41.4-26.7-.9-53.5 11.9-63.5 37.8-4.8 12.6-4.4 26.3-2.8 39.5.7 6 1.7 12.7 4.7 18.1-9.7-2.9-4.5 17.7-3.4 21.3 1.6 5.1 3 23.4 12.1 20.9.8 8.1 1.7 16.4 3.9 24.3 1.5 5.3 4.6 9.8 8.2 13.9 1.8 2 2.7 2.2 2.6 4.8-.1 7.8.1 16.2-1.9 23.8-2 7.6-18.7 10.8-25.4 12.2-18 3.7-34.6 5.4-49.6 16.6-17.5 12.9-26.6 33-26.6 54.7h278c0-29.5-17.8-55.5-45.8-65.2-11.2-3.9 11.3 3.9 0 0zm-202.1 28.8c5.6-5.9 12.7-11.1 20.4-14 10.5-4 22.4-3.8 33.3-6.6 9-2.3 20.2-5.9 27.2-12.4 6.4-6 7.1-15.2 7.7-23.5.5-7 .4-13.9.4-20.9 0-4.9-5.7-7.7-8.5-11.6-4.5-6.1-4.7-15.2-5.6-22.5-.4-3.2-.5-7.3-3.2-9.5-3-2.4-5.2-3.7-6.7-7.5-2-5.2-2.7-10.8-4.3-16.2-1-3.5 2.5-6.8 3.9-9.7 2.6-5.3-1.9-13.5-2.8-19-2.8-16.4-2.7-34.3 9.1-47.3 23.7-26.2 78-17.9 85.8 18.9 2.4 11.5.9 24.9-2.3 36.1-1.4 4.8-3 8.3-.2 13 4.2 6.8 2.4 11.2.4 18.8-1.6 6.3-3.6 9.1-8.4 13-4 3.2-3.4 11.2-4.1 15.8-.8 5.6-1.3 11.5-4.7 16.2-1.3 1.8-8.4 7.4-8.4 9.3 0 11-.5 22.2 1.4 33.1 2.6 15.5 15.6 19.2 28.6 24.5 13.2 5.1 28.5 3.2 41.3 9.5 13.2 6.5 25.9 18.4 29.7 33.1H135c1.9-8.3 6.5-14.6 12.1-20.6 9.2-9.7-5.9 6.3 0 0z"}}),_c('path',{attrs:{"d":"M144.1 322c7-3.5 14.6-4.3 22.3-5.1 2.8-.3 4.1-2.2 2-4.9-4-5.1-17.8-6.1-23.6-8.4-3.6-1.4-4.6-2.7-4.9-6.7-.1-1.8-1.1-9.8.3-11.1 1-1 7.3-.6 8.7-.8 5.7-.7 11.5-1.9 16.9-4 2.3-.9 4.5-2 6.5-3.4 2.4-1.8-1.8-6.2-2.9-8.6-3.4-7.5-4.9-15.7-5.4-23.9-1-16.1 1.5-32.3-1.5-48.3C158 172.3 139.1 160 115 160c-14.9 0-29.6 5.1-37.9 18.1-9.2 14.3-8.7 32.1-8.2 48.4.3 9.3.7 18.7-.6 28-.6 4-1.5 7.9-2.9 11.7-1.1 2.9-6.7 10.1-4.5 11.6 8.3 5.9 22.3 7.9 32.3 7.1.3 4.9 1.2 11.2-.6 15.8-2.8 7.2-23.7 9.1-30 11.2C45 317.8 32 332.5 32 352h79.5c1.3 0 6.3-9.3 7.7-10.8 7-7.8 15.6-14.5 24.9-19.2 9-4.5-14.6 7.4 0 0zm-41.3 14H53.9c7.1-11.8 24.9-11 36.6-15.2 10.8-3.9 17.7-10.5 18.8-22 .1-1.3.2-29.2-.9-29.2-8.7-.3-17.8-.1-26.5-1.4 6.9-22.3.3-45.3 4-67.8 2.7-16.3 13.1-25.3 29.7-25.3 15.9 0 27.7 7.4 31.1 23.4 4.8 23.2-2 46.9 5.4 69.9-5.5 1.4-11.3 1.6-17 1.8-2.8.1-5.7.2-8.5.3-1.8.1-1.2 3.2-1.3 4.7-1 10.9-5 28.1 3.7 36.9-9.6 6-20 14.3-26.2 23.9zm297 16H480c0-19.5-13.1-34.3-30.7-40.1-8.1-2.6-23.7-3.4-29.5-10.4-2.9-3.5-1.3-12.4-1-16.6 4.4.4 9.2-.3 13.7-.9 4.1-.6 8.1-1.4 12-2.8 1.8-.7 3.6-1.4 5.3-2.4 3.9-2.3 2.1-2.7.1-6.1-10.9-18.3-6-41.5-6.5-61.6-.4-16.7-4.8-35-20-44.4-13.7-8.5-34-8.8-48.7-2.8-42.4 17-17.4 73.2-31.9 105.4-2.5 5.4-6.1 7.3.2 10.5 3.5 1.8 7.3 3 11.1 3.9 5.8 1.4 11.8 2.2 17.8 2.4 1 0 .3 12.6 0 13.9-1.1 4.9-11.8 6.3-15.8 7.4-4.1 1.1-10.9 1.4-12.9 5.7-3 6.4 9.9 4.8 13.1 5.4 10.3 1.9 19.4 7.6 27.4 14.1 5.9 4.8 13.9 11.6 16.1 19.4zm-.4-27.1c-5.1-4.7-10.4-9.3-16.3-13 8.8-8.8 4.7-25.9 3.7-36.9-.6-6.3-2-4.7-8.3-4.9-6-.2-12.8.1-18.5-1.8 7.2-22.3 1.3-45.2 5-67.9 2.8-17.1 14.5-25.5 31.5-25.5 15.4 0 26 7.7 29.2 23 4.9 23.1-2.6 47 4.5 70-8.5 1.3-17.3 1-25.9 1.3-2.1.1-1.9 25.1-1.7 27.3.7 11.7 6.1 18.8 17.2 23.3 12.1 4.9 31 3.6 38.4 15.9h-44.7c-7.1.1-8.9-6.1-14.1-10.8-5-4.6 4 3.6 0 0z"}})]),_vm._v(" "),_c('svg',{staticClass:"vux-x-icon vux-x-icon-ios-people",attrs:{"slot":"icon-active","type":"ios-people","size":"30","xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 512 512"},slot:"icon-active"},[_c('path',{attrs:{"d":"M349.2 334.8c11.3 3.9-11.2-3.9 0 0z"}}),_c('path',{attrs:{"d":"M349.2 334.8c-13.5-4.7-28.1-5-41.6-9.7-4.1-1.4-12.2-3.1-13.9-7.8-1.6-4.6-1.6-10-1.9-14.8-.2-3.8-.3-7.6-.3-11.4 0-2.5 6.4-7.8 7.8-10.1 5.4-9 5.9-21.1 6.9-31.3 8.7 2.4 9.8-13.7 11.3-18.6 1.1-3.4 7.8-26.8-2.6-23.6 2.5-4.4 3.5-9.8 4.2-14.7 2-12.8 2.8-26.8-1.1-39.3-8.1-26-33-40.6-59.3-41.4-26.7-.9-53.5 11.9-63.5 37.8-4.8 12.6-4.4 26.3-2.8 39.5.7 6 1.7 12.7 4.7 18.1-9.7-2.9-4.5 17.7-3.4 21.3 1.6 5.1 3 23.4 12.1 20.9.8 8.1 1.7 16.4 3.9 24.3 1.5 5.3 4.6 9.8 8.2 13.9 1.8 2 2.7 2.2 2.6 4.8-.1 7.8.1 16.2-1.9 23.8-2 7.6-18.7 10.8-25.4 12.2-18 3.7-34.6 5.4-49.6 16.6-17.5 12.9-26.6 33-26.6 54.7h278c0-29.5-17.8-55.5-45.8-65.2z"}}),_c('path',{attrs:{"d":"M143.3 322.5l1.6-.8c-.3.1-.6.3-.8.4-.3.1-.5.2-.8.4z"}}),_c('path',{attrs:{"d":"M143.3 322.5c-3.4 1.7-7.5 3.8.8-.4l.8-.4c6.8-3.2 14.1-4 21.4-4.7 2.8-.3 4.1-2.2 2-4.9-4-5.1-17.8-6.1-23.6-8.4-3.6-1.4-4.6-2.7-4.9-6.7-.1-1.8-1.1-9.8.3-11.1 1-1 7.3-.6 8.7-.8 5.7-.7 11.5-1.9 16.9-4 2.3-.9 4.5-2 6.5-3.4 2.4-1.8-1.8-6.2-2.9-8.6-3.4-7.5-4.9-15.7-5.4-23.9-1-16.1 1.5-32.3-1.5-48.3-4.5-24.5-23.4-36.8-47.5-36.8-14.9 0-29.6 5.1-37.9 18.1-9.2 14.3-8.7 32.1-8.2 48.4.3 9.3.7 18.7-.6 28-.6 4-1.5 7.9-2.9 11.7-1.1 2.9-6.7 10.1-4.5 11.6 8.3 5.9 22.3 7.9 32.3 7.1.3 4.9 1.2 11.2-.6 15.8-2.8 7.2-23.7 9.1-30 11.2C45 317.8 32 332 32 352h79.5c1.3 0 6.3-9.3 7.7-10.8 6.8-7.5 15.1-14 24.1-18.7zm306-10.6c-8.1-2.6-23.7-3.4-29.5-10.4-2.9-3.5-1.3-12.4-1-16.6 4.4.4 9.2-.3 13.7-.9 4.1-.6 8.1-1.4 12-2.8 1.8-.7 3.6-1.4 5.3-2.4 3.9-2.3 2.1-2.7.1-6.1-10.9-18.3-6-41.5-6.5-61.6-.4-16.7-4.8-35-20-44.4-13.7-8.5-34-8.8-48.7-2.8-42.4 17-17.4 73.2-31.9 105.4-2.5 5.4-6.1 7.3.2 10.5 3.5 1.8 7.3 3 11.1 3.9 5.8 1.4 11.8 2.2 17.8 2.4 1 0 .3 12.6 0 13.9-1.1 4.9-11.8 6.3-15.8 7.4-4.1 1.1-10.9 1.4-12.9 5.7-3 6.4 9.9 4.8 13.1 5.4 10.3 1.9 19.4 7.6 27.4 14.1 6 4.9 14.1 11.5 16.3 19.5h80.2c-.2-20.1-13.3-34.4-30.9-40.2z"}})]),_vm._v(" "),_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("会议")])]),_vm._v(" "),_c('tabbar-item',{attrs:{"selected":_vm.$route.path == '/contacts',"link":"/contacts"}},[_c('svg',{staticClass:"vux-x-icon vux-x-icon-contacts-outline",attrs:{"slot":"icon","type":"contacts-outline","size":"30","viewBox":"0 0 1024 1024","version":"1.1","xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30"},slot:"icon"},[_c('path',{attrs:{"d":"M566.67461439 509.26626929c60.14207583 0 109.34922878-49.20715295 109.34922876-109.34922878s-49.20715295-109.34922878-109.34922877-109.34922877-109.34922878 49.20715295-109.34922877 109.34922877 49.20715295 109.34922878 109.34922877 109.34922878z m0-164.02384315c30.07103791 0 54.67461439 24.60357647 54.67461439 54.67461437s-24.60357647 54.67461439-54.67461439 54.67461439-54.67461439-24.60357647-54.67461439-54.67461439 24.60357647-54.67461439 54.67461439-54.67461437zM607.68057518 528.40238432h-82.0119216c-84.74565231 0-150.35518955 90.21311374-150.35518955 150.35518954 0 13.66865358 0 54.67461439 54.67461439 54.6746144h273.37307192c54.67461439 0 54.67461439-41.00596077 54.6746144-54.6746144 0-60.14207583-65.60953726-150.35518955-150.35518956-150.35518954zM429.98807842 678.75757386c0-32.80476865 43.7396915-95.68057518 95.68057516-95.68057517h82.0119216c51.94088367 0 95.68057518 62.87580654 95.68057516 95.68057517H429.98807842z","p-id":"1593"}}),_c('path',{attrs:{"d":"M812.71037912 101.9403921H265.96423526C219.49081305 101.9403921 183.95231368 137.47889146 183.95231368 183.95231368v158.55638173H156.61500651c-16.40238432 0-27.3373072 10.93492288-27.33730721 27.3373072s10.93492288 27.3373072 27.33730721 27.33730719h27.33730717v218.69845753H156.61500651c-16.40238432 0-27.3373072 10.93492288-27.33730721 27.33730719s10.93492288 27.3373072 27.33730721 27.3373072h27.33730717V840.04768632c0 46.47342222 35.53849936 82.01192158 82.01192158 82.01192158h546.74614386c46.47342222 0 82.01192158-35.53849936 82.01192158-82.01192158V183.95231368c0-46.47342222-35.53849936-82.01192158-82.01192158-82.01192158z m27.3373072 738.10729422c0 16.40238432-10.93492288 27.3373072-27.3373072 27.33730717H265.96423526c-16.40238432 0-27.3373072-10.93492288-27.33730718-27.33730717v-169.4913046h27.33730718c16.40238432 0 27.3373072-10.93492288 27.33730721-27.3373072s-10.93492288-27.3373072-27.33730721-27.33730719H238.62692808v-218.69845754h27.33730718c16.40238432 0 27.3373072-10.93492288 27.33730721-27.33730718s-10.93492288-27.3373072-27.33730721-27.3373072H238.62692808V183.95231368c0-16.40238432 10.93492288-27.3373072 27.33730718-27.33730717h546.74614386c16.40238432 0 27.3373072 10.93492288 27.3373072 27.33730717v656.09537264z","p-id":"1594"}})]),_vm._v(" "),_c('svg',{staticClass:"vux-x-icon vux-x-icon-contacts",attrs:{"slot":"icon-active","type":"contacts","size":"30","viewBox":"0 0 1024 1024","version":"1.1","xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30"},slot:"icon-active"},[_c('path',{attrs:{"d":"M807.76913804 68.34629293H216.23086196C165.95010849 68.34629293 127.50012055 106.79628089 127.50012055 157.07703435v171.54610007h59.15382761c17.74614829 0 29.57691381 11.83076552 29.5769138 29.57691381s-11.83076552 29.57691381-29.5769138 29.5769138H127.50012055v236.61531043h59.15382761c17.74614829 0 29.57691381 11.83076552 29.5769138 29.57691379s-11.83076552 29.57691381-29.5769138 29.57691381H127.50012055V866.92296565c0 50.28075346 38.44998795 88.73074141 88.73074141 88.73074142h591.53827608c50.28075346 0 88.73074141-38.44998795 88.73074141-88.73074142V157.07703435c0-50.28075346-38.44998795-88.73074141-88.73074141-88.73074142z m-266.19222423 204.08070526c65.06921037 0 118.30765522 53.23844484 118.30765521 118.30765521s-53.23844484 118.30765522-118.30765521 118.30765522-118.30765522-53.23844484-118.30765522-118.30765522 53.23844484-118.30765522 118.30765522-118.30765521z m147.88456902 479.14600362H393.69234478c-59.15382761 0-59.15382761-44.3653707-59.15382761-59.15382761 0-65.06921037 70.98459313-162.67302592 162.67302593-162.67302591h88.7307414c91.68843279 0 162.67302592 97.60381556 162.67302593 162.67302591 0 14.7884569 0 59.15382761-59.1538276 59.15382761z","p-id":"1731"}})]),_vm._v(" "),_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("通讯录")])]),_vm._v(" "),_c('tabbar-item',{attrs:{"selected":_vm.$route.path == '/t',"link":"/t"}},[_c('svg',{staticClass:"vux-x-icon vux-x-icon-ios-photos-outline",attrs:{"slot":"icon","type":"ios-photos-outline","size":"30","xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 512 512"},slot:"icon"},[_c('path',{attrs:{"d":"M96 128v320h384V128H96zm368 304H112V144h352v288z"}}),_c('path',{attrs:{"d":"M32 64v320h48v-16H48V80h352v32h16V64z"}})]),_vm._v(" "),_c('svg',{staticClass:"vux-x-icon vux-x-icon-ios-photos",attrs:{"slot":"icon-active","type":"ios-photos","size":"30","xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 512 512"},slot:"icon-active"},[_c('path',{attrs:{"d":"M96 128v320h384V128H96z"}}),_c('path',{attrs:{"d":"M416 64H32v320h48V112h336z"}})]),_vm._v(" "),_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("社区")])]),_vm._v(" "),_c('tabbar-item',{attrs:{"link":"/card"}},[_c('svg',{staticClass:"vux-x-icon vux-x-icon-card",attrs:{"slot":"icon","type":"card","size":"30","viewBox":"0 0 1024 1024","version":"1.1","xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30"},slot:"icon"},[_c('path',{attrs:{"d":"M877.714286 841.142857H73.142857a18.285714 18.285714 0 0 1-18.285714-18.285714v-548.571429A18.285714 18.285714 0 0 1 73.142857 256h804.571429a18.285714 18.285714 0 0 1 18.285714 18.285714v548.571429a18.285714 18.285714 0 0 1-18.285714 18.285714zM91.428571 804.571429h768V292.571429h-768z","p-id":"4355"}}),_c('path',{attrs:{"d":"M749.714286 493.714286h-182.857143a18.285714 18.285714 0 0 1 0-36.571429h182.857143a18.285714 18.285714 0 0 1 0 36.571429zM640 566.857143h-73.142857a18.285714 18.285714 0 0 1 0-36.571429h73.142857a18.285714 18.285714 0 0 1 0 36.571429zM694.857143 219.428571H146.285714a18.285714 18.285714 0 0 1 0-36.571428h548.571429a18.285714 18.285714 0 0 1 0 36.571428z","p-id":"4356"}}),_c('path',{attrs:{"d":"M950.857143 768a18.285714 18.285714 0 0 1-18.285714-18.285714V219.428571H621.714286a18.285714 18.285714 0 0 1 0-36.571428h329.142857a18.285714 18.285714 0 0 1 18.285714 18.285714v548.571429a18.285714 18.285714 0 0 1-18.285714 18.285714zM493.714286 731.428571h-292.571429a18.285714 18.285714 0 0 1-18.285714-18.285714v-36.571428a91.794286 91.794286 0 0 1 36.571428-73.142858l80.822858-60.708571a17.92 17.92 0 0 1 25.6 3.657143 18.651429 18.651429 0 0 1-3.657143 25.6L241.371429 632.685714a54.491429 54.491429 0 0 0-21.942858 43.885715v18.285714h256v-18.285714a54.491429 54.491429 0 0 0-21.942857-43.885715l-80.822857-60.708571a18.651429 18.651429 0 0 1-3.657143-25.6 17.92 17.92 0 0 1 25.6-3.657143L475.428571 603.428571a91.794286 91.794286 0 0 1 36.571429 73.142858v36.571428a18.285714 18.285714 0 0 1-18.285714 18.285714z","p-id":"4357"}}),_c('path',{attrs:{"d":"M347.428571 585.142857A91.428571 91.428571 0 0 1 256 493.714286v-36.571429a91.428571 91.428571 0 0 1 182.857143 0v36.571429A91.428571 91.428571 0 0 1 347.428571 585.142857z m0-182.857143A54.857143 54.857143 0 0 0 292.571429 457.142857v36.571429a54.857143 54.857143 0 0 0 109.714285 0v-36.571429A54.857143 54.857143 0 0 0 347.428571 402.285714z","p-id":"4358"}})]),_vm._v(" "),_c('svg',{staticClass:"vux-x-icon vux-x-icon-card",attrs:{"slot":"icon-active","type":"card","size":"30","viewBox":"0 0 1024 1024","version":"1.1","xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30"},slot:"icon-active"},[_c('path',{attrs:{"d":"M877.714286 841.142857H73.142857a18.285714 18.285714 0 0 1-18.285714-18.285714v-548.571429A18.285714 18.285714 0 0 1 73.142857 256h804.571429a18.285714 18.285714 0 0 1 18.285714 18.285714v548.571429a18.285714 18.285714 0 0 1-18.285714 18.285714zM91.428571 804.571429h768V292.571429h-768z","p-id":"4355"}}),_c('path',{attrs:{"d":"M749.714286 493.714286h-182.857143a18.285714 18.285714 0 0 1 0-36.571429h182.857143a18.285714 18.285714 0 0 1 0 36.571429zM640 566.857143h-73.142857a18.285714 18.285714 0 0 1 0-36.571429h73.142857a18.285714 18.285714 0 0 1 0 36.571429zM694.857143 219.428571H146.285714a18.285714 18.285714 0 0 1 0-36.571428h548.571429a18.285714 18.285714 0 0 1 0 36.571428z","p-id":"4356"}}),_c('path',{attrs:{"d":"M950.857143 768a18.285714 18.285714 0 0 1-18.285714-18.285714V219.428571H621.714286a18.285714 18.285714 0 0 1 0-36.571428h329.142857a18.285714 18.285714 0 0 1 18.285714 18.285714v548.571429a18.285714 18.285714 0 0 1-18.285714 18.285714zM493.714286 731.428571h-292.571429a18.285714 18.285714 0 0 1-18.285714-18.285714v-36.571428a91.794286 91.794286 0 0 1 36.571428-73.142858l80.822858-60.708571a17.92 17.92 0 0 1 25.6 3.657143 18.651429 18.651429 0 0 1-3.657143 25.6L241.371429 632.685714a54.491429 54.491429 0 0 0-21.942858 43.885715v18.285714h256v-18.285714a54.491429 54.491429 0 0 0-21.942857-43.885715l-80.822857-60.708571a18.651429 18.651429 0 0 1-3.657143-25.6 17.92 17.92 0 0 1 25.6-3.657143L475.428571 603.428571a91.794286 91.794286 0 0 1 36.571429 73.142858v36.571428a18.285714 18.285714 0 0 1-18.285714 18.285714z","p-id":"4357"}}),_c('path',{attrs:{"d":"M347.428571 585.142857A91.428571 91.428571 0 0 1 256 493.714286v-36.571429a91.428571 91.428571 0 0 1 182.857143 0v36.571429A91.428571 91.428571 0 0 1 347.428571 585.142857z m0-182.857143A54.857143 54.857143 0 0 0 292.571429 457.142857v36.571429a54.857143 54.857143 0 0 0 109.714285 0v-36.571429A54.857143 54.857143 0 0 0 347.428571 402.285714z","p-id":"4358"}})]),_vm._v(" "),_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("名片")])]),_vm._v(" "),_c('tabbar-item',{attrs:{"selected":_vm.$route.path == '/my',"link":"/my"}},[_c('svg',{staticClass:"vux-x-icon vux-x-icon-ios-person-outline",attrs:{"slot":"icon","type":"ios-person-outline","size":"30","xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 512 512"},slot:"icon"},[_c('path',{attrs:{"d":"M202.4 201.7zm160.9 162.2c-12.9-4.6-31.4-6.2-43.2-8.8-6.8-1.5-16.7-5.3-20-9.2-3.3-4-1.3-40.9-1.3-40.9s6.1-9.6 9.4-18 6.9-31.4 6.9-31.4 6.8 0 9.2-11.9c2.6-13 6.6-18.4 6.1-28.1-.5-9-5.2-9.5-5.7-9.5 0 0 4.9-13.6 5.6-42.4C331.1 129.6 305 96 256 96s-75 33.5-74.3 67.6c.6 28.7 5.6 42.4 5.6 42.4-.5 0-5.2.5-5.7 9.5-.5 9.7 3.6 14.9 6.1 27.9 2.4 11.9 9.2 12 9.2 12s3.6 23.1 6.9 31.5c3.3 8.5 9.4 18 9.4 18s2 36.9-1.3 40.9-13.2 7.7-20 9.2c-11.9 2.6-30.3 4.3-43.2 8.9C135.8 368.5 96 384 96 416h320c0-32-39.8-47.5-52.7-52.1zM256 400H118.7c2-3 4.7-5.1 8.2-7.6 7-5.1 16.1-9.8 27.1-13.6 6.8-2.4 16.7-4 25.4-5.3 5.7-.9 11.1-1.7 15.9-2.8 3.4-.8 20.8-5 28.8-14.6 4.5-5.4 5.8-12.7 5.6-32.3-.1-10-.6-19.3-.6-19.7l-.2-4.2-2.3-3.5c-1.5-2.3-5.8-9.5-8-15.3-1.8-4.7-4.6-19.2-6-28.1 0 0 .4 1-.5-3.7s-8.4-4.3-9.4-8c-.9-3.6-1.8-6.9-4.3-18.2-2.5-11.3 2.8-11.2 3.9-16.2.6-3.1 0-5.7 0-5.8-.3-1-4.1-13.4-4.7-37.7-.3-13.2 4.6-25.6 13.8-34.9 10.6-10.8 26-16.5 44.5-16.5 19 0 34 5.7 44.6 16.5 9.2 9.3 14.1 21.7 13.8 34.9-.5 24.2-4.3 36.6-4.7 37.7 0 .1-.6 1.7-.4 5.2.2 5.4 6.8 5.5 4.3 16.8s-3.4 14.6-4.3 18.2c-.9 3.6-8.5 3.3-9.4 8-.9 4.7-.5 3.7-.5 3.7-1.4 8.9-4.2 23.4-6 28.1-2.3 5.8-6.6 13-8 15.3l-2.3 3.5-.2 4.2c0 .4-.5 9.7-.6 19.7-.2 19.6 1.1 26.9 5.6 32.3 8 9.5 25.4 13.8 28.8 14.6 4.8 1.1 10.2 1.9 15.9 2.8 8.7 1.3 18.6 2.9 25.4 5.3 11 3.9 20.2 8.6 27.1 13.7 3.5 2.5 6.2 4.6 8.2 7.6L256 400z"}})]),_vm._v(" "),_c('svg',{staticClass:"vux-x-icon vux-x-icon-ios-person",attrs:{"slot":"icon-active","type":"ios-person","size":"30","xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 512 512"},slot:"icon-active"},[_c('path',{attrs:{"d":"M363.3 363.9c-12.9-4.6-31.4-6.2-43.2-8.8-6.8-1.5-16.7-5.3-20-9.2-3.3-4-1.3-40.9-1.3-40.9s6.1-9.6 9.4-18 6.9-31.4 6.9-31.4 6.8 0 9.2-11.9c2.6-13 6.6-18.4 6.1-28.1-.5-9-5.2-9.5-5.7-9.5 0 0 4.9-13.6 5.6-42.4C331.1 129.6 305 96 256 96s-75 33.5-74.3 67.6c.6 28.7 5.6 42.4 5.6 42.4-.5 0-5.2.5-5.7 9.5-.5 9.7 3.6 14.9 6.1 27.9 2.4 11.9 9.2 12 9.2 12s3.6 23.1 6.9 31.5c3.3 8.5 9.4 18 9.4 18s2 36.9-1.3 40.9-13.2 7.7-20 9.2c-11.9 2.6-30.3 4.3-43.2 8.9C135.8 368.5 96 384 96 416h320c0-32-39.8-47.5-52.7-52.1z"}})]),_vm._v(" "),_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("我的")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Footer = (esExports);
// CONCATENATED MODULE: ./src/components/Footer.vue
function injectStyle (ssrContext) {
  __webpack_require__("a4Np")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5f374a4a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_Footer,
  selectortype_template_index_0_src_components_Footer,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_Footer = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Te/k":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TuEr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UNGY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/vux/src/components/icon/index.vue + 3 modules
var icon = __webpack_require__("oWtu");

// EXTERNAL MODULE: ./node_modules/vux/src/components/datetime/datetimepicker.js + 2 modules
var datetimepicker = __webpack_require__("zV4+");

// EXTERNAL MODULE: ./node_modules/vux/src/components/group/index.vue + 3 modules
var group = __webpack_require__("rHil");

// EXTERNAL MODULE: ./node_modules/vux/src/components/inline-desc/index.vue + 3 modules
var inline_desc = __webpack_require__("kbG3");

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/uuid.js
var uuid = __webpack_require__("KRg4");

// EXTERNAL MODULE: ./node_modules/vux/src/tools/date/format.js
var date_format = __webpack_require__("ODCk");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/datetime/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var datetime = ({
  name: 'datetime',
  mixins: [uuid["a" /* default */]],
  components: {
    Group: group["a" /* default */],
    InlineDesc: inline_desc["a" /* default */],
    Icon: icon["a" /* default */]
  },
  props: {
    format: {
      type: String,
      default: 'YYYY-MM-DD',
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          return console.error('[VUX] Datetime prop:format 使用 A 时只允许的值为： YYYY-MM-DD A');
        }
        return true;
      }
    },
    title: String,
    value: {
      type: String,
      default: ''
    },
    inlineDesc: String,
    placeholder: String,
    minYear: Number,
    maxYear: Number,
    confirmText: String,
    cancelText: String,
    clearText: String,
    yearRow: {
      type: String,
      default: '{value}'
    },
    monthRow: {
      type: String,
      default: '{value}'
    },
    dayRow: {
      type: String,
      default: '{value}'
    },
    hourRow: {
      type: String,
      default: '{value}'
    },
    minuteRow: {
      type: String,
      default: '{value}'
    },
    required: {
      type: Boolean,
      default: false
    },
    minHour: {
      type: Number,
      default: 0
    },
    maxHour: {
      type: Number,
      default: 23
    },
    startDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:start-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    endDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:end-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    valueTextAlign: String,
    displayFormat: Function,
    readonly: Boolean,
    hourList: Array,
    minuteList: Array,
    show: Boolean,
    defaultSelectedValue: String,
    computeHoursFunction: Function,
    computeDaysFunction: Function,
    orderMap: Object
  },
  created: function created() {
    this.isFirstSetValue = false;
    this.currentValue = this.value;
  },
  data: function data() {
    return {
      currentShow: false,
      currentValue: null,
      valid: true,
      errors: {}
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    var uuid = this.uuid;
    this.$el.setAttribute('id', 'vux-datetime-' + uuid);
    if (!this.readonly) {
      this.$nextTick(function () {
        _this2.render();

        if (_this2.show) {
          _this2.$nextTick(function () {
            _this2.picker && _this2.picker.show(_this2.currentValue);
          });
        }
      });
    }
  },

  computed: {
    styles: function styles() {
      if (!this.$parent) {
        return {};
      }
      return {
        width: this.$parent.labelWidth,
        textAlign: this.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight
      };
    },
    pickerOptions: function pickerOptions() {
      var _this = this;
      var options = {
        trigger: '#vux-datetime-' + this.uuid,
        format: this.format,
        value: this.currentValue,
        output: '.vux-datetime-value',
        confirmText: _this.getButtonText('confirm'),
        cancelText: _this.getButtonText('cancel'),
        clearText: _this.clearText,
        yearRow: this.yearRow,
        monthRow: this.monthRow,
        dayRow: this.dayRow,
        hourRow: this.hourRow,
        minuteRow: this.minuteRow,
        minHour: this.minHour,
        maxHour: this.maxHour,
        startDate: this.startDate,
        endDate: this.endDate,
        hourList: this.hourList,
        minuteList: this.minuteList,
        defaultSelectedValue: this.defaultSelectedValue,
        computeHoursFunction: this.computeHoursFunction,
        computeDaysFunction: this.computeDaysFunction,
        orderMap: this.orderMap || {},
        onSelect: function onSelect(type, val, wholeValue) {
          if (_this.picker && _this.picker.config.renderInline) {
            _this.$emit('input', wholeValue);
            _this.$emit('on-change', wholeValue);
          }
        },
        onConfirm: function onConfirm(value) {
          _this.currentValue = value;
        },
        onClear: function onClear(value) {
          _this.$emit('on-clear', value);
        },
        onHide: function onHide(type) {
          _this.currentShow = false;
          _this.$emit('update:show', false);
          _this.validate();
          _this.$emit('on-hide', type);
          if (type === 'cancel') {
            _this.$emit('on-cancel');
          }
          if (type === 'confirm') {
            setTimeout(function () {
              _this.$nextTick(function () {
                _this.$emit('on-confirm', _this.value);
              });
            });
          }
        },
        onShow: function onShow() {
          _this.currentShow = true;
          _this.$emit('update:show', true);
          _this.$emit('on-show');
        }
      };
      if (this.minYear) {
        options.minYear = this.minYear;
      }
      if (this.maxYear) {
        options.maxYear = this.maxYear;
      }
      return options;
    },
    firstError: function firstError() {
      var key = keys_default()(this.errors)[0];
      return this.errors[key];
    },
    labelClass: function labelClass() {
      if (!this.$parent) {
        return {};
      }
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    getButtonText: function getButtonText(type) {
      if (type === 'cancel' && this.cancelText) {
        return this.cancelText;
      } else if (type === 'confirm' && this.confirmText) {
        return this.confirmText;
      }
      return this.$el.getAttribute('data-' + type + '-text');
    },
    render: function render() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.picker && _this3.picker.destroy();
        _this3.picker = new datetimepicker["a" /* default */](_this3.pickerOptions);
      });
    },
    validate: function validate() {
      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填';
        return;
      }
      this.valid = true;
      this.errors = {};
    }
  },
  watch: {
    readonly: function readonly(val) {
      if (val) {
        this.picker && this.picker.destroy();
      } else {
        this.render();
      }
    },
    show: function show(val) {
      if (val === this.currentShow) return;
      if (val) {
        this.picker && this.picker.show(this.currentValue);
      } else {
        this.picker && this.picker.hide(this.currentValue);
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      if (!this.isFirstSetValue) {
        this.isFirstSetValue = true;
        oldVal && this.$emit('on-change', val);
      } else {
        this.$emit('on-change', val);
      }
      this.validate();
    },
    startDate: function startDate() {
      this.render();
    },
    endDate: function endDate() {
      this.render();
    },
    format: function format(val) {
      if (this.currentValue) {
        this.currentValue = Object(date_format["a" /* default */])(this.currentValue, val);
      }
      this.render();
    },
    value: function value(val) {
      // do not force render when renderInline is true
      if (this.readonly || this.picker && this.picker.config.renderInline) {
        this.currentValue = val;
        return;
      }
      if (this.currentValue !== val) {
        this.currentValue = val;
        this.render();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.picker && this.picker.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/datetime/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var components_datetime = ({
  name: 'datetime',
  mixins: [uuid["a" /* default */]],
  components: {
    Group: group["a" /* default */],
    InlineDesc: inline_desc["a" /* default */],
    Icon: icon["a" /* default */]
  },
  props: {
    format: {
      type: String,
      default: 'YYYY-MM-DD',
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          return console.error('[VUX] Datetime prop:format 使用 A 时只允许的值为： YYYY-MM-DD A');
        }
        return true;
      }
    },
    title: String,
    value: {
      type: String,
      default: ''
    },
    inlineDesc: String,
    placeholder: String,
    minYear: Number,
    maxYear: Number,
    confirmText: String,
    cancelText: String,
    clearText: String,
    yearRow: {
      type: String,
      default: '{value}'
    },
    monthRow: {
      type: String,
      default: '{value}'
    },
    dayRow: {
      type: String,
      default: '{value}'
    },
    hourRow: {
      type: String,
      default: '{value}'
    },
    minuteRow: {
      type: String,
      default: '{value}'
    },
    required: {
      type: Boolean,
      default: false
    },
    minHour: {
      type: Number,
      default: 0
    },
    maxHour: {
      type: Number,
      default: 23
    },
    startDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:start-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    endDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:end-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    valueTextAlign: String,
    displayFormat: Function,
    readonly: Boolean,
    hourList: Array,
    minuteList: Array,
    show: Boolean,
    defaultSelectedValue: String,
    computeHoursFunction: Function,
    computeDaysFunction: Function,
    orderMap: Object
  },
  created: function created() {
    this.isFirstSetValue = false;
    this.currentValue = this.value;
  },
  data: function data() {
    return {
      currentShow: false,
      currentValue: null,
      valid: true,
      errors: {}
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    var uuid = this.uuid;
    this.$el.setAttribute('id', 'vux-datetime-' + uuid);
    if (!this.readonly) {
      this.$nextTick(function () {
        _this2.render();

        if (_this2.show) {
          _this2.$nextTick(function () {
            _this2.picker && _this2.picker.show(_this2.currentValue);
          });
        }
      });
    }
  },

  computed: {
    styles: function styles() {
      if (!this.$parent) {
        return {};
      }
      return {
        width: this.$parent.labelWidth,
        textAlign: this.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight
      };
    },
    pickerOptions: function pickerOptions() {
      var _this = this;
      var options = {
        trigger: '#vux-datetime-' + this.uuid,
        format: this.format,
        value: this.currentValue,
        output: '.vux-datetime-value',
        confirmText: _this.getButtonText('confirm'),
        cancelText: _this.getButtonText('cancel'),
        clearText: _this.clearText,
        yearRow: this.yearRow,
        monthRow: this.monthRow,
        dayRow: this.dayRow,
        hourRow: this.hourRow,
        minuteRow: this.minuteRow,
        minHour: this.minHour,
        maxHour: this.maxHour,
        startDate: this.startDate,
        endDate: this.endDate,
        hourList: this.hourList,
        minuteList: this.minuteList,
        defaultSelectedValue: this.defaultSelectedValue,
        computeHoursFunction: this.computeHoursFunction,
        computeDaysFunction: this.computeDaysFunction,
        orderMap: this.orderMap || {},
        onSelect: function onSelect(type, val, wholeValue) {
          if (_this.picker && _this.picker.config.renderInline) {
            _this.$emit('input', wholeValue);
            _this.$emit('on-change', wholeValue);
          }
        },
        onConfirm: function onConfirm(value) {
          _this.currentValue = value;
        },
        onClear: function onClear(value) {
          _this.$emit('on-clear', value);
        },
        onHide: function onHide(type) {
          _this.currentShow = false;
          _this.$emit('update:show', false);
          _this.validate();
          _this.$emit('on-hide', type);
          if (type === 'cancel') {
            _this.$emit('on-cancel');
          }
          if (type === 'confirm') {
            setTimeout(function () {
              _this.$nextTick(function () {
                _this.$emit('on-confirm', _this.value);
              });
            });
          }
        },
        onShow: function onShow() {
          _this.currentShow = true;
          _this.$emit('update:show', true);
          _this.$emit('on-show');
        }
      };
      if (this.minYear) {
        options.minYear = this.minYear;
      }
      if (this.maxYear) {
        options.maxYear = this.maxYear;
      }
      return options;
    },
    firstError: function firstError() {
      var key = keys_default()(this.errors)[0];
      return this.errors[key];
    },
    labelClass: function labelClass() {
      if (!this.$parent) {
        return {};
      }
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    getButtonText: function getButtonText(type) {
      if (type === 'cancel' && this.cancelText) {
        return this.cancelText;
      } else if (type === 'confirm' && this.confirmText) {
        return this.confirmText;
      }
      return this.$el.getAttribute('data-' + type + '-text');
    },
    render: function render() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.picker && _this3.picker.destroy();
        _this3.picker = new datetimepicker["a" /* default */](_this3.pickerOptions);
      });
    },
    validate: function validate() {
      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填';
        return;
      }
      this.valid = true;
      this.errors = {};
    }
  },
  watch: {
    readonly: function readonly(val) {
      if (val) {
        this.picker && this.picker.destroy();
      } else {
        this.render();
      }
    },
    show: function show(val) {
      if (val === this.currentShow) return;
      if (val) {
        this.picker && this.picker.show(this.currentValue);
      } else {
        this.picker && this.picker.hide(this.currentValue);
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      if (!this.isFirstSetValue) {
        this.isFirstSetValue = true;
        oldVal && this.$emit('on-change', val);
      } else {
        this.$emit('on-change', val);
      }
      this.validate();
    },
    startDate: function startDate() {
      this.render();
    },
    endDate: function endDate() {
      this.render();
    },
    format: function format(val) {
      if (this.currentValue) {
        this.currentValue = Object(date_format["a" /* default */])(this.currentValue, val);
      }
      this.render();
    },
    value: function value(val) {
      // do not force render when renderInline is true
      if (this.readonly || this.picker && this.picker.config.renderInline) {
        this.currentValue = val;
        return;
      }
      if (this.currentValue !== val) {
        this.currentValue = val;
        this.render();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.picker && this.picker.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3077eb4a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/datetime/index.vue
var datetime_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"vux-datetime weui-cell",class:{'weui-cell_access': !_vm.readonly},attrs:{"data-cancel-text":'取消',"data-confirm-text":'确定',"href":"javascript:"}},[_vm._t("default",function(){return [_c('div',[_vm._t("title",function(){return [_c('p',{class:_vm.labelClass,style:(_vm.styles),domProps:{"innerHTML":_vm._s(_vm.title)}})]}),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft vux-cell-primary vux-datetime-value",style:({
        textAlign: _vm.valueTextAlign
      })},[(!_vm.currentValue && _vm.placeholder)?_c('span',{staticClass:"vux-cell-placeholder"},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_vm._v(" "),(_vm.currentValue)?_c('span',{staticClass:"vux-cell-value"},[_vm._v(_vm._s(_vm.displayFormat ? _vm.displayFormat(_vm.currentValue) : _vm.currentValue))]):_vm._e(),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.valid),expression:"!valid"}],staticClass:"vux-input-icon",attrs:{"type":"warn","title":_vm.firstError}})],1)]})],2)}
var staticRenderFns = []
var esExports = { render: datetime_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_datetime = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/datetime/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("T5Vs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_datetime,
  src_components_datetime,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var vux_src_components_datetime = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VKKs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = getMeetingSelect;
/* harmony export (immutable) */ __webpack_exports__["l"] = setMeetingSelect;
/* harmony export (immutable) */ __webpack_exports__["a"] = getApiUrl;
/* harmony export (immutable) */ __webpack_exports__["b"] = getExpoConfig;
/* harmony export (immutable) */ __webpack_exports__["j"] = setExpoConfig;
/* harmony export (immutable) */ __webpack_exports__["k"] = setFormRecordQuery;
/* harmony export (immutable) */ __webpack_exports__["c"] = getFormRecordQuery;
/* harmony export (immutable) */ __webpack_exports__["r"] = setUuid;
/* harmony export (immutable) */ __webpack_exports__["i"] = getUuid;
/* harmony export (immutable) */ __webpack_exports__["n"] = setRef;
/* harmony export (immutable) */ __webpack_exports__["p"] = setRefTmp;
/* harmony export (immutable) */ __webpack_exports__["f"] = getRef;
/* harmony export (immutable) */ __webpack_exports__["o"] = setRefMeeting;
/* harmony export (immutable) */ __webpack_exports__["g"] = getRefMeeting;
/* harmony export (immutable) */ __webpack_exports__["e"] = getPopupList;
/* harmony export (immutable) */ __webpack_exports__["m"] = setPopupList;
/* harmony export (immutable) */ __webpack_exports__["h"] = getSmsCount;
/* harmony export (immutable) */ __webpack_exports__["q"] = setSmsCount;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");



var UuidKey = 'uuid';
var RefKey = 'ref_user';
var RefTmpKey = 'ref_tmp_user';
var ApiKey = 'api';

var RefMeetingKey = 'ref_meeting';

var PopupViewKey = 'popup';

var SmsCountKey = 'sms_count';

var ExpoConfigKey = 'expo_config';

var FormRecordQueryKey = 'form_record_query';

var MeetingSelectKey = 'meeting_select';

function getMeetingSelect() {
  return localStorage.getItem(MeetingSelectKey);
}

function setMeetingSelect(meetingId) {
  localStorage.setItem(MeetingSelectKey, meetingId);
}

function getApiUrl() {
  return localStorage.getItem(ApiKey);
}

function getExpoConfig() {
  var val = localStorage.getItem(ExpoConfigKey);
  var dataObj = JSON.parse(val);
  if (dataObj) {
    return dataObj;
  } else {
    return null;
  }
}

function setExpoConfig(config) {
  localStorage.setItem(ExpoConfigKey, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(config));
}

function setFormRecordQuery(query) {
  localStorage.setItem(FormRecordQueryKey, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(query));
}

function getFormRecordQuery() {
  var val = localStorage.getItem(FormRecordQueryKey);
  var dataObj = JSON.parse(val);
  if (dataObj) {
    return dataObj;
  } else {
    return null;
  }
}

function setUuid(uuid) {
  var currTime = new Date().getTime();
  localStorage.setItem(UuidKey, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ uuid: uuid, time: currTime }));
}

function getUuid() {
  var val = localStorage.getItem(UuidKey);
  var dataObj = JSON.parse(val);
  if (dataObj) {
    return dataObj.uuid;
  } else {
    return null;
  }
}

function setRef(ref) {
  var currTime = new Date().getTime();
  var val = localStorage.getItem(RefKey);
  var dataObj = JSON.parse(val);
  if (dataObj) {
    dataObj['user_id'] = ref;
    dataObj['user_time'] = currTime;
  } else {
    dataObj = { user_id: ref, user_time: currTime };
  }
  localStorage.setItem(RefKey, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(dataObj));
}

function setRefTmp(ref) {
  var currTime = new Date().getTime();
  var val = localStorage.getItem(RefTmpKey);
  var dataObj = JSON.parse(val);
  if (dataObj) {
    dataObj['user_id'] = ref;
    dataObj['user_time'] = currTime;
  } else {
    dataObj = { user_id: ref, user_time: currTime };
  }
  localStorage.setItem(RefTmpKey, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(dataObj));
}

function getRef() {
  var val = localStorage.getItem(RefKey);
  var dataObj = JSON.parse(val);
  if (dataObj) {
    return dataObj;
  } else {
    var tmp = localStorage.getItem(RefTmpKey);
    var tmpObj = JSON.parse(tmp);
    if (tmpObj && __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.user && __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.user.id !== tmpObj.user_id) {
      localStorage.setItem(RefKey, tmp);
    } else {
      return null;
    }
  }
}

function setRefMeeting(ref) {
  var currTime = new Date().getTime();
  var val = localStorage.getItem(RefMeetingKey);
  var dataObj = JSON.parse(val);
  if (dataObj) {
    dataObj['user_id'] = ref;
    dataObj['user_time'] = currTime;
  } else {
    dataObj = { user_id: ref, user_time: currTime };
  }
  localStorage.setItem(RefMeetingKey, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(dataObj));
}

function getRefMeeting() {
  var val = localStorage.getItem(RefMeetingKey);
  var dataObj = JSON.parse(val);
  if (dataObj) {
    return dataObj.user_id;
  } else {
    return null;
  }
}

function getPopupList() {
  var val = localStorage.getItem(PopupViewKey);
  var dataObj = JSON.parse(val);
  var uuid = getUuid();
  if (dataObj && dataObj[uuid]) {
    return dataObj[uuid];
  } else {
    return [];
  }
}

function setPopupList(list) {
  var val = localStorage.getItem(PopupViewKey);
  var dataObj = val ? JSON.parse(val) : {};
  var uuid = getUuid();
  dataObj[uuid] = list;
  localStorage.setItem(PopupViewKey, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(dataObj));
}

function getSmsCount() {
  var val = localStorage.getItem(SmsCountKey);
  if (val) {
    try {
      return parseInt(val);
    } catch (e) {
      return 0;
    }
  } else {
    return 0;
  }
}

function setSmsCount(smsCount) {
  localStorage.setItem(SmsCountKey, smsCount);
}

/***/ }),

/***/ "VWqx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "W2k9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WOhk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XZOv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./src/store/index.js + 5 modules
var store = __webpack_require__("IcnI");

// CONCATENATED MODULE: ./src/router/modules/news.js
var newsRouter = [{
  path: '/news',
  name: 'NewsIndex',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(108)]).then(__webpack_require__.bind(null, "/iyE"));
  }
}, {
  path: '/news/:id(\\d+)',
  name: 'NewsDetail',
  component: function component() {
    return __webpack_require__.e/* import() */(109).then(__webpack_require__.bind(null, "52vC"));
  }
}];

/* harmony default export */ var news = (newsRouter);
// CONCATENATED MODULE: ./src/router/modules/link.js
var linkRouter = [{
  path: '/link/:id(\\d+)',
  name: 'LinkDetail',
  component: function component() {
    return __webpack_require__.e/* import() */(170).then(__webpack_require__.bind(null, "8ZMF"));
  }
}];

/* harmony default export */ var modules_link = (linkRouter);
// CONCATENATED MODULE: ./src/router/modules/video.js
var videoRouter = [{
  path: '/video',
  name: 'VideoIndex',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(4)]).then(__webpack_require__.bind(null, "kRZe"));
  }
}, {
  path: '/video/:id(\\d+)',
  name: 'VideoDetail',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(8)]).then(__webpack_require__.bind(null, "cHDi"));
  }
}];

/* harmony default export */ var video = (videoRouter);
// CONCATENATED MODULE: ./src/router/modules/meeting.js
var meetingRouter = [{
  path: '/m',
  name: 'MeetingIndex',
  meta: {
    keepAlive: true
  },
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(88)]).then(__webpack_require__.bind(null, "7PpU"));
  }
}, {
  path: '/m/:id(\\d+)',
  name: 'MeetingDetail',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(188)]).then(__webpack_require__.bind(null, "0cIL"));
  }
}, {
  path: '/m/sign/:id(\\d+)',
  name: 'MeetingSign',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(72)]).then(__webpack_require__.bind(null, "jQH/"));
  }
}, {
  path: '/m/sign/record/:id(\\d+)',
  name: 'MeetingSignRecord',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(25)]).then(__webpack_require__.bind(null, "eXED"));
  }
}, {
  path: '/m/apply',
  name: 'MeetingApply',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(65)]).then(__webpack_require__.bind(null, "Zamv"));
  }
}, {
  path: '/m/apply/success',
  name: 'MeetingApplySuccess',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(140)]).then(__webpack_require__.bind(null, "fph7"));
  }
}, {
  path: '/m/seat',
  name: 'MeetingSeat',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(217)]).then(__webpack_require__.bind(null, "zpSL"));
  }
}];

/* harmony default export */ var meeting = (meetingRouter);
// CONCATENATED MODULE: ./src/router/modules/form.js
var formRouter = [{
  path: '/form/:id(\\d+)',
  name: 'FormDetail',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(156)]).then(__webpack_require__.bind(null, "Ao6r"));
  }
}, {
  path: '/form/apply',
  name: 'FormApply',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(68)]).then(__webpack_require__.bind(null, "c1BI"));
  }
}, {
  path: '/form/apply/success',
  name: 'FormApplySuccess',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(183)]).then(__webpack_require__.bind(null, "2NSv"));
  }
}];

/* harmony default export */ var modules_form = (formRouter);
// CONCATENATED MODULE: ./src/router/modules/topic.js
var topicRouter = [{
  path: '/t',
  name: 'TopicIndex',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(53)]).then(__webpack_require__.bind(null, "3p6A"));
  }
}, {
  path: '/t/:id(\\d+)',
  name: 'TopicDetail',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(24)]).then(__webpack_require__.bind(null, "IdQs"));
  }
}, {
  path: '/t/tag/:tag',
  name: 'TopicTag',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(190)]).then(__webpack_require__.bind(null, "ZoOe"));
  }
}, {
  path: '/t/msg',
  name: 'TopicMsg',
  component: function component() {
    return __webpack_require__.e/* import() */(71).then(__webpack_require__.bind(null, "9WSO"));
  }
}, {
  path: '/t/create',
  name: 'TopicCreate',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(57)]).then(__webpack_require__.bind(null, "Su/U"));
  }
}, {
  path: '/t/edit',
  name: 'TopicEdit',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(38)]).then(__webpack_require__.bind(null, "nvVJ"));
  }
}];

/* harmony default export */ var topic = (topicRouter);
// CONCATENATED MODULE: ./src/router/modules/expo.js
var expoRouter = [{
  path: '/e',
  name: 'ExpoIndex',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(116)]).then(__webpack_require__.bind(null, "WVi1"));
  }
}, {
  path: '/e/:id(\\d+)',
  name: 'ExpoDetail',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(20)]).then(__webpack_require__.bind(null, "nddy"));
  }
}, {
  path: '/e/guest',
  name: 'ExpoGuest',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(142)]).then(__webpack_require__.bind(null, "CAJT"));
  }
}, {
  path: '/e/join',
  name: 'ExpoJoin',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(89)]).then(__webpack_require__.bind(null, "qeiZ"));
  }
}, {
  path: '/e/vote',
  name: 'ExpoVote',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(204)]).then(__webpack_require__.bind(null, "jrvU"));
  }
}, {
  path: '/e/join/success/',
  name: 'ExpoJoinSuccess',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(165)]).then(__webpack_require__.bind(null, "/BTq"));
  }
}, {
  path: '/e/vote/success/',
  name: 'ExpoVoteSuccess',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(158)]).then(__webpack_require__.bind(null, "X4CG"));
  }
}, {
  path: '/e/ep/create/success',
  name: 'EpCreateSuccess',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(193)]).then(__webpack_require__.bind(null, "2Pek"));
  }
}, {
  path: '/e/ep/create',
  name: 'EpCreate',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(169)]).then(__webpack_require__.bind(null, "TSux"));
  }
}, {
  path: '/e/ep/edit/:id(\\d+)',
  name: 'EpEdit',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(196)]).then(__webpack_require__.bind(null, "/hmQ"));
  }
}, {
  path: '/e/ep/edit/tag',
  name: 'EpEditTag',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(125)]).then(__webpack_require__.bind(null, "PHdL"));
  }
}, {
  path: '/e/ep/:id(\\d+)',
  name: 'EpDetail',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(10)]).then(__webpack_require__.bind(null, "1wBO"));
  }
}, {
  path: '/e/ep/action/:id(\\d+)',
  name: 'EpAction',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(27)]).then(__webpack_require__.bind(null, "+/OH"));
  }
}, {
  path: '/e/ep/comment/:id(\\d+)',
  name: 'EpComment',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(55)]).then(__webpack_require__.bind(null, "YtN+"));
  }
}];

/* harmony default export */ var expo = (expoRouter);
// CONCATENATED MODULE: ./src/router/modules/vip.js
var vipRouter = [{
  path: '/vip',
  name: 'VipIndex',
  component: function component() {
    return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, "YDKI"));
  }
}, {
  path: '/vip/scheme',
  name: 'VipScheme',
  component: function component() {
    return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, "27fm"));
  }
}, {
  path: '/vip/apply/success',
  name: 'VipApplySuccess',
  component: function component() {
    return __webpack_require__.e/* import() */(172).then(__webpack_require__.bind(null, "/iGW"));
  }
}, {
  path: '/vip/pay/success',
  name: 'VipPaySuccess',
  component: function component() {
    return __webpack_require__.e/* import() */(202).then(__webpack_require__.bind(null, "ya3w"));
  }
}, {
  path: '/vip/user',
  name: 'VipUser',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(6)]).then(__webpack_require__.bind(null, "MDDO"));
  }
}];

/* harmony default export */ var vip = (vipRouter);
// CONCATENATED MODULE: ./src/router/modules/my.js
var myRouter = [{
  path: '/my',
  name: 'MyIndex',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(101)]).then(__webpack_require__.bind(null, "xtOy"));
  }
}, {
  path: '/my/about',
  name: 'MyAbout',
  component: function component() {
    return __webpack_require__.e/* import() */(201).then(__webpack_require__.bind(null, "LSWF"));
  }
}, {
  path: '/my/profile',
  name: 'MyProfile',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(205)]).then(__webpack_require__.bind(null, "Qrio"));
  }
}, {
  path: '/my/debug',
  name: 'MyDebug',
  component: function component() {
    return __webpack_require__.e/* import() */(69).then(__webpack_require__.bind(null, "GAEs"));
  }
}, {
  path: '/my/personal',
  name: 'MyPersonal',
  component: function component() {
    return __webpack_require__.e/* import() */(220).then(__webpack_require__.bind(null, "l8q9"));
  }
}, {
  path: '/my/avatar/edit',
  name: 'MyAvatarEdit',
  component: function component() {
    return __webpack_require__.e/* import() */(62).then(__webpack_require__.bind(null, "rkF1"));
  }
}, {
  path: '/my/topics',
  name: 'MyTopics',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(162)]).then(__webpack_require__.bind(null, "8Z14"));
  }
}, {
  path: '/my/topic/fav',
  name: 'MyFavTopic',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(148)]).then(__webpack_require__.bind(null, "41ZR"));
  }
}, {
  path: '/my/replies',
  name: 'MyReplies',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(36)]).then(__webpack_require__.bind(null, "q5Al"));
  }
}, {
  path: '/my/coin',
  name: 'MyCoin',
  component: function component() {
    return __webpack_require__.e/* import() */(167).then(__webpack_require__.bind(null, "ttLW"));
  }
}, {
  path: '/my/eps',
  name: 'MyEps',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(82)]).then(__webpack_require__.bind(null, "KfNZ"));
  }
}, {
  path: '/my/ep/:id(\\d+)',
  name: 'MyEp',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(130)]).then(__webpack_require__.bind(null, "b02I"));
  }
}, {
  path: '/my/orders',
  name: 'MyOrders',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(12)]).then(__webpack_require__.bind(null, "DBCu"));
  }
}, {
  path: '/my/order/:id(\\d+)',
  name: 'MyOrder',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(128)]).then(__webpack_require__.bind(null, "SuVw"));
  }
}, {
  path: '/my/mobile/edit',
  name: 'MyMobileEdit',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(132)]).then(__webpack_require__.bind(null, "OIcR"));
  }
}, {
  path: '/my/mobile2/edit',
  name: 'MyMobile2Edit',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(154)]).then(__webpack_require__.bind(null, "FG00"));
  }
}];

/* harmony default export */ var my = (myRouter);
// CONCATENATED MODULE: ./src/router/modules/user.js
var userRouter = [{
  path: '/user/rich',
  name: 'UserRich',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(139)]).then(__webpack_require__.bind(null, "jXjz"));
  }
}, {
  path: '/user/ticket/record',
  name: 'UserTicketRecord',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(119)]).then(__webpack_require__.bind(null, "4Dcq"));
  }
}, {
  path: '/user/:id(\\d+)',
  name: 'UserDetail',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(9)]).then(__webpack_require__.bind(null, "yW15"));
  }
}, {
  path: '/user/fav',
  name: 'UserFav',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(126)]).then(__webpack_require__.bind(null, "kHoq"));
  }
}];

/* harmony default export */ var user = (userRouter);
// CONCATENATED MODULE: ./src/router/modules/survey.js
var surveyRouter = [{
  path: '/survey/detail/:id(\\d+)',
  name: 'SurveyDetail',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(70)]).then(__webpack_require__.bind(null, "Jsln"));
  }
}, {
  path: '/survey/:id(\\d+)',
  name: 'SurveyBefore',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(104)]).then(__webpack_require__.bind(null, "VePw"));
  }
}, {
  path: '/survey/success',
  name: 'SurveySuccess',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(106)]).then(__webpack_require__.bind(null, "f8ra"));
  }
}, {
  path: '/survey/overdue',
  name: 'SurveyOverdue',
  component: function component() {
    return __webpack_require__.e/* import() */(124).then(__webpack_require__.bind(null, "iaHd"));
  }
}];

/* harmony default export */ var survey = (surveyRouter);
// CONCATENATED MODULE: ./src/router/modules/card.js
var cardRouter = [{
  path: '/card',
  name: 'CardIndex',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(168)]).then(__webpack_require__.bind(null, "bWPM"));
  }
}, {
  path: '/card/:id(\\d+)/:key',
  name: 'CardDetailKey',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(__webpack_require__.bind(null, "CBkU"));
  }
}, {
  path: '/card/:id(\\d+)',
  name: 'CardDetail',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(__webpack_require__.bind(null, "CBkU"));
  }
}, {
  path: '/card/exchange',
  name: 'CardExchange',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(13)]).then(__webpack_require__.bind(null, "I2fW"));
  }
}, {
  path: '/card/custom',
  name: 'CardCustom',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(199)]).then(__webpack_require__.bind(null, "iPDi"));
  }
}, {
  path: '/card/ticket',
  name: 'CardTicket',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(146)]).then(__webpack_require__.bind(null, "kMPA"));
  }
}];

/* harmony default export */ var card = (cardRouter);
// CONCATENATED MODULE: ./src/router/modules/activity.js
var activityRouter = [{
  path: '/activity/:id(\\d+)',
  name: 'ActivityDetail',
  component: function component() {
    return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, "myIg"));
  }
}];

/* harmony default export */ var activity = (activityRouter);
// CONCATENATED MODULE: ./src/router/modules/admin/ad.js
var adminAdRouter = [{
  path: '/admin/g',
  name: 'AdminAdIndex',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(197)]).then(__webpack_require__.bind(null, "zTzs"));
  }
}, {
  path: '/admin/g/create',
  name: 'AdminAdCreate',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(19)]).then(__webpack_require__.bind(null, "dxai"));
  }
}, {
  path: '/admin/g/edit',
  name: 'AdminAdEdit',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(16)]).then(__webpack_require__.bind(null, "Hdj3"));
  }
}];

/* harmony default export */ var ad = (adminAdRouter);
// CONCATENATED MODULE: ./src/router/modules/admin/expo.js
var adminExpoRouter = [{
  path: '/admin/e',
  name: 'AdminExpoIndex',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(80)]).then(__webpack_require__.bind(null, "UBhs"));
  }
}, {
  path: '/admin/e/create',
  name: 'AdminExpoCreate',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(26)]).then(__webpack_require__.bind(null, "4MN6"));
  }
}, {
  path: '/admin/e/edit',
  name: 'AdminExpoEdit',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(49)]).then(__webpack_require__.bind(null, "e4Mr"));
  }
}, {
  path: '/admin/e/tag',
  name: 'AdminExpoTag',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(141)]).then(__webpack_require__.bind(null, "6snu"));
  }
}, {
  path: '/admin/e/join',
  name: 'AdminExpoJoin',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(200)]).then(__webpack_require__.bind(null, "kNLL"));
  }
}, {
  path: '/admin/e/guest',
  name: 'AdminExpoGuest',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(131)]).then(__webpack_require__.bind(null, "mUkp"));
  }
}, {
  path: '/admin/e/cert',
  name: 'AdminExpoCert',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(177)]).then(__webpack_require__.bind(null, "xpDb"));
  }
}, {
  path: '/admin/e/cg',
  name: 'AdminExpoCg',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(151)]).then(__webpack_require__.bind(null, "3wbW"));
  }
}, {
  path: '/admin/e/ep',
  name: 'AdminExpoEpIndex',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(97)]).then(__webpack_require__.bind(null, "b7UA"));
  }
}, {
  path: '/admin/e/ep/stat',
  name: 'AdminExpoEpStat',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(180)]).then(__webpack_require__.bind(null, "c09b"));
  }
}, {
  path: '/admin/e/ep/export',
  name: 'AdminExpoEpExport',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(214)]).then(__webpack_require__.bind(null, "eGGC"));
  }
}];

/* harmony default export */ var admin_expo = (adminExpoRouter);
// CONCATENATED MODULE: ./src/router/modules/admin/sign.js
var adminSignRouter = [{
  path: '/admin/sign',
  name: 'AdminSignIndex',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(96)]).then(__webpack_require__.bind(null, "xCAM"));
  }
}, {
  path: '/admin/sign/create',
  name: 'AdminSignCreate',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(18)]).then(__webpack_require__.bind(null, "sCLq"));
  }
}, {
  path: '/admin/sign/edit',
  name: 'AdminSignEdit',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(17)]).then(__webpack_require__.bind(null, "Nbic"));
  }
}, {
  path: '/admin/sign/result',
  name: 'AdminSignResult',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(78)]).then(__webpack_require__.bind(null, "5ZO+"));
  }
}, {
  path: '/admin/sign/link',
  name: 'AdminSignLink',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(153)]).then(__webpack_require__.bind(null, "wOw7"));
  }
}, {
  path: '/admin/sign/verify',
  name: 'AdminSignVerify',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(118)]).then(__webpack_require__.bind(null, "dAlp"));
  }
}, {
  path: '/admin/sign/printer',
  name: 'AdminSignPrinter',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(115)]).then(__webpack_require__.bind(null, "X17k"));
  }
}, {
  path: '/admin/sign/member/create',
  name: 'AdminSignMemberCreate',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(75)]).then(__webpack_require__.bind(null, "zeTE"));
  }
}];

/* harmony default export */ var sign = (adminSignRouter);
// CONCATENATED MODULE: ./src/router/modules/admin/survey.js
var adminSurveyRouter = [{
  path: '/admin/survey',
  name: 'AdminSurveyIndex',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(92)]).then(__webpack_require__.bind(null, "E50G"));
  }
}, {
  path: '/admin/survey/create',
  name: 'AdminSurveyCreate',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(48)]).then(__webpack_require__.bind(null, "DVrI"));
  }
}, {
  path: '/admin/survey/edit',
  name: 'AdminSurveyEdit',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(42)]).then(__webpack_require__.bind(null, "ufdX"));
  }
}, {
  path: '/admin/survey/link',
  name: 'AdminSurveyLink',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(150)]).then(__webpack_require__.bind(null, "njr3"));
  }
}, {
  path: '/admin/survey/result',
  name: 'AdminSurveyResult',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(174)]).then(__webpack_require__.bind(null, "cyYC"));
  }
}];

/* harmony default export */ var admin_survey = (adminSurveyRouter);
// CONCATENATED MODULE: ./src/router/modules/admin/meeting.js
var adminMeetingRouter = [{
  path: '/admin/m',
  name: 'AdminMeetingIndex',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(40)]).then(__webpack_require__.bind(null, "aZ4L"));
  }
}, {
  path: '/admin/m/create',
  name: 'AdminMeetingCreate',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(61)]).then(__webpack_require__.bind(null, "eiBV"));
  }
}, {
  path: '/admin/m/edit',
  name: 'AdminMeetingEdit',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(30)]).then(__webpack_require__.bind(null, "6jfK"));
  }
}, {
  path: '/admin/m/link',
  name: 'AdminMeetingLink',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(164)]).then(__webpack_require__.bind(null, "5hSK"));
  }
}, {
  path: '/admin/m/member/statistics',
  name: 'AdminMeetingMemberStatistics',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(105)]).then(__webpack_require__.bind(null, "BMfQ"));
  }
}, {
  path: '/admin/m/track',
  name: 'AdminMeetingTrack',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(137)]).then(__webpack_require__.bind(null, "FQs9"));
  }
}, {
  path: '/admin/m/track/cg',
  name: 'AdminMeetingTrackCg',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(120)]).then(__webpack_require__.bind(null, "E9no"));
  }
}, {
  path: '/admin/m/member',
  name: 'AdminMeetingMember',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(23)]).then(__webpack_require__.bind(null, "csZc"));
  }
}, {
  path: '/admin/m/member/create',
  name: 'AdminMeetingMemberCreate',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(74)]).then(__webpack_require__.bind(null, "zAqK"));
  }
}, {
  path: '/admin/m/member/multi_create',
  name: 'AdminMeetingMemberMultiCreate',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(187)]).then(__webpack_require__.bind(null, "OTpF"));
  }
}, {
  path: '/admin/m/member/log',
  name: 'AdminMeetingMemberLog',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(176)]).then(__webpack_require__.bind(null, "zZoS"));
  }
}, {
  path: '/admin/m/member/track',
  name: 'AdminMeetingMemberTrack',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(122)]).then(__webpack_require__.bind(null, "0kUV"));
  }
}, {
  path: '/admin/m/signer',
  name: 'AdminMeetingSigner',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(98)]).then(__webpack_require__.bind(null, "tSFM"));
  }
}, {
  path: '/admin/m/apply',
  name: 'AdminMeetingApply',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(133)]).then(__webpack_require__.bind(null, "xP32"));
  }
}, {
  path: '/admin/m/seat/conf',
  name: 'AdminMeetingSeatConf',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(210)]).then(__webpack_require__.bind(null, "03Au"));
  }
}, {
  path: '/admin/m/printer',
  name: 'AdminMeetingPrinter',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(175)]).then(__webpack_require__.bind(null, "u5PG"));
  }
}];

/* harmony default export */ var admin_meeting = (adminMeetingRouter);
// CONCATENATED MODULE: ./src/router/modules/admin/card.js
var adminCardRouter = [{
  path: '/admin/card',
  name: 'AdminCardIndex',
  component: function component() {
    return __webpack_require__.e/* import() */(114).then(__webpack_require__.bind(null, "A8A8"));
  }
}, {
  path: '/admin/card/stat',
  name: 'AdminCardStat',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(113)]).then(__webpack_require__.bind(null, "NBrP"));
  }
}];

/* harmony default export */ var admin_card = (adminCardRouter);
// CONCATENATED MODULE: ./src/router/modules/admin/download.js
var adminDownloadRouter = [{
  path: '/admin/download',
  name: 'AdminDownloadIndex',
  component: function component() {
    return __webpack_require__.e/* import() */(79).then(__webpack_require__.bind(null, "C3MC"));
  }
}, {
  path: '/admin/download/csv',
  name: 'AdminDownloadCsv',
  component: function component() {
    return __webpack_require__.e/* import() */(102).then(__webpack_require__.bind(null, "OdR8"));
  }
}];

/* harmony default export */ var download = (adminDownloadRouter);
// CONCATENATED MODULE: ./src/router/modules/admin/form.js
var adminFormRouter = [{
  path: '/admin/form',
  name: 'AdminFormIndex',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(100)]).then(__webpack_require__.bind(null, "Krj5"));
  }
}, {
  path: '/admin/form/create',
  name: 'AdminFormCreate',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(44)]).then(__webpack_require__.bind(null, "AEWt"));
  }
}, {
  path: '/admin/form/edit',
  name: 'AdminFormEdit',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(54)]).then(__webpack_require__.bind(null, "u1ou"));
  }
}, {
  path: '/admin/form/record',
  name: 'AdminFormRecord',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(73)]).then(__webpack_require__.bind(null, "/Yov"));
  }
}, {
  path: '/admin/form/stat',
  name: 'AdminFormStat',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(218)]).then(__webpack_require__.bind(null, "CPwW"));
  }
}, {
  path: '/admin/form/option',
  name: 'AdminFormOption',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(123)]).then(__webpack_require__.bind(null, "hs1n"));
  }
}];

/* harmony default export */ var admin_form = (adminFormRouter);
// CONCATENATED MODULE: ./src/router/modules/admin/link.js
var adminLinkRouter = [{
  path: '/admin/link',
  name: 'AdminLinkIndex',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(208)]).then(__webpack_require__.bind(null, "RbSU"));
  }
}, {
  path: '/admin/link/create',
  name: 'AdminLinkCreate',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(31)]).then(__webpack_require__.bind(null, "WkjS"));
  }
}, {
  path: '/admin/link/edit',
  name: 'AdminLinkEdit',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(33)]).then(__webpack_require__.bind(null, "yN2d"));
  }
}];

/* harmony default export */ var admin_link = (adminLinkRouter);
// CONCATENATED MODULE: ./src/router/modules/admin/video.js
var adminVideoRouter = [{
  path: '/admin/video',
  name: 'AdminVideoIndex',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(86)]).then(__webpack_require__.bind(null, "8UK9"));
  }
}, {
  path: '/admin/video/create',
  name: 'AdminVideoCreate',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(181)]).then(__webpack_require__.bind(null, "tn7o"));
  }
}, {
  path: '/admin/video/edit',
  name: 'AdminVideoEdit',
  component: function component() {
    return __webpack_require__.e/* import() */(192).then(__webpack_require__.bind(null, "yHdn"));
  }
}, {
  path: '/admin/video/viewer',
  name: 'AdminVideoViewer',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(206)]).then(__webpack_require__.bind(null, "pGBM"));
  }
}];

/* harmony default export */ var admin_video = (adminVideoRouter);
// CONCATENATED MODULE: ./src/router/modules/admin/index.js
var adminIndexRouter = [{
  path: '/admin',
  name: 'AdminIndex',
  component: function component() {
    return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "x0vE"));
  }
}, {
  path: '/admin/apply',
  name: 'AdminApply',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(157)]).then(__webpack_require__.bind(null, "WMKi"));
  }
}, {
  path: '/admin/list',
  name: 'AdminList',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(81)]).then(__webpack_require__.bind(null, "JEU3"));
  }
}, {
  path: '/admin/log',
  name: 'AdminLog',
  component: function component() {
    return __webpack_require__.e/* import() */(178).then(__webpack_require__.bind(null, "rSC+"));
  }
}, {
  path: '/admin/visit',
  name: 'AdminVisit',
  component: function component() {
    return __webpack_require__.e/* import() */(134).then(__webpack_require__.bind(null, "LlnY"));
  }
}, {
  path: '/admin/statistics/flow',
  name: 'AdminStatisticsFlow',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(182)]).then(__webpack_require__.bind(null, "ImXW"));
  }
}, {
  path: '/admin/statistics/client',
  name: 'AdminStatisticsClient',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(171)]).then(__webpack_require__.bind(null, "9vIr"));
  }
}, {
  path: '/admin/statistics/client_ref',
  name: 'AdminStatisticsClientRef',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(99)]).then(__webpack_require__.bind(null, "FIuF"));
  }
}, {
  path: '/admin/statistics/sign',
  name: 'AdminStatisticsSign',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(215)]).then(__webpack_require__.bind(null, "ixIF"));
  }
}, {
  path: '/admin/order/index',
  name: 'AdminOrderIndex',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(11)]).then(__webpack_require__.bind(null, "z33s"));
  }
}, {
  path: '/admin/order/stat',
  name: 'AdminOrderStat',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(112)]).then(__webpack_require__.bind(null, "/tbk"));
  }
}, {
  path: '/admin/setting',
  name: 'AdminSetting',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(111)]).then(__webpack_require__.bind(null, "lUxu"));
  }
}, {
  path: '/admin/debug',
  name: 'AdminDebug',
  component: function component() {
    return __webpack_require__.e/* import() */(195).then(__webpack_require__.bind(null, "0jNv"));
  }
}, {
  path: '/admin/tag',
  name: 'AdminTagIndex',
  component: function component() {
    return __webpack_require__.e/* import() */(159).then(__webpack_require__.bind(null, "x+k4"));
  }
}];

/* harmony default export */ var admin = (adminIndexRouter);
// CONCATENATED MODULE: ./src/router/modules/admin/printer.js
var adminPrinterRouter = [{
  path: '/admin/printer',
  name: 'AdminPrinterIndex',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(147)]).then(__webpack_require__.bind(null, "2I4S"));
  }
}];

/* harmony default export */ var printer = (adminPrinterRouter);
// CONCATENATED MODULE: ./src/router/modules/admin/live.js
var adminLiveRouter = [{
  path: '/admin/live',
  name: 'AdminLiveIndex',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(91)]).then(__webpack_require__.bind(null, "O3cy"));
  }
}, {
  path: '/admin/live/create',
  name: 'AdminLiveCreate',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(56)]).then(__webpack_require__.bind(null, "i5nE"));
  }
}, {
  path: '/admin/live/edit',
  name: 'AdminLiveEdit',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(34)]).then(__webpack_require__.bind(null, "qzzm"));
  }
}, {
  path: '/admin/live/link',
  name: 'AdminLiveLink',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(135)]).then(__webpack_require__.bind(null, "ojlJ"));
  }
}, {
  path: '/admin/live/manager',
  name: 'AdminLiveManager',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(85)]).then(__webpack_require__.bind(null, "aYls"));
  }
}, {
  path: '/admin/live/viewer',
  name: 'AdminLiveViewer',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(138)]).then(__webpack_require__.bind(null, "isk9"));
  }
}];

/* harmony default export */ var live = (adminLiveRouter);
// CONCATENATED MODULE: ./src/router/modules/admin/subscribe.js
var adminSubscribeRouter = [{
  path: '/admin/subscribe',
  name: 'AdminSubscribe',
  component: function component() {
    return __webpack_require__.e/* import() */(110).then(__webpack_require__.bind(null, "zOzA"));
  }
}];

/* harmony default export */ var subscribe = (adminSubscribeRouter);
// CONCATENATED MODULE: ./src/router/modules/order.js
var orderRouter = [{
  path: '/order/pay',
  name: 'OrderPay',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(129)]).then(__webpack_require__.bind(null, "0/mr"));
  }
}, {
  path: '/order/pay/offline',
  name: 'OrderPayOffline',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(166)]).then(__webpack_require__.bind(null, "AhDL"));
  }
}, {
  path: '/order/pay/success',
  name: 'OrderPaySuccess',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(198)]).then(__webpack_require__.bind(null, "L3os"));
  }
}];

/* harmony default export */ var order = (orderRouter);
// CONCATENATED MODULE: ./src/router/modules/contacts.js
var contactsRouter = [{
  path: '/contacts',
  name: 'ContactsIndex',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(37)]).then(__webpack_require__.bind(null, "41Rh"));
  }
},
// {
//   path: '/contacts/control',
//   name: 'ContactsControl',
//   component: () => import('@/views/contacts/control')
// },
{
  path: '/contacts/:id(\\d+)',
  name: 'ContactsDetail',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(3)]).then(__webpack_require__.bind(null, "0wur"));
  }
}, {
  path: '/contacts/join_success',
  name: 'ContactsJoinSuccess',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(186)]).then(__webpack_require__.bind(null, "F8B9"));
  }
}, {
  path: '/contacts/view',
  name: 'ContactsView',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(161)]).then(__webpack_require__.bind(null, "zf2W"));
  }
}, {
  path: '/contacts/ticket',
  name: 'ContactsTicket',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(213)]).then(__webpack_require__.bind(null, "nrgo"));
  }
}, {
  path: '/contacts/invite',
  name: 'ContactsInvite',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(47)]).then(__webpack_require__.bind(null, "jBez"));
  }
}, {
  path: '/contacts/ref',
  name: 'ContactsRef',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(93)]).then(__webpack_require__.bind(null, "nCTr"));
  }
}];

/* harmony default export */ var contacts = (contactsRouter);
// CONCATENATED MODULE: ./src/router/modules/lucky.js
var luckyRouter = [{
  path: '/lucky/:id(\\d+)',
  name: 'LuckyDetail',
  component: function component() {
    return __webpack_require__.e/* import() */(64).then(__webpack_require__.bind(null, "im8V"));
  }
}, {
  path: '/lucky/dashboard/:id(\\d+)',
  name: 'LuckyDashboard',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(22)]).then(__webpack_require__.bind(null, "Q/iU"));
  }
}];
/* harmony default export */ var lucky = (luckyRouter);
// CONCATENATED MODULE: ./src/router/modules/library.js
var libraryRouter = [{
  path: '/library/:id(\\d+)',
  name: 'LibraryDetail',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(173)]).then(__webpack_require__.bind(null, "pAzi"));
  }
}];
/* harmony default export */ var library = (libraryRouter);
// CONCATENATED MODULE: ./src/router/modules/live.js
var live_libraryRouter = [{
  path: '/live/preview/:id(\\d+)',
  name: 'LivePreview',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(117)]).then(__webpack_require__.bind(null, "xkuT"));
  }
}, {
  path: '/live/:id(\\d+)',
  name: 'LiveDetail',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(77)]).then(__webpack_require__.bind(null, "a0HI"));
  }
}, {
  path: '/live/apply/:id(\\d+)',
  name: 'LiveApply',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(189)]).then(__webpack_require__.bind(null, "Z2Uz"));
  }
}];
/* harmony default export */ var modules_live = (live_libraryRouter);
// CONCATENATED MODULE: ./src/router/modules/admin/activity.js
var adminActivityRouter = [{
  path: '/admin/activity',
  name: 'AdminActivityIndex',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(84)]).then(__webpack_require__.bind(null, "r9ZP"));
  }
}, {
  path: '/admin/activity/create',
  name: 'AdminActivityCreate',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(51)]).then(__webpack_require__.bind(null, "7ENu"));
  }
}, {
  path: '/admin/activity/edit',
  name: 'AdminActivityEdit',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(50)]).then(__webpack_require__.bind(null, "n8uR"));
  }
}, {
  path: '/admin/activity/link',
  name: 'AdminActivityLink',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(179)]).then(__webpack_require__.bind(null, "UDde"));
  }
}, {
  path: '/admin/activity/picture',
  name: 'AdminActivityPictureIndex',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(163)]).then(__webpack_require__.bind(null, "73ry"));
  }
}, {
  path: '/admin/activity/picture/create',
  name: 'AdminActivityPictureCreate',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(121)]).then(__webpack_require__.bind(null, "ZGhn"));
  }
}];

/* harmony default export */ var admin_activity = (adminActivityRouter);
// CONCATENATED MODULE: ./src/router/modules/admin/contacts.js
var adminContactsRouter = [{
  path: '/admin/contacts',
  name: 'AdminContactsIndex',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(67)]).then(__webpack_require__.bind(null, "oS+U"));
  }
}, {
  path: '/admin/contacts/create',
  name: 'AdminContactsCreate',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(41)]).then(__webpack_require__.bind(null, "6vgk"));
  }
}, {
  path: '/admin/contacts/edit',
  name: 'AdminContactsEdit',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(35)]).then(__webpack_require__.bind(null, "rVmH"));
  }
}, {
  path: '/admin/contacts/control',
  name: 'AdminContactsControl',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(14)]).then(__webpack_require__.bind(null, "LqJy"));
  }
}, {
  path: '/admin/contacts/vip',
  name: 'AdminContactsVip',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(203)]).then(__webpack_require__.bind(null, "7onD"));
  }
}, {
  path: '/admin/contacts/member/index',
  name: 'AdminContactsMemberIndex',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(43)]).then(__webpack_require__.bind(null, "7T1a"));
  }
}, {
  path: '/admin/contacts/news/index',
  name: 'AdminContactsNewsIndex',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(184)]).then(__webpack_require__.bind(null, "0MFh"));
  }
}, {
  path: '/admin/contacts/link',
  name: 'AdminContactsLink',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(207)]).then(__webpack_require__.bind(null, "fGRQ"));
  }
}, {
  path: '/admin/contacts/custom',
  name: 'AdminContactsCustom',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(212)]).then(__webpack_require__.bind(null, "XxNj"));
  }
}];

/* harmony default export */ var admin_contacts = (adminContactsRouter);
// CONCATENATED MODULE: ./src/router/modules/admin/lucky.js
var adminLuckyRouter = [{
  path: '/admin/lucky',
  name: 'AdminLuckyIndex',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(95)]).then(__webpack_require__.bind(null, "rguv"));
  }
}, {
  path: '/admin/lucky/create',
  name: 'AdminLuckyCreate',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(60)]).then(__webpack_require__.bind(null, "LuqC"));
  }
}, {
  path: '/admin/lucky/edit',
  name: 'AdminLuckyEdit',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(59)]).then(__webpack_require__.bind(null, "cW/y"));
  }
}, {
  path: '/admin/lucky/link',
  name: 'AdminLuckyLink',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(209)]).then(__webpack_require__.bind(null, "ZknU"));
  }
}, {
  path: '/admin/lucky/result',
  name: 'AdminLuckyResult',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(136)]).then(__webpack_require__.bind(null, "6xS7"));
  }
}];
/* harmony default export */ var admin_lucky = (adminLuckyRouter);
// CONCATENATED MODULE: ./src/router/modules/admin/library.js
var adminLibraryRouter = [{
  path: '/admin/library',
  name: 'AdminLibraryIndex',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(63)]).then(__webpack_require__.bind(null, "y/hf"));
  }
}, {
  path: '/admin/library/create',
  name: 'AdminLibraryCreate',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(58)]).then(__webpack_require__.bind(null, "gWdT"));
  }
}, {
  path: '/admin/library/edit',
  name: 'AdminLibraryEdit',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(29)]).then(__webpack_require__.bind(null, "C6Kn"));
  }
}, {
  path: '/admin/library/link',
  name: 'AdminLibraryLink',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(216)]).then(__webpack_require__.bind(null, "ILig"));
  }
}, {
  path: '/admin/library/stat',
  name: 'AdminLibraryStat',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(145)]).then(__webpack_require__.bind(null, "nYd3"));
  }
}];

/* harmony default export */ var admin_library = (adminLibraryRouter);
// CONCATENATED MODULE: ./src/router/modules/admin/wp.js
var adminWpRouter = [{
  path: '/admin/wp',
  name: 'AdminWpIndex',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(83)]).then(__webpack_require__.bind(null, "jbc+"));
  }
}, {
  path: '/admin/wp/create',
  name: 'AdminWpCreate',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(46)]).then(__webpack_require__.bind(null, "H46K"));
  }
}, {
  path: '/admin/wp/edit',
  name: 'AdminWpEdit',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(45)]).then(__webpack_require__.bind(null, "F8QE"));
  }
}];

/* harmony default export */ var wp = (adminWpRouter);
// CONCATENATED MODULE: ./src/router/modules/admin/exhibitor.js
var adminExhibitorRouter = [{
  path: '/admin/exhibitor',
  name: 'AdminExhibitorIndex',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(94)]).then(__webpack_require__.bind(null, "fZod"));
  }
}, {
  path: '/admin/exhibitor/create',
  name: 'AdminExhibitorCreate',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(28)]).then(__webpack_require__.bind(null, "5WZC"));
  }
}, {
  path: '/admin/exhibitor/edit',
  name: 'AdminExhibitorEdit',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(32)]).then(__webpack_require__.bind(null, "nZo6"));
  }
}, {
  path: '/admin/exhibitor/detail',
  name: 'AdminExhibitorDetail',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(160)]).then(__webpack_require__.bind(null, "wkIh"));
  }
}, {
  path: '/admin/exhibitor/track',
  name: 'AdminExhibitorTrack',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(127)]).then(__webpack_require__.bind(null, "Cplk"));
  }
}];

/* harmony default export */ var exhibitor = (adminExhibitorRouter);
// CONCATENATED MODULE: ./src/router/index.js





/* Router Modules */













// import adminNewsRouter from './modules/admin/news'




// import meetingSignRouter from './modules/m_sign'


// import adminMeetingSignRouter from './modules/admin/meetingSign'



// import adminPictureRouter from './modules/admin/pic'















// import adminCertRouter from './modules/admin/cert'


vue_esm["default"].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var router = __webpack_exports__["a"] = (new vue_router_esm["a" /* default */]({
  mode: 'history', // require service support
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: [{
    path: '/',
    redirect: store["a" /* default */].getters.token ? '/contacts' : '/t'
  },
  // {
  //   path: '/redirect',
  //   name: 'Redirect',
  //   component: () => import('@/views/error/redirect')
  // },
  {
    path: '/logout',
    name: 'Logout',
    component: function component() {
      return __webpack_require__.e/* import() */(191).then(__webpack_require__.bind(null, "PNMN"));
    }
  }, {
    path: '/login',
    name: 'Login',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(76)]).then(__webpack_require__.bind(null, "N/Di"));
    }
  }, {
    path: '/register',
    name: 'Register',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(149)]).then(__webpack_require__.bind(null, "NBc0"));
    }
  }, {
    path: '/login1',
    name: 'Login1',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(66)]).then(__webpack_require__.bind(null, "/ii5"));
    }
  }, {
    path: '/register1',
    name: 'Register1',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(90)]).then(__webpack_require__.bind(null, "v3/b"));
    }
  }].concat(toConsumableArray_default()(modules_link), toConsumableArray_default()(news), toConsumableArray_default()(video), toConsumableArray_default()(meeting), toConsumableArray_default()(modules_form), toConsumableArray_default()(topic), toConsumableArray_default()(expo), toConsumableArray_default()(vip), toConsumableArray_default()(user), toConsumableArray_default()(card), toConsumableArray_default()(order), toConsumableArray_default()(lucky), toConsumableArray_default()(library), toConsumableArray_default()(contacts), toConsumableArray_default()(my), toConsumableArray_default()(survey), toConsumableArray_default()(activity), toConsumableArray_default()(modules_live), toConsumableArray_default()(admin), toConsumableArray_default()(exhibitor), toConsumableArray_default()(ad), toConsumableArray_default()(admin_expo), toConsumableArray_default()(sign), toConsumableArray_default()(admin_survey), toConsumableArray_default()(admin_meeting), toConsumableArray_default()(download), toConsumableArray_default()(admin_video), toConsumableArray_default()(printer), toConsumableArray_default()(admin_activity), toConsumableArray_default()(live), toConsumableArray_default()(admin_contacts), toConsumableArray_default()(admin_lucky), toConsumableArray_default()(admin_library), toConsumableArray_default()(admin_form), toConsumableArray_default()(admin_link), toConsumableArray_default()(subscribe), toConsumableArray_default()(admin_card), toConsumableArray_default()(wp), [
  // ...adminCertRouter,
  {
    path: '/sign/:id(\\d+)',
    name: 'SignDetail',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(143)]).then(__webpack_require__.bind(null, "1HyW"));
    }
  }, {
    path: '/sign/:id(\\d+)/yes',
    name: 'SignDetailYes',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(144)]).then(__webpack_require__.bind(null, "AIa/"));
    }
  }, {
    path: '/sign/:sign_id(\\d+)/:user_id(\\d+)',
    name: 'SignView',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(155)]).then(__webpack_require__.bind(null, "QmWc"));
    }
  }, {
    path: '/sign/result',
    name: 'SignResult',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(87)]).then(__webpack_require__.bind(null, "hFMK"));
    }
  }, {
    path: '/s',
    name: 'SearchIndex',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(5)]).then(__webpack_require__.bind(null, "Rv23"));
    }
  }, {
    path: '/s/e',
    name: 'SearchExpo',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(52)]).then(__webpack_require__.bind(null, "oD6r"));
    }
  }, {
    path: '/v/:id',
    redirect: '/e/:id'
  }, {
    path: '/contacts/index',
    redirect: '/contacts'
  }, {
    path: '/c/:id',
    redirect: function redirect(to) {
      var params = to.params,
          query = to.query;

      if (query.return_vid) {
        return {
          name: 'EpDetail',
          params: { id: params.id },
          query: { expo: query.return_vid }
        };
      } else {
        return {
          name: 'EpDetail',
          params: { id: params.id }
        };
      }
    }
  }, {
    path: '/term',
    name: 'Term',
    component: function component() {
      return __webpack_require__.e/* import() */(185).then(__webpack_require__.bind(null, "Xmrc"));
    }
  }, {
    path: '/wx_notice',
    name: 'WxNotice',
    component: function component() {
      return __webpack_require__.e/* import() */(194).then(__webpack_require__.bind(null, "kYFw"));
    }
  }, {
    path: '/file_preview',
    name: 'FilePreview',
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(103)]).then(__webpack_require__.bind(null, "Q3mS"));
    }
  }, {
    path: '/download',
    name: 'FileDownload',
    component: function component() {
      return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, "7RVW"));
    }
  }, {
    path: '/confirm_mobile',
    name: 'ConfirmMobile',
    component: function component() {
      return __webpack_require__.e/* import() */(211).then(__webpack_require__.bind(null, "cofd"));
    }
  }, {
    path: '/403',
    name: '403',
    component: function component() {
      return __webpack_require__.e/* import() */(219).then(__webpack_require__.bind(null, "eeAK"));
    }
  }, {
    path: '/404',
    name: '404',
    component: function component() {
      return __webpack_require__.e/* import() */(107).then(__webpack_require__.bind(null, "34W9"));
    }
  }, {
    path: '/test',
    name: 'Test',
    meta: {
      keepAlive: true
    },
    component: function component() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(152)]).then(__webpack_require__.bind(null, "khAq"));
    }
  }, { path: '*', redirect: '/404', hidden: true }])
}));

/***/ }),

/***/ "YqUT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YxJB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var flexbox = ({
  name: 'flexbox',
  props: {
    gutter: {
      type: Number,
      default: 8
    },
    orient: {
      type: String,
      default: 'horizontal'
    },
    justify: String,
    align: String,
    wrap: String,
    direction: String
  },
  computed: {
    styles: function styles() {
      var styles = {
        'justify-content': this.justify,
        '-webkit-justify-content': this.justify,
        'align-items': this.align,
        '-webkit-align-items': this.align,
        'flex-wrap': this.wrap,
        '-webkit-flex-wrap': this.wrap,
        'flex-direction': this.direction,
        '-webkit-flex-direction': this.direction
      };
      return styles;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var flexbox_flexbox = ({
  name: 'flexbox',
  props: {
    gutter: {
      type: Number,
      default: 8
    },
    orient: {
      type: String,
      default: 'horizontal'
    },
    justify: String,
    align: String,
    wrap: String,
    direction: String
  },
  computed: {
    styles: function styles() {
      var styles = {
        'justify-content': this.justify,
        '-webkit-justify-content': this.justify,
        'align-items': this.align,
        '-webkit-align-items': this.align,
        'flex-wrap': this.wrap,
        '-webkit-flex-wrap': this.wrap,
        'flex-direction': this.direction,
        '-webkit-flex-direction': this.direction
      };
      return styles;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f37d428","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/flexbox/flexbox.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-flexbox",class:{
  'vux-flex-col': _vm.orient === 'vertical',
  'vux-flex-row': _vm.orient === 'horizontal'
},style:(_vm.styles)},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_flexbox_flexbox = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/flexbox/flexbox.vue
function injectStyle (ssrContext) {
  __webpack_require__("M5Ib")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  flexbox_flexbox,
  components_flexbox_flexbox,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_flexbox_flexbox = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZLZR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "a4Np":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aFVK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addOauthPath;
/* harmony export (immutable) */ __webpack_exports__["b"] = addQueryPath;
/* harmony export (immutable) */ __webpack_exports__["c"] = deepClone;
/* unused harmony export toPrecision */
/* harmony export (immutable) */ __webpack_exports__["d"] = statusFilter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_my__ = __webpack_require__("3VVt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_admin_index__ = __webpack_require__("tRmb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vux_src_tools_querystring_index_js__ = __webpack_require__("Wqb0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_compressorjs__ = __webpack_require__("Sm12");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_compressorjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_compressorjs__);











function addOauthPath(path, query) {
  var queryDict = null;
  if ((typeof query === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(query)) === 'object') {
    queryDict = query;
  } else {
    queryDict = __WEBPACK_IMPORTED_MODULE_7_vux_src_tools_querystring_index_js__["a" /* default */].parse(query);
  }
  queryDict['oauth'] = 1;
  return path + encodeURIComponent('?' + __WEBPACK_IMPORTED_MODULE_7_vux_src_tools_querystring_index_js__["a" /* default */].stringify(queryDict));
}

function addQueryPath(path, query, addQuery) {
  var queryDict = null;
  if ((typeof query === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(query)) === 'object') {
    queryDict = query;
  } else {
    queryDict = __WEBPACK_IMPORTED_MODULE_7_vux_src_tools_querystring_index_js__["a" /* default */].parse(query);
  }
  queryDict = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(query, addQuery);
  return path + '?' + __WEBPACK_IMPORTED_MODULE_7_vux_src_tools_querystring_index_js__["a" /* default */].stringify(queryDict);
}

function deepClone(source) {
  if (!source && (typeof source === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(source)) !== 'object') {
    throw new Error('error arguments', 'shallowClone');
  }
  var targetObj = source.constructor === Array ? [] : {};
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(source).forEach(function (keys) {
    if (source[keys] && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(source[keys]) === 'object') {
      targetObj[keys] = deepClone(source[keys]);
    } else {
      targetObj[keys] = source[keys];
    }
  });
  return targetObj;
}

__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.callCustomerService = function () {
  location.href = 'tel:18666186648';
};

__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.transferLink = function (content) {
  var admin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var reg = null;
  if (admin === 1 || admin === 2) {
    reg = /((http|https):\/\/)[\w\-_]+(\.[\w\-_]+)+([\w\-.,@?^=%&:/~+#]*[\w\-@?^=%&/~+#])?/ig;
  } else {
    reg = /(https:\/\/|http:\/\/)*[a-z0-9]+\.aibang360\.com(\/[a-z0-9&=?/_%.]*)*/ig;
  }
  var newString = content.replace(reg, function (match) {
    if (match.startsWith('http') || match.startsWith('https')) {
      return '<a href="' + match + '">' + match + '</a>';
    } else {
      return '<a href="https://' + match + '">' + match + '</a>';
    }
  });
  var hideReg = /(\[hide\])+/ig;
  newString = newString.replace(hideReg, function (match) {
    return '<span class="hide-tag"> \u9690\u85CF\u5185\u5BB9\u56DE\u590D\u53EF\u89C1 </span>';
  });
  var mobileReg = /1[0-9]{10}/;
  newString = newString.replace(mobileReg, function (match) {
    return '<a href="tel:' + match + '">' + match + '</a>';
  });
  return newString;
};

__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.uploadImage = function (image) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

    new __WEBPACK_IMPORTED_MODULE_8_compressorjs___default.a(image, {
      quality: 0.8,
      success: function success(rst) {
        Object(__WEBPACK_IMPORTED_MODULE_5__api_my__["v" /* uploadImage */])(rst).then(function (res) {
          resolve({ 'rst': res.data.rst.url });
        }).catch(function (err) {
          reject(err);
        });
      }
    });
  });
};

__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.uploadExpoImage = function (image) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

    new __WEBPACK_IMPORTED_MODULE_8_compressorjs___default.a(image, {
      quality: 0.8,
      success: function success(rst) {
        Object(__WEBPACK_IMPORTED_MODULE_5__api_my__["u" /* uploadExpoImage */])(rst).then(function (res) {
          resolve({ 'rst': res.data.rst.url });
        }).catch(function (err) {
          reject(err);
        });
      }
    });
  });
};

__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.uploadAdminImage = function (image) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

    new __WEBPACK_IMPORTED_MODULE_8_compressorjs___default.a(image, {
      quality: 0.8,
      success: function success(rst) {
        Object(__WEBPACK_IMPORTED_MODULE_6__api_admin_index__["h" /* uploadAdminImage */])(rst).then(function (res) {
          resolve({ 'rst': res.data.rst.url });
        }).catch(function (err) {
          reject(err);
        });
      }
    });
  });
};

__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.transferTradition = function (string) {
  var simpPYStr = '啊阿埃挨哎唉哀皑癌蔼矮艾碍爱隘鞍氨安俺按暗岸胺案肮昂盎凹敖熬翱袄傲奥懊澳芭捌扒叭吧笆八疤巴拔跋靶把耙坝霸罢爸白柏百摆佰败拜稗斑班搬扳般颁板版扮拌伴瓣半办绊邦帮梆榜膀绑棒磅蚌镑傍谤苞胞包褒剥薄雹保堡饱宝抱报暴豹鲍爆杯碑悲卑北辈背贝钡倍狈备惫焙被奔苯本笨崩绷甭泵蹦迸逼鼻比鄙笔彼碧蓖蔽毕毙毖币庇痹闭敝弊必辟壁臂避陛鞭边编贬扁便变卞辨辩辫遍标彪膘表鳖憋别瘪彬斌濒滨宾摈兵冰柄丙秉饼炳病并玻菠播拨钵波博勃搏铂箔伯帛舶脖膊渤泊驳捕卜哺补埠不布步簿部怖擦猜裁材才财睬踩采彩菜蔡餐参蚕残惭惨灿苍舱仓沧藏操糙槽曹草厕策侧册测层蹭插叉茬茶查碴搽察岔差诧拆柴豺搀掺蝉馋谗缠铲产阐颤昌猖场尝常长偿肠厂敞畅唱倡超抄钞朝嘲潮巢吵炒车扯撤掣彻澈郴臣辰尘晨忱沉陈趁衬撑称城橙成呈乘程惩澄诚承逞骋秤吃痴持匙池迟弛驰耻齿侈尺赤翅斥炽充冲虫崇宠抽酬畴踌稠愁筹仇绸瞅丑臭初出橱厨躇锄雏滁除楚础储矗搐触处揣川穿椽传船喘串疮窗幢床闯创吹炊捶锤垂春椿醇唇淳纯蠢戳绰疵茨磁雌辞慈瓷词此刺赐次聪葱囱匆从丛凑粗醋簇促蹿篡窜摧崔催脆瘁粹淬翠村存寸磋撮搓措挫错搭达答瘩打大呆歹傣戴带殆代贷袋待逮怠耽担丹单郸掸胆旦氮但惮淡诞弹蛋当挡党荡档刀捣蹈倒岛祷导到稻悼道盗德得的蹬灯登等瞪凳邓堤低滴迪敌笛狄涤翟嫡抵底地蒂第帝弟递缔颠掂滇碘点典靛垫电佃甸店惦奠淀殿碉叼雕凋刁掉吊钓调跌爹碟蝶迭谍叠丁盯叮钉顶鼎锭定订丢东冬董懂动栋侗恫冻洞兜抖斗陡豆逗痘都督毒犊独读堵睹赌杜镀肚度渡妒端短锻段断缎堆兑队对墩吨蹲敦顿囤钝盾遁掇哆多夺垛躲朵跺舵剁惰堕蛾峨鹅俄额讹娥恶厄扼遏鄂饿恩而儿耳尔饵洱二贰发罚筏伐乏阀法珐藩帆番翻樊矾钒繁凡烦反返范贩犯饭泛坊芳方肪房防妨仿访纺放菲非啡飞肥匪诽吠肺废沸费芬酚吩氛分纷坟焚汾粉奋份忿愤粪丰封枫蜂峰锋风疯烽逢冯缝讽奉凤佛否夫敷肤孵扶拂辐幅氟符伏俘服浮涪福袱弗甫抚辅俯釜斧脯腑府腐赴副覆赋复傅付阜父腹负富讣附妇缚咐噶嘎该改概钙盖溉干甘杆柑竿肝赶感秆敢赣冈刚钢缸肛纲岗港杠篙皋高膏羔糕搞镐稿告哥歌搁戈鸽胳疙割革葛格蛤阁隔铬个各给根跟耕更庚羹埂耿梗工攻功恭龚供躬公宫弓巩汞拱贡共钩勾沟苟狗垢构购够辜菇咕箍估沽孤姑鼓古蛊骨谷股故顾固雇刮瓜剐寡挂褂乖拐怪棺关官冠观管馆罐惯灌贯光广逛瑰规圭硅归龟闺轨鬼诡癸桂柜跪贵刽辊滚棍锅郭国果裹过哈骸孩海氦亥害骇酣憨邯韩含涵寒函喊罕翰撼捍旱憾悍焊汗汉夯杭航壕嚎豪毫郝好耗号浩呵喝荷菏核禾和何合盒貉阂河涸赫褐鹤贺嘿黑痕很狠恨哼亨横衡恒轰哄烘虹鸿洪宏弘红喉侯猴吼厚候后呼乎忽瑚壶葫胡蝴狐糊湖弧虎唬护互沪户花哗华猾滑画划化话槐徊怀淮坏欢环桓还缓换患唤痪豢焕涣宦幻荒慌黄磺蝗簧皇凰惶煌晃幌恍谎灰挥辉徽恢蛔回毁悔慧卉惠晦贿秽会烩汇讳诲绘荤昏婚魂浑混豁活伙火获或惑霍货祸击圾基机畸稽积箕肌饥迹激讥鸡姬绩缉吉极棘辑籍集及急疾汲即嫉级挤几脊己蓟技冀季伎祭剂悸济寄寂计记既忌际继纪嘉枷夹佳家加荚颊贾甲钾假稼价架驾嫁歼监坚尖笺间煎兼肩艰奸缄茧检柬碱硷拣捡简俭剪减荐槛鉴践贱见键箭件健舰剑饯渐溅涧建僵姜将浆江疆蒋桨奖讲匠酱降蕉椒礁焦胶交郊浇骄娇嚼搅铰矫侥脚狡角饺缴绞剿教酵轿较叫窖揭接皆秸街阶截劫节茎睛晶鲸京惊精粳经井警景颈静境敬镜径痉靖竟竞净炯窘揪究纠玖韭久灸九酒厩救旧臼舅咎就疚鞠拘狙疽居驹菊局咀矩举沮聚拒据巨具距踞锯俱句惧炬剧捐鹃娟倦眷卷绢撅攫抉掘倔爵桔杰捷睫竭洁结解姐戒藉芥界借介疥诫届巾筋斤金今津襟紧锦仅谨进靳晋禁近烬浸尽劲荆兢觉决诀绝均菌钧军君峻俊竣浚郡骏喀咖卡咯开揩楷凯慨刊堪勘坎砍看康慷糠扛抗亢炕考拷烤靠坷苛柯棵磕颗科壳咳可渴克刻客课肯啃垦恳坑吭空恐孔控抠口扣寇枯哭窟苦酷库裤夸垮挎跨胯块筷侩快宽款匡筐狂框矿眶旷况亏盔岿窥葵奎魁傀馈愧溃坤昆捆困括扩廓阔垃拉喇蜡腊辣啦莱来赖蓝婪栏拦篮阑兰澜谰揽览懒缆烂滥琅榔狼廊郎朗浪捞劳牢老佬姥酪烙涝勒乐雷镭蕾磊累儡垒擂肋类泪棱楞冷厘梨犁黎篱狸离漓理李里鲤礼莉荔吏栗丽厉励砾历利傈例俐痢立粒沥隶力璃哩俩联莲连镰廉怜涟帘敛脸链恋炼练粮凉梁粱良两辆量晾亮谅撩聊僚疗燎寥辽潦了撂镣廖料列裂烈劣猎琳林磷霖临邻鳞淋凛赁吝拎玲菱零龄铃伶羚凌灵陵岭领另令溜琉榴硫馏留刘瘤流柳六龙聋咙笼窿隆垄拢陇楼娄搂篓漏陋芦卢颅庐炉掳卤虏鲁麓碌露路赂鹿潞禄录陆戮驴吕铝侣旅履屡缕虑氯律率滤绿峦挛孪滦卵乱掠略抡轮伦仑沦纶论萝螺罗逻锣箩骡裸落洛骆络妈麻玛码蚂马骂嘛吗埋买麦卖迈脉瞒馒蛮满蔓曼慢漫谩芒茫盲氓忙莽猫茅锚毛矛铆卯茂冒帽貌贸么玫枚梅酶霉煤没眉媒镁每美昧寐妹媚门闷们萌蒙檬盟锰猛梦孟眯醚靡糜迷谜弥米秘觅泌蜜密幂棉眠绵冕免勉娩缅面苗描瞄藐秒渺庙妙蔑灭民抿皿敏悯闽明螟鸣铭名命谬摸摹蘑模膜磨摩魔抹末莫墨默沫漠寞陌谋牟某拇牡亩姆母墓暮幕募慕木目睦牧穆拿哪呐钠那娜纳氖乃奶耐奈南男难囊挠脑恼闹淖呢馁内嫩能妮霓倪泥尼拟你匿腻逆溺蔫拈年碾撵捻念娘酿鸟尿捏聂孽啮镊镍涅您柠狞凝宁拧泞牛扭钮纽脓浓农弄奴努怒女暖虐疟挪懦糯诺哦欧鸥殴藕呕偶沤啪趴爬帕怕琶拍排牌徘湃派攀潘盘磐盼畔判叛乓庞旁耪胖抛咆刨炮袍跑泡呸胚培裴赔陪配佩沛喷盆砰抨烹澎彭蓬棚硼篷膨朋鹏捧碰坯砒霹批披劈琵毗啤脾疲皮匹痞僻屁譬篇偏片骗飘漂瓢票撇瞥拼频贫品聘乒坪苹萍平凭瓶评屏坡泼颇婆破魄迫粕剖扑铺仆莆葡菩蒲埔朴圃普浦谱曝瀑期欺栖戚妻七凄漆柒沏其棋奇歧畦崎脐齐旗祈祁骑起岂乞企启契砌器气迄弃汽泣讫掐洽牵扦钎铅千迁签仟谦乾黔钱钳前潜遣浅谴堑嵌欠歉枪呛腔羌墙蔷强抢橇锹敲悄桥瞧乔侨巧鞘撬翘峭俏窍切茄且怯窃钦侵亲秦琴勤芹擒禽寝沁青轻氢倾卿清擎晴氰情顷请庆琼穷秋丘邱球求囚酋泅趋区蛆曲躯屈驱渠取娶龋趣去圈颧权醛泉全痊拳犬券劝缺炔瘸却鹊榷确雀裙群然燃冉染瓤壤攘嚷让饶扰绕惹热壬仁人忍韧任认刃妊纫扔仍日戎茸蓉荣融熔溶容绒冗揉柔肉茹蠕儒孺如辱乳汝入褥软阮蕊瑞锐闰润若弱撒洒萨腮鳃塞赛三叁伞散桑嗓丧搔骚扫嫂瑟色涩森僧莎砂杀刹沙纱傻啥煞筛晒珊苫杉山删煽衫闪陕擅赡膳善汕扇缮墒伤商赏晌上尚裳梢捎稍烧芍勺韶少哨邵绍奢赊蛇舌舍赦摄射慑涉社设砷申呻伸身深娠绅神沈审婶甚肾慎渗声生甥牲升绳省盛剩胜圣师失狮施湿诗尸虱十石拾时什食蚀实识史矢使屎驶始式示士世柿事拭誓逝势是嗜噬适仕侍释饰氏市恃室视试收手首守寿授售受瘦兽蔬枢梳殊抒输叔舒淑疏书赎孰熟薯暑曙署蜀黍鼠属术述树束戍竖墅庶数漱恕刷耍摔衰甩帅栓拴霜双爽谁水睡税吮瞬顺舜说硕朔烁斯撕嘶思私司丝死肆寺嗣四伺似饲巳松耸怂颂送宋讼诵搜艘擞嗽苏酥俗素速粟僳塑溯宿诉肃酸蒜算虽隋随绥髓碎岁穗遂隧祟孙损笋蓑梭唆缩琐索锁所塌他它她塔獭挞蹋踏胎苔抬台泰酞太态汰坍摊贪瘫滩坛檀痰潭谭谈坦毯袒碳探叹炭汤塘搪堂棠膛唐糖倘躺淌趟烫掏涛滔绦萄桃逃淘陶讨套特藤腾疼誊梯剔踢锑提题蹄啼体替嚏惕涕剃屉天添填田甜恬舔腆挑条迢眺跳贴铁帖厅听烃汀廷停亭庭挺艇通桐酮瞳同铜彤童桶捅筒统痛偷投头透凸秃突图徒途涂屠土吐兔湍团推颓腿蜕褪退吞屯臀拖托脱鸵陀驮驼椭妥拓唾挖哇蛙洼娃瓦袜歪外豌弯湾玩顽丸烷完碗挽晚皖惋宛婉万腕汪王亡枉网往旺望忘妄威巍微危韦违桅围唯惟为潍维苇萎委伟伪尾纬未蔚味畏胃喂魏位渭谓尉慰卫瘟温蚊文闻纹吻稳紊问嗡翁瓮挝蜗涡窝我斡卧握沃巫呜钨乌污诬屋无芜梧吾吴毋武五捂午舞伍侮坞戊雾晤物勿务悟误昔熙析西硒矽晰嘻吸锡牺稀息希悉膝夕惜熄烯溪汐犀檄袭席习媳喜铣洗系隙戏细瞎虾匣霞辖暇峡侠狭下厦夏吓掀锨先仙鲜纤咸贤衔舷闲涎弦嫌显险现献县腺馅羡宪陷限线相厢镶香箱襄湘乡翔祥详想响享项巷橡像向象萧硝霄削哮嚣销消宵淆晓小孝校肖啸笑效楔些歇蝎鞋协挟携邪斜胁谐写械卸蟹懈泄泻谢屑薪芯锌欣辛新忻心信衅星腥猩惺兴刑型形邢行醒幸杏性姓兄凶胸匈汹雄熊休修羞朽嗅锈秀袖绣墟戌需虚嘘须徐许蓄酗叙旭序畜恤絮婿绪续轩喧宣悬旋玄选癣眩绚靴薛学穴雪血勋熏循旬询寻驯巡殉汛训讯逊迅压押鸦鸭呀丫芽牙蚜崖衙涯雅哑亚讶焉咽阉烟淹盐严研蜒岩延言颜阎炎沿奄掩眼衍演艳堰燕厌砚雁唁彦焰宴谚验殃央鸯秧杨扬佯疡羊洋阳氧仰痒养样漾邀腰妖瑶摇尧遥窑谣姚咬舀药要耀椰噎耶爷野冶也页掖业叶曳腋夜液一壹医揖铱依伊衣颐夷遗移仪胰疑沂宜姨彝椅蚁倚已乙矣以艺抑易邑屹亿役臆逸肄疫亦裔意毅忆义益溢诣议谊译异翼翌绎茵荫因殷音阴姻吟银淫寅饮尹引隐印英樱婴鹰应缨莹萤营荧蝇迎赢盈影颖硬映哟拥佣臃痈庸雍踊蛹咏泳涌永恿勇用幽优悠忧尤由邮铀犹油游酉有友右佑釉诱又幼迂淤于盂榆虞愚舆余俞逾鱼愉渝渔隅予娱雨与屿禹宇语羽玉域芋郁吁遇喻峪御愈欲狱育誉浴寓裕预豫驭鸳渊冤元垣袁原援辕园员圆猿源缘远苑愿怨院曰约越跃钥岳粤月悦阅耘云郧匀陨允运蕴酝晕韵孕匝砸杂栽哉灾宰载再在咱攒暂赞赃脏葬遭糟凿藻枣早澡蚤躁噪造皂灶燥责择则泽贼怎增憎曾赠扎喳渣札轧铡闸眨栅榨咋乍炸诈摘斋宅窄债寨瞻毡詹粘沾盏斩辗崭展蘸栈占战站湛绽樟章彰漳张掌涨杖丈帐账仗胀瘴障招昭找沼赵照罩兆肇召遮折哲蛰辙者锗蔗这浙珍斟真甄砧臻贞针侦枕疹诊震振镇阵蒸挣睁征狰争怔整拯正政帧症郑证芝枝支吱蜘知肢脂汁之织职直植殖执值侄址指止趾只旨纸志挚掷至致置帜峙制智秩稚质炙痔滞治窒中盅忠钟衷终种肿重仲众舟周州洲诌粥轴肘帚咒皱宙昼骤珠株蛛朱猪诸诛逐竹烛煮拄瞩嘱主著柱助蛀贮铸筑住注祝驻抓爪拽专砖转撰赚篆桩庄装妆撞壮状椎锥追赘坠缀谆准捉拙卓桌琢茁酌啄着灼浊兹咨资姿滋淄孜紫仔籽滓子自渍字鬃棕踪宗综总纵邹走奏揍租足卒族祖诅阻组钻纂嘴醉最罪尊遵昨左佐柞做作坐座锕嗳嫒瑷暧霭谙铵鹌媪骜鳌钯呗钣鸨龅鹎贲锛荜哔滗铋筚跸苄缏笾骠飑飙镖镳鳔傧缤槟殡膑镔髌鬓禀饽钹鹁钸骖黪恻锸侪钗冁谄谶蒇忏婵骣觇禅镡伥苌怅阊鲳砗伧谌榇碜龀枨柽铖铛饬鸱铳俦帱雠刍绌蹰钏怆缍鹑辍龊鹚苁骢枞辏撺锉鹾哒鞑骀绐殚赕瘅箪谠砀裆焘镫籴诋谛绨觌镝巅钿癫铫鲷鲽铤铥岽鸫窦渎椟牍笃黩簖怼镦炖趸铎谔垩阏轭锇锷鹗颚颛鳄诶迩铒鸸鲕钫鲂绯镄鲱偾沣凫驸绂绋赙麸鲋鳆钆赅尴擀绀戆睾诰缟锆纥镉颍亘赓绠鲠诟缑觏诂毂钴锢鸪鹄鹘鸹掴诖掼鹳鳏犷匦刿妫桧鲑鳜衮绲鲧埚呙帼椁蝈铪阚绗颉灏颢诃阖蛎黉讧荭闳鲎浒鹕骅桦铧奂缳锾鲩鳇诙荟哕浍缋珲晖诨馄阍钬镬讦诘荠叽哜骥玑觊齑矶羁虿跻霁鲚鲫郏浃铗镓蛲谏缣戋戬睑鹣笕鲣鞯绛缰挢峤鹪鲛疖颌鲒卺荩馑缙赆觐刭泾迳弪胫靓阄鸠鹫讵屦榉飓钜锔窭龃锩镌隽谲珏皲剀垲忾恺铠锴龛闶钪铐骒缂轲钶锞颔龈铿喾郐哙脍狯髋诓诳邝圹纩贶匮蒉愦聩篑阃锟鲲蛴崃徕涞濑赉睐铼癞籁岚榄斓镧褴阆锒唠崂铑铹痨鳓诔缧俪郦坜苈莅蓠呖逦骊缡枥栎轹砺锂鹂疠粝跞雳鲡鳢蔹奁潋琏殓裢裣鲢魉缭钌鹩蔺廪檩辚躏绫棂蛏鲮浏骝绺镏鹨茏泷珑栊胧砻偻蒌喽嵝镂瘘耧蝼髅垆撸噜闾泸渌栌橹轳辂辘氇胪鸬鹭舻鲈脔娈栾鸾銮囵荦猡泺椤脶镙榈褛锊呒唛嬷杩劢缦镘颡鳗麽扪焖懑钔芈谧猕祢渑腼黾缈缪闵缗谟蓦馍殁镆钼铙讷铌鲵辇鲶茑袅陧蘖嗫颟蹑苎咛聍侬哝驽钕傩讴怄瓯蹒疱辔纰罴铍谝骈缥嫔钋镤镨蕲骐绮桤碛颀颃鳍佥荨悭骞缱椠钤嫱樯戗炝锖锵镪羟跄诮谯荞缲硗跷惬锲箧锓揿鲭茕蛱巯赇虮鳅诎岖阒觑鸲诠绻辁铨阕阙悫荛娆桡饪轫嵘蝾缛铷颦蚬飒毵糁缫啬铯穑铩鲨酾讪姗骟钐鳝垧殇觞厍滠畲诜谂渖谥埘莳弑轼贳铈鲥绶摅纾闩铄厮驷缌锶鸶薮馊飕锼谡稣谇荪狲唢睃闼铊鳎钛鲐昙钽锬顸傥饧铴镗韬铽缇鹈阗粜龆鲦恸钭钍抟饨箨鼍娲腽纨绾辋诿帏闱沩涠玮韪炜鲔阌莴龌邬庑怃妩骛鹉鹜饩阋玺觋硖苋莶藓岘猃娴鹇痫蚝籼跹芗饷骧缃飨哓潇骁绡枭箫亵撷绁缬陉荥馐鸺诩顼谖铉镟谑泶鳕埙浔鲟垭娅桠氩厣赝俨兖谳恹闫酽魇餍鼹炀轺鹞鳐靥谒邺晔烨诒呓峄饴怿驿缢轶贻钇镒镱瘗舣铟瘾茔莺萦蓥撄嘤滢潆璎鹦瘿颏罂镛莸铕鱿伛俣谀谕蓣嵛饫阈妪纡觎欤钰鹆鹬龉橼鸢鼋钺郓芸恽愠纭韫殒氲瓒趱錾驵赜啧帻箦谮缯谵诏钊谪辄鹧浈缜桢轸赈祯鸩诤峥钲铮筝骘栉栀轵轾贽鸷蛳絷踬踯觯锺纣绉伫槠铢啭馔颞骓缒诼镯谘缁辎赀眦锱龇鲻偬诹驺鲰镞缵躜鳟讠谫郄勐凼坂垅垴埯埝苘荬荮莜莼菰藁揸吒吣咔咝咴噘噼嚯幞岙嵴彷徼犸狍馀馇馓馕愣憷懔丬溆滟溷漤潴澹甯纟绔绱珉枧桊桉槔橥轱轷赍肷胨飚煳煅熘愍淼砜磙眍钚钷铘铞锃锍锎锏锘锝锪锫锿镅镎镢镥镩镲稆鹋鹛鹱疬疴痖癯裥襁耢颥螨麴鲅鲆鲇鲞鲴鲺鲼鳊鳋鳘鳙鞒鞴齄';
  var ftPYStr = '啊阿埃挨哎唉哀皚癌藹矮艾礙愛隘鞍氨安俺按暗岸胺案骯昂盎凹敖熬翺襖傲奧懊澳芭捌扒叭吧笆八疤巴拔跋靶把耙壩霸罷爸白柏百擺佰敗拜稗斑班搬扳般頒板版扮拌伴瓣半辦絆邦幫梆榜膀綁棒磅蚌鎊傍謗苞胞包褒剝薄雹保堡飽寶抱報暴豹鮑爆杯碑悲卑北輩背貝鋇倍狽備憊焙被奔苯本笨崩繃甭泵蹦迸逼鼻比鄙筆彼碧蓖蔽畢斃毖幣庇痹閉敝弊必辟壁臂避陛鞭邊編貶扁便變卞辨辯辮遍標彪膘表鱉憋別癟彬斌瀕濱賓擯兵冰柄丙秉餅炳病並玻菠播撥缽波博勃搏鉑箔伯帛舶脖膊渤泊駁捕蔔哺補埠不布步簿部怖擦猜裁材才財睬踩采彩菜蔡餐參蠶殘慚慘燦蒼艙倉滄藏操糙槽曹草廁策側冊測層蹭插叉茬茶查碴搽察岔差詫拆柴豺攙摻蟬饞讒纏鏟產闡顫昌猖場嘗常長償腸廠敞暢唱倡超抄鈔朝嘲潮巢吵炒車扯撤掣徹澈郴臣辰塵晨忱沈陳趁襯撐稱城橙成呈乘程懲澄誠承逞騁秤吃癡持匙池遲弛馳恥齒侈尺赤翅斥熾充沖蟲崇寵抽酬疇躊稠愁籌仇綢瞅醜臭初出櫥廚躇鋤雛滁除楚礎儲矗搐觸處揣川穿椽傳船喘串瘡窗幢床闖創吹炊捶錘垂春椿醇唇淳純蠢戳綽疵茨磁雌辭慈瓷詞此刺賜次聰蔥囪匆從叢湊粗醋簇促躥篡竄摧崔催脆瘁粹淬翠村存寸磋撮搓措挫錯搭達答瘩打大呆歹傣戴帶殆代貸袋待逮怠耽擔丹單鄲撣膽旦氮但憚淡誕彈蛋當擋黨蕩檔刀搗蹈倒島禱導到稻悼道盜德得的蹬燈登等瞪凳鄧堤低滴迪敵笛狄滌翟嫡抵底地蒂第帝弟遞締顛掂滇碘點典靛墊電佃甸店惦奠澱殿碉叼雕雕刁掉吊釣調跌爹碟蝶叠諜疊丁盯叮釘頂鼎錠定訂丟東冬董懂動棟侗恫凍洞兜抖鬥陡豆逗痘都督毒犢獨讀堵睹賭杜鍍肚度渡妒端短鍛段斷緞堆兌隊對墩噸蹲敦頓囤鈍盾遁掇哆多奪垛躲朵跺舵剁惰墮蛾峨鵝俄額訛娥惡厄扼遏鄂餓恩而兒耳爾餌洱二貳發罰筏伐乏閥法琺藩帆番翻樊礬釩繁凡煩反返範販犯飯泛坊芳方肪房防妨仿訪紡放菲非啡飛肥匪誹吠肺廢沸費芬酚吩氛分紛墳焚汾粉奮份忿憤糞豐封楓蜂峰鋒風瘋烽逢馮縫諷奉鳳佛否夫敷膚孵扶拂輻幅氟符伏俘服浮涪福袱弗甫撫輔俯釜斧脯腑府腐赴副覆賦復傅付阜父腹負富訃附婦縛咐噶嘎該改概鈣蓋溉幹甘桿柑竿肝趕感稈敢贛岡剛鋼缸肛綱崗港杠篙臯高膏羔糕搞鎬稿告哥歌擱戈鴿胳疙割革葛格蛤閣隔鉻個各給根跟耕更庚羹埂耿梗工攻功恭龔供躬公宮弓鞏汞拱貢共鉤勾溝茍狗垢構購夠辜菇咕箍估沽孤姑鼓古蠱骨谷股故顧固雇刮瓜剮寡掛褂乖拐怪棺關官冠觀管館罐慣灌貫光廣逛瑰規圭矽歸龜閨軌鬼詭癸桂櫃跪貴劊輥滾棍鍋郭國果裹過哈骸孩海氦亥害駭酣憨邯韓含涵寒函喊罕翰撼捍旱憾悍焊汗漢夯杭航壕嚎豪毫郝好耗號浩呵喝荷菏核禾和何合盒貉閡河涸赫褐鶴賀嘿黑痕很狠恨哼亨橫衡恒轟哄烘虹鴻洪宏弘紅喉侯猴吼厚候後呼乎忽瑚壺葫胡蝴狐糊湖弧虎唬護互滬戶花嘩華猾滑畫劃化話槐徊懷淮壞歡環桓還緩換患喚瘓豢煥渙宦幻荒慌黃磺蝗簧皇凰惶煌晃幌恍謊灰揮輝徽恢蛔回毀悔慧卉惠晦賄穢會燴匯諱誨繪葷昏婚魂渾混豁活夥火獲或惑霍貨禍擊圾基機畸稽積箕肌饑跡激譏雞姬績緝吉極棘輯籍集及急疾汲即嫉級擠幾脊己薊技冀季伎祭劑悸濟寄寂計記既忌際繼紀嘉枷夾佳家加莢頰賈甲鉀假稼價架駕嫁殲監堅尖箋間煎兼肩艱奸緘繭檢柬堿鹼揀撿簡儉剪減薦檻鑒踐賤見鍵箭件健艦劍餞漸濺澗建僵姜將漿江疆蔣槳獎講匠醬降蕉椒礁焦膠交郊澆驕嬌嚼攪鉸矯僥腳狡角餃繳絞剿教酵轎較叫窖揭接皆稭街階截劫節莖睛晶鯨京驚精粳經井警景頸靜境敬鏡徑痙靖竟競凈炯窘揪究糾玖韭久灸九酒廄救舊臼舅咎就疚鞠拘狙疽居駒菊局咀矩舉沮聚拒據巨具距踞鋸俱句懼炬劇捐鵑娟倦眷卷絹撅攫抉掘倔爵桔傑捷睫竭潔結解姐戒藉芥界借介疥誡屆巾筋斤金今津襟緊錦僅謹進靳晉禁近燼浸盡勁荊兢覺決訣絕均菌鈞軍君峻俊竣浚郡駿喀咖卡咯開揩楷凱慨刊堪勘坎砍看康慷糠扛抗亢炕考拷烤靠坷苛柯棵磕顆科殼咳可渴克刻客課肯啃墾懇坑吭空恐孔控摳口扣寇枯哭窟苦酷庫褲誇垮挎跨胯塊筷儈快寬款匡筐狂框礦眶曠況虧盔巋窺葵奎魁傀饋愧潰坤昆捆困括擴廓闊垃拉喇蠟臘辣啦萊來賴藍婪欄攔籃闌蘭瀾讕攬覽懶纜爛濫瑯榔狼廊郎朗浪撈勞牢老佬姥酪烙澇勒樂雷鐳蕾磊累儡壘擂肋類淚棱楞冷厘梨犁黎籬貍離漓理李裏鯉禮莉荔吏栗麗厲勵礫歷利傈例俐痢立粒瀝隸力璃哩倆聯蓮連鐮廉憐漣簾斂臉鏈戀煉練糧涼梁粱良兩輛量晾亮諒撩聊僚療燎寥遼潦了撂鐐廖料列裂烈劣獵琳林磷霖臨鄰鱗淋凜賃吝拎玲菱零齡鈴伶羚淩靈陵嶺領另令溜琉榴硫餾留劉瘤流柳六龍聾嚨籠窿隆壟攏隴樓婁摟簍漏陋蘆盧顱廬爐擄鹵虜魯麓碌露路賂鹿潞祿錄陸戮驢呂鋁侶旅履屢縷慮氯律率濾綠巒攣孿灤卵亂掠略掄輪倫侖淪綸論蘿螺羅邏鑼籮騾裸落洛駱絡媽麻瑪碼螞馬罵嘛嗎埋買麥賣邁脈瞞饅蠻滿蔓曼慢漫謾芒茫盲氓忙莽貓茅錨毛矛鉚卯茂冒帽貌貿麽玫枚梅酶黴煤沒眉媒鎂每美昧寐妹媚門悶們萌蒙檬盟錳猛夢孟瞇醚靡糜迷謎彌米秘覓泌蜜密冪棉眠綿冕免勉娩緬面苗描瞄藐秒渺廟妙蔑滅民抿皿敏憫閩明螟鳴銘名命謬摸摹蘑模膜磨摩魔抹末莫墨默沫漠寞陌謀牟某拇牡畝姆母墓暮幕募慕木目睦牧穆拿哪吶鈉那娜納氖乃奶耐奈南男難囊撓腦惱鬧淖呢餒內嫩能妮霓倪泥尼擬妳匿膩逆溺蔫拈年碾攆撚念娘釀鳥尿捏聶孽嚙鑷鎳涅您檸獰凝寧擰濘牛扭鈕紐膿濃農弄奴努怒女暖虐瘧挪懦糯諾哦歐鷗毆藕嘔偶漚啪趴爬帕怕琶拍排牌徘湃派攀潘盤磐盼畔判叛乓龐旁耪胖拋咆刨炮袍跑泡呸胚培裴賠陪配佩沛噴盆砰抨烹澎彭蓬棚硼篷膨朋鵬捧碰坯砒霹批披劈琵毗啤脾疲皮匹痞僻屁譬篇偏片騙飄漂瓢票撇瞥拼頻貧品聘乒坪蘋萍平憑瓶評屏坡潑頗婆破魄迫粕剖撲鋪仆莆葡菩蒲埔樸圃普浦譜曝瀑期欺棲戚妻七淒漆柒沏其棋奇歧畦崎臍齊旗祈祁騎起豈乞企啟契砌器氣迄棄汽泣訖掐洽牽扡釬鉛千遷簽仟謙乾黔錢鉗前潛遣淺譴塹嵌欠歉槍嗆腔羌墻薔強搶橇鍬敲悄橋瞧喬僑巧鞘撬翹峭俏竅切茄且怯竊欽侵親秦琴勤芹擒禽寢沁青輕氫傾卿清擎晴氰情頃請慶瓊窮秋丘邱球求囚酋泅趨區蛆曲軀屈驅渠取娶齲趣去圈顴權醛泉全痊拳犬券勸缺炔瘸卻鵲榷確雀裙群然燃冉染瓤壤攘嚷讓饒擾繞惹熱壬仁人忍韌任認刃妊紉扔仍日戎茸蓉榮融熔溶容絨冗揉柔肉茹蠕儒孺如辱乳汝入褥軟阮蕊瑞銳閏潤若弱撒灑薩腮鰓塞賽三三傘散桑嗓喪搔騷掃嫂瑟色澀森僧莎砂殺剎沙紗傻啥煞篩曬珊苫杉山刪煽衫閃陜擅贍膳善汕扇繕墑傷商賞晌上尚裳梢捎稍燒芍勺韶少哨邵紹奢賒蛇舌舍赦攝射懾涉社設砷申呻伸身深娠紳神沈審嬸甚腎慎滲聲生甥牲升繩省盛剩勝聖師失獅施濕詩屍虱十石拾時什食蝕實識史矢使屎駛始式示士世柿事拭誓逝勢是嗜噬適仕侍釋飾氏市恃室視試收手首守壽授售受瘦獸蔬樞梳殊抒輸叔舒淑疏書贖孰熟薯暑曙署蜀黍鼠屬術述樹束戍豎墅庶數漱恕刷耍摔衰甩帥栓拴霜雙爽誰水睡稅吮瞬順舜說碩朔爍斯撕嘶思私司絲死肆寺嗣四伺似飼巳松聳慫頌送宋訟誦搜艘擻嗽蘇酥俗素速粟僳塑溯宿訴肅酸蒜算雖隋隨綏髓碎歲穗遂隧祟孫損筍蓑梭唆縮瑣索鎖所塌他它她塔獺撻蹋踏胎苔擡臺泰酞太態汰坍攤貪癱灘壇檀痰潭譚談坦毯袒碳探嘆炭湯塘搪堂棠膛唐糖倘躺淌趟燙掏濤滔絳萄桃逃淘陶討套特藤騰疼謄梯剔踢銻提題蹄啼體替嚏惕涕剃屜天添填田甜恬舔腆挑條迢眺跳貼鐵帖廳聽烴汀廷停亭庭挺艇通桐酮瞳同銅彤童桶捅筒統痛偷投頭透凸禿突圖徒途塗屠土吐兔湍團推頹腿蛻褪退吞屯臀拖托脫鴕陀馱駝橢妥拓唾挖哇蛙窪娃瓦襪歪外豌彎灣玩頑丸烷完碗挽晚皖惋宛婉萬腕汪王亡枉網往旺望忘妄威巍微危韋違桅圍唯惟為濰維葦萎委偉偽尾緯未蔚味畏胃餵魏位渭謂尉慰衛瘟溫蚊文聞紋吻穩紊問嗡翁甕撾蝸渦窩我斡臥握沃巫嗚鎢烏汙誣屋無蕪梧吾吳毋武五捂午舞伍侮塢戊霧晤物勿務悟誤昔熙析西硒矽晰嘻吸錫犧稀息希悉膝夕惜熄烯溪汐犀檄襲席習媳喜銑洗系隙戲細瞎蝦匣霞轄暇峽俠狹下廈夏嚇掀鍁先仙鮮纖鹹賢銜舷閑涎弦嫌顯險現獻縣腺餡羨憲陷限線相廂鑲香箱襄湘鄉翔祥詳想響享項巷橡像向象蕭硝霄削哮囂銷消宵淆曉小孝校肖嘯笑效楔些歇蠍鞋協挾攜邪斜脅諧寫械卸蟹懈泄瀉謝屑薪芯鋅欣辛新忻心信釁星腥猩惺興刑型形邢行醒幸杏性姓兄兇胸匈洶雄熊休修羞朽嗅銹秀袖繡墟戌需虛噓須徐許蓄酗敘旭序畜恤絮婿緒續軒喧宣懸旋玄選癬眩絢靴薛學穴雪血勛熏循旬詢尋馴巡殉汛訓訊遜迅壓押鴉鴨呀丫芽牙蚜崖衙涯雅啞亞訝焉咽閹煙淹鹽嚴研蜒巖延言顏閻炎沿奄掩眼衍演艷堰燕厭硯雁唁彥焰宴諺驗殃央鴦秧楊揚佯瘍羊洋陽氧仰癢養樣漾邀腰妖瑤搖堯遙窯謠姚咬舀藥要耀椰噎耶爺野冶也頁掖業葉曳腋夜液壹壹醫揖銥依伊衣頤夷遺移儀胰疑沂宜姨彜椅蟻倚已乙矣以藝抑易邑屹億役臆逸肄疫亦裔意毅憶義益溢詣議誼譯異翼翌繹茵蔭因殷音陰姻吟銀淫寅飲尹引隱印英櫻嬰鷹應纓瑩螢營熒蠅迎贏盈影穎硬映喲擁傭臃癰庸雍踴蛹詠泳湧永恿勇用幽優悠憂尤由郵鈾猶油遊酉有友右佑釉誘又幼迂淤於盂榆虞愚輿余俞逾魚愉渝漁隅予娛雨與嶼禹宇語羽玉域芋郁籲遇喻峪禦愈欲獄育譽浴寓裕預豫馭鴛淵冤元垣袁原援轅園員圓猿源緣遠苑願怨院曰約越躍鑰嶽粵月悅閱耘雲鄖勻隕允運蘊醞暈韻孕匝砸雜栽哉災宰載再在咱攢暫贊贓臟葬遭糟鑿藻棗早澡蚤躁噪造皂竈燥責擇則澤賊怎增憎曾贈紮喳渣劄軋鍘閘眨柵榨咋乍炸詐摘齋宅窄債寨瞻氈詹粘沾盞斬輾嶄展蘸棧占戰站湛綻樟章彰漳張掌漲杖丈帳賬仗脹瘴障招昭找沼趙照罩兆肇召遮折哲蟄轍者鍺蔗這浙珍斟真甄砧臻貞針偵枕疹診震振鎮陣蒸掙睜征猙爭怔整拯正政幀癥鄭證芝枝支吱蜘知肢脂汁之織職直植殖執值侄址指止趾只旨紙誌摯擲至致置幟峙制智秩稚質炙痔滯治窒中盅忠鐘衷終種腫重仲眾舟周州洲謅粥軸肘帚咒皺宙晝驟珠株蛛朱豬諸誅逐竹燭煮拄矚囑主著柱助蛀貯鑄築住註祝駐抓爪拽專磚轉撰賺篆樁莊裝妝撞壯狀椎錐追贅墜綴諄準捉拙卓桌琢茁酌啄著灼濁茲咨資姿滋淄孜紫仔籽滓子自漬字鬃棕蹤宗綜總縱鄒走奏揍租足卒族祖詛阻組鉆纂嘴醉最罪尊遵昨左佐柞做作坐座錒噯嬡璦曖靄諳銨鵪媼驁鰲鈀唄鈑鴇齙鵯賁錛蓽嗶潷鉍篳蹕芐緶籩驃颮飆鏢鑣鰾儐繽檳殯臏鑌髕鬢稟餑鈸鵓鈽驂黲惻鍤儕釵囅諂讖蕆懺嬋驏覘禪鐔倀萇悵閶鯧硨傖諶櫬磣齔棖檉鋮鐺飭鴟銃儔幬讎芻絀躕釧愴綞鶉輟齪鶿蓯驄樅輳攛銼鹺噠韃駘紿殫賧癉簞讜碭襠燾鐙糴詆諦綈覿鏑巔鈿癲銚鯛鰈鋌銩崠鶇竇瀆櫝牘篤黷籪懟鐓燉躉鐸諤堊閼軛鋨鍔鶚顎顓鱷誒邇鉺鴯鮞鈁魴緋鐨鯡僨灃鳧駙紱紼賻麩鮒鰒釓賅尷搟紺戇睪誥縞鋯紇鎘潁亙賡綆鯁詬緱覯詁轂鈷錮鴣鵠鶻鴰摑詿摜鸛鰥獷匭劌媯檜鮭鱖袞緄鯀堝咼幗槨蟈鉿闞絎頡灝顥訶闔蠣黌訌葒閎鱟滸鶘驊樺鏵奐繯鍰鯇鰉詼薈噦澮繢琿暉諢餛閽鈥鑊訐詰薺嘰嚌驥璣覬齏磯羈蠆躋霽鱭鯽郟浹鋏鎵蟯諫縑戔戩瞼鶼筧鰹韉絳韁撟嶠鷦鮫癤頜鮚巹藎饉縉贐覲剄涇逕弳脛靚鬮鳩鷲詎屨櫸颶鉅鋦窶齟錈鐫雋譎玨皸剴塏愾愷鎧鍇龕閌鈧銬騍緙軻鈳錁頷齦鏗嚳鄶噲膾獪髖誆誑鄺壙纊貺匱蕢憒聵簣閫錕鯤蠐崍徠淶瀨賚睞錸癩籟嵐欖斕鑭襤閬鋃嘮嶗銠鐒癆鰳誄縲儷酈壢藶蒞蘺嚦邐驪縭櫪櫟轢礪鋰鸝癘糲躒靂鱺鱧蘞奩瀲璉殮褳襝鰱魎繚釕鷯藺廩檁轔躪綾欞蟶鯪瀏騮綹鎦鷚蘢瀧瓏櫳朧礱僂蔞嘍嶁鏤瘺耬螻髏壚擼嚕閭瀘淥櫨櫓轤輅轆氌臚鸕鷺艫鱸臠孌欒鸞鑾圇犖玀濼欏腡鏍櫚褸鋝嘸嘜嬤榪勱縵鏝顙鰻麼捫燜懣鍆羋謐獼禰澠靦黽緲繆閔緡謨驀饃歿鏌鉬鐃訥鈮鯢輦鯰蔦裊隉蘗囁顢躡苧嚀聹儂噥駑釹儺謳慪甌蹣皰轡紕羆鈹諞駢縹嬪釙鏷鐠蘄騏綺榿磧頎頏鰭僉蕁慳騫繾槧鈐嬙檣戧熗錆鏘鏹羥蹌誚譙蕎繰磽蹺愜鍥篋鋟撳鯖煢蛺巰賕蟣鰍詘嶇闃覷鴝詮綣輇銓闋闕愨蕘嬈橈飪軔嶸蠑縟銣顰蜆颯毿糝繅嗇銫穡鎩鯊釃訕姍騸釤鱔坰殤觴厙灄畬詵諗瀋謚塒蒔弒軾貰鈰鰣綬攄紓閂鑠廝駟緦鍶鷥藪餿颼鎪謖穌誶蓀猻嗩脧闥鉈鰨鈦鮐曇鉭錟頇儻餳鐋鏜韜鋱緹鵜闐糶齠鰷慟鈄釷摶飩籜鼉媧膃紈綰輞諉幃闈溈潿瑋韙煒鮪閿萵齷鄔廡憮嫵騖鵡鶩餼鬩璽覡硤莧薟蘚峴獫嫻鷴癇蠔秈躚薌餉驤緗饗嘵瀟驍綃梟簫褻擷紲纈陘滎饈鵂詡頊諼鉉鏇謔澩鱈塤潯鱘埡婭椏氬厴贗儼兗讞懨閆釅魘饜鼴煬軺鷂鰩靨謁鄴曄燁詒囈嶧飴懌驛縊軼貽釔鎰鐿瘞艤銦癮塋鶯縈鎣攖嚶瀅瀠瓔鸚癭頦罌鏞蕕銪魷傴俁諛諭蕷崳飫閾嫗紆覦歟鈺鵒鷸齬櫞鳶黿鉞鄆蕓惲慍紜韞殞氳瓚趲鏨駔賾嘖幘簀譖繒譫詔釗謫輒鷓湞縝楨軫賑禎鴆諍崢鉦錚箏騭櫛梔軹輊贄鷙螄縶躓躑觶鍾紂縐佇櫧銖囀饌顳騅縋諑鐲諮緇輜貲眥錙齜鯔傯諏騶鯫鏃纘躦鱒訁譾郤猛氹阪壟堖垵墊檾蕒葤蓧蒓菇槁摣咤唚哢噝噅撅劈謔襆嶴脊仿僥獁麅餘餷饊饢楞怵懍爿漵灩混濫瀦淡寧糸絝緔瑉梘棬案橰櫫軲軤賫膁腖飈糊煆溜湣渺碸滾瞘鈈鉕鋣銱鋥鋶鐦鐧鍩鍀鍃錇鎄鎇鎿鐝鑥鑹鑔穭鶓鶥鸌癧屙瘂臒襇繈耮顬蟎麯鮁鮃鮎鯗鯝鯴鱝鯿鰠鰵鱅鞽韝齇';
  var qqPYStr = '娿婀埃挨餀呃哀皑癌蔼婑銰碍嬡隘鞍氨鮟唵洝暗岸胺案肮昻盎凹獓熬翱仸謸奧襖奧妑捌朳朳妑笆仈疤妑菝柭靶妑耙坝覇罢妑皛柏咟擺佰敗湃稗癍癍搬扳瘢頒闆蝂汾絆柈瓣柈刅绊綁幇梆徬嫎垹蜯嫎蚌镑徬谤苞菢笣褒剝薄雹湺堡怉寶砲蕔懪豹鲍嚗柸碑蕜萆苝輩揹赑钡俻狈備惫焙被渀苯夲苯镚绷甭泵嘣逬腷嬶仳啚毣彼碧蓖幣滭斃毖币庇痹閉獙弊怭澼壁臂鐴陛鞭笾揙貶碥楩變卞辧辮辮猵摽滮鏢錶鳖憋莂癟彬斌濒璸濱摈娦栤窉眪秉饼炳疒並箥菠譒妭钵菠博勃搏铂箔伯帛舶脖膊渤泊訤峬卜誧卟埠芣鈽荹簿蔀怖攃猜裁財財財棌棌采埰婇蔡爘傪蛬殘慙參灿芲舱仺獊蔵懆鐰槽蓸愺厠憡側冊恻層竲揷紁茬嗏楂楂搽镲岔槎诧拆枈豺搀傪蝉镵谗瀍铲浐闡顫誯猖畼甞瑺萇偿肠廠敞畅晿倡趫莏鈔謿謿謿漅訬炒車扯徹掣沏瞮郴烥宸尘曟忱冗陳趁衬撐稱峸橙荿珵塖珵懲僜諴承浧骋秤阣痴歭匙肔呎肔肔恥歯侈呎哧趐斥炽茺沖蟲漴寵菗絒帱帱婤僽薵仇皗瞅忸溴初炪廚廚躇鋤雛蒢篨椘绌储矗搐触處遄巛瑏椽伝船遄賗疮囱幢床闖創欥炊腄腄箠舂椿錞脣錞蒓蠢戥焯疵垐濨雌辭濨瓷詞泚剌賜佽聪茐囱茐苁苁凑粗齰簇娖蹿篡窜凗慛慛脆瘁濢濢濢籿洊籿磋撮髊措挫措溚垯荅瘩咑汏槑歹傣瀻帶殆笩贷袋待曃怠耽泹冄啴郸掸狚狚氮泹惮惔诞弹疍當澢黨蕩澢叨搗稲箌島祷导菿稲悼檤盜徳嘚哋簦燈憕等簦凳郰諟彽嘀廸敵廸狄涤翟嫡抵疧哋渧苐渧弚递缔颠掂滇碘點敟靛垫電佃甸扂惦奠淀殿淍汈鵰蜩刁鋽铞銱蜩瓞嗲渫渫迭媟疉玎饤汀町嵿鼎锭萣忊丟崬笗蓳慬憅崬侗恫岽狪兠鬦乧跿荳浢哣嘟督毐渎獨渎陼睹帾荰镀肚喥喥妒鍴短葮葮斷葮碓兌隊怼墩沌壿敦頓囤沌盾遁掇哆哆奪垛躱朶跺舵剁媠憜睋睋鹅皒额讹皒悪苊扼遏鄂皒慁洏ル洱尒聶洱②贰潑藅筏浌疺阀琺珐藩汎畨飜樊矾钒瀿汎煩反返笵贩氾粄疺汸淓汸肪房汸妨汸汸汸倣婔悱啡飛萉厞诽吠腓廢沸曊棼酚玢氛汾妢墳焚汾帉奮妢忿濆粪仹崶猦蜂峯峯颩瘋烽漨溤漨讽唪鳯仏娝玞敷膚孵荴拂辐諨氟苻茯俘棴捊涪湢袱弗甫抚辅椨釜釡脯腑椨腐赴諨覆賦復傅苻阜父腹萯冨讣胕妇缚咐噶嗄姟妀漑鈣葢漑迀苷杆柑芉肝迀憾秆噉赣罓碙鋼矼釭罁罓港釭禞皋滈膏餻溔鎬鎬鎬哠滒戨擱戈鸽胳疙剨愅噶咯蛤阁隔铬個茖给艮茛畊浭菮羹埂耿梗笁糼糼塨龚栱匑厷営弖巩汞珙貢珙溝芶芶苟豞垢媾媾夠辜菇咕箍诂钴箛菇鼔咕蛊嗗唂骰诂顧凅雇剮呱剮寡啩啩乖枴怪菅関菅蒄觀涫菅潅遦潅遦洸広迋瑰規圭硅歸亀閨匦媿詭癸蓕匱蛫貴刽辊蔉輥煱漷國淉裹過铪骸陔嗨氦亥嗐骇酣憨邯韓浛凾寒凾諴癷翰撼捍猂憾悍猂汙漢夯忼航壕嚎濠毫郝恏秏呺滘哬曷嗬菏劾秝啝哬匼盉貉阂菏涸赫褐鹤哿潶嫼痕佷哏悢涥悙橫蘅恆轟晎烘渱鴻葓宖宖葒糇糇糇犼厚糇後苸苸唿瑚壺煳箶箶狐煳煳弧唬唬戶沍戶戶埖蕐澕磆磆畵劃囮話槐佪懷准壞歡寰桓還緩換漶喚痪豢焕涣宦抝巟巟曂磺蝗簧瑝瑝瑝瑝愰縨恍巟洃媈媈幑恢蛔冋毇珻慧卉惠珻贿秽浍烩匯讳诲浍荤涽殙魂渾婫豁萿钬焱镬戓惑靃貨禍击圾樭僟畸稽積箕肌饥迹噭讥鶏姬绩缉咭极棘辑籍潗彶喼疾汲旣嫉级哜凢脊己蓟技冀悸伎祭剂悸哜寄寂計汜旣忌漈继汜嘉枷夾佳傢咖荚颊贾曱钾徦糘價泇駕糘姧盬堅尖笺簡煎凲肩艰奷缄茧撿柬碱硷拣撿彅倹彅諴薦槛鉴践濺見楗箭件揵舰劍饯渐溅涧踺壃葁將槳茳彊蔣桨奨講匠醬夅蕉椒礁潐烄茭郊浇嬌嬌嚼搅铰矫侥腳烄角饺儌烄剿嘋酵轿珓嘂窖揭帹湝秸街阶截劫兯莖聙瞐鯨倞驚棈粳經丼檠憬頸靜璄擏傹徑痉靖獍競凈泂僒啾究糾玖韭玖灸勼氿厩慦舊臼舅咎僦咎鞠佝狙疽劇驹匊挶咀怇舉沮藂岠琚姖倶岠踞涺倶呴惧岠涺涓鵑涓惓眷捲涓瘚攫決崛崛嚼桔傑啑睫竭洁結解姐悈藉芥鎅徣夰疥诫屆凧荕釿唫妗珒噤緊婂僅殣琎靳晉噤菦烬锓浕勁荊兢覺吷吷蕝汮箘呁軍焄浚浚浚浚郡浚喀咖鉲咯閞揩揩剀慨刋堪勘坎歃看嫝嵻嵻摃忼囥忼栲洘栲靠坷岢柯錁溘錁萪涜嗑妸渇尅尅愙錁肻肻恳垦妔妔涳恐芤啌摳囗釦簆喖哭崫楛酷厙褲洿垮挎跨胯赽筷侩赽寬窾匡筺誑框纩洭纩況扝盔岿窺葵喹魁傀潰隗潰堒崐涃涃葀拡霩闊柆菈喇臘臘辣菈莱唻攋藍漤孄拦藍阑蘭瀾谰灠灠攋灠灡嚂哴蓈哴蓢蓢蓢烺崂崂窂荖佬粩絡絡崂嘞泺檑檑檑藞蔂儡垒檑叻類汨棱楞唥厘悡犁黎篱狸蓠漓理李里鲤礼莉荔吏栗婯疠励砾呖悡傈唎俐痢竝粒沥隶劦璃哩唡聅嗹涟镰廉憐涟帘潋臉嗹戀煉煉悢涼樑粱悢倆唡糧涼煷涼嫽窷獠療獠寥辽潦孒撂镣漻料烮煭烮挘獵啉啉潾霖臨鄰潾啉凛賃悋柃玪夌蕶齡玪伶玪夌靈夌玪領叧泠媹琉媹硫馏畱嚠媹蓅栁陸瀧聾茏茏窿湰泷泷茏溇溇嵝溇屚陋廬盧颅廬爐掳卤虏噜麓碌蕗蕗赂蔍潞禄淥陸戮馿焒焒佀膂履屢缕慮氯侓卛慮淥欒孌孿滦卵亂稤畧囵囵囵仑囵纶囵囉螺囉羅囉儸骡裸落詻詻絡媽嫲犸犸犸骉罵嫲嬤埋荬麥賣邁霡慲獌蠻慲嫚嫚嫚嫚谩笀汒吂氓杧漭貓罞锚毝罞铆茆茂萺萺邈貿庅坆枚烸酶苺湈莈葿媒镁烸羙昧寐妺媚閄悶們萠懞檬擝锰掹夢掹侎醚靡糜洣洣弥洣秘觅泌滵滵幂婂眠婂冕凂勉娩缅媔媌媌媌邈仯緲庿仯篾搣姄抿皿勄悯閩眀螟嘄佲洺掵繆嗼摹嚤嗼嗼嚤嚤嚤沬沬嗼嚜默沬嗼寞帞湈哞湈拇牡畝姆毋募暮募募慕朩朩睦牧穆嗱哪妠妠哪哪妠氖釢艿恧柰遖莮難灢撓悩悩閙淖迡浽禸嫰能妮霓淣狔胒抳沵嫟膩屰溺蔫秥姩碾撵捻淰娘酿茑杘涅嗫糵啮嗫镍涅您柠狞凝苧拧泞犇沑妞狃哝哝哝挵伮怓伮囡煖疟疟挪穤穤喏呃瓯瓯瓯耦嘔耦沤啪汃瓟啪啪琶啪棑簰棑湃哌襻瀋盤磐昐溿叛判乓厐臱耪眫拋垉铇垉垉垉垉怌胚掊裴婄婄蓜姵沛濆湓泙抨烹澎憉莑堋硼篷膨萠鵬唪湴坯砒噼纰怶噼琵毗啤裨疲怶苉痞僻庇譬萹媥爿騙彯慓瓢嘌潎潎拚頻貧闆娉乒岼泙泙岼憑甁评屛岥秡櫇嘙岥魄廹粕剖圤舗圤莆匍箁蒲逋圤圃普浦鐠曝鑤剘剘栖嘁悽⑦凄漆柒沏娸諆渏忮畦崎脐斉旗祈祁騏起豈阣佱晵契砌噐氣迄棄汽淇讫拤洽撁扦钎鉛芉迁簽仟嗛墘黔錢钳湔濳遣淺谴堑嵌芡嗛熗濸腔羌嫱嫱強熗橇锹毃佾喬趭喬喬巧鞘毳趬峭佾竅苆苆苴愜苆钦埐儭蓁噖懄芹檎噙寑沁圊輕氢傾卿凊擎啨氰凊頃埥庆琼窮偢坵邱浗浗囚媨泅趋岖蛆浀軀屈駆渠掫婜龋趣厾圜颧權醛葲洤痊拳吠券勧蒛炔瘸卻鹊榷確雀峮羣嘫嘫姌媣瓤壤攘孃讓隢擾隢惹慹壬芢亾涊韧姙認刄妊纫扔仍ㄖ戎茸嫆荣瀜嫆嫆嫆絨冗渘渘禸筎蠕濡孺洳媷乳肗叺褥軟朊惢瑞銳潤潤婼弜潵灑蕯腮鳃噻噻彡叁傘潵鎟鎟喪搔騒掃溲瑟脃澀潹僧莏唦摋閷乷纱傻倽繺篩曬姍苫杉屾剼煽釤閁陝擅赡膳僐訕傓缮墒傷啇賞晌仩尙裳哨哨哨燒芍汋韶仯哨卲袑奢赊虵舙舎赦摂射慑渉涻蔎砷妽呻訷裑堔娠訷鉮瀋谉嬸卙腎慎椮殸泩甥狌圱繩渻墭乗夝聖溮妷浉湤濕詩迉虱拾坧湁溡什喰蚀實識史矢使屍馶始鉽沶仕迣枾倳拭誓迣勢湜嗜噬适仕侍释飾氏巿恃厔視鉽荍掱渞垨壽涭售辤痩獣蔬枢梳姝杼瀭埱忬蔋疏書赎孰孰薯濐曙署蜀黍癙屬朮沭樹娕戍竪墅庶薮漱恕唰耍摔缞甩帥拴拴灀叒摤誰渁腄挩吮橓順橓説碩朔爍凘凘凘偲俬呞噝屍肆峙嗣④伺姒饲巳菘聳怂頌鎹浨讼誦溲艘擞嗽蘇酥俗嫊趚粟僳愬溯蹜訴歗酸祘匴虽陏隨浽髓誶嵗穗嬘隧祟孫損笋蓑逡逡縮鎖鎍鎻葰禢彵咜咜嗒獭挞蹋沓胎苔孡珆溙酞忲忲呔坍摊貪瘫滩墵檀痰憛谭談钽毯袒湠探嘆湠饧溏搪漟橖膛瑭溏倘躺淌趟烫匋濤瑫绦匋洮洮匋匋討套特駦駦庝誊珶剔踢锑諟趧渧渧軆櫕嚏惕珶珶屟兲婖瑱甶甛恬婖睓狣條迢眺朓萜鉄萜廰厛烃汀侹渟渟侹侹艇嗵秱酮瞳哃恫浵僮硧硧茼統痌偸投頭透凸禿湥圖徙蒤凃廜汢汢兎湍團蓷颓蹆蜕蹆蹆昋屯臀柂仛脫袉拕駞袉椭鋖沰唾挖哇蛙哇哇咓襪歪迯豌塆塆琓顽汍烷唍涴梚脕皖惋宛啘萭腕忹迋匄忹蛧暀忹朢莣妄媙蘶嶶佹韦違桅圍惟惟潙潍惟苇崣逶偉沩屗纬沬墛菋嵔媦嵔蘶莅渭媦墛墛衞瘟溫螡妏聞鈫沕穏紊問滃暡瓮挝窩煱窉莪斡臥楃沃莁嗚钨烏汚莁偓嘸蕪梧圄呉毋娬伍圄吘橆⑤侮坞戊霚晤粅匢務圄誤厝凞唽覀硒矽晰嘻扱唶犠浠息唏悉膝汐厝熄烯渓汐犀檄袭席習媳禧铣冼係隙戱細磍虾匣葭轄叚浹浹浹芐厦嗄圷锨锨姺佡鮮汘咸賢銜舷娴涎妶溓显険哯獻縣腺陥羨宪陥限線楿厢镶萫葙襄湘芗翔祥詳想姠啍頙巷潒潒姠潒簘硝霄萷涍嚣销消宵淆哓尒涍校肖啸笑效楔些歇蝎嚡拹挾携峫斜脅喈冩悈啣蟹澥绁瀉塮屑蕲芯锌俽厗噺忻杺信衅暒睲睲瑆興鉶侀形郉垳瑆圉莕悻狌兇兇洶匈汹雄熋咻俢饈朽溴琇莠袖绣歔戌濡歔歔湏俆汻蓄酗溆旮垿畜恤絮胥緒續蓒媗媗悬嫙玆選癣妶絢靴薛敩泬膤洫勛熏揗洵咰浔紃廵咰卂訓卂遜卂壓呷鴉鴨吖吖厊厊蚜崖衙涯蕥啞亞冴漹咽阉煙殗鹽嚴妍蜒啱娫訁顔閻烾沿奄殗眼衍湮滟堰嬿厭砚雁唁彦熖匽谚験殃姎鴦秧昜婸佯疡咩樣陽氧卬癢養樣羕撽崾岆愮愮尧滛窰愮烑吆舀葯婹耀倻噎倻爺嘢冶竾頁掖鄴旪曳腋液液①壹悘揖铱畩吚扆颐夷遗簃儀胰寲沂宜侇彝掎蚁掎巳乁矣姒兿抑昜邑屹億役臆逸肄疫洂裔嬑藙忆義谥溢诣议谊譯異翼翌绎筃荫洇殷堷隂絪荶檭婬夤飮吚吲陻茚渶璎璎鹰應缨瑩萤營荧蝇迊赢盁影颕哽眏喲砽砽臃痈滽澭踊蛹怺怺悀怺恿湧鼡豳沋滺沋尤甴邮铀沋怞遊酉洧伖祐祐釉诱叒孧扜菸纡盂榆虞愚舆悇揄揄渔揄揄渔隅予娯雨玙屿禹荢娪羽砡域芋喐吁喁喻峪御匬慾獄唷謍浴寓裕預豫驭鴛棩寃沅垣媴厡瑗辕圎園園猿羱緣逺夗蒝葾阮曰箹樾跞钥捳粵仴哾閱秐囩郧枃殒狁運藴酝暈韻夃匝咂卆酨酨災宰酨侢茬洎瓒暫瓒賍賍髒蹧蹧凿藻栆皁璪蚤璪璪慥唣灶璪嫧萚荝澤賊怎熷璔嶒熷紥喳碴札轧铡閘喳栅搾咋咋怍怍擿斋宅搾債寨瞻毡詹秥跕盏斬辗崭蹍蘸棧颭戰跕偡綻樟嶂彰漳張礃涨粀扙賬账扙胀瘴障妱昭找沼趙燳罩狣肇佋嗻菥悊蛰辙鍺锗蔗適淅沴斟嫃甄砧臻浈針浈忱疹沴震桭鎮俥篜諍諍姃狰踭姃整拯囸炡帧症鄭姃芷汥伎汥倁倁汥脂汥と枳轵矗淔殖秇惪侄歮栺圵趾呮旨衹梽挚掷臸臸置帜峙淛潪秩雉質炙痔滞菭窒狆盅筗妕衷蔠種妕偅仲衆洀淍詶詶诌粥轴肘帚咒皺宙昼骤咮株咮咮蕏渚诛豩艸烛煑拄瞩瞩炷著炷莇蛀贮铸茿炷炷柷驻抓爪跩抟磚啭撰賺篆桩圧裝妝獞匨匨椎锥搥赘墜綴谆痽浞炪婥棹琢茁酌啄着灼浊兹恣粢恣稵淄孜橴仔籽滓ふ洎渍牸鬃琮琮崈琮縂枞邹趉楱楱蒩娖卒蔟袓蒩蒩蒩鑽纂觜酔朂嶵澊噂葃咗佐柞莋莋唑蓙錒噯嬡璦曖靄諳銨鵪媼驁鰲鈀唄鈑鴇齙鵯賁錛蓽嗶潷鉍篳蹕芐緶籩驃颮飆鏢鑣鰾儐繽檳殯臏鑌髕鬢稟餑鈸鵓鈽驂黲惻鍤儕釵囅諂讖蕆懺嬋驏覘禪鐔倀萇悵閶鯧硨傖諶櫬磣齔棖檉鋮鐺飭鴟銃儔幬讎芻絀躕釧愴綞鶉輟齪鶿蓯驄樅輳攛銼鹺噠韃駘紿殫賧癉簞讜碭襠燾鐙糴詆諦綈覿鏑巔鈿癲銚鯛鰈鋌銩崠鶇竇瀆櫝牘篤黷籪懟鐓燉躉鐸諤堊閼軛鋨鍔鶚顎顓鱷誒邇鉺鴯鮞鈁魴緋鐨鯡僨灃鳧駙紱紼賻麩鮒鰒釓賅尷搟紺戇睪誥縞鋯紇鎘潁亙賡綆鯁詬緱覯詁轂鈷錮鴣鵠鶻鴰摑詿摜鸛鰥獷匭劌媯檜鮭鱖袞緄鯀堝咼幗槨蟈鉿闞絎頡灝顥訶闔蠣黌訌葒閎鱟滸鶘驊樺鏵奐繯鍰鯇鰉詼薈噦澮繢琿暉諢餛閽鈥鑊訐詰薺嘰嚌驥璣覬齏磯羈蠆躋霽鱭鯽郟浹鋏鎵蟯諫縑戔戩瞼鶼筧鰹韉絳韁撟嶠鷦鮫癤頜鮚巹藎饉縉贐覲剄涇逕弳脛靚鬮鳩鷲詎屨櫸颶鉅鋦窶齟錈鐫雋譎玨皸剴塏愾愷鎧鍇龕閌鈧銬騍緙軻鈳錁頷齦鏗嚳鄶噲膾獪髖誆誑鄺壙纊貺匱蕢憒聵簣閫錕鯤蠐崍徠淶瀨賚睞錸癩籟嵐欖斕鑭襤閬鋃嘮嶗銠鐒癆鰳誄縲儷酈壢藶蒞蘺嚦邐驪縭櫪櫟轢礪鋰鸝癘糲躒靂鱺鱧蘞奩瀲璉殮褳襝鰱魎繚釕鷯藺廩檁轔躪綾欞蟶鯪瀏騮綹鎦鷚蘢瀧瓏櫳朧礱僂蔞嘍嶁鏤瘺耬螻髏壚擼嚕閭瀘淥櫨櫓轤輅轆氌臚鸕鷺艫鱸臠孌欒鸞鑾圇犖玀濼欏腡鏍櫚褸鋝嘸嘜嬤榪勱縵鏝顙鰻麼捫燜懣鍆羋謐獼禰澠靦黽緲繆閔緡謨驀饃歿鏌鉬鐃訥鈮鯢輦鯰蔦裊隉蘗囁顢躡苧嚀聹儂噥駑釹儺謳慪甌蹣皰轡紕羆鈹諞駢縹嬪釙鏷鐠蘄騏綺榿磧頎頏鰭僉蕁慳騫繾槧鈐嬙檣戧熗錆鏘鏹羥蹌誚譙蕎繰磽蹺愜鍥篋鋟撳鯖煢蛺巰賕蟣鰍詘嶇闃覷鴝詮綣輇銓闋闕愨蕘嬈橈飪軔嶸蠑縟銣顰蜆颯毿糝繅嗇銫穡鎩鯊釃訕姍騸釤鱔坰殤觴厙灄畬詵諗瀋謚塒蒔弒軾貰鈰鰣綬攄紓閂鑠廝駟緦鍶鷥藪餿颼鎪謖穌誶蓀猻嗩脧闥鉈鰨鈦鮐曇鉭錟頇儻餳鐋鏜韜鋱緹鵜闐糶齠鰷慟鈄釷摶飩籜鼉媧膃紈綰輞諉幃闈溈潿瑋韙煒鮪閿萵齷鄔廡憮嫵騖鵡鶩餼鬩璽覡硤莧薟蘚峴獫嫻鷴癇蠔秈躚薌餉驤緗饗嘵瀟驍綃梟簫褻擷紲纈陘滎饈鵂詡頊諼鉉鏇謔澩鱈塤潯鱘埡婭椏氬厴贗儼兗讞懨閆釅魘饜鼴煬軺鷂鰩靨謁鄴曄燁詒囈嶧飴懌驛縊軼貽釔鎰鐿瘞艤銦癮塋鶯縈鎣攖嚶瀅瀠瓔鸚癭頦罌鏞蕕銪魷傴俁諛諭蕷崳飫閾嫗紆覦歟鈺鵒鷸齬櫞鳶黿鉞鄆蕓惲慍紜韞殞氳瓚趲鏨駔賾嘖幘簀譖繒譫詔釗謫輒鷓湞縝楨軫賑禎鴆諍崢鉦錚箏騭櫛梔軹輊贄鷙螄縶躓躑觶鍾紂縐佇櫧銖囀饌顳騅縋諑鐲諮緇輜貲眥錙齜鯔傯諏騶鯫鏃纘躦鱒訁譾郤猛氹阪壟堖垵墊檾蕒葤蓧蒓菇槁摣咤唚哢噝噅撅劈謔襆嶴脊仿僥獁麅餘餷饊饢楞怵懍爿漵灩混濫瀦淡寧糸絝緔瑉梘棬案橰櫫軲軤賫膁腖飈糊煆溜湣渺碸滾瞘鈈鉕鋣銱鋥鋶鐦鐧鍩鍀鍃錇鎄鎇鎿鐝鑥鑹鑔穭鶓鶥鸌癧屙瘂臒襇繈耮顬蟎麯鮁鮃鮎鯗鯝鯴鱝鯿鰠鰵鱅鞽韝齇';
  var str = '';
  for (var i = 0; i < string.length; i++) {
    if (ftPYStr.indexOf(string.charAt(i)) !== -1) {
      str += simpPYStr.charAt(ftPYStr.indexOf(string.charAt(i)));
    } else if (qqPYStr.indexOf(string.charAt(i)) !== -1) {
      str += simpPYStr.charAt(qqPYStr.indexOf(string.charAt(i)));
    } else {
      str += string.charAt(i);
    }
  }
  return str;
};

function toPrecision(num, precision) {
  if (precision === undefined) precision = 2;
  return parseFloat(Math.round(num * Math.pow(10, precision)) / Math.pow(10, precision));
}

function statusFilter(status) {
  var map = {
    'show': '展示',
    'hide': '隐藏',
    'trash': '回收站'
  };
  return map[status] ? map[status] : status;
}

/***/ }),

/***/ "b8LD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cJYu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cu/V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eDDz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fFU4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gsj7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hdOo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iPXC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export delFirstPage */
/* harmony export (immutable) */ __webpack_exports__["e"] = getFocusNotice;
/* harmony export (immutable) */ __webpack_exports__["o"] = setFocusNotice;
/* harmony export (immutable) */ __webpack_exports__["f"] = getRegCode;
/* harmony export (immutable) */ __webpack_exports__["p"] = setRegCode;
/* harmony export (immutable) */ __webpack_exports__["a"] = delRegCode;
/* harmony export (immutable) */ __webpack_exports__["k"] = getWxCode;
/* harmony export (immutable) */ __webpack_exports__["u"] = setWxCode;
/* harmony export (immutable) */ __webpack_exports__["c"] = delWxCode;
/* harmony export (immutable) */ __webpack_exports__["i"] = getSurveyCode;
/* harmony export (immutable) */ __webpack_exports__["s"] = setSurveyCode;
/* harmony export (immutable) */ __webpack_exports__["d"] = getExhibitorMid;
/* harmony export (immutable) */ __webpack_exports__["n"] = setExhibitorMid;
/* harmony export (immutable) */ __webpack_exports__["b"] = delSurveyCode;
/* harmony export (immutable) */ __webpack_exports__["h"] = getSearchHistory;
/* harmony export (immutable) */ __webpack_exports__["r"] = setSearchHistory;
/* harmony export (immutable) */ __webpack_exports__["l"] = removeSearchHistory;
/* harmony export (immutable) */ __webpack_exports__["j"] = getVipUserSearchHistory;
/* harmony export (immutable) */ __webpack_exports__["t"] = setVipUserSearchHistory;
/* harmony export (immutable) */ __webpack_exports__["m"] = removeVipUserSearchHistory;
/* unused harmony export getVipEpSearchHistory */
/* unused harmony export setVipEpSearchHistory */
/* unused harmony export removeVipEpSearchHistory */
/* harmony export (immutable) */ __webpack_exports__["q"] = setRegSource;
/* harmony export (immutable) */ __webpack_exports__["g"] = getRegSource;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);



var FocusNoticeKey = 'Focus_Notice';
var RegCodeKey = 'REG_CODE';
var WxCodeKey = 'WX_CODE';
var FirstKey = 'First';
var SurveyCodeKey = 'Survey_CODE';
var SearchHistoryKey = 'SH';
var SearchVipUserHistoryKey = 'SVUH';
var SearchVipEpHistoryKey = 'SVEH';
var ExhibitorMidKey = 'Exhibitor_Mid';

var RegSourceKey = 'ref';

function delFirstPage() {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.remove(FirstKey);
}

function getFocusNotice() {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get(FocusNoticeKey);
}

function setFocusNotice() {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set(FocusNoticeKey, 1, {
    expires: 7
  });
}

function getRegCode() {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get(RegCodeKey);
}

function setRegCode(code) {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set(RegCodeKey, code, {
    expires: 0.0035
  });
}

function delRegCode() {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.remove(RegCodeKey);
}

function getWxCode() {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get(WxCodeKey);
}

function setWxCode(code) {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set(WxCodeKey, code, {
    expires: 0.0035
  });
}

function delWxCode() {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.remove(WxCodeKey);
}

function getSurveyCode() {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get(SurveyCodeKey);
}

function setSurveyCode(code) {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set(SurveyCodeKey, code);
}

function getExhibitorMid() {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get(ExhibitorMidKey);
}

function setExhibitorMid(code) {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set(ExhibitorMidKey, code);
}

function delSurveyCode() {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.remove(SurveyCodeKey);
}

function getSearchHistory() {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get(SearchHistoryKey);
}

function setSearchHistory(content) {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set(SearchHistoryKey, content);
}

function removeSearchHistory() {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.remove(SearchHistoryKey);
}

function getVipUserSearchHistory() {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get(SearchVipUserHistoryKey);
}

function setVipUserSearchHistory(content) {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set(SearchVipUserHistoryKey, content);
}

function removeVipUserSearchHistory() {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.remove(SearchVipUserHistoryKey);
}

function getVipEpSearchHistory() {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get(SearchVipEpHistoryKey);
}

function setVipEpSearchHistory(content) {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set(SearchVipEpHistoryKey, content);
}

function removeVipEpSearchHistory() {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.remove(SearchVipEpHistoryKey);
}

function setRegSource(source) {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set(RegSourceKey, source);
}

function getRegSource() {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get(RegSourceKey);
}

/***/ }),

/***/ "kAA/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kbG3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-desc/index.vue
//
//
//
//

/* harmony default export */ var inline_desc = ({
  name: 'inline-desc'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-desc/index.vue
//
//
//
//

/* harmony default export */ var components_inline_desc = ({
  name: 'inline-desc'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d40071a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/inline-desc/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"vux-label-desc"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_inline_desc = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/inline-desc/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("uyKd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_inline_desc,
  src_components_inline_desc,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_inline_desc = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lRz9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_auth__ = __webpack_require__("TIfe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_storage__ = __webpack_require__("VKKs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global__ = __webpack_require__("BfUi");







var service = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.create({

  baseURL: __WEBPACK_IMPORTED_MODULE_4__global__["a" /* default */].apiUrl + '/aa/v1',

  timeout: 15000
});

service.defaults.retry = 3;
service.defaults.retryDelay = 1000;

service.interceptors.request.use(function (request) {

  var token = Object(__WEBPACK_IMPORTED_MODULE_1__utils_auth__["a" /* getToken */])();
  if (token) {
    request.headers['token'] = token;
  } else {
    var uuid = Object(__WEBPACK_IMPORTED_MODULE_2__utils_storage__["i" /* getUuid */])();
    if (uuid) {
      request.headers['uuid'] = uuid;
    } else {
      uuid = Date.parse(new Date()).toString() + Math.random().toString();
      Object(__WEBPACK_IMPORTED_MODULE_2__utils_storage__["r" /* setUuid */])(uuid);
      request.headers['uuid'] = uuid;
    }
  }
  return request;
});

service.interceptors.response.use(function (response) {

  return response;
}, function (error) {
  console.log(error);
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('UPDATE_LOADING_STATUS', { isLoading: false });
});

/* harmony default export */ __webpack_exports__["a"] = (service);

/***/ }),

/***/ "lmDi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lvdZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mzja":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/components/x-dialog/index.vue + 3 modules
var x_dialog = __webpack_require__("/kga");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/alert/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_alert = ({
  name: 'alert',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/alert/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var src_components_alert = ({
  name: 'alert',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3dd202a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/alert/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-alert"},[_c('x-dialog',{attrs:{"mask-transition":_vm.maskTransition,"dialog-transition":_vm.dialogTransition,"hide-on-blur":_vm.hideOnBlur,"mask-z-index":_vm.maskZIndex},on:{"on-hide":function($event){return _vm.$emit('on-hide')},"on-show":function($event){return _vm.$emit('on-show')}},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[_c('div',{staticClass:"weui-dialog__hd"},[_c('strong',{staticClass:"weui-dialog__title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"weui-dialog__bd"},[_vm._t("default",function(){return [_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})]})],2),_vm._v(" "),_c('div',{staticClass:"weui-dialog__ft"},[_c('a',{staticClass:"weui-dialog__btn weui-dialog__btn_primary",attrs:{"href":"javascript:;"},on:{"click":_vm._onHide}},[_vm._v(_vm._s(_vm.buttonText || '确定'))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var vux_src_components_alert = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/alert/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("TuEr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_components_alert,
  vux_src_components_alert,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var node_modules_vux_src_components_alert = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "n4IK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oWtu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/icon/index.vue
//
//
//
//

/* harmony default export */ var icon = ({
  name: 'icon',
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className: function className() {
      // compatible with old type param
      return 'weui-icon weui_icon_' + this.type + ' weui-icon-' + this.type.replace(/_/g, '-');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/icon/index.vue
//
//
//
//

/* harmony default export */ var components_icon = ({
  name: 'icon',
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className: function className() {
      // compatible with old type param
      return 'weui-icon weui_icon_' + this.type + ' weui-icon-' + this.type.replace(/_/g, '-');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ed96448","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/icon/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:[_vm.className, _vm.isMsg ? 'weui-icon_msg' : '']})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_icon = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/icon/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("5VbK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_icon,
  src_components_icon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_icon = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "owug":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rGqP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/divider/index.vue
//
//
//
//
//
//

/* harmony default export */ var divider = ({
  name: 'divider'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/divider/index.vue
//
//
//
//
//
//

/* harmony default export */ var components_divider = ({
  name: 'divider'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-263730af","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/divider/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"vux-divider"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_divider = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/divider/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("LWON")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_divider,
  src_components_divider,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_divider = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rHil":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/libs/clean-style.js
var clean_style = __webpack_require__("wmxo");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/group/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var group = ({
  name: 'group',
  methods: {
    cleanStyle: clean_style["a" /* default */]
  },
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number],
    footerTitle: String,
    footerTitleColor: String
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/group/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_group = ({
  name: 'group',
  methods: {
    cleanStyle: clean_style["a" /* default */]
  },
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number],
    footerTitle: String,
    footerTitleColor: String
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-347cf7be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/group/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.title)?_c('div',{staticClass:"weui-cells__title",style:(_vm.cleanStyle({
    color: _vm.titleColor
  })),domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),_vm._t("title"),_vm._v(" "),_c('div',{staticClass:"weui-cells",class:{
    'vux-no-group-title': !_vm.title
  },style:(_vm.cleanStyle({
    marginTop: typeof _vm.gutter === 'number' ? (_vm.gutter + 'px') : _vm.gutter
  }))},[_vm._t("after-title"),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),(_vm.footerTitle)?_c('div',{staticClass:"weui-cells__title vux-group-footer-title",style:(_vm.cleanStyle({
    color: _vm.footerTitleColor
  })),domProps:{"innerHTML":_vm._s(_vm.footerTitle)}}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_group = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/group/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("uWE6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_group,
  src_components_group,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_group = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rLAy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/safari-fix.js
var safari_fix = __webpack_require__("xNvf");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7981d141","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/toast/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-toast"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowMask && _vm.show),expression:"isShowMask && show"}],staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('transition',{attrs:{"name":_vm.currentTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-toast",class:_vm.toastClass,style:({width: _vm.width})},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.type !== 'text'),expression:"type !== 'text'"}],staticClass:"weui-icon-success-no-circle weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content",style:(_vm.style),domProps:{"innerHTML":_vm._s(_vm.text)}}):_c('p',{staticClass:"weui-toast__content",style:(_vm.style)},[_vm._t("default")],2)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_toast = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/toast/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("3Ziz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_toast,
  src_components_toast,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_toast = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sVzw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t7qc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tRmb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = fetchAdminVisit;
/* harmony export (immutable) */ __webpack_exports__["h"] = uploadAdminImage;
/* harmony export (immutable) */ __webpack_exports__["f"] = transferAdminMedia2Url;
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchAdminDownloadList;
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchAdminTagList;
/* harmony export (immutable) */ __webpack_exports__["g"] = updateUserCoin;
/* unused harmony export fetchAdminUserInfo */
/* harmony export (immutable) */ __webpack_exports__["e"] = fetchAdminVisitData;
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchAdminClientData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_request__ = __webpack_require__("vLgD");


function fetchAdminVisit(query) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/admin/visit',
    method: 'get',
    params: query
  });
}

function uploadAdminImage(file) {
  var fileData = new FormData();
  fileData.append('img', file);
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/upload/admin',
    method: 'post',
    data: fileData
  });
}

function transferAdminMedia2Url(mediaId) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/upload/admin/media_id_to_url',
    method: 'post',
    data: {
      media_id: mediaId
    }
  });
}

function fetchAdminDownloadList(query) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/admin/download/list',
    method: 'get',
    params: query
  });
}

function fetchAdminTagList() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/admin/tag/list',
    method: 'get'
  });
}

function updateUserCoin(item) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/admin/user/coin',
    method: 'put',
    data: item
  });
}

function fetchAdminUserInfo(query) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/admin/user',
    method: 'get',
    params: query
  });
}

function fetchAdminVisitData(query) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/admin/visit/data',
    method: 'get',
    params: query
  });
}

function fetchAdminClientData() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/admin/user/stat',
    method: 'get'
  });
}

/***/ }),

/***/ "tZYb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u6MN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uWE6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uwyH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uyKd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uzBN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = transferMedia2Url;
/* harmony export (immutable) */ __webpack_exports__["c"] = uploadDoc;
/* unused harmony export fetchVideoStatus */
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchUploadStsToken;
/* unused harmony export uploadPublic */
/* unused harmony export uploadPrivate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_request__ = __webpack_require__("vLgD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_global__ = __webpack_require__("BfUi");



function transferMedia2Url(mediaId) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/upload/media_id_to_url',
    method: 'post',
    data: {
      media_id: mediaId
    }
  });
}

function uploadDoc(file) {
  var fileData = new FormData();
  fileData.append('data', file);
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/upload/doc',
    method: 'post',
    data: fileData
  });
}

function fetchVideoStatus(query) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    baseURL: __WEBPACK_IMPORTED_MODULE_1__utils_global__["a" /* default */].apiVideoUrl + '/aa/v1',
    timeout: 90000,
    url: '/upload/video',
    method: 'get',
    params: query
  });
}

function fetchUploadStsToken() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/upload/sts/token',
    method: 'get'
  });
}

function uploadPublic(file) {
  var fileData = new FormData();
  fileData.append('data', file);
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/upload/public',
    method: 'post',
    data: fileData
  });
}

function uploadPrivate(file) {
  var fileData = new FormData();
  fileData.append('data', file);
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: '/upload/private',
    method: 'post',
    data: fileData
  });
}

/***/ }),

/***/ "vLgD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_auth__ = __webpack_require__("TIfe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_storage__ = __webpack_require__("VKKs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__global__ = __webpack_require__("BfUi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_base__ = __webpack_require__("aFVK");











var service = __WEBPACK_IMPORTED_MODULE_6_axios___default.a.create({

  baseURL: __WEBPACK_IMPORTED_MODULE_7__global__["a" /* default */].apiUrl + '/aa/v1',
  timeout: 15000
});

service.defaults.retry = 3;
service.defaults.retryDelay = 1000;

service.interceptors.request.use(function (request) {

  var token = Object(__WEBPACK_IMPORTED_MODULE_2__utils_auth__["a" /* getToken */])();
  if (token) {
    request.headers['token'] = token;
  }
  var uuid = Object(__WEBPACK_IMPORTED_MODULE_3__utils_storage__["i" /* getUuid */])();
  if (uuid) {
    request.headers['uuid'] = uuid;
  } else {
    uuid = Date.parse(new Date()).toString() + Math.random().toString();
    Object(__WEBPACK_IMPORTED_MODULE_3__utils_storage__["r" /* setUuid */])(uuid);
    request.headers['uuid'] = uuid;
  }
  return request;
});

service.interceptors.response.use(function (response) {

  return response;
}, function (error) {
  console.log(error);
  __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('UPDATE_LOADING_STATUS', { isLoading: false });
  var statusCode = 0;
  if (error.response) {
    statusCode = error.response.status;
    if (statusCode === 401) {
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('FedLogOut');
      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].$vux.toast.show({
        text: '请先登录<br/>(系统自动跳转中)',
        type: 'warn',
        time: 500,
        width: '9em'
      });
      var path = Object(__WEBPACK_IMPORTED_MODULE_8__utils_base__["a" /* addOauthPath */])(__WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].currentRoute.path, __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].currentRoute.query);
      __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].push({
        path: '/login?back=' + encodeURIComponent(path)
      });
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    } else if (statusCode === 409) {
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('FedLogOut');
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    } else {
      var content = error.response ? error.response.data.message : error.message;

      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].$vux.alert.show({
        title: '提示',
        content: content
      });

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    }
  } else {
    var config = error.config;

    config.__retryCount = config.__retryCount || 0;
    if (config.__retryCount >= config.retry) {
      var _content = error.message;
      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].$vux.alert.show({
        title: '提示',
        content: _content
      });
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    }
    config.__retryCount += 1;
    var backoff = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
      setTimeout(function () {
        resolve();
      }, config.retryDelay || 1);
    });
    return backoff.then(function () {
      return service(config);
    });
  }
});

/* harmony default export */ __webpack_exports__["a"] = (service);

/***/ }),

/***/ "wRzN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xhby":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z/9y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.022f0095ea16da24c9f0.js